
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree135"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree135"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.3" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.3"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.3"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.3";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.3";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.3";

});



parcelRegister("kfsOU", function(module, exports) {
'use strict';

var $5kweD = parcelRequire("5kweD");

var $jTkcJ = parcelRequire("jTkcJ");
module.exports = $jTkcJ;
$jTkcJ.prototype.message = $ebdb906eb43ac433$var$message;
$jTkcJ.prototype.info = $ebdb906eb43ac433$var$info;
$jTkcJ.prototype.fail = $ebdb906eb43ac433$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $ebdb906eb43ac433$var$message(reason, position, origin) {
    var message = new $5kweD(reason, position, origin);
    if (this.path) {
        message.name = this.path + ':' + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $ebdb906eb43ac433$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $ebdb906eb43ac433$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("5kweD", function(module, exports) {
'use strict';

var $7RfN2 = parcelRequire("7RfN2");
module.exports = $3e17d334d9a84f4b$var$VMessage;
// Inherit from `Error#`.
function $3e17d334d9a84f4b$var$VMessagePrototype() {}
$3e17d334d9a84f4b$var$VMessagePrototype.prototype = Error.prototype;
$3e17d334d9a84f4b$var$VMessage.prototype = new $3e17d334d9a84f4b$var$VMessagePrototype();
// Message properties.
var $3e17d334d9a84f4b$var$proto = $3e17d334d9a84f4b$var$VMessage.prototype;
$3e17d334d9a84f4b$var$proto.file = '';
$3e17d334d9a84f4b$var$proto.name = '';
$3e17d334d9a84f4b$var$proto.reason = '';
$3e17d334d9a84f4b$var$proto.message = '';
$3e17d334d9a84f4b$var$proto.stack = '';
$3e17d334d9a84f4b$var$proto.fatal = null;
$3e17d334d9a84f4b$var$proto.column = null;
$3e17d334d9a84f4b$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $3e17d334d9a84f4b$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === 'string') {
        origin = position;
        position = null;
    }
    parts = $3e17d334d9a84f4b$var$parseOrigin(origin);
    range = $7RfN2(position) || '1:1';
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $3e17d334d9a84f4b$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === 'string') {
        index = origin.indexOf(':');
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("7RfN2", function(module, exports) {
'use strict';
var $5b89bb37f552ffbc$var$own = {}.hasOwnProperty;
module.exports = $5b89bb37f552ffbc$var$stringify;
function $5b89bb37f552ffbc$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ($5b89bb37f552ffbc$var$own.call(value, 'position') || $5b89bb37f552ffbc$var$own.call(value, 'type')) return $5b89bb37f552ffbc$var$position(value.position);
    // Position.
    if ($5b89bb37f552ffbc$var$own.call(value, 'start') || $5b89bb37f552ffbc$var$own.call(value, 'end')) return $5b89bb37f552ffbc$var$position(value);
    // Point.
    if ($5b89bb37f552ffbc$var$own.call(value, 'line') || $5b89bb37f552ffbc$var$own.call(value, 'column')) return $5b89bb37f552ffbc$var$point(value);
    // ?
    return '';
}
function $5b89bb37f552ffbc$var$point(point) {
    if (!point || typeof point !== 'object') point = {};
    return $5b89bb37f552ffbc$var$index(point.line) + ':' + $5b89bb37f552ffbc$var$index(point.column);
}
function $5b89bb37f552ffbc$var$position(pos) {
    if (!pos || typeof pos !== 'object') pos = {};
    return $5b89bb37f552ffbc$var$point(pos.start) + '-' + $5b89bb37f552ffbc$var$point(pos.end);
}
function $5b89bb37f552ffbc$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}

});


parcelRegister("jTkcJ", function(module, exports) {
'use strict';

var $9haXP = parcelRequire("9haXP");

var $4lnqT = parcelRequire("4lnqT");

var $7B5Ea = parcelRequire("7B5Ea");
module.exports = $e7b2d3880a01f8e5$var$VFile;
var $e7b2d3880a01f8e5$var$own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $e7b2d3880a01f8e5$var$order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
$e7b2d3880a01f8e5$var$VFile.prototype.toString = $e7b2d3880a01f8e5$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($e7b2d3880a01f8e5$var$VFile.prototype, 'path', {
    get: $e7b2d3880a01f8e5$var$getPath,
    set: $e7b2d3880a01f8e5$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($e7b2d3880a01f8e5$var$VFile.prototype, 'dirname', {
    get: $e7b2d3880a01f8e5$var$getDirname,
    set: $e7b2d3880a01f8e5$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($e7b2d3880a01f8e5$var$VFile.prototype, 'basename', {
    get: $e7b2d3880a01f8e5$var$getBasename,
    set: $e7b2d3880a01f8e5$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($e7b2d3880a01f8e5$var$VFile.prototype, 'extname', {
    get: $e7b2d3880a01f8e5$var$getExtname,
    set: $e7b2d3880a01f8e5$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($e7b2d3880a01f8e5$var$VFile.prototype, 'stem', {
    get: $e7b2d3880a01f8e5$var$getStem,
    set: $e7b2d3880a01f8e5$var$setStem
});
// Construct a new file.
function $e7b2d3880a01f8e5$var$VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === 'string' || $7B5Ea(options)) options = {
        contents: options
    };
    else if ('message' in options && 'messages' in options) return options;
    if (!(this instanceof $e7b2d3880a01f8e5$var$VFile)) return new $e7b2d3880a01f8e5$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $4lnqT.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < $e7b2d3880a01f8e5$var$order.length){
        prop = $e7b2d3880a01f8e5$var$order[index];
        if ($e7b2d3880a01f8e5$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($e7b2d3880a01f8e5$var$order.indexOf(prop) < 0) this[prop] = options[prop];
}
function $e7b2d3880a01f8e5$var$getPath() {
    return this.history[this.history.length - 1];
}
function $e7b2d3880a01f8e5$var$setPath(path) {
    $e7b2d3880a01f8e5$var$assertNonEmpty(path, 'path');
    if (this.path !== path) this.history.push(path);
}
function $e7b2d3880a01f8e5$var$getDirname() {
    return typeof this.path === 'string' ? $9haXP.dirname(this.path) : undefined;
}
function $e7b2d3880a01f8e5$var$setDirname(dirname) {
    $e7b2d3880a01f8e5$var$assertPath(this.path, 'dirname');
    this.path = $9haXP.join(dirname || '', this.basename);
}
function $e7b2d3880a01f8e5$var$getBasename() {
    return typeof this.path === 'string' ? $9haXP.basename(this.path) : undefined;
}
function $e7b2d3880a01f8e5$var$setBasename(basename) {
    $e7b2d3880a01f8e5$var$assertNonEmpty(basename, 'basename');
    $e7b2d3880a01f8e5$var$assertPart(basename, 'basename');
    this.path = $9haXP.join(this.dirname || '', basename);
}
function $e7b2d3880a01f8e5$var$getExtname() {
    return typeof this.path === 'string' ? $9haXP.extname(this.path) : undefined;
}
function $e7b2d3880a01f8e5$var$setExtname(extname) {
    $e7b2d3880a01f8e5$var$assertPart(extname, 'extname');
    $e7b2d3880a01f8e5$var$assertPath(this.path, 'extname');
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
        if (extname.indexOf('.', 1) > -1) throw new Error('`extname` cannot contain multiple dots');
    }
    this.path = $9haXP.join(this.dirname, this.stem + (extname || ''));
}
function $e7b2d3880a01f8e5$var$getStem() {
    return typeof this.path === 'string' ? $9haXP.basename(this.path, this.extname) : undefined;
}
function $e7b2d3880a01f8e5$var$setStem(stem) {
    $e7b2d3880a01f8e5$var$assertNonEmpty(stem, 'stem');
    $e7b2d3880a01f8e5$var$assertPart(stem, 'stem');
    this.path = $9haXP.join(this.dirname || '', stem + (this.extname || ''));
}
// Get the value of the file.
function $e7b2d3880a01f8e5$var$toString(encoding) {
    return (this.contents || '').toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function $e7b2d3880a01f8e5$var$assertPart(part, name) {
    if (part && part.indexOf($9haXP.sep) > -1) throw new Error('`' + name + '` cannot be a path: did not expect `' + $9haXP.sep + '`');
}
// Assert that `part` is not empty.
function $e7b2d3880a01f8e5$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
// Assert `path` exists.
function $e7b2d3880a01f8e5$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}

});
parcelRegister("9haXP", function(module, exports) {

$parcel$export(module.exports, "basename", () => $6c0e34cf2f183349$export$9bf319d8f74f51d1, (v) => $6c0e34cf2f183349$export$9bf319d8f74f51d1 = v);
$parcel$export(module.exports, "dirname", () => $6c0e34cf2f183349$export$7f7b8152cc673abe, (v) => $6c0e34cf2f183349$export$7f7b8152cc673abe = v);
$parcel$export(module.exports, "extname", () => $6c0e34cf2f183349$export$d0e86f3a75393fa3, (v) => $6c0e34cf2f183349$export$d0e86f3a75393fa3 = v);
$parcel$export(module.exports, "join", () => $6c0e34cf2f183349$export$f7e2c8231c57a8bd, (v) => $6c0e34cf2f183349$export$f7e2c8231c57a8bd = v);
$parcel$export(module.exports, "sep", () => $6c0e34cf2f183349$export$5aee1a5bd9743d8f, (v) => $6c0e34cf2f183349$export$5aee1a5bd9743d8f = v);
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $6c0e34cf2f183349$export$9bf319d8f74f51d1;
var $6c0e34cf2f183349$export$7f7b8152cc673abe;
var $6c0e34cf2f183349$export$d0e86f3a75393fa3;
var $6c0e34cf2f183349$export$f7e2c8231c57a8bd;
var $6c0e34cf2f183349$export$5aee1a5bd9743d8f;
'use strict';
$6c0e34cf2f183349$export$9bf319d8f74f51d1 = $6c0e34cf2f183349$var$basename;
$6c0e34cf2f183349$export$7f7b8152cc673abe = $6c0e34cf2f183349$var$dirname;
$6c0e34cf2f183349$export$d0e86f3a75393fa3 = $6c0e34cf2f183349$var$extname;
$6c0e34cf2f183349$export$f7e2c8231c57a8bd = $6c0e34cf2f183349$var$join;
$6c0e34cf2f183349$export$5aee1a5bd9743d8f = '/';
function $6c0e34cf2f183349$var$basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $6c0e34cf2f183349$var$assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function $6c0e34cf2f183349$var$dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    $6c0e34cf2f183349$var$assertPath(path);
    if (!path.length) return '.';
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
function $6c0e34cf2f183349$var$extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    $6c0e34cf2f183349$var$assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
function $6c0e34cf2f183349$var$join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        $6c0e34cf2f183349$var$assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + '/' + arguments[index];
    }
    return joined === undefined ? '.' : $6c0e34cf2f183349$var$normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $6c0e34cf2f183349$var$normalize(path) {
    var absolute;
    var value;
    $6c0e34cf2f183349$var$assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = $6c0e34cf2f183349$var$normalizeString(path, !absolute);
    if (!value.length && !absolute) value = '.';
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function $6c0e34cf2f183349$var$normalizeString(path, allowAboveRoot) {
    var result = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function $6c0e34cf2f183349$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}

});

parcelRegister("4lnqT", function(module, exports) {

$parcel$export(module.exports, "cwd", () => $329b4cd6854e87dd$export$5f7bb87daeae59c1, (v) => $329b4cd6854e87dd$export$5f7bb87daeae59c1 = v);
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $329b4cd6854e87dd$export$5f7bb87daeae59c1;
'use strict';
$329b4cd6854e87dd$export$5f7bb87daeae59c1 = $329b4cd6854e87dd$var$cwd;
function $329b4cd6854e87dd$var$cwd() {
    return '/';
}

});

parcelRegister("7B5Ea", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

});



parcelRegister("aLwp9", function(module, exports) {
'use strict';
module.exports = $7d676e09422cf90a$var$fromMarkdown;

var $jLyeA = parcelRequire("jLyeA");

var $75AmO = parcelRequire("75AmO");

var $1MCee = parcelRequire("1MCee");

var $as1T9 = parcelRequire("as1T9");

var $g0vJR = parcelRequire("g0vJR");

var $jIo9t = parcelRequire("jIo9t");

var $aLFcx = parcelRequire("aLFcx");

var $6st82 = parcelRequire("6st82");

var $7kD0n = parcelRequire("7kD0n");

var $7RfN2 = parcelRequire("7RfN2");
function $7d676e09422cf90a$var$fromMarkdown(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $7d676e09422cf90a$var$compiler(options)($6st82($jIo9t(options).document().write($aLFcx()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function $7d676e09422cf90a$var$compiler(options) {
    var settings = options || {};
    var config = $7d676e09422cf90a$var$configure({
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: 'root',
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if ($1MCee.call(handler, events[index][1].type)) handler[events[index][1].type].call($75AmO({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error('Cannot close document, a token (`' + tokenStack[tokenStack.length - 1].type + '`, ' + $7RfN2({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ') is still open');
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + $7RfN2({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open.type !== token.type) throw new Error('Cannot close `' + token.type + '` (' + $7RfN2({
            start: token.start,
            end: token.end
        }) + '): a different token (`' + open.type + '`, ' + $7RfN2({
            start: open.start,
            end: open.end
        }) + ') is open');
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return $jLyeA(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $as1T9(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData('atHardBreak', true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = $as1T9(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData('inReference', true);
        if (this.stack[this.stack.length - 1].type === 'link') this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData('inReference');
    }
    function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $as1T9(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData('characterReferenceType');
        var value;
        var tail;
        if (type) {
            value = $g0vJR(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else value = $7kD0n(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    function heading() {
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: 'break'
        };
    }
    function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
function $7d676e09422cf90a$var$configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)$7d676e09422cf90a$var$extension(config, extensions[index]);
    return config;
}
function $7d676e09422cf90a$var$extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = $1MCee.call(config, key) ? config[key] : config[key] = {};
        if (key === 'canContainEols' || key === 'transforms') config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

});
parcelRegister("jLyeA", function(module, exports) {
'use strict';
module.exports = $e63cf65621459320$var$toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function $e63cf65621459320$var$toString(node) {
    return node && (node.value || node.alt || node.title || 'children' in node && $e63cf65621459320$var$all(node.children) || 'length' in node && $e63cf65621459320$var$all(node)) || '';
}
function $e63cf65621459320$var$all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $e63cf65621459320$var$toString(values[index]);
    return result.join('');
}

});

parcelRegister("75AmO", function(module, exports) {
'use strict';
var $529535bb2c0867a0$var$assign = Object.assign;
module.exports = $529535bb2c0867a0$var$assign;

});

parcelRegister("1MCee", function(module, exports) {
'use strict';
var $14c7ed8e7894ca78$var$own = {}.hasOwnProperty;
module.exports = $14c7ed8e7894ca78$var$own;

});

parcelRegister("as1T9", function(module, exports) {
'use strict';
function $79bdfbf2d4044818$var$normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ') // Trim.
    .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = $79bdfbf2d4044818$var$normalizeIdentifier;

});

parcelRegister("g0vJR", function(module, exports) {
'use strict';

var $hzBBi = parcelRequire("hzBBi");
function $ba7544119362f5c4$var$safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return '\uFFFD';
    return $hzBBi(code);
}
module.exports = $ba7544119362f5c4$var$safeFromInt;

});
parcelRegister("hzBBi", function(module, exports) {
'use strict';
var $ccb2df43798bf21b$var$fromCharCode = String.fromCharCode;
module.exports = $ccb2df43798bf21b$var$fromCharCode;

});


parcelRegister("jIo9t", function(module, exports) {
'use strict';

var $f0ix8 = parcelRequire("f0ix8");

var $kIO1P = parcelRequire("kIO1P");

var $fUIRT = parcelRequire("fUIRT");

var $jibao = parcelRequire("jibao");

var $k77qH = parcelRequire("k77qH");

var $knAXI = parcelRequire("knAXI");

var $280SI = parcelRequire("280SI");

var $kCt2h = parcelRequire("kCt2h");
function $e5a4dc6d353b9d74$var$parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: $k77qH([
            $kCt2h
        ].concat($280SI(settings.extensions))),
        content: create($f0ix8),
        document: create($kIO1P),
        flow: create($fUIRT),
        string: create($jibao.string),
        text: create($jibao.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return $knAXI(parser, initializer, from);
        }
    }
}
module.exports = $e5a4dc6d353b9d74$var$parse;

});
parcelRegister("f0ix8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $haNiV = parcelRequire("haNiV");

var $aP2DW = parcelRequire("aP2DW");
var $aec53b784ff5ca6a$var$tokenize = $aec53b784ff5ca6a$var$initializeContent;
function $aec53b784ff5ca6a$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $aP2DW(effects, contentStart, 'linePrefix');
    }
    function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ($haNiV(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
module.exports.tokenize = $aec53b784ff5ca6a$var$tokenize;

});
parcelRegister("haNiV", function(module, exports) {
'use strict';
function $c8099da3ddbfb96e$var$markdownLineEnding(code) {
    return code < -2;
}
module.exports = $c8099da3ddbfb96e$var$markdownLineEnding;

});

parcelRegister("aP2DW", function(module, exports) {
'use strict';

var $hUP7l = parcelRequire("hUP7l");
function $7e10b7b13b3babed$var$spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if ($hUP7l(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if ($hUP7l(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = $7e10b7b13b3babed$var$spaceFactory;

});
parcelRegister("hUP7l", function(module, exports) {
'use strict';
function $d0af517cbb14ad7f$var$markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = $d0af517cbb14ad7f$var$markdownSpace;

});



parcelRegister("kIO1P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $haNiV = parcelRequire("haNiV");

var $aP2DW = parcelRequire("aP2DW");

var $7Mwhu = parcelRequire("7Mwhu");
var $f15eb955d9a1f69b$var$tokenize = $f15eb955d9a1f69b$var$initializeDocument;
var $f15eb955d9a1f69b$var$containerConstruct = {
    tokenize: $f15eb955d9a1f69b$var$tokenizeContainer
};
var $f15eb955d9a1f69b$var$lazyFlowConstruct = {
    tokenize: $f15eb955d9a1f69b$var$tokenizeLazyFlow
};
function $f15eb955d9a1f69b$var$initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt($f15eb955d9a1f69b$var$containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit('chunkFlow'));
            return flowStart(code);
        }
        if ($haNiV(code)) {
            effects.consume(code);
            continueFlow(effects.exit('chunkFlow'));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt($f15eb955d9a1f69b$var$containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt($f15eb955d9a1f69b$var$containerConstruct, inspectFlowEnd, effects.attempt($f15eb955d9a1f69b$var$lazyFlowConstruct, inspectFlowEnd, effects.check($7Mwhu, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function $f15eb955d9a1f69b$var$tokenizeContainer(effects, ok, nok) {
    return $aP2DW(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function $f15eb955d9a1f69b$var$tokenizeLazyFlow(effects, ok, nok) {
    return $aP2DW(effects, effects.lazy(this.parser.constructs.flow, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
module.exports.tokenize = $f15eb955d9a1f69b$var$tokenize;

});
parcelRegister("7Mwhu", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $aP2DW = parcelRequire("aP2DW");
var $5aa60e75f3be8f63$var$partialBlankLine = {
    tokenize: $5aa60e75f3be8f63$var$tokenizePartialBlankLine,
    partial: true
};
function $5aa60e75f3be8f63$var$tokenizePartialBlankLine(effects, ok, nok) {
    return $aP2DW(effects, afterWhitespace, 'linePrefix');
    function afterWhitespace(code) {
        return code === null || $haNiV(code) ? ok(code) : nok(code);
    }
}
module.exports = $5aa60e75f3be8f63$var$partialBlankLine;

});


parcelRegister("fUIRT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $k8mIn = parcelRequire("k8mIn");

var $aP2DW = parcelRequire("aP2DW");

var $7Mwhu = parcelRequire("7Mwhu");
var $b95ee3e24c12c9dd$var$tokenize = $b95ee3e24c12c9dd$var$initializeFlow;
function $b95ee3e24c12c9dd$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    $7Mwhu, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, $aP2DW(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt($k8mIn, afterConstruct)), 'linePrefix')));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}
module.exports.tokenize = $b95ee3e24c12c9dd$var$tokenize;

});
parcelRegister("k8mIn", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $9L4qe = parcelRequire("9L4qe");

var $5P0YF = parcelRequire("5P0YF");

var $aP2DW = parcelRequire("aP2DW");
// No name because it must not be turned off.
var $ea862cb11b4bd7fb$var$content = {
    tokenize: $ea862cb11b4bd7fb$var$tokenizeContent,
    resolve: $ea862cb11b4bd7fb$var$resolveContent,
    interruptible: true,
    lazy: true
};
var $ea862cb11b4bd7fb$var$continuationConstruct = {
    tokenize: $ea862cb11b4bd7fb$var$tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function $ea862cb11b4bd7fb$var$resolveContent(events) {
    $5P0YF(events);
    return events;
}
function $ea862cb11b4bd7fb$var$tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if ($haNiV(code)) return effects.check($ea862cb11b4bd7fb$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous = previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        return data;
    }
}
function $ea862cb11b4bd7fb$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $aP2DW(effects, prefixed, 'linePrefix');
    }
    function prefixed(code) {
        if (code === null || $haNiV(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf('codeIndented') > -1 || $9L4qe(self.events, 'linePrefix') < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = $ea862cb11b4bd7fb$var$content;

});
parcelRegister("9L4qe", function(module, exports) {
'use strict';

var $25Upe = parcelRequire("25Upe");
function $71abeefde994694c$var$prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return $25Upe(tail[2].sliceStream(tail[1]));
}
module.exports = $71abeefde994694c$var$prefixSize;

});
parcelRegister("25Upe", function(module, exports) {
'use strict';
// Counts tabs based on their expanded size, and CR+LF as one character.
function $1867cd7207cfa1a3$var$sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === 'string' ? chunks[index].length : 1;
    return size;
}
module.exports = $1867cd7207cfa1a3$var$sizeChunks;

});


parcelRegister("5P0YF", function(module, exports) {
'use strict';

var $75AmO = parcelRequire("75AmO");

var $cV7wI = parcelRequire("cV7wI");

var $aS1M5 = parcelRequire("aS1M5");
function $43d2794b2ac2cf3c$var$subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                $75AmO(jumps, $43d2794b2ac2cf3c$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = $aS1M5(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                $cV7wI(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function $43d2794b2ac2cf3c$var$subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === 'enter') entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        $cV7wI(events, start, 2, slice);
    }
}
module.exports = $43d2794b2ac2cf3c$var$subtokenize;

});
parcelRegister("cV7wI", function(module, exports) {
'use strict';

var $ig5oJ = parcelRequire("ig5oJ");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function $9680a58d5e1e9846$var$chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        $ig5oJ.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) $ig5oJ.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            $ig5oJ.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = $9680a58d5e1e9846$var$chunkedSplice;

});
parcelRegister("ig5oJ", function(module, exports) {
'use strict';
var $d4ade880f7ac09f5$var$splice = [].splice;
module.exports = $d4ade880f7ac09f5$var$splice;

});


parcelRegister("aS1M5", function(module, exports) {
'use strict';

var $75AmO = parcelRequire("75AmO");
function $7ea052ed3e594421$var$shallow(object) {
    return $75AmO({}, object);
}
module.exports = $7ea052ed3e594421$var$shallow;

});




parcelRegister("jibao", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $75AmO = parcelRequire("75AmO");

var $aS1M5 = parcelRequire("aS1M5");
var $e0b85c3445d6eeec$var$text = $e0b85c3445d6eeec$var$initializeFactory('text');
var $e0b85c3445d6eeec$var$string = $e0b85c3445d6eeec$var$initializeFactory('string');
var $e0b85c3445d6eeec$var$resolver = {
    resolveAll: $e0b85c3445d6eeec$var$createResolver()
};
function $e0b85c3445d6eeec$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $e0b85c3445d6eeec$var$createResolver(field === 'text' ? $e0b85c3445d6eeec$var$resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function $e0b85c3445d6eeec$var$createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function $e0b85c3445d6eeec$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: $aS1M5(data.end)
            };
            data.end = $aS1M5(token.start);
            if (data.start.offset === data.end.offset) $75AmO(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
module.exports.resolver = $e0b85c3445d6eeec$var$resolver;
module.exports.string = $e0b85c3445d6eeec$var$string;
module.exports.text = $e0b85c3445d6eeec$var$text;

});

parcelRegister("k77qH", function(module, exports) {
'use strict';

var $1MCee = parcelRequire("1MCee");

var $cV7wI = parcelRequire("cV7wI");

var $280SI = parcelRequire("280SI");
function $ea4a3970b6257c24$var$combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)$ea4a3970b6257c24$var$extension(all, extensions[index]);
    return all;
}
function $ea4a3970b6257c24$var$extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = $1MCee.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = $ea4a3970b6257c24$var$constructs($280SI(right[code]), $1MCee.call(left, code) ? left[code] : []);
    }
}
function $ea4a3970b6257c24$var$constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    $cV7wI(existing, 0, 0, before);
    return existing;
}
module.exports = $ea4a3970b6257c24$var$combineExtensions;

});
parcelRegister("280SI", function(module, exports) {
'use strict';
function $18cd032b208c715e$var$miniflat(value) {
    return value === null || value === undefined ? [] : 'length' in value ? value : [
        value
    ];
}
module.exports = $18cd032b208c715e$var$miniflat;

});


parcelRegister("knAXI", function(module, exports) {
'use strict';

var $75AmO = parcelRequire("75AmO");

var $haNiV = parcelRequire("haNiV");

var $f2fat = parcelRequire("f2fat");

var $cV7wI = parcelRequire("cV7wI");

var $280SI = parcelRequire("280SI");

var $1Q9SC = parcelRequire("1Q9SC");

var $70c5h = parcelRequire("70c5h");

var $aS1M5 = parcelRequire("aS1M5");

var $7Ldkc = parcelRequire("7Ldkc");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function $ed62a0903524c12d$var$createTokenizer(parser, initialize, from) {
    var point = from ? $aS1M5(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = $f2fat(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = $1Q9SC(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return $70c5h(sliceStream(token));
    }
    function sliceStream(token) {
        return $7Ldkc(chunks, token);
    }
    function now() {
        return $aS1M5(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if ($haNiV(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || 'length' in constructs ? handleListOfConstructs($280SI(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ $280SI(constructs[code]).concat($280SI(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? $75AmO({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) $cV7wI(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = $ed62a0903524c12d$var$createTokenizer;

});
parcelRegister("f2fat", function(module, exports) {
'use strict';

var $cV7wI = parcelRequire("cV7wI");
function $af22ceeed1fac3dd$var$chunkedPush(list, items) {
    if (list.length) {
        $cV7wI(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = $af22ceeed1fac3dd$var$chunkedPush;

});

parcelRegister("1Q9SC", function(module, exports) {
'use strict';
function $15724fb758c966ef$var$resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = $15724fb758c966ef$var$resolveAll;

});

parcelRegister("70c5h", function(module, exports) {
'use strict';

var $hzBBi = parcelRequire("hzBBi");
function $5191e82266ac62e8$var$serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === 'string') value = chunk;
        else if (chunk === -5) value = '\r';
        else if (chunk === -4) value = '\n';
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = '\t';
        else if (chunk === -1) {
            if (atTab) continue;
            value = ' ';
        } else // Currently only replacement character.
        value = $hzBBi(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}
module.exports = $5191e82266ac62e8$var$serializeChunks;

});

parcelRegister("7Ldkc", function(module, exports) {
'use strict';
function $5a67423231fab32c$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = $5a67423231fab32c$var$sliceChunks;

});


parcelRegister("kCt2h", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $jibao = parcelRequire("jibao");

var $bZM9j = parcelRequire("bZM9j");

var $8D2ZX = parcelRequire("8D2ZX");

var $21oju = parcelRequire("21oju");

var $hBTAh = parcelRequire("hBTAh");

var $kUPHq = parcelRequire("kUPHq");

var $6hQf1 = parcelRequire("6hQf1");

var $kvsMV = parcelRequire("kvsMV");

var $7mP7E = parcelRequire("7mP7E");

var $alpyD = parcelRequire("alpyD");

var $2pgEX = parcelRequire("2pgEX");

var $ftd6z = parcelRequire("ftd6z");

var $2tDVB = parcelRequire("2tDVB");

var $9ufqp = parcelRequire("9ufqp");

var $4Sy7e = parcelRequire("4Sy7e");

var $cO4BK = parcelRequire("cO4BK");

var $i0FOh = parcelRequire("i0FOh");

var $dL8bm = parcelRequire("dL8bm");

var $1YVbb = parcelRequire("1YVbb");

var $9KmeU = parcelRequire("9KmeU");

var $6E6c1 = parcelRequire("6E6c1");
var $03dfb52e075b810f$var$document = {
    42: $1YVbb,
    // Asterisk
    43: $1YVbb,
    // Plus sign
    45: $1YVbb,
    // Dash
    48: $1YVbb,
    // 0
    49: $1YVbb,
    // 1
    50: $1YVbb,
    // 2
    51: $1YVbb,
    // 3
    52: $1YVbb,
    // 4
    53: $1YVbb,
    // 5
    54: $1YVbb,
    // 6
    55: $1YVbb,
    // 7
    56: $1YVbb,
    // 8
    57: $1YVbb,
    // 9
    62: $21oju // Greater than
};
var $03dfb52e075b810f$var$contentInitial = {
    91: $alpyD // Left square bracket
};
var $03dfb52e075b810f$var$flowInitial = {
    '-2': $kvsMV,
    // Horizontal tab
    '-1': $kvsMV,
    // Virtual space
    32: $kvsMV // Space
};
var $03dfb52e075b810f$var$flow = {
    35: $ftd6z,
    // Number sign
    42: $6E6c1,
    // Asterisk
    45: [
        $9KmeU,
        $6E6c1
    ],
    // Dash
    60: $2tDVB,
    // Less than
    61: $9KmeU,
    // Equals to
    95: $6E6c1,
    // Underscore
    96: $6hQf1,
    // Grave accent
    126: $6hQf1 // Tilde
};
var $03dfb52e075b810f$var$string = {
    38: $kUPHq,
    // Ampersand
    92: $hBTAh // Backslash
};
var $03dfb52e075b810f$var$text = {
    '-5': $dL8bm,
    // Carriage return
    '-4': $dL8bm,
    // Line feed
    '-3': $dL8bm,
    // Carriage return + line feed
    33: $cO4BK,
    // Exclamation mark
    38: $kUPHq,
    // Ampersand
    42: $bZM9j,
    // Asterisk
    60: [
        $8D2ZX,
        $9ufqp
    ],
    // Less than
    91: $i0FOh,
    // Left square bracket
    92: [
        $2pgEX,
        $hBTAh
    ],
    // Backslash
    93: $4Sy7e,
    // Right square bracket
    95: $bZM9j,
    // Underscore
    96: $7mP7E // Grave accent
};
var $03dfb52e075b810f$var$insideSpan = {
    null: [
        $bZM9j,
        $jibao.resolver
    ]
};
var $03dfb52e075b810f$var$disable = {
    null: []
};
module.exports.contentInitial = $03dfb52e075b810f$var$contentInitial;
module.exports.disable = $03dfb52e075b810f$var$disable;
module.exports.document = $03dfb52e075b810f$var$document;
module.exports.flow = $03dfb52e075b810f$var$flow;
module.exports.flowInitial = $03dfb52e075b810f$var$flowInitial;
module.exports.insideSpan = $03dfb52e075b810f$var$insideSpan;
module.exports.string = $03dfb52e075b810f$var$string;
module.exports.text = $03dfb52e075b810f$var$text;

});
parcelRegister("bZM9j", function(module, exports) {
'use strict';

var $f2fat = parcelRequire("f2fat");

var $cV7wI = parcelRequire("cV7wI");

var $b0OGF = parcelRequire("b0OGF");

var $hZ9Nj = parcelRequire("hZ9Nj");

var $1Q9SC = parcelRequire("1Q9SC");

var $aS1M5 = parcelRequire("aS1M5");
var $8bbabdab1060380b$var$attention = {
    name: 'attention',
    tokenize: $8bbabdab1060380b$var$tokenizeAttention,
    resolveAll: $8bbabdab1060380b$var$resolveAllAttention
};
function $8bbabdab1060380b$var$resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: $hZ9Nj($aS1M5(events[open][1].end), -use),
                end: $aS1M5(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: $aS1M5(events[index][1].start),
                end: $hZ9Nj($aS1M5(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: $aS1M5(events[open][1].end),
                end: $aS1M5(events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: $aS1M5(openingSequence.start),
                end: $aS1M5(closingSequence.end)
            };
            events[open][1].end = $aS1M5(openingSequence.start);
            events[index][1].start = $aS1M5(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = $f2fat(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = $f2fat(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = $f2fat(nextEvents, $1Q9SC(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = $f2fat(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = $f2fat(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            $cV7wI(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
function $8bbabdab1060380b$var$tokenizeAttention(effects, ok) {
    var before = $b0OGF(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter('attentionSequence');
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit('attentionSequence');
        after = $b0OGF(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = $8bbabdab1060380b$var$attention;

});
parcelRegister("b0OGF", function(module, exports) {
'use strict';

var $iDp4A = parcelRequire("iDp4A");

var $cMokS = parcelRequire("cMokS");

var $6x2gg = parcelRequire("6x2gg");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function $80470337b3835068$var$classifyCharacter(code) {
    if (code === null || $iDp4A(code) || $6x2gg(code)) return 1;
    if ($cMokS(code)) return 2;
}
module.exports = $80470337b3835068$var$classifyCharacter;

});
parcelRegister("iDp4A", function(module, exports) {
'use strict';
function $d90f5180b6e1d69f$var$markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = $d90f5180b6e1d69f$var$markdownLineEndingOrSpace;

});

parcelRegister("cMokS", function(module, exports) {
'use strict';

var $34eUw = parcelRequire("34eUw");

var $fwMB1 = parcelRequire("fwMB1");
// In fact adds to the bundle size.
var $94dcd84cd338928a$var$unicodePunctuation = $fwMB1($34eUw);
module.exports = $94dcd84cd338928a$var$unicodePunctuation;

});
parcelRegister("34eUw", function(module, exports) {
'use strict';
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var $23bd4fc1d9d0c447$var$unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = $23bd4fc1d9d0c447$var$unicodePunctuation;

});

parcelRegister("fwMB1", function(module, exports) {
'use strict';

var $hzBBi = parcelRequire("hzBBi");
function $b4df8a546871677f$var$regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test($hzBBi(code));
    }
}
module.exports = $b4df8a546871677f$var$regexCheck;

});


parcelRegister("6x2gg", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $4c1794351598f258$var$unicodeWhitespace = $fwMB1(/\s/);
module.exports = $4c1794351598f258$var$unicodeWhitespace;

});


parcelRegister("hZ9Nj", function(module, exports) {
'use strict';
// chunks (replacement characters, tabs, or line endings).
function $d17fbb213a2e67c4$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = $d17fbb213a2e67c4$var$movePoint;

});


parcelRegister("8D2ZX", function(module, exports) {
'use strict';

var $9OAxp = parcelRequire("9OAxp");

var $5Uxes = parcelRequire("5Uxes");

var $dNZXi = parcelRequire("dNZXi");

var $3Kke3 = parcelRequire("3Kke3");
var $64844aa887be7112$var$autolink = {
    name: 'autolink',
    tokenize: $64844aa887be7112$var$tokenizeAutolink
};
function $64844aa887be7112$var$tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    function open(code) {
        if ($9OAxp(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return $dNZXi(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || $5Uxes(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || $5Uxes(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            return end(code);
        }
        if (code === 32 || code === 60 || $3Kke3(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ($dNZXi(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return $5Uxes(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || $5Uxes(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.exit('autolink');
        return ok;
    }
}
module.exports = $64844aa887be7112$var$autolink;

});
parcelRegister("9OAxp", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $725520383dd8ecd4$var$asciiAlpha = $fwMB1(/[A-Za-z]/);
module.exports = $725520383dd8ecd4$var$asciiAlpha;

});

parcelRegister("5Uxes", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $44dbf5eeadcad228$var$asciiAlphanumeric = $fwMB1(/[\dA-Za-z]/);
module.exports = $44dbf5eeadcad228$var$asciiAlphanumeric;

});

parcelRegister("dNZXi", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $a0cfe90185dbcd0f$var$asciiAtext = $fwMB1(/[#-'*+\--9=?A-Z^-~]/);
module.exports = $a0cfe90185dbcd0f$var$asciiAtext;

});

parcelRegister("3Kke3", function(module, exports) {
'use strict';
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function $2ba55b667c8e32f2$var$asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = $2ba55b667c8e32f2$var$asciiControl;

});


parcelRegister("21oju", function(module, exports) {
'use strict';

var $hUP7l = parcelRequire("hUP7l");

var $aP2DW = parcelRequire("aP2DW");
var $178e88e1534f519a$var$blockQuote = {
    name: 'blockQuote',
    tokenize: $178e88e1534f519a$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $178e88e1534f519a$var$tokenizeBlockQuoteContinuation
    },
    exit: $178e88e1534f519a$var$exit
};
function $178e88e1534f519a$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if ($hUP7l(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
function $178e88e1534f519a$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return $aP2DW(effects, effects.attempt($178e88e1534f519a$var$blockQuote, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function $178e88e1534f519a$var$exit(effects) {
    effects.exit('blockQuote');
}
module.exports = $178e88e1534f519a$var$blockQuote;

});

parcelRegister("hBTAh", function(module, exports) {
'use strict';

var $aufVC = parcelRequire("aufVC");
var $cd21023bf54827d3$var$characterEscape = {
    name: 'characterEscape',
    tokenize: $cd21023bf54827d3$var$tokenizeCharacterEscape
};
function $cd21023bf54827d3$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return open;
    }
    function open(code) {
        if ($aufVC(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $cd21023bf54827d3$var$characterEscape;

});
parcelRegister("aufVC", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $7a290fc132e98542$var$asciiPunctuation = $fwMB1(/[!-/:-@[-`{-~]/);
module.exports = $7a290fc132e98542$var$asciiPunctuation;

});


parcelRegister("kUPHq", function(module, exports) {
'use strict';

var $7kD0n = parcelRequire("7kD0n");

var $5Uxes = parcelRequire("5Uxes");

var $8DRjW = parcelRequire("8DRjW");

var $hNhpA = parcelRequire("hNhpA");
function $f3a1240f0d32e3b4$var$_interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        default: e
    };
}
var $f3a1240f0d32e3b4$var$decodeEntity__default = /*#__PURE__*/ $f3a1240f0d32e3b4$var$_interopDefaultLegacy($7kD0n);
var $f3a1240f0d32e3b4$var$characterReference = {
    name: 'characterReference',
    tokenize: $f3a1240f0d32e3b4$var$tokenizeCharacterReference
};
function $f3a1240f0d32e3b4$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = $5Uxes;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = $hNhpA;
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = $8DRjW;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit('characterReferenceValue');
            if (test === $5Uxes && !$f3a1240f0d32e3b4$var$decodeEntity__default['default'](self.sliceSerialize(token))) return nok(code);
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = $f3a1240f0d32e3b4$var$characterReference;

});
parcelRegister("7kD0n", function(module, exports) {
'use strict';
/* eslint-env browser */ var $5568a845e49a3b88$var$el;
var $5568a845e49a3b88$var$semicolon = 59 //  ';'
;
module.exports = $5568a845e49a3b88$var$decodeEntity;
function $5568a845e49a3b88$var$decodeEntity(characters) {
    var entity = '&' + characters + ';';
    var char;
    $5568a845e49a3b88$var$el = $5568a845e49a3b88$var$el || document.createElement('i');
    $5568a845e49a3b88$var$el.innerHTML = entity;
    char = $5568a845e49a3b88$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $5568a845e49a3b88$var$semicolon && characters !== 'semi') return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});

parcelRegister("8DRjW", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $64ab539d37a2c981$var$asciiDigit = $fwMB1(/\d/);
module.exports = $64ab539d37a2c981$var$asciiDigit;

});

parcelRegister("hNhpA", function(module, exports) {
'use strict';

var $fwMB1 = parcelRequire("fwMB1");
var $cf4484dd86cfd11c$var$asciiHexDigit = $fwMB1(/[\dA-Fa-f]/);
module.exports = $cf4484dd86cfd11c$var$asciiHexDigit;

});


parcelRegister("6hQf1", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $iDp4A = parcelRequire("iDp4A");

var $9L4qe = parcelRequire("9L4qe");

var $aP2DW = parcelRequire("aP2DW");
var $493cda9dae49855b$var$codeFenced = {
    name: 'codeFenced',
    tokenize: $493cda9dae49855b$var$tokenizeCodeFenced,
    concrete: true
};
function $493cda9dae49855b$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = $9L4qe(this.events, 'linePrefix');
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeFencedFenceSequence');
        return sizeOpen < 3 ? nok(code) : $aP2DW(effects, infoOpen, 'whitespace')(code);
    }
    function infoOpen(code) {
        if (code === null || $haNiV(code)) return openAfter(code);
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    function info(code) {
        if (code === null || $iDp4A(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return $aP2DW(effects, infoAfter, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || $haNiV(code)) return openAfter(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || $haNiV(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit('codeFencedFence');
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? $aP2DW(effects, content, 'linePrefix', initialPrefix + 1) : content);
        }
        effects.enter('codeFlowValue');
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || $haNiV(code)) {
            effects.exit('codeFlowValue');
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return $aP2DW(effects, closingSequenceStart, 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter('codeFencedFence');
            effects.enter('codeFencedFenceSequence');
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit('codeFencedFenceSequence');
            return $aP2DW(effects, closingSequenceEnd, 'whitespace')(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || $haNiV(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = $493cda9dae49855b$var$codeFenced;

});

parcelRegister("kvsMV", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $cV7wI = parcelRequire("cV7wI");

var $9L4qe = parcelRequire("9L4qe");

var $aP2DW = parcelRequire("aP2DW");
var $03da465530dd2db6$var$codeIndented = {
    name: 'codeIndented',
    tokenize: $03da465530dd2db6$var$tokenizeCodeIndented,
    resolve: $03da465530dd2db6$var$resolveCodeIndented
};
var $03da465530dd2db6$var$indentedContentConstruct = {
    tokenize: $03da465530dd2db6$var$tokenizeIndentedContent,
    partial: true
};
function $03da465530dd2db6$var$resolveCodeIndented(events, context) {
    var code = {
        type: 'codeIndented',
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    $cV7wI(events, 0, 0, [
        [
            'enter',
            code,
            context
        ]
    ]);
    $cV7wI(events, events.length, 0, [
        [
            'exit',
            code,
            context
        ]
    ]);
    return events;
}
function $03da465530dd2db6$var$tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt($03da465530dd2db6$var$indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if ($haNiV(code)) return effects.attempt($03da465530dd2db6$var$indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter('codeFlowValue');
        return content(code);
    }
    function content(code) {
        if (code === null || $haNiV(code)) {
            effects.exit('codeFlowValue');
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function $03da465530dd2db6$var$tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return $aP2DW(effects, afterPrefix, 'linePrefix', 5);
    function afterPrefix(code) {
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return $aP2DW(effects, afterPrefix, 'linePrefix', 5);
        }
        return $9L4qe(self.events, 'linePrefix') < 4 ? nok(code) : ok(code);
    }
}
module.exports = $03da465530dd2db6$var$codeIndented;

});

parcelRegister("7mP7E", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");
var $55d23e54a538c457$var$codeText = {
    name: 'codeText',
    tokenize: $55d23e54a538c457$var$tokenizeCodeText,
    resolve: $55d23e54a538c457$var$resolveCodeText,
    previous: $55d23e54a538c457$var$previous
};
function $55d23e54a538c457$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function $55d23e54a538c457$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
function $55d23e54a538c457$var$tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit('codeTextSequence');
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return gap;
        }
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return gap;
        } // Data.
        effects.enter('codeTextData');
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || $haNiV(code)) {
            effects.exit('codeTextData');
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        } // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}
module.exports = $55d23e54a538c457$var$codeText;

});

parcelRegister("alpyD", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $iDp4A = parcelRequire("iDp4A");

var $as1T9 = parcelRequire("as1T9");

var $cfOVd = parcelRequire("cfOVd");

var $iLad3 = parcelRequire("iLad3");

var $aP2DW = parcelRequire("aP2DW");

var $8BorE = parcelRequire("8BorE");

var $3PJRh = parcelRequire("3PJRh");
var $787fb0be363a8a08$var$definition = {
    name: 'definition',
    tokenize: $787fb0be363a8a08$var$tokenizeDefinition
};
var $787fb0be363a8a08$var$titleConstruct = {
    tokenize: $787fb0be363a8a08$var$tokenizeTitle,
    partial: true
};
function $787fb0be363a8a08$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter('definition');
        return $iLad3.call(self, effects, labelAfter, nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    function labelAfter(code) {
        identifier = $as1T9(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker') // Note: blank lines can’t exist in content.
            ;
            return $8BorE(effects, $cfOVd(effects, effects.attempt($787fb0be363a8a08$var$titleConstruct, $aP2DW(effects, after, 'whitespace'), $aP2DW(effects, after, 'whitespace')), nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString'));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || $haNiV(code)) {
            effects.exit('definition');
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function $787fb0be363a8a08$var$tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return $iDp4A(code) ? $8BorE(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return $3PJRh(effects, $aP2DW(effects, after, 'whitespace'), nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
        return nok(code);
    }
    function after(code) {
        return code === null || $haNiV(code) ? ok(code) : nok(code);
    }
}
module.exports = $787fb0be363a8a08$var$definition;

});
parcelRegister("cfOVd", function(module, exports) {
'use strict';

var $3Kke3 = parcelRequire("3Kke3");

var $iDp4A = parcelRequire("iDp4A");

var $haNiV = parcelRequire("haNiV");
// eslint-disable-next-line max-params
function $8ebe62c408d10f68$var$destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if ($3Kke3(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || $haNiV(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit('chunkString');
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || $iDp4A(code)) {
            if (balance) return nok(code);
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ($3Kke3(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = $8ebe62c408d10f68$var$destinationFactory;

});

parcelRegister("iLad3", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $hUP7l = parcelRequire("hUP7l");
// eslint-disable-next-line max-params
function $da84892f53204e5e$var$labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || $haNiV(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !$hUP7l(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = $da84892f53204e5e$var$labelFactory;

});

parcelRegister("8BorE", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $hUP7l = parcelRequire("hUP7l");

var $aP2DW = parcelRequire("aP2DW");
function $6434bdae37cdefde$var$whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ($hUP7l(code)) return $aP2DW(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}
module.exports = $6434bdae37cdefde$var$whitespaceFactory;

});

parcelRegister("3PJRh", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $aP2DW = parcelRequire("aP2DW");
function $2ca9b5057ad68285$var$titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return $aP2DW(effects, atTitleBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || $haNiV(code)) {
            effects.exit('chunkString');
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = $2ca9b5057ad68285$var$titleFactory;

});


parcelRegister("2pgEX", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");
var $1c0ad6cdf51946f8$var$hardBreakEscape = {
    name: 'hardBreakEscape',
    tokenize: $1c0ad6cdf51946f8$var$tokenizeHardBreakEscape
};
function $1c0ad6cdf51946f8$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('hardBreakEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if ($haNiV(code)) {
            effects.exit('escapeMarker');
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $1c0ad6cdf51946f8$var$hardBreakEscape;

});

parcelRegister("ftd6z", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $iDp4A = parcelRequire("iDp4A");

var $hUP7l = parcelRequire("hUP7l");

var $cV7wI = parcelRequire("cV7wI");

var $aP2DW = parcelRequire("aP2DW");
var $b433bad2d69fc152$var$headingAtx = {
    name: 'headingAtx',
    tokenize: $b433bad2d69fc152$var$tokenizeHeadingAtx,
    resolve: $b433bad2d69fc152$var$resolveHeadingAtx
};
function $b433bad2d69fc152$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        $cV7wI(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
function $b433bad2d69fc152$var$tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter('atxHeading');
        effects.enter('atxHeadingSequence');
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || $iDp4A(code)) {
            effects.exit('atxHeadingSequence');
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequence(code);
        }
        if (code === null || $haNiV(code)) {
            effects.exit('atxHeading');
            return ok(code);
        }
        if ($hUP7l(code)) return $aP2DW(effects, headingBreak, 'whitespace')(code);
        effects.enter('atxHeadingText');
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit('atxHeadingSequence');
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || $iDp4A(code)) {
            effects.exit('atxHeadingText');
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = $b433bad2d69fc152$var$headingAtx;

});

parcelRegister("2tDVB", function(module, exports) {
'use strict';

var $9OAxp = parcelRequire("9OAxp");

var $5Uxes = parcelRequire("5Uxes");

var $haNiV = parcelRequire("haNiV");

var $iDp4A = parcelRequire("iDp4A");

var $hUP7l = parcelRequire("hUP7l");

var $hzBBi = parcelRequire("hzBBi");

var $6ab2z = parcelRequire("6ab2z");

var $7Qod8 = parcelRequire("7Qod8");

var $7Mwhu = parcelRequire("7Mwhu");
var $1cdd43129ab0b79c$var$htmlFlow = {
    name: 'htmlFlow',
    tokenize: $1cdd43129ab0b79c$var$tokenizeHtmlFlow,
    resolveTo: $1cdd43129ab0b79c$var$resolveToHtmlFlow,
    concrete: true
};
var $1cdd43129ab0b79c$var$nextBlankConstruct = {
    tokenize: $1cdd43129ab0b79c$var$tokenizeNextBlank,
    partial: true
};
function $1cdd43129ab0b79c$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function $1cdd43129ab0b79c$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ($9OAxp(code)) {
            effects.consume(code);
            buffer = $hzBBi(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = 'CDATA[';
            index = 0;
            return cdataOpenInside;
        }
        if ($9OAxp(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if ($9OAxp(code)) {
            effects.consume(code);
            buffer = $hzBBi(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || $iDp4A(code)) {
            if (code !== 47 && startTag && $7Qod8.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ($6ab2z.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || $5Uxes(code)) {
            effects.consume(code);
            buffer += $hzBBi(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if ($hUP7l(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || $9OAxp(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $5Uxes(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || $haNiV(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || $iDp4A(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || $hUP7l(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if ($hUP7l(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || $haNiV(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ($haNiV(code) && (kind === 6 || kind === 7)) return effects.check($1cdd43129ab0b79c$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || $haNiV(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit('htmlFlowData');
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ($haNiV(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return htmlContinueStart;
        }
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && $7Qod8.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if ($9OAxp(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += $hzBBi(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || $haNiV(code)) {
            effects.exit('htmlFlowData');
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit('htmlFlow');
        return ok(code);
    }
}
function $1cdd43129ab0b79c$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit('htmlFlowData');
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        return effects.attempt($7Mwhu, ok, nok);
    }
}
module.exports = $1cdd43129ab0b79c$var$htmlFlow;

});
parcelRegister("6ab2z", function(module, exports) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $47cc3da676a9222b$var$basics = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
module.exports = $47cc3da676a9222b$var$basics;

});

parcelRegister("7Qod8", function(module, exports) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $5b602b7fc35ea078$var$raws = [
    'pre',
    'script',
    'style',
    'textarea'
];
module.exports = $5b602b7fc35ea078$var$raws;

});


parcelRegister("9ufqp", function(module, exports) {
'use strict';

var $9OAxp = parcelRequire("9OAxp");

var $5Uxes = parcelRequire("5Uxes");

var $haNiV = parcelRequire("haNiV");

var $iDp4A = parcelRequire("iDp4A");

var $hUP7l = parcelRequire("hUP7l");

var $aP2DW = parcelRequire("aP2DW");
var $6e82e1749b7908fe$var$htmlText = {
    name: 'htmlText',
    tokenize: $6e82e1749b7908fe$var$tokenizeHtmlText
};
function $6e82e1749b7908fe$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ($9OAxp(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = 'CDATA[';
            index = 0;
            return cdataOpen;
        }
        if ($9OAxp(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ($haNiV(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ($haNiV(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ($haNiV(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ($haNiV(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if ($9OAxp(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || $5Uxes(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if ($haNiV(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || $5Uxes(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || $iDp4A(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || $9OAxp(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ($haNiV(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $5Uxes(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ($haNiV(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ($haNiV(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ($hUP7l(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ($haNiV(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || $iDp4A(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || $iDp4A(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $aP2DW(effects, afterPrefix, 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $6e82e1749b7908fe$var$htmlText;

});

parcelRegister("4Sy7e", function(module, exports) {
'use strict';

var $iDp4A = parcelRequire("iDp4A");

var $f2fat = parcelRequire("f2fat");

var $cV7wI = parcelRequire("cV7wI");

var $as1T9 = parcelRequire("as1T9");

var $1Q9SC = parcelRequire("1Q9SC");

var $aS1M5 = parcelRequire("aS1M5");

var $cfOVd = parcelRequire("cfOVd");

var $iLad3 = parcelRequire("iLad3");

var $3PJRh = parcelRequire("3PJRh");

var $8BorE = parcelRequire("8BorE");
var $38d6ab36735c358f$var$labelEnd = {
    name: 'labelEnd',
    tokenize: $38d6ab36735c358f$var$tokenizeLabelEnd,
    resolveTo: $38d6ab36735c358f$var$resolveToLabelEnd,
    resolveAll: $38d6ab36735c358f$var$resolveAllLabelEnd
};
var $38d6ab36735c358f$var$resourceConstruct = {
    tokenize: $38d6ab36735c358f$var$tokenizeResource
};
var $38d6ab36735c358f$var$fullReferenceConstruct = {
    tokenize: $38d6ab36735c358f$var$tokenizeFullReference
};
var $38d6ab36735c358f$var$collapsedReferenceConstruct = {
    tokenize: $38d6ab36735c358f$var$tokenizeCollapsedReference
};
function $38d6ab36735c358f$var$resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd')) {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
function $38d6ab36735c358f$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: $aS1M5(events[open][1].start),
        end: $aS1M5(events[events.length - 1][1].end)
    };
    label = {
        type: 'label',
        start: $aS1M5(events[open][1].start),
        end: $aS1M5(events[close][1].end)
    };
    text = {
        type: 'labelText',
        start: $aS1M5(events[open + offset + 2][1].end),
        end: $aS1M5(events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = $f2fat(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = $f2fat(media, [
        [
            'enter',
            text,
            context
        ]
    ]) // Between.
    ;
    media = $f2fat(media, $1Q9SC(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = $f2fat(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = $f2fat(media, events.slice(close + 1)) // Media close.
    ;
    media = $f2fat(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    $cV7wI(events, open, events.length, media);
    return events;
}
function $38d6ab36735c358f$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf($as1T9(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($38d6ab36735c358f$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($38d6ab36735c358f$var$fullReferenceConstruct, ok, defined ? effects.attempt($38d6ab36735c358f$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function $38d6ab36735c358f$var$tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return $8BorE(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return $cfOVd(effects, destinationAfter, nok, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 3)(code);
    }
    function destinationAfter(code) {
        return $iDp4A(code) ? $8BorE(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return $3PJRh(effects, $8BorE(effects, end), nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
function $38d6ab36735c358f$var$tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return $iLad3.call(self, effects, afterLabel, nok, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf($as1T9(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function $38d6ab36735c358f$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}
module.exports = $38d6ab36735c358f$var$labelEnd;

});

parcelRegister("cO4BK", function(module, exports) {
'use strict';

var $4Sy7e = parcelRequire("4Sy7e");
var $952dba9713438d69$var$labelStartImage = {
    name: 'labelStartImage',
    tokenize: $952dba9713438d69$var$tokenizeLabelStartImage,
    resolveAll: $4Sy7e.resolveAll
};
function $952dba9713438d69$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $952dba9713438d69$var$labelStartImage;

});

parcelRegister("i0FOh", function(module, exports) {
'use strict';

var $4Sy7e = parcelRequire("4Sy7e");
var $d1c8a8ae01f2c295$var$labelStartLink = {
    name: 'labelStartLink',
    tokenize: $d1c8a8ae01f2c295$var$tokenizeLabelStartLink,
    resolveAll: $4Sy7e.resolveAll
};
function $d1c8a8ae01f2c295$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $d1c8a8ae01f2c295$var$labelStartLink;

});

parcelRegister("dL8bm", function(module, exports) {
'use strict';

var $aP2DW = parcelRequire("aP2DW");
var $a04602fb77127832$var$lineEnding = {
    name: 'lineEnding',
    tokenize: $a04602fb77127832$var$tokenizeLineEnding
};
function $a04602fb77127832$var$tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return $aP2DW(effects, ok, 'linePrefix');
    }
}
module.exports = $a04602fb77127832$var$lineEnding;

});

parcelRegister("1YVbb", function(module, exports) {
'use strict';

var $8DRjW = parcelRequire("8DRjW");

var $hUP7l = parcelRequire("hUP7l");

var $9L4qe = parcelRequire("9L4qe");

var $25Upe = parcelRequire("25Upe");

var $aP2DW = parcelRequire("aP2DW");

var $7Mwhu = parcelRequire("7Mwhu");

var $6E6c1 = parcelRequire("6E6c1");
var $1717bfae4c56df1c$var$list = {
    name: 'list',
    tokenize: $1717bfae4c56df1c$var$tokenizeListStart,
    continuation: {
        tokenize: $1717bfae4c56df1c$var$tokenizeListContinuation
    },
    exit: $1717bfae4c56df1c$var$tokenizeListEnd
};
var $1717bfae4c56df1c$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $1717bfae4c56df1c$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
var $1717bfae4c56df1c$var$indentConstruct = {
    tokenize: $1717bfae4c56df1c$var$tokenizeIndent,
    partial: true
};
function $1717bfae4c56df1c$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = $9L4qe(self.events, 'linePrefix');
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : $8DRjW(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check($6E6c1, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if ($8DRjW(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check($7Mwhu, self.interrupt ? nok : onBlank, effects.attempt($1717bfae4c56df1c$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if ($hUP7l(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + $25Upe(self.sliceStream(effects.exit('listItemPrefix')));
        return ok(code);
    }
}
function $1717bfae4c56df1c$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check($7Mwhu, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return $aP2DW(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !$hUP7l(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt($1717bfae4c56df1c$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return $aP2DW(effects, effects.attempt($1717bfae4c56df1c$var$list, ok, nok), 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4)(code);
    }
}
function $1717bfae4c56df1c$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return $aP2DW(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    function afterPrefix(code) {
        return $9L4qe(self.events, 'listItemIndent') === self.containerState.size ? ok(code) : nok(code);
    }
}
function $1717bfae4c56df1c$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function $1717bfae4c56df1c$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return $aP2DW(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 5);
    function afterPrefix(code) {
        return $hUP7l(code) || !$9L4qe(self.events, 'listItemPrefixWhitespace') ? nok(code) : ok(code);
    }
}
module.exports = $1717bfae4c56df1c$var$list;

});
parcelRegister("6E6c1", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $hUP7l = parcelRequire("hUP7l");

var $aP2DW = parcelRequire("aP2DW");
var $4d6b484931fcd81f$var$thematicBreak = {
    name: 'thematicBreak',
    tokenize: $4d6b484931fcd81f$var$tokenizeThematicBreak
};
function $4d6b484931fcd81f$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('thematicBreak');
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if ($hUP7l(code)) return $aP2DW(effects, atBreak, 'whitespace')(code);
        if (size < 3 || code !== null && !$haNiV(code)) return nok(code);
        effects.exit('thematicBreak');
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return atBreak(code);
    }
}
module.exports = $4d6b484931fcd81f$var$thematicBreak;

});


parcelRegister("9KmeU", function(module, exports) {
'use strict';

var $haNiV = parcelRequire("haNiV");

var $aS1M5 = parcelRequire("aS1M5");

var $aP2DW = parcelRequire("aP2DW");
var $7189a93649e9f0b8$var$setextUnderline = {
    name: 'setextUnderline',
    tokenize: $7189a93649e9f0b8$var$tokenizeSetextUnderline,
    resolveTo: $7189a93649e9f0b8$var$resolveToSetextUnderline
};
function $7189a93649e9f0b8$var$resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    heading = {
        type: 'setextHeading',
        start: $aS1M5(events[text][1].start),
        end: $aS1M5(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = $aS1M5(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
function $7189a93649e9f0b8$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
        paragraph = self.events[index][1].type === 'paragraph';
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            effects.enter('setextHeadingLineSequence');
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit('setextHeadingLineSequence');
        return $aP2DW(effects, closingSequenceEnd, 'lineSuffix')(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || $haNiV(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $7189a93649e9f0b8$var$setextUnderline;

});



parcelRegister("aLFcx", function(module, exports) {
'use strict';
var $7d6e40e40079a8b8$var$search = /[\0\t\n\r]/g;
function $7d6e40e40079a8b8$var$preprocess() {
    var start = true;
    var column = 1;
    var buffer = '';
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $7d6e40e40079a8b8$var$search.lastIndex = startPosition;
            match = $7d6e40e40079a8b8$var$search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = $7d6e40e40079a8b8$var$preprocess;

});

parcelRegister("6st82", function(module, exports) {
'use strict';

var $5P0YF = parcelRequire("5P0YF");
function $4b3bf3f32d6cd161$var$postprocess(events) {
    while(!$5P0YF(events));
    return events;
}
module.exports = $4b3bf3f32d6cd161$var$postprocess;

});


parcelRegister("jLZ37", function(module, exports) {
'use strict';
module.exports = $e651c33bf4085f1d$var$toHast;

var $7Tal1 = parcelRequire("7Tal1");

var $i1KRK = parcelRequire("i1KRK");

var $1r8n7 = parcelRequire("1r8n7");

var $a2nKw = parcelRequire("a2nKw");

var $kjiN1 = parcelRequire("kjiN1");

var $fZnFV = parcelRequire("fZnFV");

var $5OlNN = parcelRequire("5OlNN");

var $2YRmg = parcelRequire("2YRmg");
var $e651c33bf4085f1d$var$own = {}.hasOwnProperty;
var $e651c33bf4085f1d$var$deprecationWarningIssued = false;
// Factory to transform.
function $e651c33bf4085f1d$var$factory(tree, options) {
    var settings = options || {};
    // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
    if (settings.allowDangerousHTML !== undefined && !$e651c33bf4085f1d$var$deprecationWarningIssued) {
        $e651c33bf4085f1d$var$deprecationWarningIssued = true;
        console.warn('mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead');
    }
    var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = $kjiN1(tree);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = Object.assign({}, $2YRmg, settings.handlers);
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    $i1KRK(tree, 'footnoteDefinition', onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && left.data) {
            data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = Object.assign({}, right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!$a2nKw(ctx)) right.position = {
            start: $1r8n7.start(ctx),
            end: $1r8n7.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === 'object' && 'length' in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$e651c33bf4085f1d$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function $e651c33bf4085f1d$var$toHast(tree, options) {
    var h = $e651c33bf4085f1d$var$factory(tree, options);
    var node = $fZnFV(h, tree);
    var foot = $5OlNN(h);
    if (foot) node.children = node.children.concat($7Tal1('text', '\n'), foot);
    return node;
}

});
parcelRegister("7Tal1", function(module, exports) {
'use strict';
module.exports = $5be5b05da58a6a55$var$u;
function $5be5b05da58a6a55$var$u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== 'object' || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = Object.assign({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

});

parcelRegister("i1KRK", function(module, exports) {
'use strict';
module.exports = $d1fcac8f04d6b69e$var$visit;

var $elV5u = parcelRequire("elV5u");
var $d1fcac8f04d6b69e$var$CONTINUE = $elV5u.CONTINUE;
var $d1fcac8f04d6b69e$var$SKIP = $elV5u.SKIP;
var $d1fcac8f04d6b69e$var$EXIT = $elV5u.EXIT;
$d1fcac8f04d6b69e$var$visit.CONTINUE = $d1fcac8f04d6b69e$var$CONTINUE;
$d1fcac8f04d6b69e$var$visit.SKIP = $d1fcac8f04d6b69e$var$SKIP;
$d1fcac8f04d6b69e$var$visit.EXIT = $d1fcac8f04d6b69e$var$EXIT;
function $d1fcac8f04d6b69e$var$visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $elV5u(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("elV5u", function(module, exports) {
'use strict';
module.exports = $a72f4f408daef608$var$visitParents;

var $jJLU6 = parcelRequire("jJLU6");

var $logf7 = parcelRequire("logf7");
var $a72f4f408daef608$var$CONTINUE = true;
var $a72f4f408daef608$var$SKIP = 'skip';
var $a72f4f408daef608$var$EXIT = false;
$a72f4f408daef608$var$visitParents.CONTINUE = $a72f4f408daef608$var$CONTINUE;
$a72f4f408daef608$var$visitParents.SKIP = $a72f4f408daef608$var$SKIP;
$a72f4f408daef608$var$visitParents.EXIT = $a72f4f408daef608$var$EXIT;
function $a72f4f408daef608$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $jJLU6(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + $logf7(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $a72f4f408daef608$var$toResult(visitor(node, parents));
                if (result[0] === $a72f4f408daef608$var$EXIT) return result;
            }
            if (node.children && result[0] !== $a72f4f408daef608$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $a72f4f408daef608$var$EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $a72f4f408daef608$var$toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        $a72f4f408daef608$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("jJLU6", function(module, exports) {
'use strict';
module.exports = $e5e760fb685eb61c$var$convert;
function $e5e760fb685eb61c$var$convert(test) {
    if (test == null) return $e5e760fb685eb61c$var$ok;
    if (typeof test === 'string') return $e5e760fb685eb61c$var$typeFactory(test);
    if (typeof test === 'object') return 'length' in test ? $e5e760fb685eb61c$var$anyFactory(test) : $e5e760fb685eb61c$var$allFactory(test);
    if (typeof test === 'function') return test;
    throw new Error('Expected function, string, or object as test');
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $e5e760fb685eb61c$var$allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $e5e760fb685eb61c$var$anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $e5e760fb685eb61c$var$convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $e5e760fb685eb61c$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $e5e760fb685eb61c$var$ok() {
    return true;
}

});

parcelRegister("logf7", function(module, exports) {
module.exports = $f928705b1598656e$var$identity;
function $f928705b1598656e$var$identity(d) {
    return d;
}

});



parcelRegister("1r8n7", function(module, exports) {
'use strict';
var $10bece897585c147$var$start = $10bece897585c147$var$factory('start');
var $10bece897585c147$var$end = $10bece897585c147$var$factory('end');
module.exports = $10bece897585c147$var$position;
$10bece897585c147$var$position.start = $10bece897585c147$var$start;
$10bece897585c147$var$position.end = $10bece897585c147$var$end;
function $10bece897585c147$var$position(node) {
    return {
        start: $10bece897585c147$var$start(node),
        end: $10bece897585c147$var$end(node)
    };
}
function $10bece897585c147$var$factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

});

parcelRegister("a2nKw", function(module, exports) {
'use strict';
module.exports = $74ec836ab00919ff$var$generated;
function $74ec836ab00919ff$var$generated(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRegister("kjiN1", function(module, exports) {
'use strict';

var $i1KRK = parcelRequire("i1KRK");
module.exports = $ec94283666fde58e$var$getDefinitionFactory;
var $ec94283666fde58e$var$own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function $ec94283666fde58e$var$getDefinitionFactory(node, options) {
    return $ec94283666fde58e$var$getterFactory($ec94283666fde58e$var$gather(node, options));
}
// Gather all definitions in `node`
function $ec94283666fde58e$var$gather(node) {
    var cache = {};
    if (!node || !node.type) throw new Error('mdast-util-definitions expected node');
    $i1KRK(node, 'definition', ondefinition);
    return cache;
    function ondefinition(definition) {
        var id = $ec94283666fde58e$var$normalise(definition.identifier);
        if (!$ec94283666fde58e$var$own.call(cache, id)) cache[id] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function $ec94283666fde58e$var$getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && $ec94283666fde58e$var$normalise(identifier);
        return id && $ec94283666fde58e$var$own.call(cache, id) ? cache[id] : null;
    }
}
function $ec94283666fde58e$var$normalise(identifier) {
    return identifier.toUpperCase();
}

});

parcelRegister("fZnFV", function(module, exports) {
'use strict';
module.exports = $ba3eeaea9d1826d9$var$one;

var $7Tal1 = parcelRequire("7Tal1");

var $cPXJW = parcelRequire("cPXJW");
var $ba3eeaea9d1826d9$var$own = {}.hasOwnProperty;
// Transform an unknown node.
function $ba3eeaea9d1826d9$var$unknown(h, node) {
    if ($ba3eeaea9d1826d9$var$text(node)) return h.augment(node, $7Tal1('text', node.value));
    return h(node, 'div', $cPXJW(h, node));
}
// Visit a node.
function $ba3eeaea9d1826d9$var$one(h, node, parent) {
    var type = node && node.type;
    var fn;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if ($ba3eeaea9d1826d9$var$own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.indexOf(type) > -1) fn = $ba3eeaea9d1826d9$var$returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === 'function' ? fn : $ba3eeaea9d1826d9$var$unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function $ba3eeaea9d1826d9$var$text(node) {
    var data = node.data || {};
    if ($ba3eeaea9d1826d9$var$own.call(data, 'hName') || $ba3eeaea9d1826d9$var$own.call(data, 'hProperties') || $ba3eeaea9d1826d9$var$own.call(data, 'hChildren')) return false;
    return 'value' in node;
}
function $ba3eeaea9d1826d9$var$returnNode(h, node) {
    var clone;
    if (node.children) {
        clone = Object.assign({}, node);
        clone.children = $cPXJW(h, node);
        return clone;
    }
    return node;
}

});
parcelRegister("cPXJW", function(module, exports) {
'use strict';
module.exports = $9588969881b1295c$var$all;

var $fZnFV = parcelRequire("fZnFV");
function $9588969881b1295c$var$all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = $fZnFV(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === 'break') {
                if (result.value) result.value = result.value.replace(/^\s+/, '');
                head = result.children && result.children[0];
                if (head && head.value) head.value = head.value.replace(/^\s+/, '');
            }
            values = values.concat(result);
        }
    }
    return values;
}

});


parcelRegister("5OlNN", function(module, exports) {
'use strict';
module.exports = $43b288b5d784432f$var$generateFootnotes;

var $cnGZN = parcelRequire("cnGZN");

var $9nVoC = parcelRequire("9nVoC");

var $8vlEq = parcelRequire("8vlEq");
function $43b288b5d784432f$var$generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: 'link',
            url: '#fnref-' + def.identifier,
            data: {
                hProperties: {
                    className: [
                        'footnote-backref'
                    ]
                }
            },
            children: [
                {
                    type: 'text',
                    value: "\u21A9"
                }
            ]
        };
        if (!tail || tail.type !== 'paragraph') {
            tail = {
                type: 'paragraph',
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: 'listItem',
            data: {
                hProperties: {
                    id: 'fn-' + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, 'div', {
        className: [
            'footnotes'
        ]
    }, $8vlEq([
        $cnGZN(h),
        $9nVoC(h, {
            type: 'list',
            ordered: true,
            children: listItems
        })
    ], true));
}

});
parcelRegister("cnGZN", function(module, exports) {
'use strict';
module.exports = $02537fefb8a9d631$var$thematicBreak;
function $02537fefb8a9d631$var$thematicBreak(h, node) {
    return h(node, 'hr');
}

});

parcelRegister("9nVoC", function(module, exports) {
'use strict';
module.exports = $6d52c8b65c22a0f3$var$list;

var $8vlEq = parcelRequire("8vlEq");

var $cPXJW = parcelRequire("cPXJW");
function $6d52c8b65c22a0f3$var$list(h, node) {
    var props = {};
    var name = node.ordered ? 'ol' : 'ul';
    var items;
    var index = -1;
    var length;
    if (typeof node.start === 'number' && node.start !== 1) props.start = node.start;
    items = $cPXJW(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf('task-list-item') !== -1) {
        props.className = [
            'contains-task-list'
        ];
        break;
    }
    return h(node, name, props, $8vlEq(items, true));
}

});
parcelRegister("8vlEq", function(module, exports) {
'use strict';
module.exports = $6312036d85444421$var$wrap;

var $7Tal1 = parcelRequire("7Tal1");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function $6312036d85444421$var$wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push($7Tal1('text', '\n'));
    while(++index < length){
        if (index) result.push($7Tal1('text', '\n'));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push($7Tal1('text', '\n'));
    return result;
}

});



parcelRegister("2YRmg", function(module, exports) {
'use strict';






















module.exports = {
    blockquote: (parcelRequire("19M7I")),
    break: (parcelRequire("8csaV")),
    code: (parcelRequire("dGTos")),
    delete: (parcelRequire("6OXI0")),
    emphasis: (parcelRequire("9L7N6")),
    footnoteReference: (parcelRequire("hT1R6")),
    footnote: (parcelRequire("fmRjw")),
    heading: (parcelRequire("b2FpY")),
    html: (parcelRequire("ebILQ")),
    imageReference: (parcelRequire("4xDW2")),
    image: (parcelRequire("ltxKP")),
    inlineCode: (parcelRequire("dRX9X")),
    linkReference: (parcelRequire("8eXiN")),
    link: (parcelRequire("d1oC8")),
    listItem: (parcelRequire("11GXx")),
    list: (parcelRequire("9nVoC")),
    paragraph: (parcelRequire("5hX5r")),
    root: (parcelRequire("cxBlE")),
    strong: (parcelRequire("ad65M")),
    table: (parcelRequire("glYDL")),
    text: (parcelRequire("hdLPH")),
    thematicBreak: (parcelRequire("cnGZN")),
    toml: $22ba932f8fab6e62$var$ignore,
    yaml: $22ba932f8fab6e62$var$ignore,
    definition: $22ba932f8fab6e62$var$ignore,
    footnoteDefinition: $22ba932f8fab6e62$var$ignore
};
// Return nothing for nodes that are ignored.
function $22ba932f8fab6e62$var$ignore() {
    return null;
}

});
parcelRegister("19M7I", function(module, exports) {
'use strict';
module.exports = $0d7bf6069cd4a99d$var$blockquote;

var $8vlEq = parcelRequire("8vlEq");

var $cPXJW = parcelRequire("cPXJW");
function $0d7bf6069cd4a99d$var$blockquote(h, node) {
    return h(node, 'blockquote', $8vlEq($cPXJW(h, node), true));
}

});

parcelRegister("8csaV", function(module, exports) {
'use strict';
module.exports = $5f854cb469f7f6cd$var$hardBreak;

var $7Tal1 = parcelRequire("7Tal1");
function $5f854cb469f7f6cd$var$hardBreak(h, node) {
    return [
        h(node, 'br'),
        $7Tal1('text', '\n')
    ];
}

});

parcelRegister("dGTos", function(module, exports) {
'use strict';
module.exports = $9f7a2a9a3e8cdc0a$var$code;

var $7Tal1 = parcelRequire("7Tal1");
function $9f7a2a9a3e8cdc0a$var$code(h, node) {
    var value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    var code;
    if (lang) props.className = [
        'language-' + lang
    ];
    code = h(node, 'code', props, [
        $7Tal1('text', value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, 'pre', [
        code
    ]);
}

});

parcelRegister("6OXI0", function(module, exports) {
'use strict';
module.exports = $4f75ba80b35d3487$var$strikethrough;

var $cPXJW = parcelRequire("cPXJW");
function $4f75ba80b35d3487$var$strikethrough(h, node) {
    return h(node, 'del', $cPXJW(h, node));
}

});

parcelRegister("9L7N6", function(module, exports) {
'use strict';
module.exports = $71ae8bf40e51fddd$var$emphasis;

var $cPXJW = parcelRequire("cPXJW");
function $71ae8bf40e51fddd$var$emphasis(h, node) {
    return h(node, 'em', $cPXJW(h, node));
}

});

parcelRegister("hT1R6", function(module, exports) {
'use strict';
module.exports = $d059032a2037e72d$var$footnoteReference;

var $7Tal1 = parcelRequire("7Tal1");
function $d059032a2037e72d$var$footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, 'sup', {
        id: 'fnref-' + identifier
    }, [
        h(node, 'a', {
            href: '#fn-' + identifier,
            className: [
                'footnote-ref'
            ]
        }, [
            $7Tal1('text', node.label || identifier)
        ])
    ]);
}

});

parcelRegister("fmRjw", function(module, exports) {
'use strict';
module.exports = $b302441aef2a42d1$var$footnote;

var $hT1R6 = parcelRequire("hT1R6");
function $b302441aef2a42d1$var$footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return $hT1R6(h, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("b2FpY", function(module, exports) {
'use strict';
module.exports = $80a0025fee2734a4$var$heading;

var $cPXJW = parcelRequire("cPXJW");
function $80a0025fee2734a4$var$heading(h, node) {
    return h(node, 'h' + node.depth, $cPXJW(h, node));
}

});

parcelRegister("ebILQ", function(module, exports) {
'use strict';
module.exports = $a544d24f31a6d015$var$html;

var $7Tal1 = parcelRequire("7Tal1");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function $a544d24f31a6d015$var$html(h, node) {
    return h.dangerous ? h.augment(node, $7Tal1('raw', node.value)) : null;
}

});

parcelRegister("4xDW2", function(module, exports) {
'use strict';
module.exports = $34e938c73615b97e$var$imageReference;

var $dMZD4 = parcelRequire("dMZD4");

var $5XWq3 = parcelRequire("5XWq3");
function $34e938c73615b97e$var$imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $5XWq3(h, node);
    props = {
        src: $dMZD4(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'img', props);
}

});
parcelRegister("dMZD4", function(module, exports) {
'use strict';
var $a09f9057097f68d0$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a09f9057097f68d0$var$getEncodeCache(exclude) {
    var i, ch, cache = $a09f9057097f68d0$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a09f9057097f68d0$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a09f9057097f68d0$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a09f9057097f68d0$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $a09f9057097f68d0$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a09f9057097f68d0$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a09f9057097f68d0$var$encode.componentChars = "-_.!~*'()";
module.exports = $a09f9057097f68d0$var$encode;

});

parcelRegister("5XWq3", function(module, exports) {
'use strict';
module.exports = $457fc7453091eab4$var$revert;

var $7Tal1 = parcelRequire("7Tal1");

var $cPXJW = parcelRequire("cPXJW");
// Return the content of a reference without definition as Markdown.
function $457fc7453091eab4$var$revert(h, node) {
    var subtype = node.referenceType;
    var suffix = ']';
    var contents;
    var head;
    var tail;
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return $7Tal1('text', '![' + node.alt + suffix);
    contents = $cPXJW(h, node);
    head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift($7Tal1('text', '['));
    tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push($7Tal1('text', suffix));
    return contents;
}

});


parcelRegister("ltxKP", function(module, exports) {
'use strict';

var $dMZD4 = parcelRequire("dMZD4");
module.exports = $fa267d4e016e1a94$var$image;
function $fa267d4e016e1a94$var$image(h, node) {
    var props = {
        src: $dMZD4(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'img', props);
}

});

parcelRegister("dRX9X", function(module, exports) {
'use strict';
module.exports = $a18e1d7c380780d4$var$inlineCode;

var $7Tal1 = parcelRequire("7Tal1");
function $a18e1d7c380780d4$var$inlineCode(h, node) {
    var value = node.value.replace(/\r?\n|\r/g, ' ');
    return h(node, 'code', [
        $7Tal1('text', value)
    ]);
}

});

parcelRegister("8eXiN", function(module, exports) {
'use strict';
module.exports = $5ffda1b647f76013$var$linkReference;

var $dMZD4 = parcelRequire("dMZD4");

var $5XWq3 = parcelRequire("5XWq3");

var $cPXJW = parcelRequire("cPXJW");
function $5ffda1b647f76013$var$linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return $5XWq3(h, node);
    props = {
        href: $dMZD4(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'a', props, $cPXJW(h, node));
}

});

parcelRegister("d1oC8", function(module, exports) {
'use strict';

var $dMZD4 = parcelRequire("dMZD4");

var $cPXJW = parcelRequire("cPXJW");
module.exports = $97ae763275816d1f$var$link;
function $97ae763275816d1f$var$link(h, node) {
    var props = {
        href: $dMZD4(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'a', props, $cPXJW(h, node));
}

});

parcelRegister("11GXx", function(module, exports) {
'use strict';
module.exports = $0bf735405dac3389$var$listItem;

var $7Tal1 = parcelRequire("7Tal1");

var $cPXJW = parcelRequire("cPXJW");
function $0bf735405dac3389$var$listItem(h, node, parent) {
    var result = $cPXJW(h, node);
    var head = result[0];
    var loose = parent ? $0bf735405dac3389$var$listLoose(parent) : $0bf735405dac3389$var$listItemLoose(node);
    var props = {};
    var wrapped = [];
    var length;
    var index;
    var child;
    if (typeof node.checked === 'boolean') {
        if (!head || head.tagName !== 'p') {
            head = h(null, 'p', []);
            result.unshift(head);
        }
        if (head.children.length > 0) head.children.unshift($7Tal1('text', ' '));
        head.children.unshift(h(null, 'input', {
            type: 'checkbox',
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            'task-list-item'
        ];
    }
    length = result.length;
    index = -1;
    while(++index < length){
        child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.tagName !== 'p') wrapped.push($7Tal1('text', '\n'));
        if (child.tagName === 'p' && !loose) wrapped = wrapped.concat(child.children);
        else wrapped.push(child);
    }
    // Add a final eol.
    if (length && (loose || child.tagName !== 'p')) wrapped.push($7Tal1('text', '\n'));
    return h(node, 'li', props, wrapped);
}
function $0bf735405dac3389$var$listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = $0bf735405dac3389$var$listItemLoose(children[index]);
    return loose;
}
function $0bf735405dac3389$var$listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("5hX5r", function(module, exports) {
'use strict';
module.exports = $3d9c5fb20df8334b$var$paragraph;

var $cPXJW = parcelRequire("cPXJW");
function $3d9c5fb20df8334b$var$paragraph(h, node) {
    return h(node, 'p', $cPXJW(h, node));
}

});

parcelRegister("cxBlE", function(module, exports) {
'use strict';
module.exports = $921589a7f49d4b71$var$root;

var $7Tal1 = parcelRequire("7Tal1");

var $8vlEq = parcelRequire("8vlEq");

var $cPXJW = parcelRequire("cPXJW");
function $921589a7f49d4b71$var$root(h, node) {
    return h.augment(node, $7Tal1('root', $8vlEq($cPXJW(h, node))));
}

});

parcelRegister("ad65M", function(module, exports) {
'use strict';
module.exports = $76efd80b61faffa2$var$strong;

var $cPXJW = parcelRequire("cPXJW");
function $76efd80b61faffa2$var$strong(h, node) {
    return h(node, 'strong', $cPXJW(h, node));
}

});

parcelRegister("glYDL", function(module, exports) {
'use strict';
module.exports = $be7da570dd44e9e6$var$table;

var $1r8n7 = parcelRequire("1r8n7");

var $8vlEq = parcelRequire("8vlEq");

var $cPXJW = parcelRequire("cPXJW");
function $be7da570dd44e9e6$var$table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align || [];
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? 'th' : 'td';
        pos = alignLength || row.length;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? $cPXJW(h, cell) : []);
        }
        result[index] = h(rows[index], 'tr', $8vlEq(out, true));
    }
    return h(node, 'table', $8vlEq([
        h(result[0].position, 'thead', $8vlEq([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: $1r8n7.start(result[1]),
        end: $1r8n7.end(result[result.length - 1])
    }, 'tbody', $8vlEq(result.slice(1), true)) : []), true));
}

});

parcelRegister("hdLPH", function(module, exports) {
'use strict';
module.exports = $c898c12a1a7a9791$var$text;

var $7Tal1 = parcelRequire("7Tal1");
function $c898c12a1a7a9791$var$text(h, node) {
    return h.augment(node, $7Tal1('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1')));
}

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = 60103, $6b3372b60d35b33f$var$c = 60106, $6b3372b60d35b33f$var$d = 60107, $6b3372b60d35b33f$var$e = 60108, $6b3372b60d35b33f$var$f = 60114, $6b3372b60d35b33f$var$g = 60109, $6b3372b60d35b33f$var$h = 60110, $6b3372b60d35b33f$var$k = 60112, $6b3372b60d35b33f$var$l = 60113, $6b3372b60d35b33f$var$m = 60120, $6b3372b60d35b33f$var$n = 60115, $6b3372b60d35b33f$var$p = 60116, $6b3372b60d35b33f$var$q = 60121, $6b3372b60d35b33f$var$r = 60122, $6b3372b60d35b33f$var$u = 60117, $6b3372b60d35b33f$var$v = 60129, $6b3372b60d35b33f$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $6b3372b60d35b33f$var$x = Symbol.for;
    $6b3372b60d35b33f$var$b = $6b3372b60d35b33f$var$x("react.element");
    $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$x("react.portal");
    $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$x("react.fragment");
    $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$x("react.strict_mode");
    $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$x("react.profiler");
    $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$x("react.provider");
    $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$x("react.context");
    $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$x("react.forward_ref");
    $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$x("react.suspense");
    $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$x("react.suspense_list");
    $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$x("react.memo");
    $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$x("react.lazy");
    $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$x("react.block");
    $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$x("react.server.block");
    $6b3372b60d35b33f$var$u = $6b3372b60d35b33f$var$x("react.fundamental");
    $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$x("react.debug_trace_mode");
    $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$x("react.legacy_hidden");
}
function $6b3372b60d35b33f$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return t;
        }
    }
}
var $6b3372b60d35b33f$var$z = $6b3372b60d35b33f$var$g, $6b3372b60d35b33f$var$A = $6b3372b60d35b33f$var$b, $6b3372b60d35b33f$var$B = $6b3372b60d35b33f$var$k, $6b3372b60d35b33f$var$C = $6b3372b60d35b33f$var$d, $6b3372b60d35b33f$var$D = $6b3372b60d35b33f$var$p, $6b3372b60d35b33f$var$E = $6b3372b60d35b33f$var$n, $6b3372b60d35b33f$var$F = $6b3372b60d35b33f$var$c, $6b3372b60d35b33f$var$G = $6b3372b60d35b33f$var$f, $6b3372b60d35b33f$var$H = $6b3372b60d35b33f$var$e, $6b3372b60d35b33f$var$I = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$z;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$B;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$C;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$D;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$E;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$F;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$G;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$H;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$I;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$v || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$l || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$w || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$u || a.$$typeof === $6b3372b60d35b33f$var$q || a[0] === $6b3372b60d35b33f$var$r) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$y;

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");





/**
 * react-router v7.18.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $f0eb7f6a0a55da23$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-KS7C4IRE.mjs"
});
var $f0eb7f6a0a55da23$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $f0eb7f6a0a55da23$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $f0eb7f6a0a55da23$var$__typeError("Cannot " + msg);
var $f0eb7f6a0a55da23$var$__privateGet = (obj, member, getter)=>($f0eb7f6a0a55da23$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $f0eb7f6a0a55da23$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $f0eb7f6a0a55da23$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $f0eb7f6a0a55da23$var$__privateSet = (obj, member, value, setter)=>($f0eb7f6a0a55da23$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $f0eb7f6a0a55da23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $f0eb7f6a0a55da23$export$825a82322d91916e = /^[\\/]{2}/;
function $f0eb7f6a0a55da23$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $f0eb7f6a0a55da23$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($f0eb7f6a0a55da23$export$e19cd5f9376f8cee || {});
var $f0eb7f6a0a55da23$var$PopStateEventType = "popstate";
function $f0eb7f6a0a55da23$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $f0eb7f6a0a55da23$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $f0eb7f6a0a55da23$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $f0eb7f6a0a55da23$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $f0eb7f6a0a55da23$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $f0eb7f6a0a55da23$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $f0eb7f6a0a55da23$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $f0eb7f6a0a55da23$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $f0eb7f6a0a55da23$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $f0eb7f6a0a55da23$export$fe53371bee54353d(to);
    }
    return $f0eb7f6a0a55da23$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $f0eb7f6a0a55da23$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f0eb7f6a0a55da23$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f0eb7f6a0a55da23$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f0eb7f6a0a55da23$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $f0eb7f6a0a55da23$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f0eb7f6a0a55da23$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f0eb7f6a0a55da23$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $f0eb7f6a0a55da23$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $f0eb7f6a0a55da23$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $f0eb7f6a0a55da23$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f0eb7f6a0a55da23$var$createKey(),
        mask: mask
    };
    return location;
}
function $f0eb7f6a0a55da23$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f0eb7f6a0a55da23$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $f0eb7f6a0a55da23$var$isLocation(to) ? to : $f0eb7f6a0a55da23$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f0eb7f6a0a55da23$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $f0eb7f6a0a55da23$var$isLocation(to) ? to : $f0eb7f6a0a55da23$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f0eb7f6a0a55da23$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $f0eb7f6a0a55da23$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($f0eb7f6a0a55da23$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($f0eb7f6a0a55da23$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $f0eb7f6a0a55da23$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $f0eb7f6a0a55da23$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $f0eb7f6a0a55da23$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $f0eb7f6a0a55da23$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $f0eb7f6a0a55da23$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $f0eb7f6a0a55da23$var$_map;
var $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $f0eb7f6a0a55da23$var$__privateAdd(this, $f0eb7f6a0a55da23$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_map).has(context)) return $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_map).set(context, value);
    }
};
$f0eb7f6a0a55da23$var$_map = new WeakMap();
var $f0eb7f6a0a55da23$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f0eb7f6a0a55da23$var$isUnsupportedLazyRouteObjectKey(key) {
    return $f0eb7f6a0a55da23$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $f0eb7f6a0a55da23$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $f0eb7f6a0a55da23$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $f0eb7f6a0a55da23$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $f0eb7f6a0a55da23$var$isIndexRoute(route) {
    return route.index === true;
}
function $f0eb7f6a0a55da23$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f0eb7f6a0a55da23$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $f0eb7f6a0a55da23$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($f0eb7f6a0a55da23$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $f0eb7f6a0a55da23$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $f0eb7f6a0a55da23$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $f0eb7f6a0a55da23$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $f0eb7f6a0a55da23$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $f0eb7f6a0a55da23$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $f0eb7f6a0a55da23$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $f0eb7f6a0a55da23$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $f0eb7f6a0a55da23$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $f0eb7f6a0a55da23$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $f0eb7f6a0a55da23$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $f0eb7f6a0a55da23$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $f0eb7f6a0a55da23$var$flattenAndRankRoutes(routes) {
    let branches = $f0eb7f6a0a55da23$var$flattenRoutes(routes);
    $f0eb7f6a0a55da23$var$rankRouteBranches(branches);
    return branches;
}
function $f0eb7f6a0a55da23$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $f0eb7f6a0a55da23$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f0eb7f6a0a55da23$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $f0eb7f6a0a55da23$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $f0eb7f6a0a55da23$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f0eb7f6a0a55da23$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $f0eb7f6a0a55da23$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $f0eb7f6a0a55da23$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $f0eb7f6a0a55da23$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f0eb7f6a0a55da23$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f0eb7f6a0a55da23$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $f0eb7f6a0a55da23$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $f0eb7f6a0a55da23$var$paramRe = /^:[\w-]+$/;
var $f0eb7f6a0a55da23$var$dynamicSegmentValue = 3;
var $f0eb7f6a0a55da23$var$indexRouteValue = 2;
var $f0eb7f6a0a55da23$var$emptySegmentValue = 1;
var $f0eb7f6a0a55da23$var$staticSegmentValue = 10;
var $f0eb7f6a0a55da23$var$splatPenalty = -2;
var $f0eb7f6a0a55da23$var$isSplat = (s)=>s === "*";
function $f0eb7f6a0a55da23$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f0eb7f6a0a55da23$var$isSplat)) initialScore += $f0eb7f6a0a55da23$var$splatPenalty;
    if (index) initialScore += $f0eb7f6a0a55da23$var$indexRouteValue;
    return segments.filter((s)=>!$f0eb7f6a0a55da23$var$isSplat(s)).reduce((score, segment)=>score + ($f0eb7f6a0a55da23$var$paramRe.test(segment) ? $f0eb7f6a0a55da23$var$dynamicSegmentValue : segment === "" ? $f0eb7f6a0a55da23$var$emptySegmentValue : $f0eb7f6a0a55da23$var$staticSegmentValue), initialScore);
}
function $f0eb7f6a0a55da23$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f0eb7f6a0a55da23$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $f0eb7f6a0a55da23$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $f0eb7f6a0a55da23$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f0eb7f6a0a55da23$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f0eb7f6a0a55da23$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f0eb7f6a0a55da23$var$normalizePathname($f0eb7f6a0a55da23$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f0eb7f6a0a55da23$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $f0eb7f6a0a55da23$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f0eb7f6a0a55da23$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $f0eb7f6a0a55da23$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $f0eb7f6a0a55da23$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f0eb7f6a0a55da23$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $f0eb7f6a0a55da23$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $f0eb7f6a0a55da23$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f0eb7f6a0a55da23$var$compilePath(path, caseSensitive = false, end = true) {
    $f0eb7f6a0a55da23$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $f0eb7f6a0a55da23$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f0eb7f6a0a55da23$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $f0eb7f6a0a55da23$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $f0eb7f6a0a55da23$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $f0eb7f6a0a55da23$var$joinPaths([
        basename,
        pathname
    ]);
}
var $f0eb7f6a0a55da23$var$isAbsoluteUrl = (url)=>$f0eb7f6a0a55da23$var$ABSOLUTE_URL_REGEX.test(url);
function $f0eb7f6a0a55da23$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $f0eb7f6a0a55da23$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $f0eb7f6a0a55da23$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $f0eb7f6a0a55da23$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $f0eb7f6a0a55da23$var$normalizeSearch(search),
        hash: $f0eb7f6a0a55da23$var$normalizeHash(hash)
    };
}
function $f0eb7f6a0a55da23$var$resolvePathname(relativePath, fromPathname) {
    let segments = $f0eb7f6a0a55da23$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f0eb7f6a0a55da23$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $f0eb7f6a0a55da23$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $f0eb7f6a0a55da23$var$getResolveToMatches(matches) {
    let pathMatches = $f0eb7f6a0a55da23$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $f0eb7f6a0a55da23$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $f0eb7f6a0a55da23$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $f0eb7f6a0a55da23$var$getInvalidPathError("?", "pathname", "search", to));
        $f0eb7f6a0a55da23$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $f0eb7f6a0a55da23$var$getInvalidPathError("#", "pathname", "hash", to));
        $f0eb7f6a0a55da23$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $f0eb7f6a0a55da23$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f0eb7f6a0a55da23$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $f0eb7f6a0a55da23$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $f0eb7f6a0a55da23$var$joinPaths = (paths)=>$f0eb7f6a0a55da23$var$removeDoubleSlashes(paths.join("/"));
var $f0eb7f6a0a55da23$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $f0eb7f6a0a55da23$var$normalizePathname = (pathname)=>$f0eb7f6a0a55da23$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $f0eb7f6a0a55da23$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $f0eb7f6a0a55da23$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $f0eb7f6a0a55da23$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $f0eb7f6a0a55da23$export$4051a07651545597(data2, init) {
    return new $f0eb7f6a0a55da23$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $f0eb7f6a0a55da23$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $f0eb7f6a0a55da23$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f0eb7f6a0a55da23$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $f0eb7f6a0a55da23$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f0eb7f6a0a55da23$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $f0eb7f6a0a55da23$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $f0eb7f6a0a55da23$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $f0eb7f6a0a55da23$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $f0eb7f6a0a55da23$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $f0eb7f6a0a55da23$var$joinPaths(parts) || "/";
}
var $f0eb7f6a0a55da23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $f0eb7f6a0a55da23$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$f0eb7f6a0a55da23$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($f0eb7f6a0a55da23$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $f0eb7f6a0a55da23$export$825a82322d91916e.test(to) ? new URL($f0eb7f6a0a55da23$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $f0eb7f6a0a55da23$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $f0eb7f6a0a55da23$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $f0eb7f6a0a55da23$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $f0eb7f6a0a55da23$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $f0eb7f6a0a55da23$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $f0eb7f6a0a55da23$var$wrapImpl(aggregated[key], original, (...args)=>$f0eb7f6a0a55da23$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $f0eb7f6a0a55da23$var$wrapImpl(aggregated.middleware, original, (...args)=>$f0eb7f6a0a55da23$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $f0eb7f6a0a55da23$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $f0eb7f6a0a55da23$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $f0eb7f6a0a55da23$export$fe53371bee54353d(to) : ".",
                ...$f0eb7f6a0a55da23$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $f0eb7f6a0a55da23$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$f0eb7f6a0a55da23$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$f0eb7f6a0a55da23$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $f0eb7f6a0a55da23$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $f0eb7f6a0a55da23$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $f0eb7f6a0a55da23$var$getReadonlyRequest(request),
            context: context != null ? $f0eb7f6a0a55da23$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $f0eb7f6a0a55da23$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $f0eb7f6a0a55da23$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $f0eb7f6a0a55da23$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $f0eb7f6a0a55da23$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $f0eb7f6a0a55da23$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $f0eb7f6a0a55da23$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $f0eb7f6a0a55da23$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $f0eb7f6a0a55da23$var$getReadonlyContext(context)
    };
}
function $f0eb7f6a0a55da23$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $f0eb7f6a0a55da23$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $f0eb7f6a0a55da23$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $f0eb7f6a0a55da23$var$getReadonlyContext(context) {
    if ($f0eb7f6a0a55da23$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $f0eb7f6a0a55da23$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $f0eb7f6a0a55da23$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $f0eb7f6a0a55da23$var$objectProtoNames;
}
// lib/router/router.ts
var $f0eb7f6a0a55da23$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $f0eb7f6a0a55da23$var$validMutationMethods = new Set($f0eb7f6a0a55da23$var$validMutationMethodsArr);
var $f0eb7f6a0a55da23$var$validRequestMethodsArr = [
    "GET",
    ...$f0eb7f6a0a55da23$var$validMutationMethodsArr
];
var $f0eb7f6a0a55da23$var$validRequestMethods = new Set($f0eb7f6a0a55da23$var$validRequestMethodsArr);
var $f0eb7f6a0a55da23$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $f0eb7f6a0a55da23$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $f0eb7f6a0a55da23$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $f0eb7f6a0a55da23$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $f0eb7f6a0a55da23$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $f0eb7f6a0a55da23$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $f0eb7f6a0a55da23$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $f0eb7f6a0a55da23$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $f0eb7f6a0a55da23$var$_routes, $f0eb7f6a0a55da23$var$_branches, $f0eb7f6a0a55da23$var$_hmrRoutes, $f0eb7f6a0a55da23$var$_hmrBranches;
var $f0eb7f6a0a55da23$var$DataRoutes = class {
    constructor(routes){
        $f0eb7f6a0a55da23$var$__privateAdd(this, $f0eb7f6a0a55da23$var$_routes);
        $f0eb7f6a0a55da23$var$__privateAdd(this, $f0eb7f6a0a55da23$var$_branches);
        $f0eb7f6a0a55da23$var$__privateAdd(this, $f0eb7f6a0a55da23$var$_hmrRoutes);
        $f0eb7f6a0a55da23$var$__privateAdd(this, $f0eb7f6a0a55da23$var$_hmrBranches);
        $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_routes, routes);
        $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_branches, $f0eb7f6a0a55da23$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_hmrRoutes) ?? $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_hmrBranches) ?? $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_branches);
    }
    get hasHMRRoutes() {
        return $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_routes, routes);
        $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_branches, $f0eb7f6a0a55da23$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_hmrRoutes, routes);
        $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_hmrBranches, $f0eb7f6a0a55da23$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_hmrRoutes)) {
            $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_routes, $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_hmrRoutes));
            $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_branches, $f0eb7f6a0a55da23$var$__privateGet(this, $f0eb7f6a0a55da23$var$_hmrBranches));
            $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_hmrRoutes, void 0);
            $f0eb7f6a0a55da23$var$__privateSet(this, $f0eb7f6a0a55da23$var$_hmrBranches, void 0);
        }
    }
};
$f0eb7f6a0a55da23$var$_routes = new WeakMap();
$f0eb7f6a0a55da23$var$_branches = new WeakMap();
$f0eb7f6a0a55da23$var$_hmrRoutes = new WeakMap();
$f0eb7f6a0a55da23$var$_hmrBranches = new WeakMap();
function $f0eb7f6a0a55da23$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $f0eb7f6a0a55da23$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $f0eb7f6a0a55da23$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$f0eb7f6a0a55da23$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $f0eb7f6a0a55da23$var$DataRoutes($f0eb7f6a0a55da23$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $f0eb7f6a0a55da23$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f0eb7f6a0a55da23$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$f0eb7f6a0a55da23$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $f0eb7f6a0a55da23$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $f0eb7f6a0a55da23$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $f0eb7f6a0a55da23$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f0eb7f6a0a55da23$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $f0eb7f6a0a55da23$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f0eb7f6a0a55da23$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $f0eb7f6a0a55da23$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f0eb7f6a0a55da23$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $f0eb7f6a0a55da23$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $f0eb7f6a0a55da23$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $f0eb7f6a0a55da23$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $f0eb7f6a0a55da23$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $f0eb7f6a0a55da23$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f0eb7f6a0a55da23$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $f0eb7f6a0a55da23$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $f0eb7f6a0a55da23$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $f0eb7f6a0a55da23$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $f0eb7f6a0a55da23$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $f0eb7f6a0a55da23$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f0eb7f6a0a55da23$var$isErrorResult(result) && $f0eb7f6a0a55da23$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f0eb7f6a0a55da23$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $f0eb7f6a0a55da23$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$f0eb7f6a0a55da23$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $f0eb7f6a0a55da23$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $f0eb7f6a0a55da23$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $f0eb7f6a0a55da23$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $f0eb7f6a0a55da23$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f0eb7f6a0a55da23$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $f0eb7f6a0a55da23$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($f0eb7f6a0a55da23$var$isErrorResult(result)) {
            let boundaryMatch = $f0eb7f6a0a55da23$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $f0eb7f6a0a55da23$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $f0eb7f6a0a55da23$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $f0eb7f6a0a55da23$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $f0eb7f6a0a55da23$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $f0eb7f6a0a55da23$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$f0eb7f6a0a55da23$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $f0eb7f6a0a55da23$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $f0eb7f6a0a55da23$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $f0eb7f6a0a55da23$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $f0eb7f6a0a55da23$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $f0eb7f6a0a55da23$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f0eb7f6a0a55da23$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f0eb7f6a0a55da23$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f0eb7f6a0a55da23$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $f0eb7f6a0a55da23$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($f0eb7f6a0a55da23$var$isRedirectResult(actionResult) || $f0eb7f6a0a55da23$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f0eb7f6a0a55da23$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($f0eb7f6a0a55da23$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $f0eb7f6a0a55da23$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f0eb7f6a0a55da23$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($f0eb7f6a0a55da23$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f0eb7f6a0a55da23$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $f0eb7f6a0a55da23$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $f0eb7f6a0a55da23$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $f0eb7f6a0a55da23$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $f0eb7f6a0a55da23$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $f0eb7f6a0a55da23$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $f0eb7f6a0a55da23$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $f0eb7f6a0a55da23$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $f0eb7f6a0a55da23$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $f0eb7f6a0a55da23$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $f0eb7f6a0a55da23$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f0eb7f6a0a55da23$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $f0eb7f6a0a55da23$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f0eb7f6a0a55da23$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f0eb7f6a0a55da23$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $f0eb7f6a0a55da23$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $f0eb7f6a0a55da23$var$getDoneFetcher(void 0));
            return;
        }
        if ($f0eb7f6a0a55da23$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $f0eb7f6a0a55da23$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($f0eb7f6a0a55da23$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $f0eb7f6a0a55da23$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $f0eb7f6a0a55da23$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $f0eb7f6a0a55da23$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $f0eb7f6a0a55da23$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($f0eb7f6a0a55da23$var$isAbsoluteUrl(location)) {
                const url = $f0eb7f6a0a55da23$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f0eb7f6a0a55da23$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f0eb7f6a0a55da23$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($f0eb7f6a0a55da23$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $f0eb7f6a0a55da23$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $f0eb7f6a0a55da23$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$f0eb7f6a0a55da23$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($f0eb7f6a0a55da23$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $f0eb7f6a0a55da23$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $f0eb7f6a0a55da23$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $f0eb7f6a0a55da23$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $f0eb7f6a0a55da23$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $f0eb7f6a0a55da23$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $f0eb7f6a0a55da23$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $f0eb7f6a0a55da23$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $f0eb7f6a0a55da23$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $f0eb7f6a0a55da23$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f0eb7f6a0a55da23$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f0eb7f6a0a55da23$export$386d57f03f0b2883;
        $f0eb7f6a0a55da23$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $f0eb7f6a0a55da23$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $f0eb7f6a0a55da23$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $f0eb7f6a0a55da23$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$f0eb7f6a0a55da23$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $f0eb7f6a0a55da23$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($f0eb7f6a0a55da23$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $f0eb7f6a0a55da23$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $f0eb7f6a0a55da23$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $f0eb7f6a0a55da23$export$3336b097a6fbc59a(routes, opts) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $f0eb7f6a0a55da23$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$f0eb7f6a0a55da23$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $f0eb7f6a0a55da23$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $f0eb7f6a0a55da23$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $f0eb7f6a0a55da23$var$defaultNormalizePath;
        let method = request.method;
        let location = $f0eb7f6a0a55da23$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04();
        if (!$f0eb7f6a0a55da23$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f0eb7f6a0a55da23$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f0eb7f6a0a55da23$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $f0eb7f6a0a55da23$export$f5708dca728d7177(requestContext instanceof $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $f0eb7f6a0a55da23$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $f0eb7f6a0a55da23$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $f0eb7f6a0a55da23$var$createDataFunctionUrl(request, location),
                    pattern: $f0eb7f6a0a55da23$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($f0eb7f6a0a55da23$export$6e80290866a84dd4(error)) return error;
                    if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $f0eb7f6a0a55da23$export$f2680fa305b734ca(error.status, error.statusText, await $f0eb7f6a0a55da23$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(error)) error = $f0eb7f6a0a55da23$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $f0eb7f6a0a55da23$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $f0eb7f6a0a55da23$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $f0eb7f6a0a55da23$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $f0eb7f6a0a55da23$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $f0eb7f6a0a55da23$var$defaultNormalizePath;
        let method = request.method;
        let location = $f0eb7f6a0a55da23$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04();
        if (!$f0eb7f6a0a55da23$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f0eb7f6a0a55da23$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f0eb7f6a0a55da23$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $f0eb7f6a0a55da23$export$f5708dca728d7177(requestContext instanceof $f0eb7f6a0a55da23$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $f0eb7f6a0a55da23$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $f0eb7f6a0a55da23$var$runServerMiddlewarePipeline({
                request: request,
                url: $f0eb7f6a0a55da23$var$createDataFunctionUrl(request, location),
                pattern: $f0eb7f6a0a55da23$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($f0eb7f6a0a55da23$var$dataWithResponseInitToResponse(error));
                if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $f0eb7f6a0a55da23$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f0eb7f6a0a55da23$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $f0eb7f6a0a55da23$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($f0eb7f6a0a55da23$var$isDataStrategyResult(e) && $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($f0eb7f6a0a55da23$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $f0eb7f6a0a55da23$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($f0eb7f6a0a55da23$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($f0eb7f6a0a55da23$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($f0eb7f6a0a55da23$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f0eb7f6a0a55da23$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $f0eb7f6a0a55da23$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f0eb7f6a0a55da23$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f0eb7f6a0a55da23$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $f0eb7f6a0a55da23$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $f0eb7f6a0a55da23$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $f0eb7f6a0a55da23$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $f0eb7f6a0a55da23$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $f0eb7f6a0a55da23$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $f0eb7f6a0a55da23$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $f0eb7f6a0a55da23$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $f0eb7f6a0a55da23$var$callDataStrategyImpl(dataStrategy || $f0eb7f6a0a55da23$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($f0eb7f6a0a55da23$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $f0eb7f6a0a55da23$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(result.result)) throw $f0eb7f6a0a55da23$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $f0eb7f6a0a55da23$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $f0eb7f6a0a55da23$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $f0eb7f6a0a55da23$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $f0eb7f6a0a55da23$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $f0eb7f6a0a55da23$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $f0eb7f6a0a55da23$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $f0eb7f6a0a55da23$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $f0eb7f6a0a55da23$var$resolveTo(to ? to : ".", $f0eb7f6a0a55da23$var$getResolveToMatches(contextualMatches), $f0eb7f6a0a55da23$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $f0eb7f6a0a55da23$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $f0eb7f6a0a55da23$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $f0eb7f6a0a55da23$export$fe53371bee54353d(path);
}
function $f0eb7f6a0a55da23$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$f0eb7f6a0a55da23$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f0eb7f6a0a55da23$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f0eb7f6a0a55da23$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $f0eb7f6a0a55da23$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$f0eb7f6a0a55da23$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$f0eb7f6a0a55da23$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f0eb7f6a0a55da23$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f0eb7f6a0a55da23$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f0eb7f6a0a55da23$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f0eb7f6a0a55da23$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f0eb7f6a0a55da23$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($f0eb7f6a0a55da23$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $f0eb7f6a0a55da23$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $f0eb7f6a0a55da23$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $f0eb7f6a0a55da23$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $f0eb7f6a0a55da23$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$f0eb7f6a0a55da23$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $f0eb7f6a0a55da23$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($f0eb7f6a0a55da23$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $f0eb7f6a0a55da23$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($f0eb7f6a0a55da23$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $f0eb7f6a0a55da23$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $f0eb7f6a0a55da23$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $f0eb7f6a0a55da23$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $f0eb7f6a0a55da23$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($f0eb7f6a0a55da23$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $f0eb7f6a0a55da23$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $f0eb7f6a0a55da23$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$f0eb7f6a0a55da23$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $f0eb7f6a0a55da23$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $f0eb7f6a0a55da23$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f0eb7f6a0a55da23$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $f0eb7f6a0a55da23$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $f0eb7f6a0a55da23$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$f0eb7f6a0a55da23$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $f0eb7f6a0a55da23$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $f0eb7f6a0a55da23$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $f0eb7f6a0a55da23$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$f0eb7f6a0a55da23$var$isSameRoute(aChild, bChild))) ?? false;
}
var $f0eb7f6a0a55da23$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $f0eb7f6a0a55da23$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $f0eb7f6a0a55da23$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $f0eb7f6a0a55da23$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $f0eb7f6a0a55da23$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $f0eb7f6a0a55da23$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $f0eb7f6a0a55da23$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $f0eb7f6a0a55da23$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $f0eb7f6a0a55da23$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $f0eb7f6a0a55da23$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $f0eb7f6a0a55da23$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $f0eb7f6a0a55da23$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $f0eb7f6a0a55da23$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $f0eb7f6a0a55da23$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $f0eb7f6a0a55da23$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $f0eb7f6a0a55da23$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $f0eb7f6a0a55da23$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $f0eb7f6a0a55da23$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $f0eb7f6a0a55da23$var$isNonNullable(value) {
    return value !== void 0;
}
function $f0eb7f6a0a55da23$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $f0eb7f6a0a55da23$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($f0eb7f6a0a55da23$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $f0eb7f6a0a55da23$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $f0eb7f6a0a55da23$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $f0eb7f6a0a55da23$var$defaultDataStrategy(args);
    return $f0eb7f6a0a55da23$var$runClientMiddlewarePipeline(args, ()=>$f0eb7f6a0a55da23$var$defaultDataStrategy(args));
}
function $f0eb7f6a0a55da23$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $f0eb7f6a0a55da23$var$runMiddlewarePipeline(args, handler, processResult, $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(result) ? $f0eb7f6a0a55da23$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $f0eb7f6a0a55da23$var$runClientMiddlewarePipeline(args, handler) {
    return $f0eb7f6a0a55da23$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($f0eb7f6a0a55da23$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $f0eb7f6a0a55da23$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $f0eb7f6a0a55da23$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $f0eb7f6a0a55da23$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $f0eb7f6a0a55da23$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $f0eb7f6a0a55da23$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $f0eb7f6a0a55da23$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $f0eb7f6a0a55da23$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $f0eb7f6a0a55da23$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $f0eb7f6a0a55da23$var$loadLazyRoute(match.route, $f0eb7f6a0a55da23$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $f0eb7f6a0a55da23$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $f0eb7f6a0a55da23$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $f0eb7f6a0a55da23$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $f0eb7f6a0a55da23$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $f0eb7f6a0a55da23$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$f0eb7f6a0a55da23$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($f0eb7f6a0a55da23$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $f0eb7f6a0a55da23$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $f0eb7f6a0a55da23$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $f0eb7f6a0a55da23$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $f0eb7f6a0a55da23$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $f0eb7f6a0a55da23$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $f0eb7f6a0a55da23$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $f0eb7f6a0a55da23$var$createDataFunctionUrl(request, path),
        pattern: $f0eb7f6a0a55da23$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $f0eb7f6a0a55da23$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $f0eb7f6a0a55da23$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $f0eb7f6a0a55da23$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $f0eb7f6a0a55da23$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f0eb7f6a0a55da23$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f0eb7f6a0a55da23$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f0eb7f6a0a55da23$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $f0eb7f6a0a55da23$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $f0eb7f6a0a55da23$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $f0eb7f6a0a55da23$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $f0eb7f6a0a55da23$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $f0eb7f6a0a55da23$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $f0eb7f6a0a55da23$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $f0eb7f6a0a55da23$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $f0eb7f6a0a55da23$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f0eb7f6a0a55da23$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f0eb7f6a0a55da23$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $f0eb7f6a0a55da23$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $f0eb7f6a0a55da23$export$961a3ef7a4da3a39(location) {
    try {
        return $f0eb7f6a0a55da23$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $f0eb7f6a0a55da23$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($f0eb7f6a0a55da23$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $f0eb7f6a0a55da23$export$825a82322d91916e.test(normalizedLocation) ? new URL($f0eb7f6a0a55da23$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($f0eb7f6a0a55da23$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $f0eb7f6a0a55da23$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($f0eb7f6a0a55da23$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $f0eb7f6a0a55da23$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f0eb7f6a0a55da23$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f0eb7f6a0a55da23$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $f0eb7f6a0a55da23$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f0eb7f6a0a55da23$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $f0eb7f6a0a55da23$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f0eb7f6a0a55da23$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f0eb7f6a0a55da23$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $f0eb7f6a0a55da23$export$f5708dca728d7177(!$f0eb7f6a0a55da23$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f0eb7f6a0a55da23$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $f0eb7f6a0a55da23$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $f0eb7f6a0a55da23$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $f0eb7f6a0a55da23$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f0eb7f6a0a55da23$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $f0eb7f6a0a55da23$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $f0eb7f6a0a55da23$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($f0eb7f6a0a55da23$var$isErrorResult(result)) {
            let boundaryMatch = $f0eb7f6a0a55da23$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($f0eb7f6a0a55da23$var$isRedirectResult(result)) $f0eb7f6a0a55da23$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $f0eb7f6a0a55da23$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f0eb7f6a0a55da23$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $f0eb7f6a0a55da23$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f0eb7f6a0a55da23$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f0eb7f6a0a55da23$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $f0eb7f6a0a55da23$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f0eb7f6a0a55da23$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f0eb7f6a0a55da23$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $f0eb7f6a0a55da23$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $f0eb7f6a0a55da23$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($f0eb7f6a0a55da23$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $f0eb7f6a0a55da23$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(path) : path;
    return $f0eb7f6a0a55da23$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $f0eb7f6a0a55da23$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $f0eb7f6a0a55da23$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $f0eb7f6a0a55da23$var$dataWithResponseInitToErrorResponse(data2) {
    return new $f0eb7f6a0a55da23$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $f0eb7f6a0a55da23$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $f0eb7f6a0a55da23$var$isDataStrategyResult(value));
}
function $f0eb7f6a0a55da23$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $f0eb7f6a0a55da23$var$isRedirectDataStrategyResult(result) {
    return $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result.result) && $f0eb7f6a0a55da23$var$redirectStatusCodes.has(result.result.status);
}
function $f0eb7f6a0a55da23$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $f0eb7f6a0a55da23$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f0eb7f6a0a55da23$export$794b2760043cf8cd(statusCode) {
    return $f0eb7f6a0a55da23$var$redirectStatusCodes.has(statusCode);
}
function $f0eb7f6a0a55da23$export$6e80290866a84dd4(result) {
    return $f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result) && $f0eb7f6a0a55da23$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $f0eb7f6a0a55da23$var$isValidMethod(method) {
    return $f0eb7f6a0a55da23$var$validRequestMethods.has(method.toUpperCase());
}
function $f0eb7f6a0a55da23$export$cbae47800eb95bc3(method) {
    return $f0eb7f6a0a55da23$var$validMutationMethods.has(method.toUpperCase());
}
function $f0eb7f6a0a55da23$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f0eb7f6a0a55da23$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f0eb7f6a0a55da23$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $f0eb7f6a0a55da23$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f0eb7f6a0a55da23$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $f0eb7f6a0a55da23$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $f0eb7f6a0a55da23$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f0eb7f6a0a55da23$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $f0eb7f6a0a55da23$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $f0eb7f6a0a55da23$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $f0eb7f6a0a55da23$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f0eb7f6a0a55da23$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $f0eb7f6a0a55da23$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f0eb7f6a0a55da23$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f0eb7f6a0a55da23$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $f0eb7f6a0a55da23$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $f0eb7f6a0a55da23$export$2eeee58951ff3c1c = $acw62.createContext(null);
$f0eb7f6a0a55da23$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $f0eb7f6a0a55da23$export$315e3ffb01f217 = $acw62.createContext(null);
$f0eb7f6a0a55da23$export$315e3ffb01f217.displayName = "DataRouterState";
var $f0eb7f6a0a55da23$export$717f757c655223f1 = $acw62.createContext(false);
function $f0eb7f6a0a55da23$var$useIsRSCRouterContext() {
    return $acw62.useContext($f0eb7f6a0a55da23$export$717f757c655223f1);
}
var $f0eb7f6a0a55da23$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$f0eb7f6a0a55da23$export$3681f408decb40d1.displayName = "ViewTransition";
var $f0eb7f6a0a55da23$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$f0eb7f6a0a55da23$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $f0eb7f6a0a55da23$var$AwaitContext = $acw62.createContext(null);
$f0eb7f6a0a55da23$var$AwaitContext.displayName = "Await";
var $f0eb7f6a0a55da23$export$2666c20e15407622 = (props)=>$acw62.createElement($f0eb7f6a0a55da23$var$AwaitContext.Provider, props);
var $f0eb7f6a0a55da23$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$f0eb7f6a0a55da23$export$3044ab7fdabeaee6.displayName = "Navigation";
var $f0eb7f6a0a55da23$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$f0eb7f6a0a55da23$export$e6a44b110a0c44d3.displayName = "Location";
var $f0eb7f6a0a55da23$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$f0eb7f6a0a55da23$export$aac280ed165a4397.displayName = "Route";
var $f0eb7f6a0a55da23$var$RouteErrorContext = $acw62.createContext(null);
$f0eb7f6a0a55da23$var$RouteErrorContext.displayName = "RouteError";
var $f0eb7f6a0a55da23$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $f0eb7f6a0a55da23$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $f0eb7f6a0a55da23$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $f0eb7f6a0a55da23$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $f0eb7f6a0a55da23$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$f0eb7f6a0a55da23$var$ERROR_DIGEST_BASE}:${$f0eb7f6a0a55da23$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $f0eb7f6a0a55da23$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$f0eb7f6a0a55da23$var$ERROR_DIGEST_BASE}:${$f0eb7f6a0a55da23$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $f0eb7f6a0a55da23$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $f0eb7f6a0a55da23$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $f0eb7f6a0a55da23$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $f0eb7f6a0a55da23$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $f0eb7f6a0a55da23$export$9c954a9d03d32f4a() {
    return $acw62.useContext($f0eb7f6a0a55da23$export$e6a44b110a0c44d3) != null;
}
function $f0eb7f6a0a55da23$export$45d76561a5302f2b() {
    $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($f0eb7f6a0a55da23$export$e6a44b110a0c44d3).location;
}
function $f0eb7f6a0a55da23$export$1b3f31771c5d07c() {
    return $acw62.useContext($f0eb7f6a0a55da23$export$e6a44b110a0c44d3).navigationType;
}
function $f0eb7f6a0a55da23$export$6c330e8992e8a295(pattern) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$f0eb7f6a0a55da23$export$81336c211d5ff295(pattern, $f0eb7f6a0a55da23$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $f0eb7f6a0a55da23$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $f0eb7f6a0a55da23$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $f0eb7f6a0a55da23$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    return isDataRoute ? $f0eb7f6a0a55da23$var$useNavigateStable() : $f0eb7f6a0a55da23$var$useNavigateUnstable();
}
function $f0eb7f6a0a55da23$var$useNavigateUnstable() {
    $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($f0eb7f6a0a55da23$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    let { pathname: locationPathname } = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($f0eb7f6a0a55da23$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $f0eb7f6a0a55da23$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $f0eb7f6a0a55da23$var$warning(activeRef.current, $f0eb7f6a0a55da23$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $f0eb7f6a0a55da23$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f0eb7f6a0a55da23$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $f0eb7f6a0a55da23$var$OutletContext = $acw62.createContext(null);
function $f0eb7f6a0a55da23$export$4138103a3ae699cc() {
    return $acw62.useContext($f0eb7f6a0a55da23$var$OutletContext);
}
function $f0eb7f6a0a55da23$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $f0eb7f6a0a55da23$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $f0eb7f6a0a55da23$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    let { pathname: locationPathname } = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($f0eb7f6a0a55da23$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$f0eb7f6a0a55da23$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $f0eb7f6a0a55da23$export$5d3fca4a98652595(routes, locationArg) {
    return $f0eb7f6a0a55da23$var$useRoutesImpl(routes, locationArg);
}
function $f0eb7f6a0a55da23$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($f0eb7f6a0a55da23$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $f0eb7f6a0a55da23$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $f0eb7f6a0a55da23$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $f0eb7f6a0a55da23$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($f0eb7f6a0a55da23$export$945fecf35a8ef089) {
        $f0eb7f6a0a55da23$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $f0eb7f6a0a55da23$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $f0eb7f6a0a55da23$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $f0eb7f6a0a55da23$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $f0eb7f6a0a55da23$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f0eb7f6a0a55da23$var$DefaultErrorComponent() {
    let error = $f0eb7f6a0a55da23$export$ed527bf60f6e05f2();
    let message = $f0eb7f6a0a55da23$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($f0eb7f6a0a55da23$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $f0eb7f6a0a55da23$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$DefaultErrorComponent, null);
var $f0eb7f6a0a55da23$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $f0eb7f6a0a55da23$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$f0eb7f6a0a55da23$var$RenderErrorBoundary.contextType = $f0eb7f6a0a55da23$export$717f757c655223f1;
var $f0eb7f6a0a55da23$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $f0eb7f6a0a55da23$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $f0eb7f6a0a55da23$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $f0eb7f6a0a55da23$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $f0eb7f6a0a55da23$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ($f0eb7f6a0a55da23$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($f0eb7f6a0a55da23$var$isBrowser && !$f0eb7f6a0a55da23$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $f0eb7f6a0a55da23$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $f0eb7f6a0a55da23$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($f0eb7f6a0a55da23$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $f0eb7f6a0a55da23$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $f0eb7f6a0a55da23$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $f0eb7f6a0a55da23$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $f0eb7f6a0a55da23$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f0eb7f6a0a55da23$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $f0eb7f6a0a55da23$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f0eb7f6a0a55da23$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($f0eb7f6a0a55da23$export$2eeee58951ff3c1c);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(ctx, $f0eb7f6a0a55da23$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $f0eb7f6a0a55da23$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($f0eb7f6a0a55da23$export$315e3ffb01f217);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(state, $f0eb7f6a0a55da23$var$getDataRouterConsoleError(hookName));
    return state;
}
function $f0eb7f6a0a55da23$var$useRouteContext(hookName) {
    let route = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(route, $f0eb7f6a0a55da23$var$getDataRouterConsoleError(hookName));
    return route;
}
function $f0eb7f6a0a55da23$var$useCurrentRouteId(hookName) {
    let route = $f0eb7f6a0a55da23$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $f0eb7f6a0a55da23$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $f0eb7f6a0a55da23$var$useRouteId() {
    return $f0eb7f6a0a55da23$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $f0eb7f6a0a55da23$export$d0fd4b7106de2769() {
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $f0eb7f6a0a55da23$export$600dc272ed516c15() {
    let dataRouterContext = $f0eb7f6a0a55da23$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $f0eb7f6a0a55da23$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f0eb7f6a0a55da23$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$f0eb7f6a0a55da23$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $f0eb7f6a0a55da23$export$1448a5050d252c4d() {
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $f0eb7f6a0a55da23$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $f0eb7f6a0a55da23$export$fd5d37484eab868d(routeId) {
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $f0eb7f6a0a55da23$export$fdc00f3f26066d5e() {
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $f0eb7f6a0a55da23$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $f0eb7f6a0a55da23$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($f0eb7f6a0a55da23$var$RouteErrorContext);
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $f0eb7f6a0a55da23$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $f0eb7f6a0a55da23$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($f0eb7f6a0a55da23$var$AwaitContext);
    return value?._data;
}
function $f0eb7f6a0a55da23$export$17f53340677d5831() {
    let value = $acw62.useContext($f0eb7f6a0a55da23$var$AwaitContext);
    return value?._error;
}
var $f0eb7f6a0a55da23$var$blockerId = 0;
function $f0eb7f6a0a55da23$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f0eb7f6a0a55da23$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $f0eb7f6a0a55da23$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $f0eb7f6a0a55da23$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $f0eb7f6a0a55da23$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$f0eb7f6a0a55da23$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $f0eb7f6a0a55da23$export$386d57f03f0b2883;
}
function $f0eb7f6a0a55da23$var$useNavigateStable() {
    let { router: router } = $f0eb7f6a0a55da23$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $f0eb7f6a0a55da23$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $f0eb7f6a0a55da23$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $f0eb7f6a0a55da23$var$warning(activeRef.current, $f0eb7f6a0a55da23$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $f0eb7f6a0a55da23$var$alreadyWarned = {};
function $f0eb7f6a0a55da23$var$warningOnce(key, cond, message) {
    if (!cond && !$f0eb7f6a0a55da23$var$alreadyWarned[key]) {
        $f0eb7f6a0a55da23$var$alreadyWarned[key] = true;
        $f0eb7f6a0a55da23$var$warning(false, message);
    }
}
function $f0eb7f6a0a55da23$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $f0eb7f6a0a55da23$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $f0eb7f6a0a55da23$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $f0eb7f6a0a55da23$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $f0eb7f6a0a55da23$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $f0eb7f6a0a55da23$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$f0eb7f6a0a55da23$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$f0eb7f6a0a55da23$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $f0eb7f6a0a55da23$var$alreadyWarned2 = {};
function $f0eb7f6a0a55da23$export$5b28268982f175ba(condition, message) {
    if (!condition && !$f0eb7f6a0a55da23$var$alreadyWarned2[message]) {
        $f0eb7f6a0a55da23$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $f0eb7f6a0a55da23$var$USE_OPTIMISTIC = "useOptimistic";
var $f0eb7f6a0a55da23$var$useOptimisticImpl = $acw62[$f0eb7f6a0a55da23$var$USE_OPTIMISTIC];
var $f0eb7f6a0a55da23$var$stableUseOptimisticSetter = ()=>void 0;
function $f0eb7f6a0a55da23$var$useOptimisticSafe(val) {
    if ($f0eb7f6a0a55da23$var$useOptimisticImpl) return $f0eb7f6a0a55da23$var$useOptimisticImpl(val);
    else return [
        val,
        $f0eb7f6a0a55da23$var$stableUseOptimisticSetter
    ];
}
function $f0eb7f6a0a55da23$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($f0eb7f6a0a55da23$export$945fecf35a8ef089) {
            if (route.element) $f0eb7f6a0a55da23$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($f0eb7f6a0a55da23$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $f0eb7f6a0a55da23$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($f0eb7f6a0a55da23$export$945fecf35a8ef089) {
            if (route.errorElement) $f0eb7f6a0a55da23$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $f0eb7f6a0a55da23$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $f0eb7f6a0a55da23$export$f30f7e456d254e83(routes, opts) {
    return $f0eb7f6a0a55da23$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $f0eb7f6a0a55da23$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $f0eb7f6a0a55da23$export$e2fd2c03906469db,
        mapRouteProperties: $f0eb7f6a0a55da23$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $f0eb7f6a0a55da23$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $f0eb7f6a0a55da23$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $f0eb7f6a0a55da23$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $f0eb7f6a0a55da23$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $f0eb7f6a0a55da23$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $f0eb7f6a0a55da23$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $f0eb7f6a0a55da23$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$f0eb7f6a0a55da23$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $f0eb7f6a0a55da23$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$f0eb7f6a0a55da23$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $f0eb7f6a0a55da23$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $f0eb7f6a0a55da23$var$MemoizedDataRoutes = $acw62.memo($f0eb7f6a0a55da23$var$DataRoutes2);
function $f0eb7f6a0a55da23$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $f0eb7f6a0a55da23$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $f0eb7f6a0a55da23$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $f0eb7f6a0a55da23$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $f0eb7f6a0a55da23$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177($f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    $f0eb7f6a0a55da23$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    let { pathname: locationPathname } = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let navigate = $f0eb7f6a0a55da23$export$9770f232ac06a008();
    let path = $f0eb7f6a0a55da23$var$resolveTo(to, $f0eb7f6a0a55da23$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $f0eb7f6a0a55da23$export$910ae8079b2c2852(props) {
    return $f0eb7f6a0a55da23$export$a3be3530d8e40d0b(props.context);
}
function $f0eb7f6a0a55da23$export$e7b0ac011bb776c6(props) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $f0eb7f6a0a55da23$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177(!$f0eb7f6a0a55da23$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $f0eb7f6a0a55da23$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $f0eb7f6a0a55da23$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $f0eb7f6a0a55da23$export$5d3fca4a98652595($f0eb7f6a0a55da23$export$16da398f5434bdec(children), location);
}
function $f0eb7f6a0a55da23$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($f0eb7f6a0a55da23$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($f0eb7f6a0a55da23$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $f0eb7f6a0a55da23$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$ResolveAwait, null, children));
}
var $f0eb7f6a0a55da23$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $f0eb7f6a0a55da23$var$ResolveAwait({ children: children }) {
    let data2 = $f0eb7f6a0a55da23$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $f0eb7f6a0a55da23$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $f0eb7f6a0a55da23$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $f0eb7f6a0a55da23$export$f5708dca728d7177(element.type === $f0eb7f6a0a55da23$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $f0eb7f6a0a55da23$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f0eb7f6a0a55da23$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $f0eb7f6a0a55da23$export$9b5b6d122dea0c88 = $f0eb7f6a0a55da23$export$16da398f5434bdec;
function $f0eb7f6a0a55da23$export$daf73786167a7f72(matches) {
    return $f0eb7f6a0a55da23$var$_renderMatches(matches);
}
function $f0eb7f6a0a55da23$var$useRouteComponentProps() {
    return {
        params: $f0eb7f6a0a55da23$export$99eaa27ddbbb95ef(),
        loaderData: $f0eb7f6a0a55da23$export$1448a5050d252c4d(),
        actionData: $f0eb7f6a0a55da23$export$fdc00f3f26066d5e(),
        matches: $f0eb7f6a0a55da23$export$2378eb7f5ff86053()
    };
}
function $f0eb7f6a0a55da23$export$6c4f3826290c37af({ children: children }) {
    const props = $f0eb7f6a0a55da23$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $f0eb7f6a0a55da23$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $f0eb7f6a0a55da23$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $f0eb7f6a0a55da23$var$useHydrateFallbackProps() {
    return {
        params: $f0eb7f6a0a55da23$export$99eaa27ddbbb95ef(),
        loaderData: $f0eb7f6a0a55da23$export$1448a5050d252c4d(),
        actionData: $f0eb7f6a0a55da23$export$fdc00f3f26066d5e()
    };
}
function $f0eb7f6a0a55da23$export$f8cff34f39c1932a({ children: children }) {
    const props = $f0eb7f6a0a55da23$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $f0eb7f6a0a55da23$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $f0eb7f6a0a55da23$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $f0eb7f6a0a55da23$var$useErrorBoundaryProps() {
    return {
        params: $f0eb7f6a0a55da23$export$99eaa27ddbbb95ef(),
        loaderData: $f0eb7f6a0a55da23$export$1448a5050d252c4d(),
        actionData: $f0eb7f6a0a55da23$export$fdc00f3f26066d5e(),
        error: $f0eb7f6a0a55da23$export$ed527bf60f6e05f2()
    };
}
function $f0eb7f6a0a55da23$export$e5afde5c4b6d747b({ children: children }) {
    const props = $f0eb7f6a0a55da23$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $f0eb7f6a0a55da23$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $f0eb7f6a0a55da23$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $f0eb7f6a0a55da23$var$defaultMethod = "get";
var $f0eb7f6a0a55da23$var$defaultEncType = "application/x-www-form-urlencoded";
function $f0eb7f6a0a55da23$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $f0eb7f6a0a55da23$var$isButtonElement(object) {
    return $f0eb7f6a0a55da23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f0eb7f6a0a55da23$var$isFormElement(object) {
    return $f0eb7f6a0a55da23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f0eb7f6a0a55da23$var$isInputElement(object) {
    return $f0eb7f6a0a55da23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f0eb7f6a0a55da23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f0eb7f6a0a55da23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$f0eb7f6a0a55da23$var$isModifiedEvent(event);
}
function $f0eb7f6a0a55da23$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f0eb7f6a0a55da23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $f0eb7f6a0a55da23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $f0eb7f6a0a55da23$var$_formDataSupportsSubmitter = null;
function $f0eb7f6a0a55da23$var$isFormDataSubmitterSupported() {
    if ($f0eb7f6a0a55da23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $f0eb7f6a0a55da23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $f0eb7f6a0a55da23$var$_formDataSupportsSubmitter = true;
    }
    return $f0eb7f6a0a55da23$var$_formDataSupportsSubmitter;
}
var $f0eb7f6a0a55da23$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f0eb7f6a0a55da23$var$getFormEncType(encType) {
    if (encType != null && !$f0eb7f6a0a55da23$var$supportedFormEncTypes.has(encType)) {
        $f0eb7f6a0a55da23$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$f0eb7f6a0a55da23$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $f0eb7f6a0a55da23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f0eb7f6a0a55da23$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $f0eb7f6a0a55da23$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $f0eb7f6a0a55da23$var$defaultMethod;
        encType = $f0eb7f6a0a55da23$var$getFormEncType(target.getAttribute("enctype")) || $f0eb7f6a0a55da23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f0eb7f6a0a55da23$var$isButtonElement(target) || $f0eb7f6a0a55da23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $f0eb7f6a0a55da23$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $f0eb7f6a0a55da23$var$defaultMethod;
        encType = $f0eb7f6a0a55da23$var$getFormEncType(target.getAttribute("formenctype")) || $f0eb7f6a0a55da23$var$getFormEncType(form.getAttribute("enctype")) || $f0eb7f6a0a55da23$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$f0eb7f6a0a55da23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f0eb7f6a0a55da23$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $f0eb7f6a0a55da23$var$defaultMethod;
        action = null;
        encType = $f0eb7f6a0a55da23$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $f0eb7f6a0a55da23$var$HOLE = -1;
var $f0eb7f6a0a55da23$var$NAN = -2;
var $f0eb7f6a0a55da23$var$NEGATIVE_INFINITY = -3;
var $f0eb7f6a0a55da23$var$NEGATIVE_ZERO = -4;
var $f0eb7f6a0a55da23$var$NULL = -5;
var $f0eb7f6a0a55da23$var$POSITIVE_INFINITY = -6;
var $f0eb7f6a0a55da23$var$UNDEFINED = -7;
var $f0eb7f6a0a55da23$var$TYPE_BIGINT = "B";
var $f0eb7f6a0a55da23$var$TYPE_DATE = "D";
var $f0eb7f6a0a55da23$var$TYPE_ERROR = "E";
var $f0eb7f6a0a55da23$var$TYPE_MAP = "M";
var $f0eb7f6a0a55da23$var$TYPE_NULL_OBJECT = "N";
var $f0eb7f6a0a55da23$var$TYPE_PROMISE = "P";
var $f0eb7f6a0a55da23$var$TYPE_REGEXP = "R";
var $f0eb7f6a0a55da23$var$TYPE_SET = "S";
var $f0eb7f6a0a55da23$var$TYPE_SYMBOL = "Y";
var $f0eb7f6a0a55da23$var$TYPE_URL = "U";
var $f0eb7f6a0a55da23$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $f0eb7f6a0a55da23$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $f0eb7f6a0a55da23$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $f0eb7f6a0a55da23$var$TIME_LIMIT_MS = 1;
var $f0eb7f6a0a55da23$var$getNow = ()=>Date.now();
var $f0eb7f6a0a55da23$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $f0eb7f6a0a55da23$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $f0eb7f6a0a55da23$var$UNDEFINED;
    if (input === null) return $f0eb7f6a0a55da23$var$NULL;
    if (Number.isNaN(input)) return $f0eb7f6a0a55da23$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $f0eb7f6a0a55da23$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $f0eb7f6a0a55da23$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $f0eb7f6a0a55da23$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $f0eb7f6a0a55da23$var$stringify.call(this, stack);
    return index;
}
async function $f0eb7f6a0a55da23$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $f0eb7f6a0a55da23$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $f0eb7f6a0a55da23$var$UNDEFINED;
        if (value === null) return $f0eb7f6a0a55da23$var$NULL;
        if (Number.isNaN(value)) return $f0eb7f6a0a55da23$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $f0eb7f6a0a55da23$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $f0eb7f6a0a55da23$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $f0eb7f6a0a55da23$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $f0eb7f6a0a55da23$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $f0eb7f6a0a55da23$var$TIME_LIMIT_MS) {
            await $f0eb7f6a0a55da23$var$yieldToMain();
            lastYieldTime = $f0eb7f6a0a55da23$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$f0eb7f6a0a55da23$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $f0eb7f6a0a55da23$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$f0eb7f6a0a55da23$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($f0eb7f6a0a55da23$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $f0eb7f6a0a55da23$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $f0eb7f6a0a55da23$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $f0eb7f6a0a55da23$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $f0eb7f6a0a55da23$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $f0eb7f6a0a55da23$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $f0eb7f6a0a55da23$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $f0eb7f6a0a55da23$var$hydrate.call(this, startIndex);
}
function $f0eb7f6a0a55da23$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $f0eb7f6a0a55da23$var$UNDEFINED:
                set(void 0);
                continue;
            case $f0eb7f6a0a55da23$var$NULL:
                set(null);
                continue;
            case $f0eb7f6a0a55da23$var$NAN:
                set(NaN);
                continue;
            case $f0eb7f6a0a55da23$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $f0eb7f6a0a55da23$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $f0eb7f6a0a55da23$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $f0eb7f6a0a55da23$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $f0eb7f6a0a55da23$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $f0eb7f6a0a55da23$var$globalObj && $f0eb7f6a0a55da23$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $f0eb7f6a0a55da23$var$globalObj && typeof $f0eb7f6a0a55da23$var$globalObj[errorType] === "function" ? new $f0eb7f6a0a55da23$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $f0eb7f6a0a55da23$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $f0eb7f6a0a55da23$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $f0eb7f6a0a55da23$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $f0eb7f6a0a55da23$var$Deferred2();
    const reader = readable.pipeThrough($f0eb7f6a0a55da23$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $f0eb7f6a0a55da23$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $f0eb7f6a0a55da23$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $f0eb7f6a0a55da23$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $f0eb7f6a0a55da23$var$unflatten.call(this, line)
    };
}
async function $f0eb7f6a0a55da23$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $f0eb7f6a0a55da23$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $f0eb7f6a0a55da23$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $f0eb7f6a0a55da23$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $f0eb7f6a0a55da23$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $f0eb7f6a0a55da23$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $f0eb7f6a0a55da23$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $f0eb7f6a0a55da23$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$f0eb7f6a0a55da23$var$TYPE_PROMISE}${deferredId}:[["${$f0eb7f6a0a55da23$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$f0eb7f6a0a55da23$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$f0eb7f6a0a55da23$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $f0eb7f6a0a55da23$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$f0eb7f6a0a55da23$var$TYPE_ERROR}${deferredId}:[["${$f0eb7f6a0a55da23$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$f0eb7f6a0a55da23$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$f0eb7f6a0a55da23$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $f0eb7f6a0a55da23$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $f0eb7f6a0a55da23$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $f0eb7f6a0a55da23$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $f0eb7f6a0a55da23$export$4cf11838cdc2a8a8(html) {
    return html.replace($f0eb7f6a0a55da23$var$ESCAPE_REGEX, (match)=>$f0eb7f6a0a55da23$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $f0eb7f6a0a55da23$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $f0eb7f6a0a55da23$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $f0eb7f6a0a55da23$var$SingleFetchNoResultError = class extends Error {
};
var $f0eb7f6a0a55da23$export$ae9272e641ead836 = 202;
var $f0eb7f6a0a55da23$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $f0eb7f6a0a55da23$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$f0eb7f6a0a55da23$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $f0eb7f6a0a55da23$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $f0eb7f6a0a55da23$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $f0eb7f6a0a55da23$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $f0eb7f6a0a55da23$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $f0eb7f6a0a55da23$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $f0eb7f6a0a55da23$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $f0eb7f6a0a55da23$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $f0eb7f6a0a55da23$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $f0eb7f6a0a55da23$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $f0eb7f6a0a55da23$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $f0eb7f6a0a55da23$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $f0eb7f6a0a55da23$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($f0eb7f6a0a55da23$export$3f1eb41d9a6a6a27(result.result) || $f0eb7f6a0a55da23$export$972111febbeef05b(result.result) || $f0eb7f6a0a55da23$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $f0eb7f6a0a55da23$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $f0eb7f6a0a55da23$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $f0eb7f6a0a55da23$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $f0eb7f6a0a55da23$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$f0eb7f6a0a55da23$var$createDeferred2());
    let singleFetchDfd = $f0eb7f6a0a55da23$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $f0eb7f6a0a55da23$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $f0eb7f6a0a55da23$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $f0eb7f6a0a55da23$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $f0eb7f6a0a55da23$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $f0eb7f6a0a55da23$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $f0eb7f6a0a55da23$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $f0eb7f6a0a55da23$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $f0eb7f6a0a55da23$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $f0eb7f6a0a55da23$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $f0eb7f6a0a55da23$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $f0eb7f6a0a55da23$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$f0eb7f6a0a55da23$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$f0eb7f6a0a55da23$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $f0eb7f6a0a55da23$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $f0eb7f6a0a55da23$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $f0eb7f6a0a55da23$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $f0eb7f6a0a55da23$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $f0eb7f6a0a55da23$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $f0eb7f6a0a55da23$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($f0eb7f6a0a55da23$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $f0eb7f6a0a55da23$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $f0eb7f6a0a55da23$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($f0eb7f6a0a55da23$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$f0eb7f6a0a55da23$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $f0eb7f6a0a55da23$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $f0eb7f6a0a55da23$export$4023ad4ecd4126a2(body, global) {
    return $f0eb7f6a0a55da23$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $f0eb7f6a0a55da23$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $f0eb7f6a0a55da23$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$f0eb7f6a0a55da23$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $f0eb7f6a0a55da23$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $f0eb7f6a0a55da23$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $f0eb7f6a0a55da23$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $f0eb7f6a0a55da23$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $f0eb7f6a0a55da23$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $f0eb7f6a0a55da23$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $f0eb7f6a0a55da23$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $f0eb7f6a0a55da23$var$getModuleLinkHrefs(matches, manifest);
    return $f0eb7f6a0a55da23$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $f0eb7f6a0a55da23$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $f0eb7f6a0a55da23$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $f0eb7f6a0a55da23$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($f0eb7f6a0a55da23$var$prefetchStyleLink));
}
async function $f0eb7f6a0a55da23$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$f0eb7f6a0a55da23$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$f0eb7f6a0a55da23$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$f0eb7f6a0a55da23$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($f0eb7f6a0a55da23$var$prefetchStyleLink));
}
async function $f0eb7f6a0a55da23$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $f0eb7f6a0a55da23$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $f0eb7f6a0a55da23$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $f0eb7f6a0a55da23$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $f0eb7f6a0a55da23$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $f0eb7f6a0a55da23$var$dedupeLinkDescriptors(links.flat(1).filter($f0eb7f6a0a55da23$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $f0eb7f6a0a55da23$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $f0eb7f6a0a55da23$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $f0eb7f6a0a55da23$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $f0eb7f6a0a55da23$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $f0eb7f6a0a55da23$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $f0eb7f6a0a55da23$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$f0eb7f6a0a55da23$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($f0eb7f6a0a55da23$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $f0eb7f6a0a55da23$var$_isPreloadSupported;
function $f0eb7f6a0a55da23$var$isPreloadSupported() {
    if ($f0eb7f6a0a55da23$var$_isPreloadSupported !== void 0) return $f0eb7f6a0a55da23$var$_isPreloadSupported;
    let el = document.createElement("link");
    $f0eb7f6a0a55da23$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $f0eb7f6a0a55da23$var$_isPreloadSupported;
}
function $f0eb7f6a0a55da23$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $f0eb7f6a0a55da23$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $f0eb7f6a0a55da23$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $f0eb7f6a0a55da23$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $f0eb7f6a0a55da23$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $f0eb7f6a0a55da23$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RemixRootDefaultErrorBoundary, {
            error: $f0eb7f6a0a55da23$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $f0eb7f6a0a55da23$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $f0eb7f6a0a55da23$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $f0eb7f6a0a55da23$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$f0eb7f6a0a55da23$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $f0eb7f6a0a55da23$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $f0eb7f6a0a55da23$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $f0eb7f6a0a55da23$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $f0eb7f6a0a55da23$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $f0eb7f6a0a55da23$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $f0eb7f6a0a55da23$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $f0eb7f6a0a55da23$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $f0eb7f6a0a55da23$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $f0eb7f6a0a55da23$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $f0eb7f6a0a55da23$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $f0eb7f6a0a55da23$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $f0eb7f6a0a55da23$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $f0eb7f6a0a55da23$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$f0eb7f6a0a55da23$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $f0eb7f6a0a55da23$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $f0eb7f6a0a55da23$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $f0eb7f6a0a55da23$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $f0eb7f6a0a55da23$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $f0eb7f6a0a55da23$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $f0eb7f6a0a55da23$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $f0eb7f6a0a55da23$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $f0eb7f6a0a55da23$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $f0eb7f6a0a55da23$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $f0eb7f6a0a55da23$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $f0eb7f6a0a55da23$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $f0eb7f6a0a55da23$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $f0eb7f6a0a55da23$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $f0eb7f6a0a55da23$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $f0eb7f6a0a55da23$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $f0eb7f6a0a55da23$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $f0eb7f6a0a55da23$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $f0eb7f6a0a55da23$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $f0eb7f6a0a55da23$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $f0eb7f6a0a55da23$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $f0eb7f6a0a55da23$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $f0eb7f6a0a55da23$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $f0eb7f6a0a55da23$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $f0eb7f6a0a55da23$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $f0eb7f6a0a55da23$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $f0eb7f6a0a55da23$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $f0eb7f6a0a55da23$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $f0eb7f6a0a55da23$var$nextPaths = /* @__PURE__ */ new Set();
var $f0eb7f6a0a55da23$var$discoveredPathsMaxSize = 1e3;
var $f0eb7f6a0a55da23$var$discoveredPaths = /* @__PURE__ */ new Set();
var $f0eb7f6a0a55da23$export$b5915cf27fa06b9f = 7680;
function $f0eb7f6a0a55da23$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $f0eb7f6a0a55da23$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $f0eb7f6a0a55da23$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $f0eb7f6a0a55da23$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $f0eb7f6a0a55da23$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$f0eb7f6a0a55da23$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($f0eb7f6a0a55da23$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $f0eb7f6a0a55da23$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $f0eb7f6a0a55da23$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $f0eb7f6a0a55da23$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$f0eb7f6a0a55da23$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$f0eb7f6a0a55da23$var$discoveredPaths.has(pathname)) $f0eb7f6a0a55da23$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($f0eb7f6a0a55da23$var$nextPaths.keys()).filter((path)=>{
                if ($f0eb7f6a0a55da23$var$discoveredPaths.has(path)) {
                    $f0eb7f6a0a55da23$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $f0eb7f6a0a55da23$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $f0eb7f6a0a55da23$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $f0eb7f6a0a55da23$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $f0eb7f6a0a55da23$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $f0eb7f6a0a55da23$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $f0eb7f6a0a55da23$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $f0eb7f6a0a55da23$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($f0eb7f6a0a55da23$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $f0eb7f6a0a55da23$export$b5915cf27fa06b9f) {
        $f0eb7f6a0a55da23$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($f0eb7f6a0a55da23$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($f0eb7f6a0a55da23$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($f0eb7f6a0a55da23$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$f0eb7f6a0a55da23$var$addToFifoQueue(p, $f0eb7f6a0a55da23$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $f0eb7f6a0a55da23$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $f0eb7f6a0a55da23$var$addToFifoQueue(path, queue) {
    if (queue.size >= $f0eb7f6a0a55da23$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $f0eb7f6a0a55da23$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $f0eb7f6a0a55da23$var$useDataRouterContext2() {
    let context = $acw62.useContext($f0eb7f6a0a55da23$export$2eeee58951ff3c1c);
    $f0eb7f6a0a55da23$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $f0eb7f6a0a55da23$var$useDataRouterStateContext() {
    let context = $acw62.useContext($f0eb7f6a0a55da23$export$315e3ffb01f217);
    $f0eb7f6a0a55da23$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $f0eb7f6a0a55da23$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$f0eb7f6a0a55da23$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $f0eb7f6a0a55da23$var$useFrameworkContext() {
    let context = $acw62.useContext($f0eb7f6a0a55da23$export$208d6a3bc3aa62bd);
    $f0eb7f6a0a55da23$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $f0eb7f6a0a55da23$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($f0eb7f6a0a55da23$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $f0eb7f6a0a55da23$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $f0eb7f6a0a55da23$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $f0eb7f6a0a55da23$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $f0eb7f6a0a55da23$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $f0eb7f6a0a55da23$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $f0eb7f6a0a55da23$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $f0eb7f6a0a55da23$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$f0eb7f6a0a55da23$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $f0eb7f6a0a55da23$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $f0eb7f6a0a55da23$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $f0eb7f6a0a55da23$var$useDataRouterStateContext();
    let matches = $f0eb7f6a0a55da23$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$f0eb7f6a0a55da23$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$f0eb7f6a0a55da23$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$f0eb7f6a0a55da23$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$f0eb7f6a0a55da23$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $f0eb7f6a0a55da23$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $f0eb7f6a0a55da23$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let { router: router } = $f0eb7f6a0a55da23$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$f0eb7f6a0a55da23$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $f0eb7f6a0a55da23$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $f0eb7f6a0a55da23$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $f0eb7f6a0a55da23$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let { future: future } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let { basename: basename } = $f0eb7f6a0a55da23$var$useDataRouterContext2();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $f0eb7f6a0a55da23$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $f0eb7f6a0a55da23$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let { basename: basename } = $f0eb7f6a0a55da23$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $f0eb7f6a0a55da23$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$f0eb7f6a0a55da23$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$f0eb7f6a0a55da23$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $f0eb7f6a0a55da23$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$f0eb7f6a0a55da23$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $f0eb7f6a0a55da23$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $f0eb7f6a0a55da23$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $f0eb7f6a0a55da23$var$useDataRouterStateContext();
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let _matches = $f0eb7f6a0a55da23$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$f0eb7f6a0a55da23$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $f0eb7f6a0a55da23$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $f0eb7f6a0a55da23$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $f0eb7f6a0a55da23$var$isHydrated = false;
function $f0eb7f6a0a55da23$export$3be068dde909e563() {
    $f0eb7f6a0a55da23$var$isHydrated = true;
}
function $f0eb7f6a0a55da23$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $f0eb7f6a0a55da23$var$useDataRouterContext2();
    let { matches: routerMatches } = $f0eb7f6a0a55da23$var$useDataRouterStateContext();
    let isRSCRouterContext = $f0eb7f6a0a55da23$var$useIsRSCRouterContext();
    let enableFogOfWar = $f0eb7f6a0a55da23$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $f0eb7f6a0a55da23$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $f0eb7f6a0a55da23$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $f0eb7f6a0a55da23$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($f0eb7f6a0a55da23$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $f0eb7f6a0a55da23$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($f0eb7f6a0a55da23$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $f0eb7f6a0a55da23$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $f0eb7f6a0a55da23$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $f0eb7f6a0a55da23$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $f0eb7f6a0a55da23$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $f0eb7f6a0a55da23$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($f0eb7f6a0a55da23$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $f0eb7f6a0a55da23$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $f0eb7f6a0a55da23$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $f0eb7f6a0a55da23$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$ff0bf87698939488, null) : null)));
}
var $f0eb7f6a0a55da23$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($f0eb7f6a0a55da23$var$isBrowser2) window.__reactRouterVersion = "7.18.1";
} catch (e) {}
function $f0eb7f6a0a55da23$export$1f3f55432a00e06d(routes, opts) {
    return $f0eb7f6a0a55da23$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $f0eb7f6a0a55da23$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $f0eb7f6a0a55da23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $f0eb7f6a0a55da23$export$9269a41d8c4635e,
        hydrationRouteProperties: $f0eb7f6a0a55da23$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $f0eb7f6a0a55da23$export$1ba7ed8a3a7b3765(routes, opts) {
    return $f0eb7f6a0a55da23$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $f0eb7f6a0a55da23$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $f0eb7f6a0a55da23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $f0eb7f6a0a55da23$export$9269a41d8c4635e,
        hydrationRouteProperties: $f0eb7f6a0a55da23$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $f0eb7f6a0a55da23$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $f0eb7f6a0a55da23$var$deserializeErrors(state.errors)
    };
    return state;
}
function $f0eb7f6a0a55da23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $f0eb7f6a0a55da23$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $f0eb7f6a0a55da23$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $f0eb7f6a0a55da23$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $f0eb7f6a0a55da23$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $f0eb7f6a0a55da23$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $f0eb7f6a0a55da23$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $f0eb7f6a0a55da23$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$f0eb7f6a0a55da23$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $f0eb7f6a0a55da23$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $f0eb7f6a0a55da23$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $f0eb7f6a0a55da23$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $f0eb7f6a0a55da23$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $f0eb7f6a0a55da23$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $f0eb7f6a0a55da23$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $f0eb7f6a0a55da23$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $f0eb7f6a0a55da23$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $f0eb7f6a0a55da23$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$f0eb7f6a0a55da23$export$a6c7ac8248d6e38a.displayName = "Link";
var $f0eb7f6a0a55da23$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $f0eb7f6a0a55da23$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($f0eb7f6a0a55da23$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f0eb7f6a0a55da23$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$f0eb7f6a0a55da23$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $f0eb7f6a0a55da23$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $f0eb7f6a0a55da23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let submit = $f0eb7f6a0a55da23$export$47c85c6e3a081d3();
    let formAction = $f0eb7f6a0a55da23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $f0eb7f6a0a55da23$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$f0eb7f6a0a55da23$export$a7fed597f4b8afd8.displayName = "Form";
function $f0eb7f6a0a55da23$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($f0eb7f6a0a55da23$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let matches = $f0eb7f6a0a55da23$export$2378eb7f5ff86053();
    $f0eb7f6a0a55da23$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $f0eb7f6a0a55da23$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$f0eb7f6a0a55da23$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $f0eb7f6a0a55da23$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$f0eb7f6a0a55da23$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$f0eb7f6a0a55da23$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $f0eb7f6a0a55da23$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f0eb7f6a0a55da23$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($f0eb7f6a0a55da23$export$2eeee58951ff3c1c);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(ctx, $f0eb7f6a0a55da23$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $f0eb7f6a0a55da23$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($f0eb7f6a0a55da23$export$315e3ffb01f217);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(state, $f0eb7f6a0a55da23$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $f0eb7f6a0a55da23$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $f0eb7f6a0a55da23$export$9770f232ac06a008();
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let path = $f0eb7f6a0a55da23$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($f0eb7f6a0a55da23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $f0eb7f6a0a55da23$export$fe53371bee54353d(location) === $f0eb7f6a0a55da23$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $f0eb7f6a0a55da23$export$f1a78c17382fe22a(defaultInit) {
    $f0eb7f6a0a55da23$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($f0eb7f6a0a55da23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $f0eb7f6a0a55da23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $f0eb7f6a0a55da23$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $f0eb7f6a0a55da23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $f0eb7f6a0a55da23$var$fetcherId = 0;
var $f0eb7f6a0a55da23$var$getUniqueFetcherId = ()=>`__${String(++$f0eb7f6a0a55da23$var$fetcherId)}__`;
function $f0eb7f6a0a55da23$export$47c85c6e3a081d3() {
    let { router: router } = $f0eb7f6a0a55da23$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let currentRouteId = $f0eb7f6a0a55da23$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f0eb7f6a0a55da23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $f0eb7f6a0a55da23$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $f0eb7f6a0a55da23$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$f0eb7f6a0a55da23$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $f0eb7f6a0a55da23$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $f0eb7f6a0a55da23$export$fe53371bee54353d(path);
}
function $f0eb7f6a0a55da23$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $f0eb7f6a0a55da23$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $f0eb7f6a0a55da23$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($f0eb7f6a0a55da23$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($f0eb7f6a0a55da23$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $f0eb7f6a0a55da23$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $f0eb7f6a0a55da23$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $f0eb7f6a0a55da23$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $f0eb7f6a0a55da23$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $f0eb7f6a0a55da23$export$fa996778a3a31087() {
    let state = $f0eb7f6a0a55da23$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $acw62.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $f0eb7f6a0a55da23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $f0eb7f6a0a55da23$var$savedScrollPositions = {};
function $f0eb7f6a0a55da23$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $f0eb7f6a0a55da23$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $f0eb7f6a0a55da23$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $f0eb7f6a0a55da23$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f0eb7f6a0a55da23$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($f0eb7f6a0a55da23$export$3044ab7fdabeaee6);
    let location = $f0eb7f6a0a55da23$export$45d76561a5302f2b();
    let matches = $f0eb7f6a0a55da23$export$2378eb7f5ff86053();
    let navigation = $f0eb7f6a0a55da23$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $f0eb7f6a0a55da23$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $f0eb7f6a0a55da23$var$getScrollRestorationKey(location, matches, basename, getKey);
            $f0eb7f6a0a55da23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f0eb7f6a0a55da23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f0eb7f6a0a55da23$var$savedScrollPositions));
        } catch (error) {
            $f0eb7f6a0a55da23$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f0eb7f6a0a55da23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f0eb7f6a0a55da23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($f0eb7f6a0a55da23$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$f0eb7f6a0a55da23$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $f0eb7f6a0a55da23$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $f0eb7f6a0a55da23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $f0eb7f6a0a55da23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $f0eb7f6a0a55da23$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $f0eb7f6a0a55da23$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $f0eb7f6a0a55da23$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($f0eb7f6a0a55da23$export$3681f408decb40d1);
    $f0eb7f6a0a55da23$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $f0eb7f6a0a55da23$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $f0eb7f6a0a55da23$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $f0eb7f6a0a55da23$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $f0eb7f6a0a55da23$export$81336c211d5ff295(path.pathname, nextPath) != null || $f0eb7f6a0a55da23$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $f0eb7f6a0a55da23$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $f0eb7f6a0a55da23$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $f0eb7f6a0a55da23$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $f0eb7f6a0a55da23$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $f0eb7f6a0a55da23$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $f0eb7f6a0a55da23$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $f0eb7f6a0a55da23$var$serializeErrors(context.errors)
        };
        let json = $f0eb7f6a0a55da23$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($f0eb7f6a0a55da23$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $f0eb7f6a0a55da23$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($f0eb7f6a0a55da23$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $f0eb7f6a0a55da23$var$getStatelessNavigator() {
    return {
        createHref: $f0eb7f6a0a55da23$var$createHref,
        encodeLocation: $f0eb7f6a0a55da23$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $f0eb7f6a0a55da23$export$69163f0b72ec60d9(routes, opts) {
    return $f0eb7f6a0a55da23$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $f0eb7f6a0a55da23$export$9269a41d8c4635e
    });
}
function $f0eb7f6a0a55da23$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $f0eb7f6a0a55da23$export$87cb1a9238dc3fba(routes, $f0eb7f6a0a55da23$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $f0eb7f6a0a55da23$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $f0eb7f6a0a55da23$var$createHref,
        encodeLocation: $f0eb7f6a0a55da23$var$encodeLocation,
        getFetcher () {
            return $f0eb7f6a0a55da23$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $f0eb7f6a0a55da23$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $f0eb7f6a0a55da23$var$createHref(to) {
    return typeof to === "string" ? to : $f0eb7f6a0a55da23$export$fe53371bee54353d(to);
}
function $f0eb7f6a0a55da23$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $f0eb7f6a0a55da23$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $f0eb7f6a0a55da23$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}




var $e1763e3299c07fa2$exports = {};
$e1763e3299c07fa2$exports = import.meta.resolve("83hTf");




class $e2eed623ba262d88$export$3f80c9932cb15319 {
    width;
    height;
    label;
    onSubmit;
    boxClass;
}
function $e2eed623ba262d88$export$dd2171e2b7d3bc5b(props) {
    const boxClass = props.boxClass !== undefined ? props.boxClass : 'input-box';
    const width = props.width !== undefined ? props.width : 256;
    const height = props.height !== undefined ? props.height : 16;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "input-line",
        children: [
            props.label !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "input-label",
                children: props.label
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: boxClass
            }),
            props.onSubmit !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: props.onSubmit,
                className: "input-button",
                children: "Submit"
            }) : null
        ]
    });
}


function $5c0ef430159b6fa2$export$ae303b2cb7384706() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "gouch-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "WHAT DO YOU HAVE TO SAY"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e1763e3299c07fa2$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2eed623ba262d88$export$dd2171e2b7d3bc5b), {
                onSubmit: ()=>{}
            })
        ]
    });
}




var $1611741e6b8afa08$exports = {};
$1611741e6b8afa08$exports = import.meta.resolve("dcsc1");


function $248a5a58ce7572bd$export$8381844b7346a7c4() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bowliver-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bowliver-header-box",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bowliver-header",
                    children: "BOWLIVER'S WORLD"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bowliver-body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1611741e6b8afa08$exports))),
                        width: 512
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bowliver-options",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "bowliver-option",
                                href: "bowliver",
                                children: "my diary"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "bowliver-option",
                                href: "bowliver",
                                children: "my mom"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: "bowliver-option",
                                href: "bowliver",
                                children: "my pics"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $aa23a299c8825048$exports = {};
$aa23a299c8825048$exports = import.meta.resolve("fTGpq");


var $0c5f5a7e0dce6c01$exports = {};
$0c5f5a7e0dce6c01$exports = import.meta.resolve("bmj6q");


var $e50d3ce6a4fad5a4$exports = {};
$e50d3ce6a4fad5a4$exports = import.meta.resolve("MqzHw");


var $01821f03f25100ea$exports = {};
$01821f03f25100ea$exports = import.meta.resolve("hJzfp");


var $9a210cf71e6c4328$exports = {};
$9a210cf71e6c4328$exports = import.meta.resolve("6X9pr");


var $a6e5ee6c837f521b$exports = {};
$a6e5ee6c837f521b$exports = import.meta.resolve("5plDN");


var $7a7480a580b597c6$exports = {};
$7a7480a580b597c6$exports = import.meta.resolve("4ctxx");


var $45aaf948e65dd669$exports = {};
$45aaf948e65dd669$exports = import.meta.resolve("eDM92");


var $b22d43a9067a2a46$exports = {};
$b22d43a9067a2a46$exports = import.meta.resolve("f0WqD");


var $e4c6a3a8278ec377$exports = {};
$e4c6a3a8278ec377$exports = import.meta.resolve("lyTUs");


var $27804691b033357a$exports = {};
$27804691b033357a$exports = import.meta.resolve("71qE1");


var $4489eae948149227$exports = {};
$4489eae948149227$exports = import.meta.resolve("2RZCs");


var $82e8e3be4c60daf9$exports = {};
$82e8e3be4c60daf9$exports = import.meta.resolve("66QAY");


var $8777d8487ab9233b$exports = {};
$8777d8487ab9233b$exports = import.meta.resolve("f6gyh");


var $a3a47090fa113089$exports = {};
$a3a47090fa113089$exports = import.meta.resolve("7euUd");


var $e171536dbce14bb9$exports = {};
$e171536dbce14bb9$exports = import.meta.resolve("i0aeK");


var $2749f9b25226c0f3$exports = {};
$2749f9b25226c0f3$exports = import.meta.resolve("jdbGC");


var $7782331d41a67c6b$exports = {};
$7782331d41a67c6b$exports = import.meta.resolve("ffwPR");


var $d00c936b920997ed$exports = {};
$d00c936b920997ed$exports = import.meta.resolve("ahDCH");


var $87b11bebc505ae94$exports = {};
$87b11bebc505ae94$exports = import.meta.resolve("M4g2I");


var $917d8a86d822dea0$exports = {};
$917d8a86d822dea0$exports = import.meta.resolve("5lLFx");


var $fc3cc83dd21c98cd$exports = {};
$fc3cc83dd21c98cd$exports = import.meta.resolve("HjcmE");


var $986b31a4c27172e9$exports = {};
$986b31a4c27172e9$exports = import.meta.resolve("jCHad");


var $eb6c140dc8bd9185$exports = {};
$eb6c140dc8bd9185$exports = import.meta.resolve("jW6Z7");


var $efefc51b95eaf3aa$exports = {};
$efefc51b95eaf3aa$exports = import.meta.resolve("a2k2F");


var $7bed951467594d91$exports = {};
$7bed951467594d91$exports = import.meta.resolve("2eEeD");


var $12f94785f33122c3$exports = {};
$12f94785f33122c3$exports = import.meta.resolve("5OGRf");


var $8e700c16dbf45784$exports = {};
$8e700c16dbf45784$exports = import.meta.resolve("7qy0L");


var $910800d2d6f2c0e2$exports = {};
$910800d2d6f2c0e2$exports = import.meta.resolve("h5FJV");


var $04d45d0e1ff66b8a$exports = {};
$04d45d0e1ff66b8a$exports = import.meta.resolve("i1u48");


var $b4e9adae5e7ae3a4$exports = {};
$b4e9adae5e7ae3a4$exports = import.meta.resolve("gvK4h");


var $ec3aaf8125386857$exports = {};
$ec3aaf8125386857$exports = import.meta.resolve("k13fJ");


var $dfc0f1152a519715$exports = {};
$dfc0f1152a519715$exports = import.meta.resolve("iyo33");


var $9ba21a1f2b7d102d$exports = {};
$9ba21a1f2b7d102d$exports = import.meta.resolve("kqobf");


var $c4d39ce06746f873$exports = {};
$c4d39ce06746f873$exports = import.meta.resolve("ghZFl");


var $64da36ffecd8d9f4$exports = {};
$64da36ffecd8d9f4$exports = import.meta.resolve("igJwL");


var $23dc0e01f26e2d26$exports = {};
$23dc0e01f26e2d26$exports = import.meta.resolve("ecy2G");


var $ca54e85bc85a613d$exports = {};
$ca54e85bc85a613d$exports = import.meta.resolve("ipm51");


var $b6e9814fc26c30c9$exports = {};
$b6e9814fc26c30c9$exports = import.meta.resolve("hJjfF");


var $7d6cf91538d9351b$exports = {};
$7d6cf91538d9351b$exports = import.meta.resolve("ckYAq");


var $719e26cf571b17b6$exports = {};
$719e26cf571b17b6$exports = import.meta.resolve("2Zp9V");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $95a9fb6ec2fcaee8$export$bdae29047cba02fc(props) {
    const [visible, setVisible] = (0, $acw62.useState)(0);
    const onMouseMove = (e)=>{
        const cursor = document.querySelector(".mcs");
        if (cursor !== null) {
            cursor.style.left = `${e.pageX}px`;
            cursor.style.top = `${e.pageY}px`;
        }
    };
    const onScroll = (e)=>{};
    const onMouseDown = (e)=>{
        if (e.button == 0 && props.onMouseDown !== undefined) props.onMouseDown(e);
        onMouseMove(e);
    };
    const onMouseUp = (e)=>{
        if (e.button == 0) {
            if (props.onMouseUp !== undefined) props.onMouseUp(e);
            onMouseMove(e);
        }
    };
    const onMouseOut = (e)=>{
        setVisible(visible + 1);
    };
    const onMouseEnter = (e)=>{
        setVisible(visible - 1);
    };
    const init = ()=>{
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseover", onMouseMove);
        document.addEventListener("drag", onMouseMove);
        document.addEventListener("dragend", onMouseMove);
        document.addEventListener("scroll", onScroll);
        document.addEventListener("mouseenter", onMouseEnter);
        document.addEventListener("mouseleave", onMouseOut);
        document.addEventListener("mouseup", onMouseUp);
    };
    (0, $acw62.useEffect)(()=>{
        init();
        return ()=>{
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseover", onMouseMove);
            document.removeEventListener("drag", onMouseMove);
            document.removeEventListener("dragend", onMouseMove);
            document.removeEventListener("scroll", onScroll);
            document.removeEventListener("mouseenter", onMouseEnter);
            document.removeEventListener("mouseleave", onMouseOut);
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mcs",
        children: visible <= 0 && props.children !== undefined ? props.children : null
    });
}


var $411acf6ebeea84e1$exports = {};
$411acf6ebeea84e1$exports = import.meta.resolve("5TXT8");


function $cf0b83fa3d0da380$export$597a2d516651c70b() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($411acf6ebeea84e1$exports))),
            className: "mcs-icon"
        })
    });
}




var $acw62 = parcelRequire("acw62");

var $4e0aa011f58a2058$exports = {};
$4e0aa011f58a2058$exports = import.meta.resolve("12tzr");


var $5f9fcf5a93fcd9cc$exports = {};
$5f9fcf5a93fcd9cc$exports = import.meta.resolve("jFgcF");




function $7609e982b08f29bb$export$6b78c2368fef3146() {
    const provider = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const [chrg, setChrg] = (0, $acw62.useState)();
    const locRef = (0, $acw62.useRef)('null');
    const loc = (0, $f0eb7f6a0a55da23$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        setChrg(provider.plzchg);
    }, [
        provider.plzchg
    ]);
    // useEffect(() => {
    //     const root_old = locRef.current.split('/')[1];
    //     const root_new = loc.pathname.split('/')[1];
    //     console.log(root_old + " > " + root_new + ", " + locRef.current + ", " + loc.pathname);
    //     if (root_old != root_new)
    //         setChrg(false);
    //     locRef.current = loc.pathname;
    // }, [loc]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        children: [
            chrg ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5f9fcf5a93fcd9cc$exports))),
                className: "mcs-bg"
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4e0aa011f58a2058$exports))),
                className: "mcs-icon"
            })
        ]
    });
}




var $44eee4417d90786e$exports = {};
$44eee4417d90786e$exports = import.meta.resolve("93EUG");


var $87a86b9b91f2a91b$exports = {};
$87a86b9b91f2a91b$exports = import.meta.resolve("ll3PY");


var $45c9efd131ea2c8c$exports = {};
$45c9efd131ea2c8c$exports = import.meta.resolve("7a8bK");



var $acw62 = parcelRequire("acw62");
function $3447a4052e21a910$export$8fbe4773bcd176a8() {
    const [image, setImage] = (0, $acw62.useState)((0, (/*@__PURE__*/$parcel$interopDefault($44eee4417d90786e$exports))));
    const aud = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($45c9efd131ea2c8c$exports))));
    const md = (e)=>{
        setImage((0, (/*@__PURE__*/$parcel$interopDefault($87a86b9b91f2a91b$exports))));
        aud.play();
    };
    const mu = (e)=>{
        setImage((0, (/*@__PURE__*/$parcel$interopDefault($44eee4417d90786e$exports))));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        onMouseDown: md,
        onMouseUp: mu,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: image,
            className: "mcs-icon"
        })
    });
}




var $8c3dd32c4da10694$exports = {};
$8c3dd32c4da10694$exports = import.meta.resolve("39iFr");


function $8cd8e5f7944ea745$export$7c7ad1b12a62cb1a() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8c3dd32c4da10694$exports))),
            className: "mcs-icon"
        })
    });
}




var $9f8f25c977fdd3f1$exports = {};
$9f8f25c977fdd3f1$exports = import.meta.resolve("8hRb1");


function $516661ddac2275e8$export$2c13362a09762823() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9f8f25c977fdd3f1$exports))),
            className: "mcs-icon"
        })
    });
}




var $6819c4dceff49cfc$exports = {};
$6819c4dceff49cfc$exports = import.meta.resolve("iqnMm");


function $3d9c24c7879bcb11$export$1a175d89f0889246() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6819c4dceff49cfc$exports))),
            className: "mcs-icon"
        })
    });
}




var $c9d27c1f37ed5374$exports = {};
$c9d27c1f37ed5374$exports = import.meta.resolve("euS6M");


function $bc05cafc7fae9b2a$export$d0ece8ab379d9bda() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a9fb6ec2fcaee8$export$bdae29047cba02fc), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c9d27c1f37ed5374$exports))),
            className: "mcs-icon"
        })
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $2ebf8dd0c68164d0$exports = {};
$2ebf8dd0c68164d0$exports = import.meta.resolve("4F31X");












const $4d33f92596c93eff$export$18a4407878007291 = {
    name: "Cursor",
    key: "crsstd",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ebf8dd0c68164d0$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($411acf6ebeea84e1$exports)))
};
const $4d33f92596c93eff$export$2d2f5704bde47ab8 = {
    name: "Hammer",
    key: "crsham",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($44eee4417d90786e$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($44eee4417d90786e$exports))),
    down: (0, (/*@__PURE__*/$parcel$interopDefault($87a86b9b91f2a91b$exports))),
    audio: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($45c9efd131ea2c8c$exports))))
};
const $4d33f92596c93eff$export$47a6a5e48542aaf2 = {
    name: "Plasma",
    key: "crsplz",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4e0aa011f58a2058$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($4e0aa011f58a2058$exports)))
};
const $4d33f92596c93eff$export$e5e83cf1a7fb0861 = {
    name: "Yo-Yo",
    key: "crsyyo",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8c3dd32c4da10694$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($8c3dd32c4da10694$exports)))
};
const $4d33f92596c93eff$export$e78d7fa5414a086a = {
    name: "Key 1",
    key: "crsky1",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9f8f25c977fdd3f1$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($9f8f25c977fdd3f1$exports)))
};
const $4d33f92596c93eff$export$15d5a8d1995f7416 = {
    name: "Key 2",
    key: "crsky2",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6819c4dceff49cfc$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($6819c4dceff49cfc$exports)))
};
const $4d33f92596c93eff$export$72d62567a5619ae = {
    name: "Key 3",
    key: "crsky3",
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9d27c1f37ed5374$exports))),
    standard: (0, (/*@__PURE__*/$parcel$interopDefault($c9d27c1f37ed5374$exports)))
};
const $4d33f92596c93eff$export$af2a7940fe411d58 = [
    $4d33f92596c93eff$export$18a4407878007291,
    $4d33f92596c93eff$export$2d2f5704bde47ab8,
    $4d33f92596c93eff$export$47a6a5e48542aaf2,
    $4d33f92596c93eff$export$e5e83cf1a7fb0861,
    $4d33f92596c93eff$export$e78d7fa5414a086a,
    $4d33f92596c93eff$export$15d5a8d1995f7416,
    $4d33f92596c93eff$export$72d62567a5619ae
];
const $4d33f92596c93eff$export$d1e6c08dda6b3d5d = (state)=>{
    switch(state){
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).STD:
            return $4d33f92596c93eff$export$18a4407878007291;
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).HAM:
            return $4d33f92596c93eff$export$2d2f5704bde47ab8;
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).PLZ:
            return $4d33f92596c93eff$export$47a6a5e48542aaf2;
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).YOY:
            return $4d33f92596c93eff$export$e5e83cf1a7fb0861;
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY1:
            return $4d33f92596c93eff$export$e78d7fa5414a086a;
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY2:
            return $4d33f92596c93eff$export$15d5a8d1995f7416;
        case (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY3:
            return $4d33f92596c93eff$export$72d62567a5619ae;
    }
};
function $4d33f92596c93eff$export$e68fe7bc96d6a348(key) {
    $4d33f92596c93eff$export$af2a7940fe411d58.forEach((v)=>{
        if (v.key == key) return v;
    });
    return $4d33f92596c93eff$export$18a4407878007291;
}
function $4d33f92596c93eff$export$161da20a2702ba06(props) {
    const info = (0, $acw62.useRef)($4d33f92596c93eff$export$18a4407878007291);
    const [image, setImage] = (0, $acw62.useState)(info.current.standard);
    const [visible, setVisible] = (0, $acw62.useState)(0);
    const context = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const onMouseMove = (e)=>{
        const cursor = document.querySelector(".mcs");
        if (cursor !== null) {
            cursor.style.left = `${e.pageX}px`;
            cursor.style.top = `${e.pageY}px`;
        }
    };
    const onScroll = (e)=>{
    // console.log(e);
    };
    const onMouseDown = (e)=>{
        if (e.button == 0) {
            if (info.current.down !== undefined) setImage(info.current.down);
            if (info.current.audio !== undefined) info.current.audio.play();
        }
        onMouseMove(e);
    };
    const onMouseUp = (e)=>{
        if (e.button == 0) {
            setImage(info.current.standard);
            onMouseMove(e);
        }
    };
    const onMouseOut = (e)=>{
        setVisible(visible + 1);
    };
    const onMouseEnter = (e)=>{
        setVisible(visible - 1);
    };
    const init = ()=>{
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseover", onMouseMove);
        document.addEventListener("drag", onMouseMove);
        document.addEventListener("dragend", onMouseMove);
        document.addEventListener("scroll", onScroll);
        document.addEventListener("mouseenter", onMouseEnter);
        document.addEventListener("mouseleave", onMouseOut);
        document.addEventListener("mouseup", onMouseUp);
    };
    const setState = (state)=>{
        const new_info = $4d33f92596c93eff$export$d1e6c08dda6b3d5d(state);
        info.current = new_info;
        setImage(info.current.standard);
    };
    (0, $acw62.useEffect)(()=>{
        setState(context.state);
    }, [
        context.state
    ]);
    (0, $acw62.useEffect)(()=>{
        init();
        return ()=>{
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseover", onMouseMove);
            document.removeEventListener("drag", onMouseMove);
            document.removeEventListener("dragend", onMouseMove);
            document.removeEventListener("scroll", onScroll);
            document.removeEventListener("mouseenter", onMouseEnter);
            document.removeEventListener("mouseleave", onMouseOut);
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mcs",
        children: visible <= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: image,
            className: "mcs-icon"
        }) : null
    });
}


const $5fc7b830e79d6137$export$3c969d42479bc900 = {
    key: 'stetrok',
    name: 'Triple Oaks',
    path: '/tripleoaks'
};
const $5fc7b830e79d6137$export$55c18d8b5b00a1cb = {
    key: 'stexanm',
    name: 'Xtreme Anime',
    path: '/xtremeanime'
};
const $5fc7b830e79d6137$export$575b2d92557d6d13 = {
    key: 'stetaco',
    name: 'Taco Bongo',
    path: '/tacobongo'
};
const $5fc7b830e79d6137$export$aacc34ff648bd1aa = {
    key: 'stewtrk',
    name: 'WTROK Radio',
    path: '/wtrok'
};
const $5fc7b830e79d6137$export$2f1b57c8d7991048 = {
    key: 'stecrnn',
    name: 'Cryptid News',
    path: '/cnn'
};
const $5fc7b830e79d6137$export$66480abf8fd33e73 = {
    key: 'stephrk',
    name: "Phrank's Cranks",
    path: '/phrankscranks'
};
const $5fc7b830e79d6137$export$a21c2d331a79837c = [
    $5fc7b830e79d6137$export$3c969d42479bc900,
    $5fc7b830e79d6137$export$575b2d92557d6d13,
    $5fc7b830e79d6137$export$aacc34ff648bd1aa,
    $5fc7b830e79d6137$export$55c18d8b5b00a1cb,
    $5fc7b830e79d6137$export$2f1b57c8d7991048,
    $5fc7b830e79d6137$export$66480abf8fd33e73
];
function $5fc7b830e79d6137$export$8eeada7b01a97848(key) {
    return $5fc7b830e79d6137$export$a21c2d331a79837c.find((i)=>i.key === key);
}


const $acd90146ef1cd4d7$var$EmptyData = ()=>{
    return {
        cursors: [
            (0, $4d33f92596c93eff$export$18a4407878007291).key
        ],
        sites: [
            (0, $5fc7b830e79d6137$export$3c969d42479bc900).key
        ]
    };
};
const $acd90146ef1cd4d7$var$LCLKEY = 'trok19ply97';
const $acd90146ef1cd4d7$var$LoadedData = ()=>{
    const cachedStateString = localStorage.getItem($acd90146ef1cd4d7$var$LCLKEY);
    const cachedState = cachedStateString !== null ? JSON.parse(cachedStateString) : $acd90146ef1cd4d7$var$EmptyData();
    const cachedCursors = [
        ...cachedState.cursors
    ];
    const cachedSites = [
        ...cachedState.sites
    ];
    return {
        cursors: cachedCursors,
        sites: cachedSites
    };
};
const $acd90146ef1cd4d7$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    data: $acd90146ef1cd4d7$var$LoadedData(),
    unlockSite: (s)=>{},
    hasUnlockedSite: (s)=>{
        return false;
    },
    unlockCursor: (c)=>{},
    hasUnlockedCursor: (c)=>{
        return false;
    },
    debugClearAll: ()=>{},
    debugUnlockAll: ()=>{}
});
const $acd90146ef1cd4d7$var$PlayerProvider = (props)=>{
    const [data, setData] = (0, $acw62.useState)($acd90146ef1cd4d7$var$LoadedData());
    const unlockCursor = (c)=>{
        if (hasUnlockedCursor(c)) return;
        const newData = {
            cursors: [
                ...data.cursors
            ],
            sites: [
                ...data.sites
            ]
        };
        newData.cursors.push(c);
        localStorage.setItem($acd90146ef1cd4d7$var$LCLKEY, JSON.stringify(newData));
        setData(newData);
    };
    const hasUnlockedCursor = (c)=>{
        return data.cursors.includes(c);
    };
    const unlockSite = (s)=>{
        if (hasUnlockedSite(s)) return;
        const newData = {
            cursors: [
                ...data.cursors
            ],
            sites: [
                ...data.sites
            ]
        };
        newData.sites.push(s);
        localStorage.setItem($acd90146ef1cd4d7$var$LCLKEY, JSON.stringify(newData));
        setData(newData);
    };
    const hasUnlockedSite = (s)=>{
        return data.sites.includes(s);
    };
    const debugClearAll = ()=>{
        localStorage.removeItem($acd90146ef1cd4d7$var$LCLKEY);
        setData($acd90146ef1cd4d7$var$EmptyData());
    };
    const debugUnlockAll = ()=>{
        const newData = {
            cursors: [],
            sites: []
        };
        (0, $5fc7b830e79d6137$export$a21c2d331a79837c).forEach((s)=>{
            newData.sites.push(s.key);
        });
        (0, $4d33f92596c93eff$export$af2a7940fe411d58).forEach((c)=>{
            newData.cursors.push(c.key);
        });
        localStorage.setItem($acd90146ef1cd4d7$var$LCLKEY, JSON.stringify(newData));
        setData(newData);
    };
    const value = (0, $acw62.useMemo)(()=>{
        return {
            data: data,
            unlockSite: unlockSite,
            hasUnlockedSite: hasUnlockedSite,
            unlockCursor: unlockCursor,
            hasUnlockedCursor: hasUnlockedCursor,
            debugClearAll: debugClearAll,
            debugUnlockAll: debugUnlockAll
        };
    }, [
        data
    ]);
    const children = (0, $acw62.useMemo)(()=>{
        return props.children;
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acd90146ef1cd4d7$var$context.Provider, {
        value: value,
        children: children
    });
};
$acd90146ef1cd4d7$var$PlayerProvider.context = $acd90146ef1cd4d7$var$context;
var $acd90146ef1cd4d7$export$2e2bcd8739ae039 = $acd90146ef1cd4d7$var$PlayerProvider;



var $ecf8a511bd2be543$export$4490bbf8c7a4868b = /*#__PURE__*/ function(CursorState) {
    CursorState[CursorState["STD"] = 0] = "STD";
    CursorState[CursorState["HAM"] = 1] = "HAM";
    CursorState[CursorState["PLZ"] = 2] = "PLZ";
    CursorState[CursorState["YOY"] = 3] = "YOY";
    CursorState[CursorState["KY1"] = 4] = "KY1";
    CursorState[CursorState["KY2"] = 5] = "KY2";
    CursorState[CursorState["KY3"] = 6] = "KY3";
    return CursorState;
}({});
const $ecf8a511bd2be543$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    state: 0,
    setState: (s)=>{},
    setStateFromCode: ()=>{},
    plzchg: false,
    setPlzchg: ()=>{}
});
const $ecf8a511bd2be543$var$CursorProvider = ({ children: children })=>{
    const playerProvider = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    const cachedStateString = localStorage.getItem('mcs');
    const cachedStateIndex = cachedStateString !== null ? parseInt(cachedStateString) : 0;
    const cachedState = cachedStateIndex;
    const [state, setState] = (0, $acw62.useState)(cachedState);
    const [plzchg, setPlzchg] = (0, $acw62.useState)(false);
    const [crs, setCrs] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf0b83fa3d0da380$export$597a2d516651c70b), {}));
    (0, $acw62.useEffect)(()=>{
        const index = state;
        localStorage.setItem('mcs', index.toString());
        switch(state){
            case 0:
            default:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf0b83fa3d0da380$export$597a2d516651c70b), {}));
                break;
            case 1:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3447a4052e21a910$export$8fbe4773bcd176a8), {}));
                break;
            case 2:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7609e982b08f29bb$export$6b78c2368fef3146), {}));
                break;
            case 3:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cd8e5f7944ea745$export$7c7ad1b12a62cb1a), {}));
                break;
            case 4:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $516661ddac2275e8$export$2c13362a09762823), {}));
                break;
            case 5:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d9c24c7879bcb11$export$1a175d89f0889246), {}));
                break;
            case 6:
                setCrs(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc05cafc7fae9b2a$export$d0ece8ab379d9bda), {}));
                break;
        }
    }, [
        state
    ]);
    const setStateFromCode = (code)=>{
        switch(code){
            case (0, $4d33f92596c93eff$export$2d2f5704bde47ab8).key:
                playerProvider.unlockCursor(code);
                setState(1);
                break;
            case (0, $4d33f92596c93eff$export$47a6a5e48542aaf2).key:
                playerProvider.unlockCursor(code);
                setState(2);
                break;
            case (0, $4d33f92596c93eff$export$e5e83cf1a7fb0861).key:
                playerProvider.unlockCursor(code);
                setState(3);
                break;
            case (0, $4d33f92596c93eff$export$e78d7fa5414a086a).key:
                playerProvider.unlockCursor(code);
                setState(4);
                break;
            case (0, $4d33f92596c93eff$export$15d5a8d1995f7416).key:
                playerProvider.unlockCursor(code);
                setState(5);
                break;
            case (0, $4d33f92596c93eff$export$72d62567a5619ae).key:
                playerProvider.unlockCursor(code);
                setState(6);
                break;
            default:
                setState(0);
                break;
        }
    };
    const value = (0, $acw62.useMemo)(()=>({
            state: state,
            setState: setState,
            setStateFromCode: setStateFromCode,
            plzchg: plzchg,
            setPlzchg: setPlzchg
        }), [
        state,
        plzchg
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ecf8a511bd2be543$var$context.Provider, {
        value: value,
        children: [
            children,
            crs
        ]
    });
};
$ecf8a511bd2be543$var$CursorProvider.context = $ecf8a511bd2be543$var$context;
var $ecf8a511bd2be543$export$2e2bcd8739ae039 = $ecf8a511bd2be543$var$CursorProvider;




var $acw62 = parcelRequire("acw62");

class $887b4dfdb08ec5f4$export$c428238bf0c81174 {
    cursor = (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).STD;
    onClick = ()=>{};
    children;
    stdOnClick = ()=>{};
    className;
    style;
    id;
}
function $887b4dfdb08ec5f4$export$7cfed81e33fc1826(props) {
    const id = props.id !== undefined ? props.id : (0, $acw62.useId)();
    const cursorContext = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const className = props.className !== undefined ? props.className : '';
    const style = props.style !== undefined ? props.style : {};
    const clickFunction = ()=>{
        if (cursorContext.state != props.cursor) {
            if (props.stdOnClick !== undefined) props.stdOnClick();
            return;
        }
        props.onClick();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        onClick: clickFunction,
        id: id,
        className: className,
        style: style,
        children: props.children
    });
}


function $34c3c3c781117e32$export$df63e0ab6c58b679(props) {
    const [smashed, setSmashed] = (0, $acw62.useState)(false);
    const className = props.className !== undefined ? props.className : "";
    const style = props.style !== undefined ? props.style : {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: className,
        style: style,
        children: [
            smashed && props.loot !== undefined ? props.loot : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: smashed ? 'smash-post' : 'smash-pre',
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $887b4dfdb08ec5f4$export$7cfed81e33fc1826), {
                    cursor: (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).HAM,
                    onClick: ()=>{
                        setSmashed(true);
                        if (props.stateRef !== undefined) props.stateRef.current = true;
                        if (props.onSmash !== undefined) props.onSmash();
                    },
                    children: props.children
                })
            })
        ]
    });
}



function $8b4304a014acb038$export$bae074112137dc8e() {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "found-page",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "found-viewport",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($986b31a4c27172e9$exports))),
                    style: {
                        top: 330,
                        left: 1150,
                        width: 84
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($01821f03f25100ea$exports))),
                    style: {
                        top: 360,
                        left: 1050,
                        width: 72
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($aa23a299c8825048$exports))),
                    style: {
                        top: 420,
                        left: 1100,
                        width: 72
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0c5f5a7e0dce6c01$exports))),
                    style: {
                        top: 360,
                        left: 700,
                        width: 48
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e50d3ce6a4fad5a4$exports))),
                    style: {
                        top: 380,
                        left: 450,
                        width: 64
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($719e26cf571b17b6$exports))),
                    style: {
                        top: 380,
                        left: 540,
                        width: 84
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a3a47090fa113089$exports))),
                    style: {
                        top: 440,
                        left: 570,
                        width: 72
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a6e5ee6c837f521b$exports))),
                    style: {
                        top: 500,
                        left: 520,
                        width: 172
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e4c6a3a8278ec377$exports))),
                    style: {
                        top: 480,
                        left: 1150,
                        width: 160
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "found-item",
                    style: {
                        top: 496,
                        left: 1190
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e171536dbce14bb9$exports))),
                        className: "spinny",
                        style: {
                            width: 40
                        },
                        onClick: ()=>{
                            nav('/omgitbfghbb');
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7a7480a580b597c6$exports))),
                    style: {
                        top: 540,
                        left: 1150,
                        width: 48
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "found-item",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7d6cf91538d9351b$exports))),
                        style: {
                            top: 475,
                            left: 1125,
                            width: 180
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($45aaf948e65dd669$exports))),
                    style: {
                        top: 600,
                        left: 100,
                        width: 172
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($910800d2d6f2c0e2$exports))),
                    style: {
                        top: 400,
                        left: 700,
                        width: 320
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b22d43a9067a2a46$exports))),
                    style: {
                        top: 430,
                        left: 950,
                        width: 108
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($27804691b033357a$exports))),
                    style: {
                        top: 250,
                        left: 150,
                        width: 64
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4489eae948149227$exports))),
                    style: {
                        top: 800,
                        left: 100,
                        width: 280
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($82e8e3be4c60daf9$exports))),
                    style: {
                        top: 600,
                        left: 700,
                        width: 128
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8777d8487ab9233b$exports))),
                    style: {
                        top: 580,
                        left: 1050,
                        width: 96
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2749f9b25226c0f3$exports))),
                    style: {
                        top: 220,
                        left: 710,
                        width: 128
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7bed951467594d91$exports))),
                    style: {
                        top: 400,
                        left: 250,
                        width: 128
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8e700c16dbf45784$exports))),
                    style: {
                        top: 420,
                        left: 420,
                        width: 72
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9ba21a1f2b7d102d$exports))),
                    style: {
                        top: 460,
                        left: 200,
                        width: 128
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7782331d41a67c6b$exports))),
                    style: {
                        top: 490,
                        left: 320,
                        width: 196
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d00c936b920997ed$exports))),
                    style: {
                        top: 420,
                        left: 0,
                        width: 208
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($04d45d0e1ff66b8a$exports))),
                    style: {
                        top: 420,
                        left: 985,
                        width: 24
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($87b11bebc505ae94$exports))),
                    style: {
                        top: 520,
                        left: 750,
                        width: 340
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9a210cf71e6c4328$exports))),
                    style: {
                        top: 800,
                        left: 600,
                        width: 220
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($917d8a86d822dea0$exports))),
                    style: {
                        top: 650,
                        left: 20,
                        width: 84
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fc3cc83dd21c98cd$exports))),
                    style: {
                        top: 800,
                        left: 980,
                        width: 220
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($23dc0e01f26e2d26$exports))),
                    style: {
                        top: 380,
                        left: 1240,
                        width: 48
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($eb6c140dc8bd9185$exports))),
                    style: {
                        top: 420,
                        left: 1280,
                        width: 128
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($efefc51b95eaf3aa$exports))),
                    style: {
                        top: 640,
                        left: 1140,
                        width: 380
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($12f94785f33122c3$exports))),
                    style: {
                        top: 500,
                        left: 1320,
                        width: 160
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b4e9adae5e7ae3a4$exports))),
                    style: {
                        top: 580,
                        left: 340,
                        width: 320
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ec3aaf8125386857$exports))),
                    style: {
                        top: 300,
                        left: 1400,
                        width: 108
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dfc0f1152a519715$exports))),
                    style: {
                        top: 380,
                        left: 150,
                        width: 64
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c4d39ce06746f873$exports))),
                    style: {
                        top: 900,
                        left: 0,
                        width: 119
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($64da36ffecd8d9f4$exports))),
                    style: {
                        top: 370,
                        left: 50,
                        width: 72
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ca54e85bc85a613d$exports))),
                    style: {
                        top: 100,
                        left: 1100,
                        width: 96
                    }
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "found-item",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b6e9814fc26c30c9$exports))),
                    style: {
                        top: 280,
                        left: 440,
                        width: 32
                    }
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");
var $b7ed009c2ed54a76$exports = {};
$b7ed009c2ed54a76$exports = import.meta.resolve("g2pmK");


var $836144792400ee33$exports = {};
$836144792400ee33$exports = import.meta.resolve("dz1Fw");


var $869c9da60153d865$exports = {};
$869c9da60153d865$exports = import.meta.resolve("aVrdr");


var $1c96bb9fc97d308b$exports = {};
$1c96bb9fc97d308b$exports = import.meta.resolve("8vu3h");


var $1a1befa0d58c79f3$exports = {};
$1a1befa0d58c79f3$exports = import.meta.resolve("euM0Y");


var $f60384e5a3266f35$exports = {};
$f60384e5a3266f35$exports = import.meta.resolve("ceqE7");


var $c15e7db7c98493bd$exports = {};
$c15e7db7c98493bd$exports = import.meta.resolve("eJm3d");


var $077f6848738ed5b5$exports = {};
$077f6848738ed5b5$exports = import.meta.resolve("gFhd7");


var $6e92464c3aca2625$exports = {};
$6e92464c3aca2625$exports = import.meta.resolve("40piC");


var $5a7beddde94dbeb1$exports = {};
$5a7beddde94dbeb1$exports = import.meta.resolve("8hKvi");


var $4afec30a1e9a4ffa$exports = {};
$4afec30a1e9a4ffa$exports = import.meta.resolve("6Fvec");


var $b2337f118d55ec55$exports = {};
$b2337f118d55ec55$exports = import.meta.resolve("hLlLm");


var $b5949658951e5817$exports = {};
$b5949658951e5817$exports = import.meta.resolve("hsTew");


var $538b9b22da6e79b7$exports = {};
$538b9b22da6e79b7$exports = import.meta.resolve("4Erxp");


var $a19bb698ba8300e8$exports = {};
$a19bb698ba8300e8$exports = import.meta.resolve("gcfvS");


var $6f946778f08d6903$exports = {};
$6f946778f08d6903$exports = import.meta.resolve("8ZGBO");


var $c4276b4573d07980$exports = {};
$c4276b4573d07980$exports = import.meta.resolve("5dTUC");


var $25749971dbbe47df$exports = {};
$25749971dbbe47df$exports = import.meta.resolve("79yvn");


var $e7c7b621257f6bdd$exports = {};
$e7c7b621257f6bdd$exports = import.meta.resolve("hugCr");



var $89fc9618342929d7$exports = {};
$89fc9618342929d7$exports = JSON.parse("{\"favorites\":[\"Knock knock? Whos there? CIA. CIA who? C, I Ate a whole cake!\",\"My Grandma Doris been staring through the window ever since it started to snow... If it gets any worse I'll have to let her in.\",\"What's the worst thing to hear during open heart surgery? Anything!\"],\"general\":[\"Why couldn't Spock flush the toilet? Because of the captain's log\",\"What did the football coach say to the broken vending machine? Give me my quarterback\",\"When is a car not a car? When it turns into parking lot\",\"Where do armies belong? In their sleevies\",\"How do trees get online? They just log on!\",\"What did the pirate say when he turned 80? Aye matey.\",\"What's the difference between a nightwatchman and a butcher? One stays awake and the other weighs a steak\",\"Why did the blind man fall down the well? Because he couldn't see that well.\",\"I tossed a coin in the air and told my friend to call it. He said \\\"come here, quarter\\\"!!\",\"Why can't you hear a pterodactyl go to the bathroom? Because the \\\"P\\\" is silent.\",\"I asked my german friend if he knew what 3x3 was.. He said nein!\"],\"animal\":[\"What did the buffalo say to her son on the first day of school? Bi son\",\"What do you call a bee born in Spring? A maybe\",\"What do you call a chicken that haunts a house? A poultrygeist\",\"What do you call a pony with a cough? A little horse\",\"What do you call a cow with no legs? Ground beef. What do you call a cow with 3 legs? Lean beef. What do you call a cow with 2 legs? Your mom.\",\"What do you call a deer with no eyes? No ideeer\",\"What do you call a deer with no eyes and no legs? Still no ideer\",\"What do you call a deer with no eyes and no legs in the ocean? Bob\",\"What do you call a fish with no eyes? Fsh\",\"Why did the scarecrow win an award? Because he was outstanding in his field.\",\"What do you get if you cross a rabbit with a wig? Hare\"],\"scary\":[\"What room can't a ghost go into? The Living Room\",\"Why couldn't the skeleton ask someone out on a date? He didn't have the guts\",\"How does a greek god talk to their friend? They column up on the perse-phone\",\"How do you make a tissue dance? You put a little boogie in it\",\"Did you hear about the elevator operator who rode to the basement to pick up dracula? He went down for the Count\",\"What's a ghost's favorite food? Boo-berries\"],\"more\":[]}");


var $bd50770fbf187e88$exports = {};
$bd50770fbf187e88$exports = import.meta.resolve("17qR7");




var $85e9a5f53799adae$exports = {};
$85e9a5f53799adae$exports = import.meta.resolve("bh460");


var $fac433673f0cd9f7$exports = {};
$fac433673f0cd9f7$exports = import.meta.resolve("hTq2C");


var $5a7a2d49c22d7098$exports = {};
$5a7a2d49c22d7098$exports = import.meta.resolve("c6YQU");


var $21a6e2a229a38c95$exports = {};
$21a6e2a229a38c95$exports = import.meta.resolve("b3ggU");


var $9d0acbe3d922236e$exports = {};
$9d0acbe3d922236e$exports = import.meta.resolve("8Ncrp");


var $f641fb18b19a5a47$exports = {};
$f641fb18b19a5a47$exports = import.meta.resolve("4PNk6");


var $a1bddd430d9cbe43$exports = {};
$a1bddd430d9cbe43$exports = import.meta.resolve("aMNE4");


var $304ffd9c15c9ca03$exports = {};
$304ffd9c15c9ca03$exports = import.meta.resolve("fXJbU");


var $5db21fd4ba023743$exports = {};
$5db21fd4ba023743$exports = import.meta.resolve("i4VOx");


var $1afe6d627a0a9016$exports = {};
$1afe6d627a0a9016$exports = import.meta.resolve("3p8r8");


var $c5e28084bf0dd1b6$exports = {};
$c5e28084bf0dd1b6$exports = import.meta.resolve("2CnZz");


var $1296f2d12fd59902$exports = {};
$1296f2d12fd59902$exports = import.meta.resolve("iFQA3");


var $7c0883e1876b72b3$exports = {};
$7c0883e1876b72b3$exports = import.meta.resolve("dDaBy");


var $3af621247eb47144$exports = {};
$3af621247eb47144$exports = import.meta.resolve("7PgpW");






var $acw62 = parcelRequire("acw62");


function $f3aebe2660fadb1d$export$61bfbcb6cfee0061(props) {
    const cursor = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const startOn = props.startOn !== undefined ? props.startOn : false;
    const [status, setStatus] = (0, $acw62.useState)(startOn);
    const className = props.className !== undefined ? props.className : '';
    const style = props.style !== undefined ? props.style : {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $887b4dfdb08ec5f4$export$7cfed81e33fc1826), {
        id: props.id,
        cursor: (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).PLZ,
        onClick: ()=>{
            if (cursor.plzchg == status) {
                if (status && props.stdOnClick !== undefined) props.stdOnClick();
                return;
            }
            const nowOn = !status;
            setStatus(nowOn);
            cursor.setPlzchg(!nowOn);
            if (nowOn && props.onEnable !== undefined) props.onEnable();
            if (!nowOn && props.onDisable !== undefined) props.onDisable();
        },
        stdOnClick: ()=>{
            if (status && props.stdOnClick !== undefined) props.stdOnClick();
        },
        className: className,
        style: style,
        children: status ? props.onState : props.offState
    });
}


var $452a05b0d36845a0$export$cd58f743ba5bc404 = /*#__PURE__*/ function(StampType) {
    StampType[StampType["TROK"] = 0] = "TROK";
    StampType[StampType["Anime"] = 1] = "Anime";
    StampType[StampType["Weblair"] = 2] = "Weblair";
    StampType[StampType["Phranks"] = 3] = "Phranks";
    StampType[StampType["TacoBongo"] = 4] = "TacoBongo";
    StampType[StampType["WTROK"] = 5] = "WTROK";
    StampType[StampType["Cryptid"] = 6] = "Cryptid";
    return StampType;
}({});
function $452a05b0d36845a0$export$8897676213252052(props) {
    const navigate = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    let stamp_on = '';
    let stamp_off = '';
    let link = undefined;
    let anim = false;
    switch(props.type){
        case 0:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($a1bddd430d9cbe43$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($3af621247eb47144$exports)));
            link = "/tripleoaks";
            break;
        case 1:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($85e9a5f53799adae$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($304ffd9c15c9ca03$exports)));
            link = '/xtremeanime';
            anim = true;
            break;
        case 2:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($fac433673f0cd9f7$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($5db21fd4ba023743$exports)));
            break;
        case 3:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($5a7a2d49c22d7098$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($1afe6d627a0a9016$exports)));
            link = '/phrankscranks';
            anim = true;
            break;
        case 4:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($f641fb18b19a5a47$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($7c0883e1876b72b3$exports)));
            link = '/tacobongo';
            anim = true;
            break;
        case 5:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($21a6e2a229a38c95$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($c5e28084bf0dd1b6$exports)));
            link = '/wtrok';
            break;
        case 6:
            stamp_on = (0, (/*@__PURE__*/$parcel$interopDefault($9d0acbe3d922236e$exports)));
            stamp_off = (0, (/*@__PURE__*/$parcel$interopDefault($1296f2d12fd59902$exports)));
            link = '/cnn';
    }
    const has_link = link !== undefined;
    const secondaryClass = has_link ? 'stamp-valid' : 'stamp-invalid';
    const on_anim = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: stamp_on,
        className: 'stamp ' + secondaryClass
    });
    const off_anim = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: stamp_off,
        className: 'stamp ' + secondaryClass
    });
    const on_std = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: stamp_on,
        className: 'stamp ' + secondaryClass,
        onClick: ()=>{
            if (link !== undefined) navigate(link);
        }
    });
    return anim ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        onState: on_anim,
        offState: off_anim,
        startOn: true,
        stdOnClick: ()=>{
            if (link !== undefined) navigate(link);
        }
    }) : has_link ? on_std : off_anim;
}


function $ac4e059a2c538140$export$ea59b6255584f4ce(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "stamp-collection",
        children: props.stamps.map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $452a05b0d36845a0$export$8897676213252052), {
                type: s
            }, i.toString()))
    });
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

class $f15fd37f3c71009b$export$2e2bcd8739ae039 {
    x = 0;
    y = 0;
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    Add(other) {
        return new $f15fd37f3c71009b$export$2e2bcd8739ae039(this.x + other.x, this.y + other.y);
    }
    Minus(other) {
        return new $f15fd37f3c71009b$export$2e2bcd8739ae039(this.x - other.x, this.y - other.y);
    }
    toString() {
        return "(" + this.x + ", " + this.y + ")";
    }
}


var $8f847b33720aceef$export$6d1afdc636af48e2 = /*#__PURE__*/ function(TargetBehavior) {
    TargetBehavior[TargetBehavior["None"] = 0] = "None";
    TargetBehavior[TargetBehavior["Stick"] = 1] = "Stick";
    TargetBehavior[TargetBehavior["Reset"] = 2] = "Reset";
    return TargetBehavior;
}({});
function $8f847b33720aceef$export$da18f7b9a566a9ea(props) {
    const cursorProvider = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    let animationFrame;
    // x, y is the initial position of the draggable element (and pos it resets to)
    // pos is the offset from the source object.
    const x = props.x !== undefined ? props.x : 0;
    const y = props.y !== undefined ? props.y : 0;
    const w = props.w;
    const h = props.h;
    const [pos, setPos] = (0, $acw62.useState)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(x, y));
    (0, $acw62.useEffect)(()=>{
        if (props.posRef !== undefined) props.posRef.current = pos;
    }, [
        pos
    ]);
    // create an id for this drag & give all the child elements this id.
    const id = (0, $acw62.useRef)(props.id !== undefined ? props.id : (0, $acw62.useId)());
    let children = props.children;
    children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
            const element = child;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                id: props.id
            });
        }
        return child;
    });
    // use this id to detect the screen pos & bounds of this draggable
    const selfRect = (0, $acw62.useRef)(DOMRect.prototype);
    const dragRef = props.dragRef !== undefined ? props.dragRef : (0, $acw62.useRef)(HTMLDivElement.prototype);
    const ogRect = (0, $acw62.useRef)(DOMRect.prototype);
    const ogScroll = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const refreshRect = ()=>{
        const selfElement = document.getElementById(id.current);
        if (selfElement !== null) selfRect.current = selfElement.getBoundingClientRect();
    };
    // tracking the drag state.
    const dragging = (0, $acw62.useRef)(false);
    const hasDragged = (0, $acw62.useRef)(false);
    const relDrag = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    // tracking the cursor position.
    const cursorPos = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const cursorDelta = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const cursorState = (0, $acw62.useRef)(cursorProvider.state);
    // tracking the sticky states.
    const stickSource = (0, $acw62.useRef)(props.stickToSource !== undefined && props.stickToSource);
    const stickTarget = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        cursorState.current = cursorProvider.state;
    }, [
        cursorProvider.state
    ]);
    const mouseWithinRange = ()=>{
        // mouse is in screen space, so we can just test against screen space selfRect      
        let diffX = cursorPos.current.x - selfRect.current.x;
        let diffY = cursorPos.current.y - selfRect.current.y;
        return diffX >= 0 && diffX <= selfRect.current.width && diffY >= 0 && diffY <= selfRect.current.height;
    };
    const isFocused = ()=>{
        return document.elementFromPoint(cursorPos.current.x, cursorPos.current.y)?.id == id.current;
    };
    const atTarget = ()=>{
        if (props.targetId === undefined) return false;
        const target = document.getElementById(props.targetId);
        if (target === undefined) return false;
        var targetRect = target?.getBoundingClientRect();
        if (targetRect === undefined) return false;
        return (selfRect.current.left >= targetRect.left && selfRect.current.left <= targetRect.right || selfRect.current.right >= targetRect.left && selfRect.current.right <= targetRect.right || selfRect.current.left <= targetRect.left && selfRect.current.right >= targetRect.right) && (selfRect.current.bottom >= targetRect.top && selfRect.current.bottom <= targetRect.bottom || selfRect.current.top >= targetRect.top && selfRect.current.top <= targetRect.bottom || selfRect.current.top <= targetRect.top && selfRect.current.bottom >= targetRect.bottom);
    };
    const onMouseOver = (e)=>{
        refreshRect();
        if (mouseWithinRange() && isFocused()) e.preventDefault();
    };
    const onMouseMove = (e)=>{
        let cursorX = 0;
        let cursorY = 0;
        if (props.wrapper) {
            const boundingRect = props.wrapper.getBoundingClientRect();
            cursorX = e.clientX - boundingRect.left;
            cursorY = e.clientY - boundingRect.top;
        } else {
            cursorX = e.clientX;
            cursorY = e.clientY;
        }
        cursorDelta.current.x = cursorX - cursorPos.current.x;
        cursorDelta.current.y = cursorY - cursorPos.current.y;
        cursorPos.current.x = cursorX;
        cursorPos.current.y = cursorY;
        if (dragging.current) {
            refreshRect();
            let dragX = cursorPos.current.x - relDrag.current.x - ogRect.current.left + x + (window.scrollX - ogScroll.current.x);
            let dragY = cursorPos.current.y - relDrag.current.y - ogRect.current.top + y + (window.scrollY - ogScroll.current.y);
            setPos(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(dragX, dragY));
            if (props.onDragged !== undefined) props.onDragged(dragX, dragY);
            return;
        }
    };
    const onMouseDown = (e)=>{
        if (cursorState.current != (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).YOY) return;
        refreshRect();
        if (mouseWithinRange() && isFocused()) {
            e.preventDefault();
            dragging.current = true;
            hasDragged.current = true;
            relDrag.current.x = cursorPos.current.x - selfRect.current.x;
            relDrag.current.y = cursorPos.current.y - selfRect.current.y;
        }
    };
    const onUpdate = ()=>{};
    const onMouseUp = (e)=>{
        if (dragging.current) {
            e.preventDefault();
            dragging.current = false;
            refreshRect();
            if (props.targetId !== undefined) {
                const isAtTarget = atTarget();
                if (isAtTarget) {
                    const canReachTarget = props.canReachTarget !== undefined ? props.canReachTarget() : true;
                    if (canReachTarget) {
                        const targetBehavior = props.targetBehaviour !== undefined ? props.targetBehaviour : 0;
                        switch(targetBehavior){
                            case 1:
                                const targetRect = document.getElementById(props.targetId)?.getBoundingClientRect();
                                if (targetRect !== undefined) {
                                    stickTarget.current = true;
                                    setPos(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(targetRect.x - ogRect.current.x + window.scrollX - ogScroll.current.x, targetRect.y - ogRect.current.y + window.scrollY - ogScroll.current.y));
                                }
                                break;
                            case 2:
                                setPos(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(x, y));
                                break;
                        }
                        if (props.onTarget !== undefined) props.onTarget();
                    }
                }
            }
            if (props.onDragEnded !== undefined) props.onDragEnded(dragRef);
            if (stickSource.current) setPos(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(x, y));
        }
    };
    const consumeDrag = (e)=>{
        e.preventDefault();
    };
    const init = ()=>{
        var selfElement = document.getElementById(id.current);
        if (selfElement !== null) ogRect.current = selfElement.getBoundingClientRect();
        ogScroll.current.x = window.scrollX;
        ogScroll.current.y = window.scrollY;
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mousedown", onMouseDown);
        window.addEventListener("mouseup", onMouseUp);
        window.addEventListener("mouseover", onMouseOver);
        window.addEventListener("dragstart", consumeDrag);
        window.addEventListener("dragover", consumeDrag);
        window.addEventListener("dragenter", consumeDrag);
        window.addEventListener("dragend", consumeDrag);
        window.addEventListener("dragleave", consumeDrag);
        loop();
    };
    const loop = ()=>{
        onUpdate();
        animationFrame = requestAnimationFrame(loop);
    };
    (0, $acw62.useEffect)(()=>{
        init();
        return ()=>{
            cancelAnimationFrame(animationFrame);
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mousedown", onMouseDown);
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("mouseover", onMouseOver);
            window.removeEventListener("dragstart", consumeDrag);
            window.removeEventListener("dragover", consumeDrag);
            window.removeEventListener("dragenter", consumeDrag);
            window.removeEventListener("dragend", consumeDrag);
            window.removeEventListener("dragleave", consumeDrag);
        };
    }, [
        props
    ]);
    let style = {
        top: pos.y,
        left: pos.x
    };
    if (w !== undefined && h !== undefined) style = {
        top: pos.y,
        left: pos.x,
        width: w,
        height: h
    };
    else if (w !== undefined) style = {
        top: pos.y,
        left: pos.x,
        width: w
    };
    else if (h !== undefined) style = {
        top: pos.y,
        left: pos.x,
        height: h
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: id.current,
        ref: dragRef,
        className: "draggable",
        style: style,
        children: children
    });
}



function $729be54a6ff46139$export$6b40d0162fab68e5(props) {
    const lock = props.lock !== undefined ? props.lock : false;
    const id = props.id !== undefined ? props.id : (0, $acw62.useId)();
    const slot = props.slot !== undefined ? props.slot : id + '-slot';
    const dragRef = (0, $acw62.useRef)(HTMLDivElement.prototype);
    const [size, setSize] = (0, $acw62.useState)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    (0, $acw62.useEffect)(()=>{
        setSize(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(dragRef.current.offsetWidth, dragRef.current.offsetHeight));
    }, [
        dragRef.current
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: slot,
        className: "draggable-slot",
        style: {
            minWidth: size.x,
            width: size.x,
            minHeight: size.y,
            height: size.y
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f847b33720aceef$export$da18f7b9a566a9ea), {
            id: id,
            sourceId: slot,
            stickToSource: lock,
            dragRef: dragRef,
            x: 0,
            y: 0,
            targetId: props.targetId,
            onTarget: props.onTarget,
            onDragEnded: props.onDropped,
            canReachTarget: props.canReachTarget,
            children: props.children
        })
    });
}




function $0b5823ce2f094c1a$export$374120720e46d765(element, container, allowOverlap) {
    const allow = allowOverlap !== undefined ? allowOverlap : false;
    if (allow && (/* Does container left or right edge pass through element? */ element.left < container.left && element.right > container.left || element.left < container.right && element.right > container.right || /* Does container top or bottom edge pass through element? */ element.top < container.top && element.bottom > container.top || element.top < container.bottom && element.bottom > container.bottom)) return true;
    /* 
    If boundaries of element fully contained inside bounday of
    container, classify this as containment of element in container
    */ if (element.left >= container.left && element.top >= container.top && element.bottom <= container.bottom && element.right <= container.right) return true;
    return false;
}





class $c9f54c59ab503c66$var$JokeTracker {
    nodes = [];
    words = [];
}
function $c9f54c59ab503c66$export$34e22106a921bb9c() {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    (0, $acw62.useEffect)(()=>{
        player.unlockSite((0, $5fc7b830e79d6137$export$66480abf8fd33e73).key);
    }, []);
    const [rndr, setRndr] = (0, $acw62.useState)(0);
    const rndrRef = (0, $acw62.useRef)(0);
    const wordIndex = (0, $acw62.useRef)(0);
    const jokeIndex = (0, $acw62.useRef)(-1);
    const jokeMaximum = (0, $acw62.useRef)(0);
    const doorState = (0, $acw62.useRef)(0);
    const mainTracker = (0, $acw62.useRef)(new $c9f54c59ab503c66$var$JokeTracker());
    const jokesTracker = (0, $acw62.useRef)(new $c9f54c59ab503c66$var$JokeTracker());
    const freeTracker = (0, $acw62.useRef)(new $c9f54c59ab503c66$var$JokeTracker());
    const audioRef = (0, $acw62.useRef)(new Audio((0, (/*@__PURE__*/$parcel$interopDefault($bd50770fbf187e88$exports)))));
    const jokeBoxRef = (0, $acw62.useRef)(HTMLDivElement.prototype);
    const boothBoxRef = (0, $acw62.useRef)(HTMLDivElement.prototype);
    const doorBoxRef = (0, $acw62.useRef)(HTMLDivElement.prototype);
    const onMainWordDrop = (r)=>{
        var wordRect = r.current.getBoundingClientRect();
        var boxRect = jokeBoxRef.current.getBoundingClientRect();
        const within = (0, $0b5823ce2f094c1a$export$374120720e46d765)(wordRect, boxRect, true);
        if (!within) {
            var jokeNode = mainTracker.current.nodes.find((n)=>n.key == r.current.id);
            if (jokeNode !== undefined) {
                const jokeIndex = mainTracker.current.nodes.indexOf(jokeNode);
                const word = mainTracker.current.words[jokeIndex];
                mainTracker.current.nodes.splice(jokeIndex, 1, /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "hyphen-nobreak all-caps hidden",
                    children: word
                }, r.current.id));
                if (!checkJokeLandingFull(r, jokeNode, word, jokeIndex, mainTracker.current)) {
                    freeTracker.current.words.push(word);
                    freeTracker.current.nodes.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f847b33720aceef$export$da18f7b9a566a9ea), {
                        id: r.current.id,
                        x: wordRect.x,
                        y: wordRect.y,
                        onDragEnded: onFreeWordDrop,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "hyphen-nobreak all-caps",
                            children: word
                        })
                    }, r.current.id));
                } else setRndr(rndrRef.current + 1);
            }
        }
    };
    const onJokeWordDrop = (r)=>{
        checkJokeLanding(r, jokesTracker.current);
    };
    const onFreeWordDrop = (r)=>{
        checkJokeLanding(r, freeTracker.current);
    };
    const checkJokeLanding = (r, tracker)=>{
        console.log(r.current.id);
        console.log(tracker.nodes);
        const node = tracker.nodes.find((n)=>n.key == r.current.id);
        if (node === undefined) return false;
        const index = tracker.nodes.indexOf(node);
        const word = tracker.words[index];
        return checkJokeLandingFull(r, node, word, index, tracker);
    };
    const checkJokeLandingFull = (r, node, word, index, tracker)=>{
        const box = r.current.getBoundingClientRect();
        const wordLower = word.toLowerCase();
        const qValid = wordLower.includes("quarter");
        if (qValid && (0, $0b5823ce2f094c1a$export$374120720e46d765)(box, boothBoxRef.current.getBoundingClientRect(), true)) {
            tracker.nodes.splice(index, 1, /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hyphen-nobreak all-caps hidden",
                children: word
            }, r.current.id));
            jokeMaximum.current++;
            setRndr(rndrRef.current + 1);
            return true;
        }
        let dValid = false;
        switch(doorState.current){
            case 0:
                dValid = wordLower.includes("knock");
                break;
            case 1:
                dValid = wordLower.includes("doris");
                break;
            case 2:
                dValid = wordLower.includes("open");
                break;
        }
        if (dValid && (0, $0b5823ce2f094c1a$export$374120720e46d765)(box, doorBoxRef.current.getBoundingClientRect(), true)) {
            tracker.nodes.splice(index, 1, /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "hyphen-nobreak all-caps hidden",
                children: word
            }, r.current.id));
            doorState.current++;
            setRndr(rndrRef.current + 1);
            return true;
        }
        console.log("dropped: " + word + " (" + r.current.id + ")");
        return false;
    };
    const cycleJoke = ()=>{
        jokeIndex.current++;
        if (jokeIndex.current >= jokeMaximum.current) jokeIndex.current = 0;
        const nextJoke = (0, (/*@__PURE__*/$parcel$interopDefault($89fc9618342929d7$exports))).favorites[jokeIndex.current];
        mainTracker.current.words = nextJoke.split(' ');
        mainTracker.current.nodes = mainTracker.current.words.map((s, i)=>{
            const id = 'wrd-' + (wordIndex.current + i + 1);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $729be54a6ff46139$export$6b40d0162fab68e5), {
                id: id,
                onDropped: onMainWordDrop,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "hyphen-nobreak all-caps",
                    children: s
                })
            }, id);
        });
        wordIndex.current += mainTracker.current.words.length;
        setRndr(rndrRef.current + 1);
    };
    (0, $acw62.useEffect)(()=>{
        rndrRef.current = rndr;
    }, [
        rndr
    ]);
    const fartSound = ()=>{
        audioRef.current.play();
        setRndr(rndrRef.current + 1);
    };
    const page = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "phranks-page",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "phranks-body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box gap-16 center-all",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "h-box gap-16 pos-rel",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
                                        className: "pos-abs",
                                        style: {
                                            top: 100,
                                            left: -200
                                        },
                                        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($869c9da60153d865$exports))),
                                            className: "width-256"
                                        }),
                                        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1c96bb9fc97d308b$exports))),
                                            className: "width-256"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        ref: boothBoxRef,
                                        className: "pos-abs no-events",
                                        style: {
                                            top: 100,
                                            left: -200,
                                            width: 256,
                                            height: 384
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "phranks-header v-box align-end width-512",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                children: "PHRANKS CRANK'S"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                children: "DON'T KNOCK IT TILL YOU TRY IT!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$PCD, {
                                        state: doorState.current
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        ref: doorBoxRef,
                                        className: "pos-abs no-events",
                                        style: {
                                            top: 0,
                                            right: 0,
                                            width: 256,
                                            height: 256
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "phranks-funbox",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "phranks-jokebutton",
                                        onClick: fartSound,
                                        children: "FART"
                                    }),
                                    jokeMaximum.current > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "phranks-jokebutton",
                                        onClick: cycleJoke,
                                        children: [
                                            "JOKE (",
                                            jokeIndex.current + 1,
                                            "/",
                                            jokeMaximum.current,
                                            ")"
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "phranks-jokebutton",
                                        disabled: true,
                                        children: "JOKE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "phranks-jokebox v-box height-96 pos-rel",
                                ref: jokeBoxRef,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "phranks-jokewords h-box",
                                    ref: jokeBoxRef,
                                    children: mainTracker.current.nodes
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box height-128 text-24",
                        children: [
                            "We've got...",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "h-box",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#animaljokes",
                                                    children: "Animal Jokes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#scaryjokes",
                                                    children: "Scary Jokes"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#generaljokes",
                                                    children: "General Jokes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#andmorejokes",
                                                    children: "And More!"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box center-all gap-16",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "height-128 center-all v-box",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c15e7db7c98493bd$exports))),
                                    className: "width-768 no-events",
                                    style: {
                                        transform: "rotateZ(15deg)"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "h-box gap-16 align-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "v-box pos-rel width-640 height-384",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1a1befa0d58c79f3$exports))),
                                                className: "pos-abs width-100p height-100p",
                                                style: {
                                                    top: 0,
                                                    left: 0
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f60384e5a3266f35$exports))),
                                                className: "pos-abs width-128",
                                                style: {
                                                    right: 48,
                                                    top: 48
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "phranks-banner padding-16 pos-abs text-white text-32 all-caps",
                                                style: {
                                                    left: 32,
                                                    top: 16
                                                },
                                                children: "Joke of the Week"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "phranks-text-yellow text-32 pos-abs width-384",
                                                style: {
                                                    left: 64,
                                                    top: 128
                                                },
                                                children: "What did the boy who swallowed a coin ask the doctor?"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "phranks-text-yellow text-24 pos-abs",
                                                style: {
                                                    left: 64,
                                                    top: 292,
                                                    width: 420
                                                },
                                                children: "Doctor, do you see any change in me?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "v-box center-all pos-rel",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
                                                startOn: true,
                                                onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6e92464c3aca2625$exports))),
                                                    className: "width-128 pos-abs",
                                                    style: {
                                                        left: 32,
                                                        top: -32
                                                    }
                                                }),
                                                offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5a7beddde94dbeb1$exports))),
                                                    className: "width-128 pos-abs filter-grayscale",
                                                    style: {
                                                        left: 32,
                                                        top: -32
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "height-96"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "v-box width-192 bg-blue phranks-text-yellow padding-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "text-32",
                                                        children: "FUNNY WORDS"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "superfluous"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "pamplemousse"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "llama"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "defenestration"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "flabbergast"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                children: "bunghole"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$JokesSection, {
                        id: "animaljokes",
                        header: "On the Farm",
                        jokes: (0, (/*@__PURE__*/$parcel$interopDefault($89fc9618342929d7$exports))).animal,
                        wordIndex: wordIndex,
                        tracker: jokesTracker.current,
                        onDragWord: onJokeWordDrop,
                        middle: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "pos-rel",
                            style: {
                                width: 640,
                                height: 189
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$FME, {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4afec30a1e9a4ffa$exports))),
                                    x: 61.80,
                                    y: 0.26,
                                    w: 32.58
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$FME, {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b2337f118d55ec55$exports))),
                                    x: 54.30,
                                    y: 55.82,
                                    w: 8.28
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$FME, {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b5949658951e5817$exports))),
                                    x: 2.34,
                                    y: 37.04,
                                    w: 50.55
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$FME, {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($538b9b22da6e79b7$exports))),
                                    x: 46.95,
                                    y: 51.59,
                                    w: 4.77
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$FME, {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a19bb698ba8300e8$exports))),
                                    x: 86.48,
                                    y: 68.52,
                                    w: 7.97
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$FME, {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6f946778f08d6903$exports))),
                                    x: 19.30,
                                    y: 30.16,
                                    w: 10.31,
                                    r: 25
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "bg-blue height-4 pos-abs",
                                    style: {
                                        top: "100%",
                                        left: 0,
                                        right: 0
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$JokesSection, {
                        id: "scaryjokes",
                        header: "Scary Stuff",
                        jokes: (0, (/*@__PURE__*/$parcel$interopDefault($89fc9618342929d7$exports))).scary,
                        wordIndex: wordIndex,
                        tracker: jokesTracker.current,
                        onDragWord: onJokeWordDrop,
                        bonus: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c4276b4573d07980$exports))),
                                    className: "pos-abs",
                                    style: {
                                        top: -32,
                                        left: -32,
                                        width: 96
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($25749971dbbe47df$exports))),
                                    className: "pos-abs",
                                    style: {
                                        top: -16,
                                        right: -32,
                                        width: 128
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$JokesSection, {
                        id: "generaljokes",
                        header: "General",
                        jokes: (0, (/*@__PURE__*/$parcel$interopDefault($89fc9618342929d7$exports))).general,
                        wordIndex: wordIndex,
                        tracker: jokesTracker.current,
                        onDragWord: onJokeWordDrop,
                        bonus: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($e7c7b621257f6bdd$exports))),
                            className: "pos-abs",
                            style: {
                                top: 16,
                                right: -16,
                                width: 96
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$JokesSection, {
                        id: "andmorejokes",
                        header: "And More...",
                        jokes: (0, (/*@__PURE__*/$parcel$interopDefault($89fc9618342929d7$exports))).more,
                        wordIndex: wordIndex,
                        tracker: jokesTracker.current,
                        onDragWord: onJokeWordDrop
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-box",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($077f6848738ed5b5$exports))),
                                className: "height-96"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "v-box",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-24 all-caps",
                                        children: "Hungry for more websites???"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac4e059a2c538140$export$ea59b6255584f4ce), {
                                        stamps: [
                                            (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Cryptid,
                                            (0, $452a05b0d36845a0$export$cd58f743ba5bc404).TacoBongo,
                                            (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Anime,
                                            (0, $452a05b0d36845a0$export$cd58f743ba5bc404).WTROK
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: freeTracker.current.nodes
                    })
                ]
            })
        });
    }, [
        rndr
    ]);
    return page;
}
function $c9f54c59ab503c66$var$JokesHeader(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: props.id,
        className: "phranks-banner pos-rel v-box center-all",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
            className: "text-64 text-blue padding-16 all-caps",
            children: props.header
        })
    });
}
function $c9f54c59ab503c66$var$JokesSection(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-32 width-640 pos-rel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c9f54c59ab503c66$var$JokesHeader, {
                header: props.header,
                id: props.id
            }),
            props.middle,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box gap-16",
                children: props.jokes.map((j, i)=>{
                    const jokeWords = j.split(' ');
                    const jokeNodes = jokeWords.map((k, l)=>{
                        const id = 'wrd-' + (props.wordIndex.current + l + 1);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $729be54a6ff46139$export$6b40d0162fab68e5), {
                            id: id,
                            onDropped: props.onDragWord,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "hyphen-nobreak",
                                children: k
                            })
                        }, id);
                    });
                    props.tracker.words.push(...jokeWords);
                    props.tracker.nodes.push(...jokeNodes);
                    props.wordIndex.current += jokeWords.length;
                    const jokeDiv = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "phranks-jokewords h-box align-start",
                        children: jokeNodes
                    }, i);
                    return jokeDiv;
                })
            }),
            props.bonus
        ]
    });
}
function $c9f54c59ab503c66$var$PCD(props) {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    const img = props.state >= 3 ? (0, (/*@__PURE__*/$parcel$interopDefault($836144792400ee33$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b7ed009c2ed54a76$exports)));
    const onclick = props.state >= 3 ? ()=>{
        nav('/thecomedyshow');
    } : ()=>{};
    let text = "";
    if (props.state == 1) text = "Who's there?";
    else if (props.state == 2) text = "Doris who?";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: img,
                className: "height-256 pos-rel",
                onClick: onclick
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs",
                style: {
                    top: 256,
                    right: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: text
                })
            })
        ]
    });
}
function $c9f54c59ab503c66$var$FME(props) {
    const r = props.r !== undefined ? props.r : 0;
    if (props.h !== undefined) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        className: "pos-abs",
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: props.h + "%",
            transform: "rotateZ(" + r + "deg)"
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        className: "pos-abs",
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            transform: "rotateZ(" + r + "deg)"
        }
    });
}




function $3b35899696dacc5b$export$19665ecffce36abe() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "somewhere-page",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            className: "somewhere-header",
            children: "somewhere else..."
        })
    });
}



function $50851625e1699575$export$31a099fb9154a7cb() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "v-box",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "taco-box width-768 height-512 v-box padding-64",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "font-taco-primary text-black text-24",
                    children: [
                        "Welcome to the ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-taco-pink",
                            children: "OFFICIAL"
                        }),
                        " home of Taco Bongo!"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "v-box",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "font-taco-primary text-black text-20 padding-8",
                        children: [
                            "Welcome to the OFFICIAL home of Taco Bongo! Hungry? Good. Chillax with the circus freaks and geek out for some suuhhweet dealios.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Don't like tacos? Talk to the paw, mega loser!",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Need to find a local franchise? You could always ask the Onion Ring Master for directions.. or you could just... ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/tacobongo/findus",
                                children: "Find Us!"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/tacobongo/sweepstakes",
                                children: "Triple Oaks! The Automobongomobile is heading to you!"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/tacobongo/meetbongo",
                                className: "font-taco-primary text-20",
                                children: "Want to meet Bongo the dog in person??"
                            })
                        ]
                    })
                })
            ]
        })
    });
}




var $141fa610bc386733$exports = {};
$141fa610bc386733$exports = import.meta.resolve("eSXH0");


var $43df588aa159cd90$exports = {};
$43df588aa159cd90$exports = import.meta.resolve("1GvuR");


var $137066da218dc882$exports = {};
$137066da218dc882$exports = import.meta.resolve("bRzZ2");


var $07049e4a46f22680$exports = {};
$07049e4a46f22680$exports = import.meta.resolve("6rk5L");


var $4ca19742b74835a8$exports = {};
$4ca19742b74835a8$exports = import.meta.resolve("d9RMf");


var $5a6097fc6b636ef5$exports = {};
$5a6097fc6b636ef5$exports = import.meta.resolve("4n9Bd");




var $c6ba1ab7b5cc4ccb$exports = {};
$c6ba1ab7b5cc4ccb$exports = import.meta.resolve("6Jp6r");




var $acw62 = parcelRequire("acw62");

function $80e4c87942015340$export$4a7108e5554afff8(props) {
    const [lines, setLines] = (0, $acw62.useState)([]);
    const width = (0, $acw62.useRef)(0);
    const className = props.className !== undefined ? 'ascii ' + props.className : 'ascii';
    const size = props.size !== undefined ? props.size : 12;
    const h_per_size = size + 1.5;
    const w_per_char = size * 7.2015 / 12;
    (0, $acw62.useEffect)(()=>{
        fetch(props.ascii).then((r)=>r.text()).then((r)=>{
            const splitText = r.split('\n');
            const newLines = [];
            splitText.forEach((v, i, a)=>{
                width.current = Math.max(width.current, v.length);
                newLines.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    id: props.id,
                    children: v
                }, i));
            });
            setLines(newLines);
        });
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        id: props.id,
        className: className,
        style: {
            fontSize: size,
            height: lines.length * h_per_size,
            width: width.current * w_per_char
        },
        children: lines
    });
}



var $acw62 = parcelRequire("acw62");


function $ee72c4bd74cbe700$export$4b2f84f7845fd(props) {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    (0, $acw62.useEffect)(()=>{
        player.unlockSite((0, $5fc7b830e79d6137$export$55c18d8b5b00a1cb).key);
    }, []);
    const page = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "page-basic",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box width-640 center-all text-xanm-green font-treb gap-16",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($141fa610bc386733$exports))),
                        className: "xanm-banner"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            children: "Will have lotsa stuffz soon!! *^-^*"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($43df588aa159cd90$exports))),
                        width: "80%"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-box gap-16",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $452a05b0d36845a0$export$8897676213252052), {
                                type: (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Anime
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-12 width-256",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("i", {
                                    children: [
                                        "Disclaimer: i do not own Cerula Nocht, or any anime ",
                                        '(',
                                        "i wish!!",
                                        ')',
                                        ". none of this belongs to me, only the original creators!"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $452a05b0d36845a0$export$8897676213252052), {
                                type: (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Anime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box xanm-border padding-16 gap-16",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "v-box padding-none",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            '>',
                                            "w",
                                            '<',
                                            "* oh hai there!! You've found my site!!! w00t!! *runs in circles, trips, and falls* I am Bee, and I run this site!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "It's under CONSTRUCTIONZ RIGHT NOW, so haev fun and be nice. \u2514(^o^ )X( ^o^)\u2518"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "No, you can NOT have Aiki-sempai, he is MINE x3 ~nyaa"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-black",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "ROFLCOPTER ATTACK! OUO"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e4c87942015340$export$4a7108e5554afff8), {
                                        id: "roflcopter",
                                        ascii: (0, (/*@__PURE__*/$parcel$interopDefault($c6ba1ab7b5cc4ccb$exports))),
                                        className: "text-black",
                                        size: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerBasic, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "h-box center-all",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-black text-24",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "Current obsession:"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMHeader, {
                                        text: "Cerula Nocht!!!!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "h-box gap-16 center-all",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($137066da218dc882$exports))),
                                        height: 312
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($07049e4a46f22680$exports))),
                                        height: 312
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "v-box text-black",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            " Okay, if u haven\u2019t heard of Cerula Nocht I\u2019m gonna sound ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                children: "Nutso for Nutty Bits"
                                            }),
                                            " but stick with me!!! It\u2019s so good. It\u2019s about two game devs named Hitomi Furutani and Aiki Asano who are working on a JRPG named Cerula Nocht! When they\u2019re working late one night theres a super weird earthquake thunderstorm combo, and they basically get sucked into their own game! Now they\u2019re lost in this weird, half-built world and have to play through the video game, fix the bugs in the code, and defeat the Draught Smog that\u2019s settled over the land and sucked the joy away!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "It\u2019s a isekai, which is my favorite type of anime. If you don\u2019t know what an isekai is, READ A BOOK DUMDUM. no, no wait come back!! I was just joking wahhh Q_Q oh noeesss\u2026."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "oh ur still here?? CELEBRATIONS!!!! puts on professor glasses  O-O*",
                                            '>',
                                            " let me excplain.."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerBasic, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMHeader, {
                                text: "Wut is an Isekai??"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "v-box text-black",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "ahhemm erm well an isekai is a type of anime where the protagonist gets transported to a faraway and magicool world. It\u2019s like Magic Knight Rayearth! And Inuyasha. Shesshyyy is so smexy x3\u2026 and also Wizard of Oz if u really think about it. The main character is usually not very strong but meets powerful peeps in the new world and saves the day!! But i like it best when they go back to the home world thats normal and all these funny fantasy superpowered guys have to like, wear school uniforms and go to class and stuffs ROFL."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "I like them a lot bc u can see urself there too. Where oh where is my cool animal friend with fire powers!! and I wouldn\u2019t have to go to school. *fart sounds*"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "ANYYYWHOOooo isekais are cool beans and u should totally check them out!!!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerBasic, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMHeader, {
                                text: "Theories and Stuffs"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "v-box text-black",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "-----IF you haven\u2019t watched past episode 11 DO NOT READ!! SPOILERS AHEAD----"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "........."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: ".................."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "----------------------I MEAN IT, DO NOT GET SPOILED --------------------------------------"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "................................................."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Aiki-kun is soooo cute AHHHHH screams and runs into a wall"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "-----------rofl okay NOW SPOILERZ--------------------------------------------------"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "I have a theory about what\u2019s gonna happen once Aiki and Hitomi finally team up with the Guilds of Nocht!!"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Okay okay so to understand my brilliant theory you need to understand Ame, which is the life energy of Cerula Nocht. There\u2019s positive ame and negative ame, which are based around life and death, give and take. As above so below! You get it. Every person has some positive ame and some negative, and their powers are based on the percentage of one to another. Nyanyakon can access both at the same time, so he has this cool power where he can tranform himself and the world around him, instead of just the world like most people. Bc the main characters are from a different world, they don\u2019t have any ame. but I think they do, they just dont know how to unlock it."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "In episode 2 when they meet Nyanyakon he says they smell different, like something is missing. Which of course you\u2019d think would be their ame, or maybe earth stink, but I think it\u2019s a clue!  We can see later in ep 4 when they walk through the Valley of NAN that the shells of enemies don\u2019t register them at all, even though they recognise Nyanyakon. AND when they\u2019re talking to The Grand Buzzard, that guy who never sleeps, he says he couldn\u2019t see them in his visions of the visit, which like, NEVER happens! BUT, for them to have no Ame would mean that they wouldn\u2019t be able to operate the sacred weapons of the Guild of the Fallen, right? Their blood still worked! So I think instead of no Ame, they have Null Ame! Like all the errors and bugs. They don\u2019t belong in the game or the world, and neither do all of these errors! "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "IDK what that  means but I wonder if it would lead to cool powers like being able to delete stuff or rewind time, kinda like developers can do when building games?? And THATS\u2019S how they\u2019re gonna defeat the smog."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "IDK WHAT DO YOU THINK ?? Am I blessed by divine inspiration??? Does the great Buzzard smile upon me?? Just a theory ",
                                            '>',
                                            "///",
                                            '<'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerBasic, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMHeader, {
                                text: "About Me"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "v-box text-black",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                children: [
                                                    "Current Residence: Where you least expect me ",
                                                    '>',
                                                    ":)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Favourite genre of music: ALL! Except country yuckk"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Thinking about: life... \u0CA0__\u0CA0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Favourite quote: MEEP!"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: "Feeling: -_____- ZZZZZZZZZZZZZzzzzzzzzzzzZZZZZZzzzzzzzZZZZZZZZZZzzzzz"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Haaiiii I\u2019m BeebiiX3, u can call me Bee for short if u wanna.  I love ummm music, drawing, Pocky, and of course ANIME (and manga). I\u2019m still new to code, so be nice 2 me. One day\u2026 I will be A PWROGAMMAAAAHHH!!! bUT NOT YET."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "I like shojos and bishie men especially lolz. ",
                                            '>',
                                            "////",
                                            '<',
                                            " I mostly watch fansubs my friend bought at a con ^.^ but I\u2019ve been known to sail the high seas on occasion LOL JK. Plz no jail time Mr police. I dun wanna be on Cops 0:\u2019\u20113 If u have a show u think I\u2019d luv, let me know!!! I hunger omnomnomnom."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "I have been pretty lonely lately, so sorry if le sadness ruins ur day. I\u2019ve been craving cuddles! First off, that sounds weird coming from me, second of all I don't even have a boyfriend! sigh warning to all of those of the male gender, beware! lol no just kidding.....sort of. muhahahaha"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "Halp me ;___; needs hug**"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: "If u know where to find epies 11-15 I would love you 5EVER! glomps Q_Q Pls let me know kthnxbaii. Blarrrgggenflargenn"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "If I\u2019m not here or watching anime you can find me on my home skillet\u2019s spooky forum ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: '/cnn',
                                                children: "HERE!"
                                            }),
                                            " \u2190- \u2190- \u2190-"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerBasic, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "anime-section",
                                style: {
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$AnimeLink, {
                                        text: "urlaboutanimehere.com",
                                        url: ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$AnimeLink, {
                                        text: "screenshots-of-spike.org",
                                        url: ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$AnimeLink, {
                                        text: "link3.link",
                                        url: ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac4e059a2c538140$export$ea59b6255584f4ce), {
                        stamps: [
                            (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Cryptid,
                            (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Phranks
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee72c4bd74cbe700$var$XANMDividerGlam, {})
                ]
            })
        });
    }, [
        props
    ]);
    return page;
}
function $ee72c4bd74cbe700$var$XANMDividerGlam() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ca19742b74835a8$exports))),
        className: "xanm-divider width-100p"
    });
}
function $ee72c4bd74cbe700$var$XANMDividerBasic() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "width-100p height-4 bg-xanm-neon"
    });
}
function $ee72c4bd74cbe700$var$XANMHeader(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
        className: "text-24",
        children: props.text
    });
}
function $ee72c4bd74cbe700$var$AnimeLink(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "anime-link",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                width: 16,
                height: 16,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5a6097fc6b636ef5$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: props.url,
                children: props.text
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



var $d8b801afb9641d7d$exports = {};
$d8b801afb9641d7d$exports = import.meta.resolve("hFm8K");



function $15eecc4430ab09f1$export$c7400c2afca92dcc(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "border-black border-radius-4 padding-8 bg-white-off",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
            children: props.text
        })
    });
}



function $1c7b5dbceb4de053$export$861edd1ccea2f746() {
    const context = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "main-body",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e4c87942015340$export$4a7108e5554afff8), {
                id: 'wlair-webmaster',
                ascii: (0, (/*@__PURE__*/$parcel$interopDefault($d8b801afb9641d7d$exports))),
                size: 12
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15eecc4430ab09f1$export$c7400c2afca92dcc), {
                        text: "Hello friends! I'm the Webmaster!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15eecc4430ab09f1$export$c7400c2afca92dcc), {
                        text: "Plz help!!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15eecc4430ab09f1$export$c7400c2afca92dcc), {
                        text: "There's a bunch of important files stuck in my brain but I can't remember them..."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15eecc4430ab09f1$export$c7400c2afca92dcc), {
                        text: "Can you find and open the Archive?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>{
                    nav('/tripleoaks');
                },
                children: "Enter my Brain"
            })
        ]
    });
}







var $acw62 = parcelRequire("acw62");


const $bbd230e5ce70aa2a$export$923ea8233b386e99 = "https://trok-5a879ddaaa05.herokuapp.com/";
const $bbd230e5ce70aa2a$export$299ba2dee77727e9 = (url, json = {})=>{
    const urlbody = new URLSearchParams(Object.entries(json)).toString();
    console.log(urlbody);
    return fetch($bbd230e5ce70aa2a$export$923ea8233b386e99 + url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
            // 'Content-Type': 'application/json'
            'Content-Type': "application/x-www-form-urlencoded"
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: urlbody // body data type must match "Content-Type" header
    });
};





var $acw62 = parcelRequire("acw62");
const $7486e87f2dee7e03$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    cmds: [],
    addCommand: (s)=>{},
    removeCommand: (s)=>{}
});
const $7486e87f2dee7e03$var$ExecProvider = ({ children: children })=>{
    const addCommand = (s)=>{
        if (cmds.includes(s)) return;
        const newCmds = [
            ...cmds
        ];
        newCmds.push(s);
        setCmds(newCmds);
    };
    const removeCommand = (s)=>{
        if (!cmds.includes(s)) return;
        const newCmds = [
            ...cmds
        ];
        newCmds.splice(newCmds.indexOf(s), 1);
        setCmds(newCmds);
    };
    const [cmds, setCmds] = (0, $acw62.useState)([]);
    const value = (0, $acw62.useMemo)(()=>{
        return {
            cmds: cmds,
            addCommand: addCommand,
            removeCommand: removeCommand
        };
    }, [
        cmds
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7486e87f2dee7e03$var$context.Provider, {
        value: value,
        children: children
    });
};
$7486e87f2dee7e03$var$ExecProvider.context = $7486e87f2dee7e03$var$context;
var $7486e87f2dee7e03$export$2e2bcd8739ae039 = $7486e87f2dee7e03$var$ExecProvider;



function $2865d2f5324aa410$export$4b85d3515bd863a5(props) {
    const [text, setText] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [result, setResult] = (0, $acw62.useState)('');
    const cursorProvider = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const execProvider = (0, $acw62.useContext)((0, $7486e87f2dee7e03$export$2e2bcd8739ae039).context);
    const navigate = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    const handleChange = (event)=>{
        setText(event.target.value);
    };
    const handleSubmit = (event)=>{
        if (text != '') setSearch(text);
        else setResult('');
        event.preventDefault();
    };
    const handleResult = (res)=>{
        console.log(res);
        const split = res.split(':');
        if (split.length == 2) {
            if (split[0] == "cursor") {
                cursorProvider.setStateFromCode(split[1]);
                setResult('Help Granted!');
                return;
            } else if (split[0] == "exec") {
                execProvider.addCommand(split[1]);
                setResult('Help Granted!');
                return;
            } else if (split[0] == "redirect") {
                navigate(split[1]);
                return;
            }
        }
        cursorProvider.setStateFromCode('');
        setResult(res);
    };
    (0, $acw62.useEffect)(()=>{
        if (search == '') return;
        try {
            const body = {
                key: search
            };
            (0, $bbd230e5ce70aa2a$export$299ba2dee77727e9)('api/search', body).then((res)=>res.json()).then((res)=>{
                setSearch('');
                setText('');
                handleResult(res.value);
            });
        } catch (e) {
            console.log(e);
            return;
        }
    }, [
        search
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box center-all gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "h-box gap-4 center-all cursor-none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        value: text,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "submit",
                        value: "Submit",
                        className: "og-button"
                    })
                ]
            }),
            search != '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "ass-text",
                children: "'Searching...'"
            }) : null,
            result != '' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "ass-text",
                children: result
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");






const $50eff8c4f50f7148$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    x: 16,
    y: 16
});
const $50eff8c4f50f7148$var$ToolbarProvider = (props)=>{
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    const loc = (0, $f0eb7f6a0a55da23$export$45d76561a5302f2b)();
    const value = {
        x: 16,
        y: 16
    };
    const toolbar = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box gap-8 center-all",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-top all-ass ass-left"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-top all-ass ass-right"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "z-top all-ass ass-bottom h-box center-all",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: 216
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "og-button",
                        onClick: ()=>{
                            nav('/');
                        },
                        children: "Exit"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-spacing"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50eff8c4f50f7148$var$CrsSelector, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "width-32"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50eff8c4f50f7148$var$QuickNav, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "width-32"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2865d2f5324aa410$export$4b85d3515bd863a5), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "width-32"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-spacing"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-top all-ass ass-top h-box center-all",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($50eff8c4f50f7148$var$DebugBar, {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-top ass-screen crt no-events"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-top ass-middle no-events"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-top asswm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e4c87942015340$export$4a7108e5554afff8), {
                    id: "twm",
                    ascii: (0, (/*@__PURE__*/$parcel$interopDefault($d8b801afb9641d7d$exports))),
                    size: 4
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($50eff8c4f50f7148$var$context.Provider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ass-padding",
                children: props.children
            }),
            loc.pathname == '/' ? null : toolbar
        ]
    });
};
function $50eff8c4f50f7148$var$CrsSelector(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box center-all gap-4",
        children: [
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).STD),
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).HAM),
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).YOY),
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).PLZ),
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY1),
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY2),
            $50eff8c4f50f7148$var$CrsBtn((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY3)
        ]
    });
}
function $50eff8c4f50f7148$var$CrsBtn(state) {
    const playerProvider = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    const cursorProvider = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const info = (0, $4d33f92596c93eff$export$d1e6c08dda6b3d5d)(state);
    if (!playerProvider.hasUnlockedCursor(info.key)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: "h-box center-all og-button",
        style: {
            width: 36,
            height: 36
        },
        onClick: ()=>{
            cursorProvider.setState(state);
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            className: "width-24 height-24",
            src: info.icon
        })
    });
}
function $50eff8c4f50f7148$var$QuickNav(props) {
    const playerProvider = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    const loc = (0, $f0eb7f6a0a55da23$export$45d76561a5302f2b)();
    const matchedSite = (0, $5fc7b830e79d6137$export$a21c2d331a79837c).find((s)=>loc.pathname.startsWith(s.path));
    const currentPath = matchedSite !== undefined ? matchedSite.path : (0, $5fc7b830e79d6137$export$3c969d42479bc900).path;
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    const [site, setSite] = (0, $acw62.useState)(currentPath);
    const handleSelect = (e)=>{
        setSite(e.target.value);
    };
    const handleSubmit = ()=>{
        nav(site);
    };
    const select = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        name: "pages",
        id: "pages",
        onChange: handleSelect,
        className: "width-128",
        value: site,
        children: playerProvider.data.sites.map((s)=>$50eff8c4f50f7148$var$NavOption(s))
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "h-box gap-4 center-all",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                children: "Navigate"
            }),
            select,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "submit",
                value: "Go!",
                className: "og-button"
            })
        ]
    });
}
function $50eff8c4f50f7148$var$NavOption(key) {
    const siteInfo = (0, $5fc7b830e79d6137$export$8eeada7b01a97848)(key);
    if (siteInfo === undefined) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
        value: siteInfo.path,
        children: siteInfo.name
    }, key);
}
function $50eff8c4f50f7148$var$DebugBar() {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box align-end justify-end gap-4 width-100p",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "og-button",
                onClick: ()=>{
                    player.debugUnlockAll();
                },
                children: "Unlock All"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "og-button",
                onClick: ()=>{
                    nav((0, $5fc7b830e79d6137$export$3c969d42479bc900).path);
                    player.debugClearAll();
                },
                children: "Clear All"
            })
        ]
    });
}
$50eff8c4f50f7148$var$ToolbarProvider.context = $50eff8c4f50f7148$var$context;
var $50eff8c4f50f7148$export$2e2bcd8739ae039 = $50eff8c4f50f7148$var$ToolbarProvider;





var $2105be4d63031cac$exports = {};
$2105be4d63031cac$exports = import.meta.resolve("2lfCo");



var $acw62 = parcelRequire("acw62");
function $990dae71a55e8f53$export$9f833f0b07b32372() {
    const audioRef = (0, $acw62.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($2105be4d63031cac$exports))));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bfh",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("audio", {
                ref: audioRef,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2105be4d63031cac$exports))),
                autoPlay: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e171536dbce14bb9$exports))),
                className: "spinny"
            })
        ]
    });
}





var $599521a4258e489b$exports = {};
$599521a4258e489b$exports = import.meta.resolve("9lf0p");


function $eb1496e00a69fcc1$export$d3ee0c2daf5ead2b() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fitp-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($599521a4258e489b$exports))),
                className: "fitp-cL"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($599521a4258e489b$exports))),
                className: "fitp-cR"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fitp-f"
            })
        ]
    });
}




var $b05a4de78d608494$exports = {};
$b05a4de78d608494$exports = import.meta.resolve("2MJWk");


function $7b0ab93779cc2597$export$f0a9532e1048387e() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-basic center-all bg-black text-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "h-box width-100p height-512 vut-bg center-all",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b05a4de78d608494$exports))),
                className: "width-384 height-384"
            })
        })
    });
}



var $09cac49fe48214f2$exports = {};
$09cac49fe48214f2$exports = import.meta.resolve("aUX3R");


var $35d66f6a5f51a94d$exports = {};
$35d66f6a5f51a94d$exports = import.meta.resolve("8hM5C");


var $49fc14ca3cff8301$exports = {};
$49fc14ca3cff8301$exports = import.meta.resolve("eV64X");


var $e7d000053250ddaa$exports = {};
$e7d000053250ddaa$exports = import.meta.resolve("hdL4e");


var $10b3345214e5ab84$exports = {};
$10b3345214e5ab84$exports = import.meta.resolve("60oXw");


var $3f175ddad07fceaa$exports = {};
$3f175ddad07fceaa$exports = import.meta.resolve("i7wnN");


var $b30b20194c18a436$exports = {};
$b30b20194c18a436$exports = import.meta.resolve("d7RsL");


var $22fee30a646748bf$exports = {};
$22fee30a646748bf$exports = import.meta.resolve("4c7gE");



var $43e604e83db353cc$exports = {};
$43e604e83db353cc$exports = import.meta.resolve("1Bi80");


var $61d4c7468224a8ab$exports = {};
$61d4c7468224a8ab$exports = import.meta.resolve("jmhgk");


var $cb1caa23024f3693$exports = {};
$cb1caa23024f3693$exports = import.meta.resolve("5MMrF");


var $864c573431e461c0$exports = {};
$864c573431e461c0$exports = import.meta.resolve("lxk2q");


var $5055a6baefc77e0c$exports = {};
$5055a6baefc77e0c$exports = import.meta.resolve("ccQRM");


var $c609b172d6d1aa85$exports = {};
$c609b172d6d1aa85$exports = import.meta.resolve("28KgG");


var $bba5db7b184fe9d4$exports = {};
$bba5db7b184fe9d4$exports = import.meta.resolve("lRuoJ");


var $3682e05a30b47b4f$exports = {};
$3682e05a30b47b4f$exports = import.meta.resolve("cQXYB");


var $a3f16576ff36bc8c$exports = {};
$a3f16576ff36bc8c$exports = import.meta.resolve("f9pTS");


var $24b13fff6fa3600d$exports = {};
$24b13fff6fa3600d$exports = import.meta.resolve("7ryBa");


var $1eac1181cbcd41d8$exports = {};
$1eac1181cbcd41d8$exports = import.meta.resolve("pac6p");


var $e12d83ba1c1b0bd3$exports = {};
$e12d83ba1c1b0bd3$exports = import.meta.resolve("9GT2Q");


var $9bcd7c56cae0f841$exports = {};
$9bcd7c56cae0f841$exports = import.meta.resolve("4XjZB");


var $eed20d3546a9ee29$exports = {};
$eed20d3546a9ee29$exports = import.meta.resolve("aIhKv");


var $2587128249ad7c60$exports = {};
$2587128249ad7c60$exports = import.meta.resolve("iNrsV");


var $994aae919b399e67$exports = {};
$994aae919b399e67$exports = import.meta.resolve("d7t8w");


var $c0559f6b9813d994$exports = {};
$c0559f6b9813d994$exports = import.meta.resolve("ey7EW");


var $5990b0607f8c5a39$exports = {};
$5990b0607f8c5a39$exports = import.meta.resolve("kSXCQ");


var $028ec7baa04bf75e$exports = {};
$028ec7baa04bf75e$exports = import.meta.resolve("3z9Bj");


var $f883c7699bddf572$exports = {};
$f883c7699bddf572$exports = import.meta.resolve("kDO3D");


var $247bea94c9d80982$exports = {};
$247bea94c9d80982$exports = import.meta.resolve("q18Ud");


var $8a6bdfc090cf4638$exports = {};
$8a6bdfc090cf4638$exports = import.meta.resolve("40Na1");


var $f26dc10253a7c2bc$exports = {};
$f26dc10253a7c2bc$exports = import.meta.resolve("byP9P");


var $c5a1f2cf4b3eb532$exports = {};
$c5a1f2cf4b3eb532$exports = import.meta.resolve("dtZUt");


var $12af05c6f0421adc$exports = {};
$12af05c6f0421adc$exports = import.meta.resolve("bu9li");


var $c8a07e82f9d9bec8$exports = {};
$c8a07e82f9d9bec8$exports = import.meta.resolve("8PQqO");


var $4acc6a8e4fc266c8$exports = {};
$4acc6a8e4fc266c8$exports = import.meta.resolve("aaybK");


var $d4f44075c28a6857$exports = {};
$d4f44075c28a6857$exports = import.meta.resolve("6BIHu");


var $afadf770d41d4a50$exports = {};
$afadf770d41d4a50$exports = import.meta.resolve("a157q");


var $94aa59c994c6a719$exports = {};
$94aa59c994c6a719$exports = import.meta.resolve("dSR6e");


var $d00a4261d473a972$exports = {};
$d00a4261d473a972$exports = import.meta.resolve("lPHKS");


var $5b3ce97d98b28e5d$exports = {};
$5b3ce97d98b28e5d$exports = import.meta.resolve("1dPJq");


var $cc50f32d5182f291$exports = {};
$cc50f32d5182f291$exports = import.meta.resolve("9M42g");


var $4328831458ee3b11$exports = {};
$4328831458ee3b11$exports = import.meta.resolve("EOyco");


var $23fecd537ea4f7aa$exports = {};
$23fecd537ea4f7aa$exports = import.meta.resolve("7GniZ");


var $4a486f6f2003f727$exports = {};
$4a486f6f2003f727$exports = import.meta.resolve("8bZPd");



const $550cc20321efe4ec$var$STD_WIDTH = 1920;
const $550cc20321efe4ec$var$STD_HEIGHT = 1371;
function $550cc20321efe4ec$export$42fdbd9715c0ebc6() {
    const width = 960;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "page-basic bg-black v-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-64"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pos-rel mask-content",
                style: {
                    width: width,
                    height: width * $550cc20321efe4ec$var$STD_HEIGHT / $550cc20321efe4ec$var$STD_WIDTH
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($09cac49fe48214f2$exports))),
                        left: 0,
                        top: 0,
                        width: 100
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($35d66f6a5f51a94d$exports))),
                        left: -0.16,
                        top: 0.00,
                        width: 58.85
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cc50f32d5182f291$exports))),
                        left: 9.64,
                        top: 33.11,
                        width: 10.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4328831458ee3b11$exports))),
                        left: 20.21,
                        top: 35.74,
                        width: 10.31
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($23fecd537ea4f7aa$exports))),
                        left: 30.52,
                        top: 35.74,
                        width: 10.31
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4a486f6f2003f727$exports))),
                            left: 40.83,
                            top: 33.99,
                            width: 8.54
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($49fc14ca3cff8301$exports))),
                        left: 5.89,
                        top: 4.08,
                        width: 15.78
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e7d000053250ddaa$exports))),
                        left: 76.30,
                        top: 19.77,
                        width: 22.92
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($10b3345214e5ab84$exports))),
                        left: 58.28,
                        top: 1.90,
                        width: 18.02
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3f175ddad07fceaa$exports))),
                        left: 11.25,
                        top: 47.63,
                        width: 7.81
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b30b20194c18a436$exports))),
                        left: 82.50,
                        top: -3.94,
                        width: 14.69
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($22fee30a646748bf$exports))),
                        left: 76.61,
                        top: 45.95,
                        width: 11.88
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b7ed009c2ed54a76$exports))),
                        left: 85.16,
                        top: 36.25,
                        width: 15.89
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($43e604e83db353cc$exports))),
                        left: 64.38,
                        top: 42.60,
                        width: 12.66
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($61d4c7468224a8ab$exports))),
                        left: 61.67,
                        top: 55.65,
                        width: 5.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cb1caa23024f3693$exports))),
                        left: 90.47,
                        top: 51.79,
                        width: 5.83
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($864c573431e461c0$exports))),
                        left: 89.84,
                        top: 59.88,
                        width: 13.02
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5055a6baefc77e0c$exports))),
                        left: 73.75,
                        top: 60.39,
                        width: 10.21
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c609b172d6d1aa85$exports))),
                        left: 92.29,
                        top: 74.18,
                        width: 7.40
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bba5db7b184fe9d4$exports))),
                        left: 63.59,
                        top: 64.33,
                        width: 8.33
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3682e05a30b47b4f$exports))),
                        left: 63.54,
                        top: 65.28,
                        width: 7.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bba5db7b184fe9d4$exports))),
                        left: 78.02,
                        top: 76.95,
                        width: 8.33
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a3f16576ff36bc8c$exports))),
                        left: 69.84,
                        top: 75.42,
                        width: 3.70
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($24b13fff6fa3600d$exports))),
                        left: 82.45,
                        top: 72.50,
                        width: 10.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1eac1181cbcd41d8$exports))),
                        left: 76.15,
                        top: 75.49,
                        width: 5.36
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e12d83ba1c1b0bd3$exports))),
                        left: 18.23,
                        top: 35.96,
                        width: 19.06
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9bcd7c56cae0f841$exports))),
                        left: 25.68,
                        top: 49.16,
                        width: 18.70
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($eed20d3546a9ee29$exports))),
                        left: 0.00,
                        top: 42.16,
                        width: 21.77
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2587128249ad7c60$exports))),
                        left: 55.26,
                        top: 43.69,
                        width: 7.08
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2587128249ad7c60$exports))),
                        left: -0.73,
                        top: 59.08,
                        width: 5.31
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bba5db7b184fe9d4$exports))),
                        left: 19.38,
                        top: 81.33,
                        width: 8.33
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bba5db7b184fe9d4$exports))),
                        left: 3.70,
                        top: 70.46,
                        width: 8.33
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($994aae919b399e67$exports))),
                        left: 14.32,
                        top: 80.01,
                        width: 10.10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0559f6b9813d994$exports))),
                        left: 19.43,
                        top: 65.43,
                        width: 7.34
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5990b0607f8c5a39$exports))),
                        left: 13.91,
                        top: 60.47,
                        width: 7.92
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($028ec7baa04bf75e$exports))),
                        left: 42.97,
                        top: 59.88,
                        width: 5.52
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0559f6b9813d994$exports))),
                        left: 46.88,
                        top: 64.55,
                        width: 6.15
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f883c7699bddf572$exports))),
                        left: 36.93,
                        top: 73.81,
                        width: 10.94
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($247bea94c9d80982$exports))),
                        left: 48.54,
                        top: 76.08,
                        width: 7.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0559f6b9813d994$exports))),
                        left: 43.02,
                        top: 77.02,
                        width: 10.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a6bdfc090cf4638$exports))),
                        left: -4.27,
                        top: 82.06,
                        width: 16.25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0559f6b9813d994$exports))),
                        left: 1.98,
                        top: 91.17,
                        width: 10.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f26dc10253a7c2bc$exports))),
                        left: 3.70,
                        top: 69.07,
                        width: 6.04
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c5a1f2cf4b3eb532$exports))),
                        left: 21.72,
                        top: 81.91,
                        width: 6.09
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($12af05c6f0421adc$exports))),
                        left: 26.04,
                        top: 84.46,
                        width: 6.72
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c8a07e82f9d9bec8$exports))),
                        left: 23.85,
                        top: 64.19,
                        width: 11.30
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4acc6a8e4fc266c8$exports))),
                        left: 37.60,
                        top: 67.47,
                        width: 4.79
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d4f44075c28a6857$exports))),
                        left: 51.67,
                        top: 57.99,
                        width: 5.42
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($afadf770d41d4a50$exports))),
                        left: 38.39,
                        top: 81.11,
                        width: 8.91
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($94aa59c994c6a719$exports))),
                        left: 35.78,
                        top: 90.44,
                        width: 11.15
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d00a4261d473a972$exports))),
                        left: 58.44,
                        top: 80.38,
                        width: 10.52
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550cc20321efe4ec$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5b3ce97d98b28e5d$exports))),
                        left: 46.67,
                        top: 82.49,
                        width: 59.01
                    })
                ]
            })
        ]
    });
}
function $550cc20321efe4ec$var$FME(props) {
    const src = props.src;
    const t = props.top;
    const l = props.left;
    const w = props.width;
    const c = props.class !== undefined ? props.class : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        className: 'pos-abs ' + c,
        style: {
            top: t + "%",
            left: l + "%",
            width: w + "%"
        }
    });
}





var $acw62 = parcelRequire("acw62");
var $ed47dfc85fd25007$exports = {};
$ed47dfc85fd25007$exports = import.meta.resolve("aiqe8");


var $95a738d32638362f$exports = {};
$95a738d32638362f$exports = JSON.parse('[{"id":"user1","username":"UserName","icon":"","signature":"whatever, i don\'t even care"},{"id":"kitty","username":"JelloKitty","icon":"","signature":"meoeoeoew!"},{"id":"butt","username":"ButtGuy","icon":"actor","signature":"my own butt, not my preferences"},{"id":"red","username":"REDCON12","icon":"group2","signature":"hey it\'s me"},{"id":"kat","username":"katkat","icon":"castle","signature":"Thinking up sewing puns is harder than it seams. I\'m out of material! "},{"id":"madmod","username":"MadMod","icon":"cheese","signature":"I Am The Great Cornholio, I need T.P. For My Bunghole!"},{"id":"rofl","username":"ROFLBeaver ","icon":"fairy","signature":"The trouble with having an open mind, of course, is that people will insist on coming along and trying to put things in it. - Terry Pratchett"},{"id":"scotty","username":"BeamMeUpScotty  ","icon":"honse","signature":"omlette du\u2026 fromage. Omlette DU\u2026 froooomage. (>w<)"},{"id":"signals","username":"FadedSignals","icon":"creature","signature":"The truth is out there."},{"id":"web","username":"W3BM45T3R","icon":"television","signature":"(\u256F\xb0\u25A1\xb0\uFF09\u256F\uFE35 \u253B\u2501\u253B"},{"id":"gert","username":"GoGert244","icon":"mask","signature":"If you\'re reading this, you\'re too close. "},{"id":"dj","username":"DJBishieB0y","icon":"layer4","signature":"This planet has - or rather had - a problem, which was this: most of the people living on it were unhappy for pretty much of the time. Many solutions were suggested for this problem, but most of these were largely concerned with the movement of small green pieces of paper, which was odd because on the whole it wasn\'t the small green pieces of paper that were unhappy."},{"id":"slim","username":"ChipperSlim321","icon":"castle","signature":"Eye of a hurricane, listen to yourself churnWorld serves its own needs, don\'t misserve your own needs Feed it off an aux, speak, grunt, no strength"},{"id":"chick","username":"xXChimkenNuggetXx","icon":"books","signature":"I got a fever, and the only prescription is more cowbell! \u1555( \u141B )\u1557"},{"id":"lettuce","username":" LettuceCrim3e   ","icon":"candle","signature":"I\u2019m fluent in sarcasm ( \u0361\xb0 \u035C\u0296 \u0361\xb0)"},{"id":"ded","username":"dedgirl","icon":"clown","signature":"There are no happy endings. Endings are the saddest part, So just give me a happy middle And a very happy start."},{"id":"howl","username":"`=howling-malestrom=","icon":"mask2","signature":"hope is the thing with feathers that perches in the soul"},{"id":"weeb","username":"BeebiiX3","icon":"nyan","signature":"Tremble at mAH p0sts.. of D0000M Like anime?? 0.0 look at my site! <link>"},{"id":"rat","username":"that_stray_rat","icon":"layer2","signature":"This message has been approved by The Committe for The Stray Rat Campaign"},{"id":"ghost","username":"GhostiewiththeMostie","icon":"mermaid","signature":"BoooOOOOooooOOOOooooooo!!! I\u2019m the GHOST of Posts PASsssSSSttttt!"},{"id":"dude","username":"TheTrousersDude","icon":"minotaur","signature":"Gon Fishin \uD83D\uDC1F"},{"id":"egg","username":"egg","icon":"egg","signature":"egg egg egg egg"},{"id":"shelvn","username":"shelvn","icon":"yea","signature":"z0nk off squ33b -___-"},{"id":"greg","username":"GregPotato","icon":"broom","signature":"www.clickhereforfreemoviesandmusic.com/veryreal/andgood"},{"id":"babs","username":"Babs","icon":"babs","signature":"wascally widdle wabbit"},{"id":"user26","username":"","icon":"","signature":""}]');


var $b439820d0f0b1ba1$exports = {};
$b439820d0f0b1ba1$exports = JSON.parse("[{\"id\":\"Info\",\"title\":\"Forum Info & Introductions \",\"description\":\"The very first board, where all the best discussions happen.\"},{\"id\":\"general\",\"title\":\"General Interests\",\"description\":\"A board for normal stuff. \"},{\"id\":\"phenomena\",\"title\":\"Unexplained Phenomena and Supernatural\",\"description\":\"For creepies, crawlies, cases, curiosities, and cryptozoological oCuurences \"},{\"id\":\"accounts\",\"title\":\"First Hand Accounts \",\"description\":\"Did you experience something? Tell us about it! Not for stories about hands. \"},{\"id\":\"news\",\"title\":\"News and Stories \",\"description\":\"Clippings and collections of happenings around the tri-state area \"},{\"id\":\"theories\",\"title\":\"Theory Crafting \",\"description\":\"Bounce ideas and theories off other brainiacs \"}]");


var $dfebc6e9267b18ee$exports = {};
$dfebc6e9267b18ee$exports = JSON.parse('{"id":"1","board":"Info","title":"Bug Catcher- report issues here! ","author":"madmod","replies":8,"posts":[{"user":"madmod","body":"Please report any issues with the forum in this thread."},{"user":"rat","body":"> Please report any issues with the forum in this thread.\\n\\n\\nI do not like this thread"},{"user":"weeb","body":"i miss dingo :(((( unban him pwease"},{"user":"scotty","body":"on my way home from school I saw caterpillr :)"},{"user":"madmod","body":"> i miss dingo :(((( unban him pwease\\n\\nWe don\'t unban people here. If he wants to roleplay as a lesbian, he\'s going to have to do it somewhere else. It\'s not that hard to be normal!"},{"user":"weeb","body":"\\n> We don\'t unban people here. If he wants to roleplay as a lesbian, he\'s going to have to do it somewhere else. It\'s not that hard to be normal!\\n\\nBAKA.... \uFF08\uFFE3\uFF5E\uFFE3;\uFF09"},{"user":"egg","body":"> on my way home from school I saw caterpillr \uD83D\uDE42\\n*Squish*"},{"user":"scotty","body":"D:"}]}');


var $ffc1ade8c75ce539$exports = {};
$ffc1ade8c75ce539$exports = JSON.parse("{\"id\":\"2\",\"board\":\"Info\",\"title\":\"My first post!\",\"author\":\"kitty\",\"replies\":2,\"posts\":[{\"user\":\"kitty\",\"body\":\"This is my first post!\"},{\"user\":\"user1\",\"body\":\"I hate you, wholeheartedly, entirely, with everything I have.\"}]}");


var $e50509e141fd6b02$exports = {};
$e50509e141fd6b02$exports = JSON.parse("{\"id\":\"3\",\"board\":\"Info\",\"title\":\"How did you find this forum? \",\"author\":\"madmod\",\"replies\":2,\"posts\":[{\"user\":\"madmod\",\"body\":\"Greetings and Saultations! This is the place to tell us how you found us. Word of mouth, smoke signals, and carrier pigeons are all valid means of locating our humble little corner of the world wide web\"},{\"user\":\"scotty\",\"body\":\"there was a flyer on the wall at volt village when i went with my dad to look at stereos\"}]}");


var $d7eef6648aca1c82$exports = {};
$d7eef6648aca1c82$exports = JSON.parse("{\"id\":\"4\",\"board\":\"Info\",\"title\":\"hi!! Im new here. My name is Scotty \",\"author\":\"scotty\",\"replies\":7,\"posts\":[{\"user\":\"scotty\",\"body\":\"Hi ! I'm scotty. I like making new friends and also scary stuff sometimes. I will start with a fun question. What do you think is scarier? Prion disease, rabies, or the black plague? Or something else\"},{\"user\":\"rat\",\"body\":\"> Hi ! I'm scotty. I like making new friends and also scary stuff sometimes. I will start with a fun question. What do you think is scarier? Prion disease, rabies, or the black plague? Or something else\\n\\n\\nwellcome to the gutters my friend\"},{\"user\":\"slim\",\"body\":\"> What do you think is scarier? Prion disease, rabies, or the black plague? Or something else\\n\\nUnless you have a time machine, I don't think the black plague is around anymore, so you can cross that off your list LOL\"},{\"user\":\"rat\",\"body\":\"> What do you think is scarier? Prion disease, rabies, or the black plague? Or something else\\n\\nIt's actually pronounced Pree-On just fyi. everyone says it wrong\"},{\"user\":\"ded\",\"body\":\"> Unless you have a time machine, I don't think the black plague is around anymore, so you can cross that off your list LOL\\n\\nActually the black plague is still an infection you can get, we just have antibiotics now. So it's a lot easier to treat. My vote is for rabies. Once you have symptoms you're already gone, yknow\"},{\"user\":\"madmod\",\"body\":\"guys we have an introduction thread pinned. Please introduce yourselves over there\"},{\"user\":\"howl\",\"body\":\"Hi scotty! Welcome to the chaos x)\"}]}");


var $bf968068791fb1d9$exports = {};
$bf968068791fb1d9$exports = JSON.parse("{\"id\":\"5\",\"board\":\"Info\",\"title\":\"Dead forum?\",\"author\":\"egg\",\"replies\":7,\"posts\":[{\"user\":\"egg\",\"body\":\"egg\"},{\"user\":\"lettuce\",\"body\":\"That's so interesting, egg. Thanks for sharing.\"},{\"user\":\"madmod\",\"body\":\"egg, please.\"},{\"user\":\"egg\",\"body\":\"egg?\"},{\"user\":\"madmod\",\"body\":\"*sighs and rubs temples* you know we have an introductions thread. you've been here for like 2 years\"},{\"user\":\"egg\",\"body\":\"apologetically egg :,(\"},{\"user\":\"madmod\",\"body\":\"[a moderator has locked this thread]\"}]}");


var $31c481fdc871e26e$exports = {};
$31c481fdc871e26e$exports = JSON.parse('{"id":"6","board":"Info","title":"\uD83D\uDCCCMaster Intro Thread ~ Say HELLO!","author":"madmod","replies":19,"posts":[{"user":"madmod","body":"Welcome everyone! Per member suggestions, I have added an introduction thread and pinned it. Please feel free to write out who you are, what you like, and why you\'re here.\\n\\nIf you feel so inclined, you can include a fun fact. If you don\'t feel so inclined.. tell us your favorite type of ice cream I guess."},{"user":"slim","body":"Hey, ChipperSlim321 signing in! We got the internet here a month ago so I wanted to give it a try \uD83D\uDE42 It\'s so fun so far!"},{"user":"greg","body":"Hello internet nerds, I am Greg Potato. No relation to Alan Cucumber or Wendy Broccoli who were both banned for totally unfair reasons.\\nFun fact about me: I have never had ice cream and don\'t plan to."},{"user":"shelvn","body":"Howdy everyone! I\'m here for a good time and a long time. I do my best to help out and provide insight where i can uwu"},{"user":"howl","body":"hey. I\'m howl. You can call me howl. I guess the old intro thread got deleted after some chaos. So, it\'s me again. You know my deal by now."},{"user":"egg","body":"EGG!!"},{"user":"howl","body":"> egg\\n\\nand that\'s egg."},{"user":"egg","body":"eeeggggg \u1566(\xf2_\xf3\u02C7)\u1564"},{"user":"chick","body":"Hi everyone I\'m also egg"},{"user":"egg","body":"!! (\u25D5`\u256D\u256E\xb4\u25D5)"},{"user":"madmod","body":"Gentle reminder everyone why the last intro thread was re-made! This is supposed to be a helpful resources for newcomers, not your personal tight 5. Thanx"},{"user":"babs","body":"Uh... hi I\'m babs. I won\'t be around much because I don\'t live around here, but I\'ll post my questions and experience in the right thread. Say hi if yinz are in the burgh :)"},{"user":"rat","body":"I\'m rat. I\'m here to keep you on your toes and post about weird stuff. I am mostly on on the weekends. Care much more about The Truth than I do about stuff like aliens. If you can\'t handle my sense of humor, just ignore me LOL"},{"user":"dj","body":"You can call me DJ! Bit of a nerd and born and raised here. I guess that\'s why I\'m on this forum. I like learning new and interesting things about the place I grew up. I can deffo hook you up with tech and radio equipment if needed! Or anime rips if that\'s your flavor"},{"user":"weeb","body":"ZOMG I luv anime >X3 squeeee~~~~ ur even a bishie.. *licks you* DJ check out mah site!! Do u watch Cerula Nocht 0.0 ??\\n\\nI\'m Beebii1! I\'m awesomesauce BLAHHH and luv 2 be here. watashiwa baka desu LOL but I\'ll do mah bestt *wags tail*"},{"user":"web","body":"Oh okay. Well, that\'s a hard act to follow, but here I go! I\'m the webmaster (not of this forum LOL). I am learning to code and manage a few websites in adjacent rings! I\'m honestly just here to hang out. Idk how I feel about ghosts, but I like aliens. And I like triple oaks!! I\'m online a lot, so if you\'re lonely and wanna talk, PM me! \u0D26\u0D4D\u0D26\u0D3F[ T \u15DC T ]"},{"user":"kat","body":"I\'m Kat! I love to sew and crochet, but I\'ve been getting into beading lately too. I can\'t stop making those bead lizards XD. I also like to hang out with my kitties and read a lot."},{"user":"red","body":"Hello! You can call me Red."},{"user":"lettuce","body":"23/yesPlz/TripOaks "}]}');


var $46e2f766144f2c1c$exports = {};
$46e2f766144f2c1c$exports = JSON.parse('{"id":"7","board":"Info","title":"Introduce yourself? ","author":"lettuce","replies":3,"posts":[{"user":"lettuce","body":"23/yesPlz/TripOaks"},{"user":"madmod","body":"Hi and welcome! We have an introduction thread already if you\'d like to introduce yourself over there... with a little more personality! thanks"},{"user":"lettuce","body":"Even more personality than that? I\'m going to have to dig deep (\u2312_\u2312;)"}]}');


var $00ff80505b809d53$exports = {};
$00ff80505b809d53$exports = JSON.parse('{"id":"8","board":"general","title":"Please help. Does anyone know algebra?","author":"scotty","replies":8,"posts":[{"user":"scotty","body":"please"},{"user":"lettuce","body":"A lot of people do, it\'s been around for hunderds of years"},{"user":"scotty","body":"can you help me"},{"user":"scotty","body":"I dont understand what a variable is"},{"user":"chick","body":"I got you! (\uFF3E\u2200\uFF3E) It\'s like a puzzle you are trying to solve! It\'s a number, but you don\'t know WHICH number it is yet until you figure it out!"},{"user":"scotty","body":"what is the answer thoguh"},{"user":"dj","body":"42!"},{"user":"scotty","body":"ok thanx"}]}');


var $12f9804bd779af7a$exports = {};
$12f9804bd779af7a$exports = JSON.parse('{"id":"9","board":"general","title":"Pie Fest Ideas ","author":"rat","replies":15,"posts":[{"user":"rat","body":"Wazzup fellow dessert lovers. im helping with the cornhogs pie fest this year. last year\'s fest was a snooze fest, and the pie was mostly grocery store garbage. if u know any home bakers who are up to the challenge, pm me.\\n\\ni know im not usually the ask for advice guy, but my kid is in the band and they really need new uniforms. those plumes are raggedy. what could make pie fest better? do not say the band, i know. i don\'t control theere setlist. im just the pie guy for now"},{"user":"ghost","body":"You should add more like, cream pies to the lineup. Banana, chocolate, peanut butter. Maybe a buckeye? They\'d have to be kept in the fridge but some of us do not like fruit pie LOL"},{"user":"egg","body":"play freebird"},{"user":"signals","body":"Saucers could probably provide pies. Maybe you could orchestrate a sponsorship deal. Advertising and guests in exchange for pies? I hear they have a special cherry chocolate pie right now, and a whipped cream sprinkles pie for the kiddos."},{"user":"scotty","body":"> Saucers could probably provide pies. Maybe you could orchestrate a sponsorship deal. Advertising and guests in exchange for pies? I hear they have a special cherry chocolate pie right now, and a whipped cream sprinkles pie for the kiddos.\\n\\nMy mom won\'t let me get the whipped cream one. she says its just \\"empty sugar\\" how is it empty if its full of sprink;es?"},{"user":"ded","body":"There aren\'t enough mixed berrie pies in the game."},{"user":"egg","body":"ADD ICE CREAM"},{"user":"web","body":"What is pie fest? A festival for pies? What does it have to do with the band"},{"user":"rat","body":"> What is pie fest? A festival for pies? What does it have to do with the band\\n\\nIt\'s a fundraiser for the corn hogs marching band. They play the halftime show and then everyone eats pie"},{"user":"ghost","body":"> What is pie fest? A festival for pies? What does it have to do with the band\\n\\nWe have like 3 things to do in town, how do you not no about pie fest?? Lol"},{"user":"web","body":"> We have like 3 things to do in town, how do you not no about pie fest?? Lol\\n\\nI guess I don\'t get out a lot [ -\uFE4F-\u3002]"},{"user":"kat","body":"Hmmmm well, I think the biggest problem is that the band is not very good.. but that\'s kinda a buzzkill! if you can\'t control that, maybe just do some advertising around town. Or a themed pie? You could do savory pies too and do a corn and ham one for the Corn Hogs. or put little pigs on the pies? Everyone loves a gimmick!"},{"user":"egg","body":"add TWO ice creams"},{"user":"web","body":"You could make mini pies! Small enough to hold in your hand"},{"user":"rat","body":"> You could make mini pies! Small enough to hold in your hand\\n\\nhand pies? yeah. We are going to"}]}');


var $3718e2bed1fea69f$exports = {};
$3718e2bed1fea69f$exports = JSON.parse('{"id":"10","board":"general","title":"Weird places to hike? (kid friendly!!)","author":"signals","replies":14,"posts":[{"user":"signals","body":"Hoping to take my kid out camping and have some quality time together. Any ideas on trails nearby that have sightings or unusual phenomena? Normally we hike around Gulch Creek but there aren\'t many campsite options.\\n\\nUnder a 2 hour drive would be ideal! Bathrooms would be nice. My kid is not exactly outdoorsy, but we\'re working on it."},{"user":"slim","body":"I went to a super cool walk last week with my parents. There were like 4 deer at LEASt and some other neat animals. Umm does your kid like animals too?"},{"user":"signals","body":"He\'s more of an academic, I\'d say. But he does like a lot of the shows on the Discovery Channel, so I bet he would enjoy deer spotting! Where were you hiking?"},{"user":"slim","body":"Oh I don\'t know, my parents drove and I fell asleep in the car. Um I can ask when my dad gets home"},{"user":"scotty","body":"ima kid"},{"user":"dude","body":"> ima kid\\n\\nHi Ima, I\'m dad!"},{"user":"rat","body":"We had a good time up at Berry\'s campground over Memorial Day! Can get a bit crowded, but in the offseason it should be all right. Pets are allowed! And they have old showers/bathrooms"},{"user":"web","body":"We have a travel agency in town! They have a staycation sale they run twice a year, so maybe give them a ring!"},{"user":"lettuce","body":"You could always break into the toilet factory and camp in there"},{"user":"rofl","body":"oof"},{"user":"slim","body":"oh man don\'t go there"},{"user":"lettuce","body":"> oh man don\'t go there\\n\\nwat its just a joke. read a book"},{"user":"slim","body":"> wat its just a joke. read a book\\n\\nNo I mean it\'s a sore spot, I wouldn\'t touch the subject. Mods will get involved."},{"user":"madmod","body":"\u0CA0_\u0CA0"}]}');


var $966fc426433e19f1$exports = {};
$966fc426433e19f1$exports = JSON.parse("{\"id\":\"11\",\"board\":\"general\",\"title\":\"What is there to do in Triple Oaks & surrounding area?\",\"author\":\"chick\",\"replies\":8,\"posts\":[{\"user\":\"chick\",\"body\":\"HI HI HI! ill be in town for summer break staying with extended fam and do nott want to be bored. what do you do around here for fun? This town has like, 3 stoplights so im not expecting much LOL but anything other than sit at home woudl be cool.\"},{\"user\":\"lettuce\",\"body\":\"You're not going to believe this, but they installed a fourth stoplight recently. But it gets pretty crowded on weekends, so expect a line! lol\"},{\"user\":\"egg\",\"body\":\"a lot of us hang out at Dumpy's Gutter. or in the woods. the theater kids hang out at saucers, so if you don't like showtunes, go before like 9. or in the computer room here online hello\"},{\"user\":\"dude\",\"body\":\"Great fishing up about 45 minutes north at Weller's Lake if that's your kind of thing\"},{\"user\":\"ded\",\"body\":\"u r so out of luck, this town is closing EVERYTHING fun :x Better off just staying home being a zombie on the interwebz\"},{\"user\":\"slim\",\"body\":\"EVERYTHING isn't closing, the town is just better for people with ACTUAL hobbies. Loitering at local businesses doesn't count.\"},{\"user\":\"chick\",\"body\":\"> EVERYTHING isn't closing, the town is just better for people with ACTUAL hobbies. Loitering at local businesses doesn't count.\\n\\nOh.... what kind of hobbies can you do here?\"},{\"user\":\"ded\",\"body\":\"I like to go hiking with my mom and the dogs. There are some of parks and trails around if you make it past all the corn. Don't forget snacks though.. there's not a lot out there. Mom usually brings a few handfuls of almonds and that lasts us the day.\"}]}");


var $5c0b2d1972b2505c$exports = {};
$5c0b2d1972b2505c$exports = JSON.parse("{\"id\":\"12\",\"board\":\"general\",\"title\":\"New Cream Bay CD? \",\"author\":\"howl\",\"replies\":10,\"posts\":[{\"user\":\"howl\",\"body\":\"Anyone hear that new CREAM BOY album? Oh the songs are SICK I cant stop listening to it. Seriously whats everyones favorite songs on the album\"},{\"user\":\"howl\",\"body\":\"Cream Bay*\"},{\"user\":\"rat\",\"body\":\"> Anyone hear that new CREAM BOY album? Oh the songs are SICK I cant stop listening to it. Seriously whats everyones favorite songs on the album\\n\\nMy favorite song is The Grouch, for obvious reasons (I hate everyone)\"},{\"user\":\"shelvn\",\"body\":\"t0tally. puttin it on the shelf right now.\"},{\"user\":\"rat\",\"body\":\"> t0tally. puttin it on the shelf right now.\\n\\nJust take those old records off the shelf. Then put those old records back on the shelf\"},{\"user\":\"dude\",\"body\":\"> Just take those old records off the shelf. Then put those old records back on the shelf \\n\\nNow Bob Seger was a TRUE musician. None of that Politically Correct Cream Boy noise! \"},{\"user\":\"weeb\",\"body\":\"OMG, Girl from the Rising Sun is the bestt!!! Maybe not as g00d as Nobuo Uematsu in his peak (is there a genre he CANT do???) and ==hard== to out cream Kenji Kawai, but Cream Boy has my head and my heart after bassist Nick Gumbo said Sailor Uranus is his fav!!!\"},{\"user\":\"egg\",\"body\":\"Eggburg egg!\"},{\"user\":\"rat\",\"body\":\"is there a mod around? Get this egg outta here\"},{\"user\":\"madmod\",\"body\":\"Cream Boy ROFL \"}]}");


var $61cb99177463e565$exports = {};
$61cb99177463e565$exports = JSON.parse("{\"id\":\"13\",\"board\":\"general\",\"title\":\"cat blanket? \",\"author\":\"scotty\",\"replies\":2,\"posts\":[{\"user\":\"scotty\",\"body\":\"hey guys! my mom bought a blanket for our cat thor. i dont know why because thor is already covered in fur!!! neway on the blanket it says its a DOG BLANKET. like right on the tag.\\n\\ndo you think thor is poisoned now? plea se I hope not ; (\"},{\"user\":\"egg\",\"body\":\"yes\"}]}");


var $c7a4e9bcc01bc840$exports = {};
$c7a4e9bcc01bc840$exports = JSON.parse('{"id":"14","board":"phenomena","title":"Missing objects explanations","author":"egg","replies":8,"posts":[{"user":"egg","body":"my stuff keeps going missing. first the toaster... now the hot water bottle. what gives.. how am i supposed ot make eggs and toast and comfrt myself while sick without them.. ... where did they go... my stuff. the triple gnomes strike again.. egg :("},{"user":"egg","body":"have you tried checking your butt??"},{"user":"egg","body":"oh wait i posted this (\u256F\xb0\u25A1\xb0\uFF09\u256F\uFE35 \u253B\u2501\u253B"},{"user":"web","body":"egg\\n"},{"user":"kat","body":"hehe hi everyone im a RAT and i like to eat apples"},{"user":"rat","body":"shut up kat"},{"user":"kat","body":"> shut up kat\\n\\nhuff my shorts dweebus, eat an apple about it"},{"user":"red","body":"Fiber is an important part of a balanced diet! Are you sure you didn\'t accidentally throw your toaster away egg? Maybe there is a burglar amongst us?"}]}');


var $2175a29575833fc9$exports = {};
$2175a29575833fc9$exports = JSON.parse('{"id":"15","board":"phenomena","title":"The real \u201Cunexplained phenomena\u201D in this town is the driving\u2026","author":"dude","replies":6,"posts":[{"user":"dude","body":"GOOD LORD TRIPLE OAKS? WE\'RE YOU BORN IN A DITCH? People are nuts these days. going 50 in a 35?? We\'re up to THREE cars crashing into buildings this year so far. We don\'t ahve that many buldiongs left!! It\'s like some of the people in this town learned to drive by watching cartoons or something. I\'m so tired of just trying to drive to work and aome hotshot in a pumped up ride blows past me! What\'s the rush bucko?? You got an order waiting for you at the Pizza Haus you gotta take home to your kids??? get in line, we\'re all waiting on pizza ! I swear the cops around here are useless."},{"user":"web","body":"i miss the bus system...actually, I\'m not sure where the buses went..."},{"user":"weeb","body":"omiGAWD drving has been the SCARIEST!!!1! I wish evryone would just B COOL >:("},{"user":"web","body":"I couldn\'t agree more. I\'m worried constantly that someone is going to crash into town hall! What is going on out there? I swear every time there\'s rain everyone panics"},{"user":"red","body":"it\'s almost like we should elect a mayor who has driven a car before...."},{"user":"scotty","body":"i have driven lodes of cars"}]}');


var $1f10c668c6db5e80$exports = {};
$1f10c668c6db5e80$exports = JSON.parse("{\"id\":\"16\",\"board\":\"phenomena\",\"title\":\"Feeling trapped. Do you think we can leave?\",\"author\":\"shelvn\",\"replies\":6,\"posts\":[{\"user\":\"shelvn\",\"body\":\"Means what it says in the title. It seems like all I'll ever see is Triple Oaks, and all I'll ever be is what I am now in the context of this town. Do I even get to exist outside of this place? Do any of us??? It's suffocating sometimes, living here.\"},{\"user\":\"weeb\",\"body\":\"One time Hikaru in C h o j i k u Y o s a i M a k u r o s u (NOT TO BE CONFUSED WITH THAT TRASH RICK HUNTER ROBOTECH GAIJIN KID'S CARTOON for babies) is having a bad day because he can't leave the SDF-1 Macross. Not to even start on how he REALLY just wantes to leave the whole UN Spacy behind for good and be with Minmay. SORRY Misa apologists, I do NOT accept their marriage as canon it is convenience only and Hikaru will be reunited with his true love and the true hero of Space War I.\"},{\"user\":\"egg\",\"body\":\"the yolk never escapes the shell\\n\"},{\"user\":\"dude\",\"body\":\"You can try anything once!\"},{\"user\":\"howl\",\"body\":\"yeah dude I feel like I'm going to die here sometimes. It's like there's a big vortex of gravity sucking everyone into a pit of weird midwestern mediocrity under us at all times\"},{\"user\":\"dj\",\"body\":\"I know how you feel, sometimes I think there's a different better me waiting out in the world for me to find, and as long as I'm here I can't escape who I was 'supposed' to be. But I don't have the money to move to the big city and also I can't abandon the few friends and family who still need me here.\\n\\nSometimes all we can do is make the best out of the life we're stuck with, and try to push it even a little bit towards the life we want.\"}]}");


var $239ec43ad6a17bf2$exports = {};
$239ec43ad6a17bf2$exports = JSON.parse("{\"id\":\"17\",\"board\":\"phenomena\",\"title\":\"HOW do you turn off this stupid toy?\",\"author\":\"dj\",\"replies\":9,\"posts\":[{\"user\":\"dj\",\"body\":\"Received one of those new trendy toys in the delivery to the shop... I figured it would be good to have in stock with the holidays coming up. But it will not. stop. talking. I feel like its watching me sometimes, but the eyes are so empty. It doesn't FEEL alive, which honestly makes it worse. Has anyone solved this?\\n\\nHopefully not sacrilegious if we're joining the veebo web ring, but I'll be stocking the shelves late at night and hear \\\"WEEHEEHEE\\\" in dead silence. Creepy.\"},{\"user\":\"greg\",\"body\":\"Electrical expert here. It sounds like ur toy is shorting out. I had the same problem yes, and I solved it by re-channeling the conductivity. What u need to do is disassemble the toy, remove the batteries, and give each one a good long lick.\\nlmk once u've done that.\"},{\"user\":\"dj\",\"body\":\"> Electrical expert here. It sounds like ur toy is shorting out. I had the same problem yes, and I solved it by re-channeling the conductivity. What u need to do is disassemble the toy, remove the batteries, and give each one a good long lick.\\nlmk once u've done that.\\n\\nWoah! An expert huh? What does licking the batteries do? I do not think I want to find out what energy tastes like. I tried taking them out, but the thing is still moving.\"},{\"user\":\"greg\",\"body\":\"Saliva is full of electrolytes that disrupt the circuits. It's a lot like defribillating a human heart. It's still moving from residiual charge, all that ends when u put licked batteries back in, trust me\"},{\"user\":\"dj\",\"body\":\"Update. It's louder now. and batteries taste terrible. Why would anyone buy this :C\"},{\"user\":\"greg\",\"body\":\"Can't believe u really licked it ROFL\"},{\"user\":\"dj\",\"body\":\"> Can't believe u really licked it ROFL\\n\\n-__-\"},{\"user\":\"egg\",\"body\":\"VEBOOO WEE HEE HEEE HOOPA .... D.....J .... HEE HEE\"},{\"user\":\"dj\",\"body\":\"Oh god, not here too. :<\"}]}");


var $faaf10f4adb639e7$exports = {};
$faaf10f4adb639e7$exports = JSON.parse("{\"id\":\"18\",\"board\":\"phenomena\",\"title\":\"Who is your favourite Midwest urban legend?\",\"author\":\"slim\",\"replies\":16,\"posts\":[{\"user\":\"slim\",\"body\":\"Discussion topic of the week! Share your favorite Midwest urban legends! The Pacific Northwest gets all the luv </3, so lets spread some midwest is best positivity! I like the Loveland Frogman(men??). Something about a little frog duder standing under a bridge is so funny to me. \\n\\nWBU?\"},{\"user\":\"scotty\",\"body\":\"doot doot\"},{\"user\":\"ded\",\"body\":\"There was this video I watched. Can't remember the name but it was definitely found footage. There were a bunch of teenagers in a house in the woods? There was party and someone's alone standing in a corenr but there are DEFINITELY aliens at the party. Really messed me up as a kid. Oh and the corn.\"},{\"user\":\"ded\",\"body\":\"In anycase I'm still alone here, waiting for you if you come back, Aliens.\"},{\"user\":\"egg\",\"body\":\"egg\"},{\"user\":\"slim\",\"body\":\"> egg\\n\\nI don't like that one very much.\"},{\"user\":\"ded\",\"body\":\"I've always been a fan of women in white. Not to pick up on the side of the road of course but! There's something about a woman in white standing alone on a bridge that gives me the creeps. TBH I always kinda wondered if you were nice enough if they'd just leave you alone\"},{\"user\":\"scotty\",\"body\":\"I like the lock ness monster\"},{\"user\":\"slim\",\"body\":\"> I like the lock ness monster\\n\\nThat one is not from the midwest bud\"},{\"user\":\"web\",\"body\":\"I've heard a lot about bloody mary! I kind of like the idea of a scary person trapped behind glass who can come out and GETCHA if you use the right words. Very cool. I sure hope there aren't two more people in this thread who say her name though LOL\"},{\"user\":\"egg\",\"body\":\"maybe like. a guy who escaped from jail and has a hook hand or two but also he really likes green bean casserole\"},{\"user\":\"howl\",\"body\":\"> maybe like. a guy who escaped from jail and has a hook hand or two but also he really likes green bean casserole\\n\\nthat's just my Uncle Bob ROFL\"},{\"user\":\"gert\",\"body\":\"> I've heard a lot about bloody mary! I kind of like the idea of a scary person trapped behind glass who can come out and GETCHA if you use the right words. Very cool. I sure hope there aren't two more people in this thread who say her name though LOL\\n\\nOhhhhh like in Candyman? Candyman, Candyman, Candyman, Candyman, Candyman hooking sound heard\"},{\"user\":\"ded\",\"body\":\"maybe I'm lame for this, but I do love the hometown outhound. Who doesn't love a big scary dog?\\n\\nWhen i was a kid a neighbors black lab got out and was wandering the culdesac and I started WAILING because I thought it was gonna get me! I couldnt use the big girl potty for WEEKS ROFLMAO\"},{\"user\":\"dude\",\"body\":\"Seatbelts Save Lives. Ha!\"},{\"user\":\"slim\",\"body\":\"> Seatbelts Save Lives. Ha!\\n\\nThat one's real! A seatbelt pulled my grandma out of a burning building, and a helmet saved my cat from a tree.\"}]}");


var $bf9dbf11f3599644$exports = {};
$bf9dbf11f3599644$exports = JSON.parse("{\"id\":\"19\",\"board\":\"phenomena\",\"title\":\"operation: cobcircle >:)\",\"author\":\"ghost\",\"replies\":11,\"posts\":[{\"user\":\"ghost\",\"body\":\"We should coordinate a group to go stomp some shapes in the corn. I'm sooooo tired of the townies not taking it seriously. I know we have other stuff going on but like! Aliens are important too! They should be taken seriously! This will really show them, if we get out there and make a sneaky pattern. IDK what it would be yet though (u__u)'\"},{\"user\":\"egg\",\"body\":\"egg\"},{\"user\":\"ded\",\"body\":\"how would this \\\"show them\\\" exactly? It's not like a bunch of teens in the corn is anything new to town, and it certainly wouldn't lend any credence alien theories if you got caught.\\n\\nGood rule of thumb: if youre going to do a crime or something similar to a crime, don't post about online. It's pretty easy dude\"},{\"user\":\"signals\",\"body\":\"oh I'm happy the local youth are getting interested in aliens and I hate to be a buzzkill but you can't really be sure what message your conveying to the other beings without a lot of research! This could be dangerous.\"},{\"user\":\"ghost\",\"body\":\"> oh I'm happy the local youth are getting interested in aliens and I hate to be a buzzkill but you can't really be sure what message your conveying to the other beings without a lot of research! This could be dangerous.\\n\\nOhhh I didn't think about that!! Thankies. If I wanted to learn more about alien sightings, is there a place I should start? I don't want to get anyone abducted or something\"},{\"user\":\"signals\",\"body\":\"> Ohhh I didn't think about that!! Thankies. If I wanted to learn more about alien sightings, is there a place I should start? I don't want to get anyone abducted or something\\n\\nI would spend some time with Sagan's Intelligent Life in the Universe. If you want to see humble beginnings, you could look into SETI work and Project Ozma. There's of course the classics like Roswell and Area 51, but even those can get a little too into the pop culture. The Kelly-Hopkinsville sighting is an interesting place to look as well. Some people think it was owls, but I don't really buy it.\"},{\"user\":\"web\",\"body\":\"Did you mean crop circles?\"},{\"user\":\"ghost\",\"body\":\"> Did you mean crop circles?\\n\\nNo I mean like, crop circles in corn. Cob. It's a pun ?\"},{\"user\":\"chick\",\"body\":\"I'm filling up my gas cans right nowww! Let's burn this mother down, baby!!!\"},{\"user\":\"red\",\"body\":\"> I'm filling up my gas cans right nowww! Let's burn this mother down, baby!!!\\n\\nArson is a federal crime.\"},{\"user\":\"chick\",\"body\":\"Oh no! I would never start a fire to hurt someone!!!! I just thought we were having a party, you know like when you have a gasoline fight with your friends at the gas station. I will definitely be more careful with my bad bad words and only use nonflammable corn ethanol at my parties in the future!!!\"}]}");


var $9d2427651ee7ea85$exports = {};
$9d2427651ee7ea85$exports = JSON.parse("{\"id\":\"20\",\"board\":\"phenomena\",\"title\":\"Numbers Stations\",\"author\":\"signals\",\"replies\":6,\"posts\":[{\"user\":\"signals\",\"body\":\"Found something unusual in the airwaves the other day. I was flipping through stations and think I heard an old numbers station broadcast. Couldn't make much sense of it, but maybe someone on here can?\\n\\nIt was on 92.4 for anyone curious. Signal came in and out though, so I'm guessing it's pretty far away or we're experiencing some local interference. If anyone has theories I'm all ears.\\n\\nThis is what I managed to write down before it went out.\\n> 8 2 6 3\\n> 4 26 4 3 7 3\\n> 8 4 3 7 3 _ 3\"},{\"user\":\"greg\",\"body\":\"U've done incredible work, signals. As an expert on numerology I'm happy to lend a hand deciphering this.\\nExhausting my methods, I found if u run this through a tutone cipher, the numbers re-orient to 8675309, which also translates alphanumerically to \\\"Jennifer\\\"\"},{\"user\":\"web\",\"body\":\"> U've done incredible work, signals. As an expert on numerology I'm happy to lend a hand deciphering this.\\nExhausting my methods, I found if u run this through a tutone cipher, the numbers re-orient to 8675309, which also translates alphanumerically to \\\"Jennifer\\\"\\n\\nOf course! Jennifer Aniston...\"},{\"user\":\"dj\",\"body\":\"Bummer, the shop has been getting so many broken radios lately that are picking up different frequencies. Haven't cracked it yet, it doesn't seem like a hardware issue. Do you really think it could mean something? :<\"},{\"user\":\"scotty\",\"body\":\"is this algebra\"},{\"user\":\"signals\",\"body\":\"> is this algebra\\n\\nScotty does your dad know how much you're on the computer?\"}]}");


var $954c7c79338f17b9$exports = {};
$954c7c79338f17b9$exports = JSON.parse("{\"id\":\"21\",\"board\":\"phenomena\",\"title\":\"Shoes about town. What do you think they mean?\",\"author\":\"howl\",\"replies\":6,\"posts\":[{\"user\":\"howl\",\"body\":\"I keep seeing sneakers tied together and tossed over powerlines. I feel like they move around. There were like 2 on Trabue the other day and now there's none. What gives? Surely not everyone has enough extra pairs of sneaks that they can toss them willy nilly about town\"},{\"user\":\"rat\",\"body\":\"> I keep seeing sneakers tied together and tossed over powerlines. I feel like they move around. There were like 2 on Trabue the other day and now there's none. What gives? Surely not everyone has enough extra pairs of sneaks that they can toss them willy nilly about town\\n\\n\\nI've heard that this means that you can buy illegal substances nearby, but I have never seen any illicit exchanges happening. I think people just like throwing shoes on powerlines and making up stories to make it more interesting\"},{\"user\":\"red\",\"body\":\"I think they are just shoes. They don't have to mean anything more.\"},{\"user\":\"madmod\",\"body\":\"maybe the birds move then around? The could easily pick up the shoestrings for nests and then drop them again\"},{\"user\":\"egg\",\"body\":\"Is this where all my missing stuff has gone? someone's just throwing shoes and toasters onto power lines?\"},{\"user\":\"dude\",\"body\":\"> maybe the birds move then around? The could easily pick up the shoestrings for nests and then drop them again\\n\\nyour making big assumptions about \\\"birds\\\" here. lol \\\"birds\\\"\"}]}");


var $688b4e5164a021ad$exports = {};
$688b4e5164a021ad$exports = JSON.parse('{"id":"22","board":"phenomena","title":"Worried about the outhound when camping!! Help!!!","author":"rofl","replies":19,"posts":[{"user":"rofl","body":"Hello outdoorsmen (and women). Some friends and I are going to be spending a few nights at Conkle\u2019s Way Campground in a few weeks\u2026 and I have to be honest. I am kinda nervous. I remember growing up and bigger kids telling us about the outhound, and of course it was just a story. Of course. But when you\u2019re out there in the woods alone, no way to call home\u2026. kinda scary!\\n\\nDoes anyone have experience with this? Is there stuff I can do to avoid making myself vulnerable? Are there any superstitions about it y\u2019know, just in case!\\n\\nAlso how well marked are the trails ROFL? I don\u2019t want to get lost and eaten!"},{"user":"slim","body":"it\u2019s a dog that lives in an outhouse. Just check the outhouse toilet before you go in. If there\u2019s a dog in it. Don\u2019t sit down."},{"user":"dj","body":"Just go to the OOO and pick up a map of all the local state parks. Trails are well marked and mostly used by familys for casual hiking. Trailhead for Conkle\u2019s Way is close to the campground, so you shouldn\u2019t get lost unless you\u2019re blindfolding yourself."},{"user":"dude","body":"> it\u2019s a dog that lives in an outhouse. Just check the outhouse toilet before you go in. If there\u2019s a dog in it. Don\u2019t sit down.\\n\\nGuess u will have to use nature\u2019s toilet if you want to avoid the dog that hangs out in outhouses! just dont use poison ivy to wipe. ouch!!"},{"user":"rat","body":"r u a baby or what? u couldn\u2019t beat toilet dog n a fight?"},{"user":"signals","body":"Play the radio all night, it\u2019ll scare off any animals (or worse). Just go far enough out from other campers so as to not be a nuisance ! Never had an issue over there, especially with a group!"},{"user":"egg","body":"At this point Id just let it take me idk"},{"user":"web","body":"Simple! Don\u2019t go Camping! haha"},{"user":"rofl","body":"> r u a baby or what? u couldn\u2019t beat toilet dog n a fight?\\n\\nEat my shorts @that_stray_rat. If you don\u2019t have anything nice to say, just shut up."},{"user":"lettuce","body":"BB gun"},{"user":"rat","body":"> Eat my shorts @that_stray_rat. If you don\u2019t have anything nice to say, just shut up.\\n\\ni\u2019m rubber your glue"},{"user":"rofl","body":"Okay I\u2019ll pick up maps, a radio, and take some kind of no-no can\u2026. and a flashlight to check the outhouse!"},{"user":"chick","body":"> BB gun\\n\\n\\nNO????"},{"user":"gert","body":"> Okay I\u2019ll pick up maps, a radio, and take some kind of no-no can\u2026. and a flashlight to check the outhouse!\\n\\nand toilet paper"},{"user":"rofl","body":"> and toilet paper\\n\\nAnd toilet paper!"},{"user":"rat","body":"> and toilet paper!\\n\\nand toilet paper."},{"user":"web","body":"> and toilet paper.\\n\\nANNNDD toilet paper!"},{"user":"lettuce","body":"> and toilet paper!\\n\\nand bbgun"},{"user":"chick","body":"> and bbgun\\n\\n\\nNO"}]}');


var $1faa7eed8fc6dcce$exports = {};
$1faa7eed8fc6dcce$exports = JSON.parse("{\"id\":\"23\",\"board\":\"accounts\",\"title\":\"Followed the footprints in the woods\",\"author\":\"egg\",\"replies\":7,\"posts\":[{\"user\":\"egg\",\"body\":\"they were SO big. you would not beleive what I found at the end of them.\"},{\"user\":\"weeb\",\"body\":\"wut was it????? *o*\"},{\"user\":\"lettuce\",\"body\":\"uh oh, egg got eaten\"},{\"user\":\"egg\",\"body\":\"BIG\"},{\"user\":\"web\",\"body\":\"Are you okay egg?\"},{\"user\":\"egg\",\"body\":\"> BIG\\n\\nSO BIG\"},{\"user\":\"web\",\"body\":\">SO BIG\\n\\nThe footprints? the trail of footprints? What left them\"}]}");


var $f6313b31d2218519$exports = {};
$f6313b31d2218519$exports = JSON.parse("{\"id\":\"24\",\"board\":\"accounts\",\"title\":\"Grusm Tsdy Account\",\"author\":\"madmod\",\"replies\":1,\"posts\":[{\"user\":\"madmod\",\"body\":\"[This thread has been REMOVED]\"}]}");


var $02082425468a3cb9$exports = {};
$02082425468a3cb9$exports = JSON.parse("{\"id\":\"25\",\"board\":\"accounts\",\"title\":\"The thing in the corn \",\"author\":\"rofl\",\"replies\":6,\"posts\":[{\"user\":\"rofl\",\"body\":\"This happened to me last week. I've been so shaken up by it, I couldn't put words down, but I'm gonna try.\\n\\nI was taking some pictures around the abandoned toilet factory (don't ask me why) and it was starting to get late. It was really overcast and the sky was getting dark so I wanted to get home fast and I decided instead of taking the long trail to the main road I would just hike down the hill and cut through the cornfield behind the old chapel. I know it can be dangerous to go through the fields, and this is gonna sound stupid, but I was scared of going through the chapel cemetery at night. So once I was down the hill, I gave the church a wide berth and pushed my way into the field.\\n\\nThis time of year the stalks are really tall, and I guess I wasn't ready for how dark it would be once I was more than a few feet inside. I didn't have a flashlight, just my camera, and the most I could get out of that was a half second of blinding flash. No good. And the wind! The rustling of the corn was so loud I couldn't hear anything else. Hate to say it, but I had no idea what direction I was going at first.\\n\\nBut when I looked above the corn, I could just barely see the steeple of the chapel peaking out. I thanked my lucky stars I had something to navigate by. So I just kept pushing through the thick leaves, looking up every few steps to make sure the chapel was still to my right. It was slow going, and I could feel the leaves scraping against my skin, but I felt like I was making progress.\\n\\nBut as I was looking up, my foot caught on something, like an exposed root, and I suddenly went down hard. I dropped my camera and the flash went off right in my face! I was totally blind for like a minute, lying on the ground in the field, and the wind was whipping up and I felt so stupid for not just sucking it up and going through the cemetery. But as much as my knees hurt I got up, picked up my camera, and kept moving. I looked up and to my relief the steeple was still in sight. \\n\\nafk, one sec\"},{\"user\":\"rofl\",\"body\":\"ok back! \\n\\nI kept going and going and going. But somehow I was still in the middle of the corn. Even if my heightened senses were making time feel longer, I knew I should've hit the end by now. And the steeple, it should be behind me. But instead, it was still off to my right, like I hadn't moved forward at all.\\n\\nWhen I next looked up to check my place, I saw it. The steeple shaking a little bit and settling back, like it had just finished moving. It was subtle but I know I saw it. I looked down and back up as fast as I could and the same thing happened again.\\n\\nI turned to the left, walked ten steps forward, and looked up. I could still see the steeple off to my right. I started to feel panic seep in, because something was very, very wrong.\\n\\nI don't know what possessed me to do this, but it was the only thing I could think of at the time. I pointed my camera in the direction of the steeple, and I took a picture. The flash lit up the night and I was once again blinded.\\n\\nAnd when the light faded away, the 'steeple' was gone.\\n\\nAt that point I ran like a dumb animal. I got cuts and bruises all over my body from the sharp leaves on the stalks, but I wasn't going to spend another minute in that cornfield. I don't know how long it actually took, but eventually I pushed out onto the side of the highway. I got home safe and I collapsed.\\n\\nI got the photo developed the next day, but the only thing in it was an empty cornfield.\\n\\nI swear to god this really happened to me. Has anybody else had an experience like this?\"},{\"user\":\"web\",\"body\":\"woah thats nuts\"},{\"user\":\"rat\",\"body\":\"Oh snap. Homie got corned.\"},{\"user\":\"ded\",\"body\":\"ROFL, I believe you. Ignore these dinguses. Are you from around here? The honest answer is that a lot of folks around here know not to look into the corn at night. Either the darkness does weird stuff, or somethings in there. I don't really want to find out. I'm from North Carolina, and my boyfriend had to tell me to stop staring into the corn at night. I guess I was doing it a lot, and it kinda creeped him out! oops.\"},{\"user\":\"egg\",\"body\":\"steeples dont normally move. maybe it was an earthquake\"}]}");


var $129171750faae9f6$exports = {};
$129171750faae9f6$exports = JSON.parse("{\"id\":\"26\",\"board\":\"accounts\",\"title\":\"Boyfriend doesn't believe me \",\"author\":\"ded\",\"replies\":6,\"posts\":[{\"user\":\"ded\",\"body\":\"Hi. I've been experiencing some pretty weird stuff lately. Hearing voices around town at night and seeing.. a weird spots? anyone else? I'm so tired of not being taken seriously. My boyfriend does not believe me when i get home from work late.\\n\\nCar's in the shop right now, and I usually close... so I've been walking home a lot. It's been fine! It's not like there's anything to worry about here minus some edgy teens and being bored to death. Maybe a stray car in a building. But man I will walk back and I get this weird feeling like I'm being watched but no one's around. The other night I was walking past some construction and i heard a rattling sound, like a door banging. It went on for wayyy longer than it should. I called out, but no one answered. So.. I kept going and figured I could call someone when I got to a phone.\\n\\nanyway as soon as I got past the construction, there was a loud POP and the rattling stopped finally. I got the weird feeling, and I hit the road asap. When I was far enough away, it almost looked like.. there was... slime.. on the road? You know when it's really hot out and the road gets all wiggly? It looked like that, but at night, and it was like 64. Creepy.\\n\\nAnother time I was cutting through memorial park, and I heard a man crying? Which, i guess its a graveyard also haha but at 3AM? Just like an old man softly weeping. I looked around and didn't see anyone.\\n\\nand then last week, I swear I saw Reggie out and about. He'd been missing for a few weeks (RIP Dumps Gumps) and so I kinda freaked out and started yelling his name. He looked at me and went to walk towards me but.. he wasn't moving right. Not like zombie weird, or limp weird, but just.. weird. Like only pieces of him were moving, the rest stayed still. I still don't know if that one was just tired hallucinations or what. He looked so sad. IDK, maybe I've just been thinking about him too much.\\n\\nI got tired of everyone brushing this off, so I started carrying my camcorder around just in case. It's not GREAT footage don't get me wrong, but i've definitely gotten.. something a few times. you can TOTALLY hear a voice call out.\\n\\nMy boyfriends been a real PITA lately, and so when I finally hyped myself up to show him what i got on tape, he told me to stop making stuff up?? Shut up! As if! It's ON camera. I moved here to be with him, and now he's driving me nuts.\\n\\nI'm so over it, and I do not really like walking home alone. WWYD?\"},{\"user\":\"dj\",\"body\":\"Woah, okay so first of all, thanks for writing all that up. I've definitely had my fair share of experiences as well. I think a lot of people in town would say the same. We're kind of haunted LOL.\\n\\nSecond, if you have the tape handy and bring it down to Volt Village when I'm working, I could probably make a few copies, so others could watch it. We have a sort of secret tiny section of evidence/footage/stories that gets passed around to locals who care about that sort of thing. No pressure or anything! But you definitely don't have to do this alone ':)'\\n\\nThird, your boyfriend doesn't sound very nice. If you're going to walk home alone, you might as well have a peaceful empty house to come home to without whatever his problem is. Maybe renting a place closer to your work?\"},{\"user\":\"madmod\",\"body\":\"sorry the crying in the graveyard was totally me\"},{\"user\":\"rat\",\"body\":\"> sorry the crying in the graveyard was totally me\\n\\nKeep that stuff at home, it's frankly embarrassing and nobody wants to see or hear that\"},{\"user\":\"signals\",\"body\":\"We live in a very strange town indeed, and you will see much the longer you live here. You can choose to see the strange as frightening OR embrace it as a new horizon. Either way the important thing is IT IS REAL!\\n\\nIf your boyfriend is local then I'm shocked to hear he's so close-minded. I'm no expert in matters of the heart but I asked my wife and she said \\\"Dump his loser butt now\\\"\"},{\"user\":\"greg\",\"body\":\"You should indeed dump his rear, my dear. Find someone who matches your intellectual prowess and attitudes towards the world.\"}]}");


var $e95350e03fc7ad99$exports = {};
$e95350e03fc7ad99$exports = JSON.parse("{\"id\":\"27\",\"board\":\"accounts\",\"title\":\"\",\"author\":\"babs\",\"replies\":8,\"posts\":[{\"user\":\"babs\",\"body\":\"Hello everyone! I found this forum searching around for answers. I was passing through town on my way up to the city and stopped for a bite at the Guzz n Stop. While I was filling up, a woman's voice kept singing and whistling, but no one was around. I sneezed, and she blessed me, and then she apologized. There were NO other cars or people (except inside the diner). And then the gas nozzle floated by itself and started filling up my car!\\n\\nBased on this forum yinz have a lot of stuff going on in town. Is your gas station known to be haunted? I'm no stranger to old weird town stuff, don't get me wrong. I was just so surprised to hear a voice so clearly. And to have someone fill up my car for me- dead or alive!!\"},{\"user\":\"howl\",\"body\":\"oh yeah thats our gas station ghost, don't worry about it\"},{\"user\":\"red\",\"body\":\"It sounds like you may have been under the influence of something, or perhaps sleep deprived? Next time you really should take a rest in the hotel down the street instead of driving out of town.\"},{\"user\":\"ghost\",\"body\":\"WhoooOOOooOOoooo Coulllddd it BeEeeeEEEEeeee (It'sssssa meEEEEEEEEE)\"},{\"user\":\"dude\",\"body\":\"I've never succumbed to such childish beliefs as ghosts, astrology, or using corn ethanol to power my 1993 Ford Taurus SHO (5.2s 0-60 in a 4-door thank you very much Mr. Ford, My Lord).\"},{\"user\":\"babs\",\"body\":\"\\n> I've never succumbed to such childish beliefs as ghosts, astrology, or using corn ethanol to power my 1993 Ford Taurus SHO (5.2s 0-60 in a 4-door thank you very much Mr. Ford, My Lord).\\n\\nWow you sound fun, hot stuff! ASL?\"},{\"user\":\"madmod\",\"body\":\"> Wow you sound fun, hot stuff! ASL?\\n\\nThis is a 13+ forum. Please have some decorum.... n00bs.\"},{\"user\":\"shelvn\",\"body\":\"That definitely sounds like a ghost! No doubt. As long as you didn't invite it into the car, you should be safe! She's pretty harmless, if not a little over-eager\"}]}");


var $3f07d6c36a738051$exports = {};
$3f07d6c36a738051$exports = JSON.parse('{"id":"28","board":"accounts","title":"old woman across the street!! weird ","author":"ghost","replies":9,"posts":[{"user":"ghost","body":"Does anyone know that lady that lives on Oak and is always outside? She really gives me the willies. I\'ve never seen her blink. She just sits on her porch and looks at me all sketchy style.\\n\\nPlease tell me I\'m being a freak and that this is a normal lady. I do NOT like the energy she gives off. ISTG shes haunted"},{"user":"ghost","body":"I just saw her again, but at night this time. None of the lights were on in her house. What is going on there ( \u0360\xb0 \u035F\u0296 \u0361\xb0)"},{"user":"howl","body":"maybe she just has nothing better to do"},{"user":"web","body":"I don"},{"user":"web","body":"> I don\\n\\nSorry I sent too early. I don\'t think people can be haunted, right? Aren\'t ghosts just souls? "},{"user":"scotty","body":"she\'s so scary that nobody will go into her yard to get our soccer ball back"},{"user":"scotty","body":"the kids told me, I am not a kid tho"},{"user":"chick","body":"Oooh that is Janet, don\'t worry about her. If you don\'t mess with her she won\'t mess with you teehee ~"},{"user":"ded","body":"lol there hasn\'t been a janet in this town in thiryfive years..... oooOOoooo"}]}');


var $433b0a113cf40047$exports = {};
$433b0a113cf40047$exports = JSON.parse("{\"id\":\"29\",\"board\":\"accounts\",\"title\":\"Weird broadcast on my ghost box, anyone else?\",\"author\":\"signals\",\"replies\":7,\"posts\":[{\"user\":\"signals\",\"body\":\"I've been fiddling with a ghost box lately (i guess UFO sightings were getting stale LOL). Took it out to the woods by the old base just to see if anyone died violently out there and stuck around... didn't hear anything until I need to hit the porta potty, of course! It was talking about someone being rude. or maybe calling me rude?\\n\\nDon't know if anyone knows if anyone's buried out there, but it seems they really value politeness, even through the veil.\"},{\"user\":\"red\",\"body\":\"Not surprising there are no ghosts by the old base. Nothing has ever really happened out that way. Totally a boring place for ghosts\"},{\"user\":\"rat\",\"body\":\"> I've been fiddling with a ghost box lately (i guess UFO sightings were getting stale LOL). Took it out to the woods by the old base just to see if anyone died violently out there and stuck around... didn't hear anything until I need to hit the porta potty, of course! It was talking about someone being rude. or maybe calling me rude?Don't know if anyone knows if anyone's buried out there, but it seems they really value politeness, even through the veil.\\n\\nSounds pretty lame, ghosts aren't real and you should be ashamed of yourself for thinking they are\"},{\"user\":\"madmod\",\"body\":\"> Sounds pretty lame, ghosts aren't real and you should be ashamed of yourself for thinking they are\\n\\nRat, this is a supportive community. If we have to listen to you roleplay as the dying rat colony in your yard, we can be supportive of a ghost box. Cool it.\"},{\"user\":\"rat\",\"body\":\"> Rat, this is a supportive community. If we have to listen to you roleplay as the dying rat colony in your yard, we can be supportive of a ghost box. Cool it.\\n\\nFine. I guess it's possible that ghosts exist. There is no scientific proof to support it though\"},{\"user\":\"egg\",\"body\":\"egg\"},{\"user\":\"ded\",\"body\":\"Ghosts are definitely real. My great grandad has been haunting this house since he died. We can't go into the attic without hearing jazz music. Poor old guy had a stroke and died right on the floor up there listening to his tunes.\"}]}");


var $3faca96884ff7c4c$exports = {};
$3faca96884ff7c4c$exports = JSON.parse('{"id":"30","board":"accounts","title":"My Rat Story","author":"rat","replies":20,"posts":[{"user":"rat","body":"I found a perfect house to carry out my plan. It has apple trees and easy access, they have no idea of the rat He** that is about to rain down upon them"},{"user":"rat","body":"Day one log: I have set up base camp underneath this poor sap\'s garage. I am scrounging up my friends to come live in the hole with me"},{"user":"rat","body":"Week 2 Log: It\'s really easy to crawl into their yard under the fence, we have been successfully infiltrating each night to retrieve apples. The apples are of poor quality, but they will provide much needed sustenance"},{"user":"rat","body":"Week 3 Log: They still suspect nothing, we\'ve been feeding to our heart content, slowly building our beautiful tunnel home under the garage"},{"user":"rat","body":"Week 4 Log: Some of the other rats are becoming bold, they are entering the yard during daylight hours. I have expressed my concerns but they do not heed my words. Their greed sickens me."},{"user":"rat","body":"Week 5 Log: I am deeply concerned. Today a new man was spotting on the property examining the entrance to our beautiful home. I am worried we will lose all we have built"},{"user":"rat","body":"** spotted"},{"user":"howl","body":"Go forth my brethren and breed your chaos across the realms of man. Purge of us our merciless hopes and dreams and engulf us in the pure fires of sin. Only then shall we encompass the whole of all freedom in the hearts of Men."},{"user":"rat","body":"Week 7 Log: It has been hard to find time to update this. My friends are dying all around me. There are jaws of death all around us, booby traps everywhere, we have lost so much, this will be my last message..."},{"user":"rofl","body":"Um I\'m pretty sure roleplaying is not allowed on this forum. unless u r a real rat???"},{"user":"slim","body":"> Um I\'m pretty sure roleplaying is not allowed on this forum. unless u r a real rat???\\n\\nHah well he\'s not much of anything anymore, if you would read the messages! Rest in piece, rat"},{"user":"weeb","body":"Hehehe so THATs were my apples hav g0ne. u musta been hungies >:o"},{"user":"rat","body":"I\'m now roleplaying as a dead rat"},{"user":"rat","body":"X_X"},{"user":"gert","body":"Riveting work here. Really getting to the bottom of the mysteries of Triple Oaks I see"},{"user":"rat","body":"> Riveting work here. Really getting to the bottom of the mysteries of Triple Oaks I see\\n\\nScrew off, Jertie"},{"user":"rofl","body":"that isn\'t what a dead rat would sayyy~ x3"},{"user":"rat","body":"> that isn\'t what a dead rat would sayyy~ x3\\n\\nLast I checked this was MY thread, I didn\'t make you come in here and read it"},{"user":"rofl","body":"guys help there\'s a bunch of dead rats in my room and they have a gun and they\'re forcing me to post opinions online (\u252C\u252C\uFE4F\u252C\u252C)"},{"user":"scotty","body":"what did i just read O.o"}]}');


var $d8e049cb84be76aa$exports = {};
$d8e049cb84be76aa$exports = JSON.parse("{\"id\":\"31\",\"board\":\"Info\",\"title\":\"Dumpy's Gutter closing after owner goes missing \",\"author\":\"ded\",\"replies\":14,\"posts\":[{\"user\":\"ded\",\"body\":\"Ughh! just heard from my friend who worked there that they're closing Dumps Gumps for the forseeable future. I guess Reggie has been missing for a week and staffs been operating as normal. But without Reg the place kinda falls apart. No one's heard from him. I even asked Barb and she didn't know anything. It's really freaky.\\n\\nIt's already so lame here, IDK where I'm gonna hang out now. I guess the sign will be up tomorrow, and then we're on our own. If you know anything or heard from Reggie, drop by Dumps if you can.... we're running out of places to lose.\"},{\"user\":\"dude\",\"body\":\"Back in my day, we didn't need combination bowling and beverage establishments to have fun. We took our age appropriate beverages to the woods out by the base and drank them with friends.\\n\\nBut! Sorry to hear about Reggie. We loved him down at the shop. I hope he turns up soon.\"},{\"user\":\"lettuce\",\"body\":\"Back in my day, we didn't need combination bowling and beverage establishments to have fun. We took our age appropriate beverages to the woods out by the base and drank them with friends.\\n\\nWell it must have been hard to get to the bowling alley before wheels were invented.\"},{\"user\":\"dude\",\"body\":\"> Well it must have been hard to get to the bowling alley before wheels were invented.\\n\\nOh we got a comedian huh? A regular clown. I was wondering why the hiring sign at Taco Bongo got taken down LOL.\"},{\"user\":\"dj\",\"body\":\"Reggie came in the other day asking for night vision goggles and walkies. We don't sell night vision goggles... but I sold him some 2-way walkies. When I asked what it was for he just said he was going splorin, whatever that means. Maybe he's on an extended camping trip.\"},{\"user\":\"ded\",\"body\":\"> Reggie came in the other day asking for night vision goggles and walkies. We don't sell night vision goggles... but I sold him some 2-way walkies. When I asked what it was for he just said he was going splorin, whatever that means. Maybe he's on an extended camping trip.\\n\\nCan u go tell the staff at dumps that? They're trying to collect all the info they can\"},{\"user\":\"lettuce\",\"body\":\"> Oh we got a comedian huh? A regular clown. I was wondering why the hiring sign at Taco Bongo got taken down LOL.\\n\\nYeah, it was my employment there and not the other reason they closed we all know about.\"},{\"user\":\"dj\",\"body\":\"> Can u go tell the staff at dumps that? They're trying to collect all the info they can\\n\\nSure thing, I can swing by after my shift tomorrow. Wanna meet there? You can show me the footage you talked about in the other thread.\"},{\"user\":\"ded\",\"body\":\"> Sure thing, I can swing by after my shift tomorrow. Wanna meet there? You can show me the footage you talked about in the other thread.\\n\\nCool beans! See u there ^^\"},{\"user\":\"scotty\",\"body\":\"mom left me there once for my friend Brendons birthday but no one else was there RIP Dumpy\"},{\"user\":\"red\",\"body\":\"If you have information on the whereabouts of missing persons, you should hand that over to the police instead of trying to conduct your own investigation.\"},{\"user\":\"ded\",\"body\":\"> If you have information on the whereabouts of missing persons, you should hand that over to the police instead of trying to conduct your own investigation.\\n\\nSheriff Barnes hates Reggie. Like he'd do anything to help. He's too busy playing lapdog for Flushmore and her big soulless toilet factory anyway\"},{\"user\":\"gert\",\"body\":\"> Sheriff Barnes hates Reggie. Like he'd do anything to help. He's too busy playing lapdog for Flushmore and her big soulless toilet factory anyway\\n\\nIn your defense, the toilet factory never had a soul. Flushmore is still up for debate.\"},{\"user\":\"scotty\",\"body\":\"who is barb\"}]}");


var $f7876c3a7d4f42f5$exports = {};
$f7876c3a7d4f42f5$exports = JSON.parse('{"id":"32","board":"Info","title":"Did anyone catch Coast to Ghost PM caller talking about the proving grounds outside of town?","author":"lettuce","replies":7,"posts":[{"user":"lettuce","body":"Shoot! I was out in the workshop listening per usue. Of course as soon as I need to visit he facilities, I seem to have missed a caller talking about the proving grounds. I know they\'re trying to turn it into a wildlife refuge or something. And folks in here have heard weird stuff when hunting. But all I caught on the tail end was a bit about voices and missing people.\\n\\nDid anyone get the full story? I wish there were replays or something."},{"user":"ded","body":"I\'m gonna call going to the bathroom visiting the proving grounds now ( \u0361\xb0 \u035C\u0296 \u0361\xb0)"},{"user":"signals","body":"Good news, I recorded the whole show! Bad news, I don\'t know where the recording is, my wife \\"cleaned up\\" my archive yesterday.\\nI vaguely remember they talked about refuge plan, but it\'s in trouble because there is an outside buyer who wants the land and is willing to pay A LOT. No word on who exactly, BUT some of the folks I talked to think this is a ploy to re-start weapons testing in secret while keeping things closed on paper."},{"user":"dude","body":"Heh wives am I right? Always so stressed about everything. Sorry to hear about your archive Signals!\\n\\nI used to go up there all the time. Never heard any voices. I guess because they\'re doing weapons testing they have to be secretive.. don\'t want the ruskies learning anything LOL. People go missing all the time around here, scared folks just like to blame the government because it seems bigger and scarier than your regular joe schmoe"},{"user":"red","body":"Sounds like your wife made an honest mistake, its probably nothing!"},{"user":"madmod","body":"Signals is right! The story wasn\'t anything groundbreaking. They primarily talked about the rumors people would \\"go missing\\" up there IYKYK and how they are trying to re-start weapons testing without anyone knowing. There was a brief interlude about secret tunnels under the radio station, but that passed quickly"},{"user":"ghost","body":"you don\'t have to listen to a radio show to talk to me guys : P"}]}');


var $c693dc454344d4fd$exports = {};
$c693dc454344d4fd$exports = JSON.parse('{"id":"33","board":"Info","title":"Mothfoot statue stolen!","author":"weeb","replies":16,"posts":[{"user":"weeb","body":"WHERE IS HEEEE? I just wanna no who did it... i pwomise I won be mad...\\n\\nok im a little mad!!! >:( how did someone take a WHOLE STATUE?? an now they get him in their r00m onleh!!!"},{"user":"shelvn","body":"Maybe he just got up and walked away ROFL"},{"user":"red","body":"Unfortunate for us to lose such an important part of town. I\'m sure that our local law enforcement is doing their best to find it, if anyone has any leads!"},{"user":"web","body":"I think I saw him!"},{"user":"weeb","body":"> I think I saw him!\\n\\nWhere?? i miss him =_="},{"user":"web","body":"> Where?? i miss him =_=\\n\\nHeh. At your mom\'s house."},{"user":"chick","body":"> Heh. At your mom\'s house.\\n\\nsighs. Web... I am sure Beeb\'s mom is a lovely lady who enjoys the fine company of a gentlemanly Mothfoot. Perhaps over tea."},{"user":"scotty","body":"how can a statue drink tea? do you just dump it on him"},{"user":"rat","body":"> WHERE IS HEEEE? I just wanna no who did it... i pwomise I won be mad...ok im a little mad!!! \uD83D\uDE20 how did someone take a WHOLE STATUE?? an now they get him in their r00m onleh!!!\\n\\nup your butt and around the corner"},{"user":"chick","body":"Newspaper says it was a kidnapping lol. Someone\'s taken our beloved big footed Lepidoptera-sapien! You\'d need to be pretty strong to carry that thing though. it\'s solid metal isn\'t it? Maybe it was a group of people.\\n\\nwhat if we have... a secret cult... and they\'re going to kill mothfoot!!"},{"user":"howl","body":"> Newspaper says it was a kidnapping lol. Someone\'s taken our beloved big footed Lepidoptera-sapien! You\'d need to be pretty strong to carry that thing though. it\'s solid metal isn\'t it? Maybe it was a group of people. \\n> what if we have... a secret cult... and they\'re going to kill mothfoot!!\\n\\nYou can\'t kill a statue. Or an idea. Mothfoot is forever. Now a cult on the other hand...."},{"user":"babs","body":"why do you talk like this"},{"user":"rat","body":"> why do you talk like this\\n\\nLike what?"},{"user":"babs","body":"> Like what?\\n\\nNot you!"},{"user":"scotty","body":"me?"},{"user":"babs","body":"Is everyone in this town like this? No wonder places are closing, geez."}]}');


var $ce0c818d352a923f$exports = {};
$ce0c818d352a923f$exports = JSON.parse("{\"id\":\"34\",\"board\":\"theories\",\"title\":\"[LOCKED] Setting up a BlowMarks stencil exchange! \",\"author\":\"madmod\",\"replies\":0,\"posts\":[]}");


var $5936439095b8e266$exports = {};
$5936439095b8e266$exports = JSON.parse("{\"id\":\"35\",\"board\":\"theories\",\"title\":\"Help Him magazines, hidden messages?\",\"author\":\"howl\",\"replies\":6,\"posts\":[{\"user\":\"howl\",\"body\":\"I just feel like everytime I see one, it's calling out to me. Who do you think is him, and why does he need help?\\n\\nmy pet theory is that theyre part of some bigger message, like a big game but in real life, and all the covers are clues on how to find HIM!! Maybe we will get a prize if we do? X3\"},{\"user\":\"web\",\"body\":\"maybe the person who draws the covers is reaching out to us. Trapped in some kind of horrible editorial job editing magazine covers\"},{\"user\":\"shelvn\",\"body\":\"Come to think of it, I've always seen those magazines but never picked one up. Do they have good articles? Surely someone is buying them if they keep being made, but I never see them in the wild.\"},{\"user\":\"kat\",\"body\":\"I've been making collages out of them, there's lots of good pictures! But I have never read an article lolz\"},{\"user\":\"dj\",\"body\":\"> I've been making collages out of them, there's lots of good pictures! But I have never read an article lolz\\n\\nIs it just the word \\\"HELP\\\" over and over and over again LOL? That would be pretty neat.\"},{\"user\":\"slim\",\"body\":\"> I've been making collages out of them, there's lots of good pictures! But I have never read an article lolz\\n\\ni've taken the time to recreate it. HIM HIM HIM HIM HIM HIM HIM (i hate my job) HIM HIM HIM HIM\"}]}");


var $231abf942feb6cc9$exports = {};
$231abf942feb6cc9$exports = JSON.parse("{\"id\":\"36\",\"board\":\"theories\",\"title\":\"I think the earth is like a blowpop \",\"author\":\"egg\",\"replies\":10,\"posts\":[{\"user\":\"egg\",\"body\":\"We just cant see the big stick at the bottom because its always below us\"},{\"user\":\"slim\",\"body\":\"What could you possibly mean by this?\"},{\"user\":\"scotty\",\"body\":\"wow what flavor is in the middle of the earth\"},{\"user\":\"ded\",\"body\":\"red, probably\"},{\"user\":\"slim\",\"body\":\"> red, probably\\n\\nRed is not a flavor, sweetie\"},{\"user\":\"howl\",\"body\":\"> Red is not a flavor, sweetie\\n\\ntell that to blue flavor you sanctimonious old man\"},{\"user\":\"egg\",\"body\":\"i never knew blow pops could cause such controversy. how many licks do you think it would take to reach the center\"},{\"user\":\"rat\",\"body\":\"> i never knew blow pops could cause such controversy. how many licks do you think it would take to reach the center\\n\\nControversy is the spice of life! A few thousand at minimum, although once you get past the mantle I think you might burn up.\"},{\"user\":\"weeb\",\"body\":\"THREE & THEN I WILL OMNONNOM IT GON3 . get in mah belleeehhh >XD\"},{\"user\":\"chick\",\"body\":\"If the stick is always below us, wouldn't the stick be a fixed point in space? We'd have to hit the stick eventually, or it could be seen from other places around the globe. We'd probably know if there was a big stick. It might even hit the moon if it rotated with us.\"}]}");


var $0ce6a4c95df79b66$exports = {};
$0ce6a4c95df79b66$exports = JSON.parse("{\"id\":\"37\",\"board\":\"theories\",\"title\":\"Red string prices too high!!\",\"author\":\"kat\",\"replies\":7,\"posts\":[{\"user\":\"kat\",\"body\":\"This economy is so busted right now. I have a huge crochet project coming up for a friend's baby shower, and a skein of acrylic is $2??? AS IF!!! Where are you getting your supplies?\"},{\"user\":\"howl\",\"body\":\"My grandma just has a bunch of yarn lying around, so I use her stuff when I need it. There's a group of knitters that hang out at the library on tuesdays. You could always go ask them\"},{\"user\":\"madmod\",\"body\":\"Kat, we've been over this. If you want to talk about crafting, please take it to the general interests board.\"},{\"user\":\"kat\",\"body\":\"> Kat, we've been over this. If you want to talk about crafting, please take it to the general interests board.\\n\\nOops sorry!! It said crafting in the title so I kinda assumed ^___^\\\"\"},{\"user\":\"madmod\",\"body\":\"I do just get my string from the craft shop in the city though. It's not exactly cheap, but it's reliable. We don't have much around town unless you special order it or buy it off the kitting ladies\"},{\"user\":\"red\",\"body\":\"I have some I could loan you. Where are you located?\"},{\"user\":\"kat\",\"body\":\"> I have some I could loan you. Where are you located?\\n\\nOH haha SORRY I don't meet strangers from online (^.^)\\\" don't wanna get murdered or whatever. Jsut store recs are perfectomundo!\"}]}");


var $a99de8f6bed5f72f$exports = {};
$a99de8f6bed5f72f$exports = JSON.parse('{"id":"38","board":"theories","title":"The big toilet is actually my friend :) ","author":"weeb","replies":7,"posts":[{"user":"weeb","body":"i luv him u guys!! he\'s part of town. 1 of us!! 1 of us!! big toilet 5ever!! He is here 2 keep us safe >o<"},{"user":"slim","body":"do you think it works?"},{"user":"shelvn","body":"Maybe that\'s where mothfoot ran off too. Someone tossed him in the toilet like a big log"},{"user":"weeb","body":"oh noes... he will dwown \u30FE(\uFFE3\u25A1\uFFE3;)\uFF89"},{"user":"web","body":"here lies Mothfoot statue... tossed in the toilet like a big log and left to dwown alone. May he rest in plumbing, serene and well loved. His feet were large, but his heart was larger."},{"user":"chick","body":"Oh my yes! I am also friends with the Big Toilet, he is so sweet to me. Buying me flowers and taking me out to dinner. I love him!!"},{"user":"greg","body":"Wow what a bunch of posers. I actually know Mount Flushmore (the big toilet\'s Christian name) and he\'s kind of a jerk who\'d hate all of u. Also he ate Mothfoot on purpose."}]}');


var $b5c8f3d2cca8eedd$exports = {};
$b5c8f3d2cca8eedd$exports = JSON.parse("{\"id\":\"39\",\"board\":\"theories\",\"title\":\"Moon Landing was not faked!\",\"author\":\"dude\",\"replies\":10,\"posts\":[{\"user\":\"dude\",\"body\":\"Okay I know, i KNow. Stick with me. We did actually go to the moon. There's enough evidence for that, or at leasrt that some sort of huge space mission happened. But they don't want the public to know how competent our space program is. Gotta keep us guessing. SO They flew up to space with props and set dressing.. to make the video look more fake! they brought a fan up there and hooked it to the ship to make wind to blow the flag, so we'd wonder how it was doing that with no wind in space.\\n\\nI'm so tired of the fighting i read on other forums. This kind of propaganda divides the people. In a relentless search for truth, we must accept that we DID go to the moon, but it was part of a bigger plan to spread misinformation through the public.\"},{\"user\":\"signals\",\"body\":\"Interesting theory! I can see why NASA would want to use set dressing to enhance the look & feel of the landing, imagine if they messed up the live video!!\\n\\nThis actually dovetails nicely with some of my own research into the Kubrick moon landing sets which I believe were NOT for fakery BUT actually used to rehearse the event ahead of time. Will post more details later sorry somebody just ordered more pancak\"},{\"user\":\"slim\",\"body\":\"putting a fan on the moon doesn't do anything if there's no air you #&@ing dingus\"},{\"user\":\"weeb\",\"body\":\"wait!! zomg wut happens with teh fan on??? nothing???\"},{\"user\":\"madmod\",\"body\":\"Interesting theory @signals! When you're back from pancakes I'd love to hear more.\"},{\"user\":\"ghost\",\"body\":\"If we didn't go to the MoooOOOonnn, where am I posting from Riiight NoooOOOooOOOw?\"},{\"user\":\"signals\",\"body\":\"> If we didn't go to the MoooOOOonnn, where am I posting from Riiight NoooOOOooOOOw?\\n\\nThis implies there are ghosts on the moon. Which.. I guess is possible, but there would have to be bodies up there too. I suppose if you moved the bodies to the dark side of it, in theory you could hide them. But then you'd assume the ghosts would move with them. If a person dies on planet Earth they don't get domain over the entire Earth.\"},{\"user\":\"rofl\",\"body\":\"im on the moon right now, and it's made of CHEESE ZOMG\"},{\"user\":\"weeb\",\"body\":\"> wut about teh FAN ???\\n\\nHonestly beeb, you couldn't really plug a fan into a spaceship anyway, so it's kind of a moot point.\"},{\"user\":\"ded\",\"body\":\"why would they fly all the way up there just to make it look fake? that doesn't make any sense at all. NASA is not some secret group of people trying to manipulate the political landscape. They're just a bunch of guys in Florida making rockets\"}]}");


var $85e90116743976f1$exports = {};
$85e90116743976f1$exports = JSON.parse("{\"id\":\"40\",\"board\":\"theories\",\"title\":\"Where is everyone buying the red suits?\",\"author\":\"madmod\",\"replies\":11,\"posts\":[{\"user\":\"madmod\",\"body\":\"we are not really a \\\"fancy suit\\\" town but suddenly all of the namby pamby city folk are walking around town in nice red suits. we don't even have a tailer in town. Did the Sears in Deerfolk do a sale or something?\"},{\"user\":\"howl\",\"body\":\"ugh i hope they are sold out 4evr, these posers are sooooo lame\"},{\"user\":\"red\",\"body\":\"Red suits are a perfectly normal fashion choice. Perhaps a lot of people in town are fans of Gwyneth Paltrow's iconic look at the 1996 MTV Video Music Awards.\"},{\"user\":\"kat\",\"body\":\"I do have to admit, they look really stunning. Red is a very seasonal color, and I've been thinking about trying to make a blazer for myself! I just can't decide if I should include shoulder pads or not >//<\"},{\"user\":\"dude\",\"body\":\"I get mine from Kmart but they're usually black or navy.\"},{\"user\":\"gert\",\"body\":\"> I get mine from Kmart but they're usually black or navy.\\n\\nK-Mart doesn't sell suits.\"},{\"user\":\"slim\",\"body\":\"> K-Mart doesn't sell suits.\\n\\nThat's because only suits shop at K-Mart.\"},{\"user\":\"dude\",\"body\":\"> K-Mart doesn't sell suits.\\n\\nOK geez IDK where they come from. My ex wife bought them for me\"},{\"user\":\"howl\",\"body\":\"> OK geez IDK where they come from. My ex wife bought them for me\\n\\nSuits come from wen a man and a woman love each other very much....\"},{\"user\":\"scotty\",\"body\":\"I dont get it\"},{\"user\":\"red\",\"body\":\"> Suits come from wen a man and a woman love each other very much....\\n\\nIncorrect. You can get high-quality suits at reasonable prices from Marshall Field's\"}]}");


var $9317d328ac34a34a$exports = {};
$9317d328ac34a34a$exports = JSON.parse('{"id":"41","board":"theories","title":"Let\u2019s talk about shoe theory","author":"howl","replies":12,"posts":[{"user":"howl","body":"I want to get those theory juices flowing. Not STRING THEORY @kat HEHE. SHOEE theory. Thoughts?? Questions?? Concerns??? What\'s with all the shoes on strings?????"},{"user":"kat","body":"If you wanted to talk String Theory, you should definitely be calling Signals. I am more of a yarn gal.\\n\\nIf I\'m here though, I have also wondered about the shoes! My brother told me growing up they signal a house that is selling illicit goods. IDK if it\'s true! I never went into one to find out XD"},{"user":"scotty","body":"wat does illicit mean"},{"user":"chick","body":"> wat does illicit mean\\n\\nIt\'s like bad. Kat means they sell drugs"},{"user":"scotty","body":"PPL CAN SELL DRUGS ????"},{"user":"dj","body":"LOL I guess they ran out of shoes to sell since they\'re all up on the powerlines.\\n\\nI was also told it was to signify a house has.. offerings"},{"user":"gert","body":"It\'s because kids get bored and toss them up there. It\'s not that complicated."},{"user":"ded","body":"it\'s true, i do it all the time to mess with people"},{"user":"dude","body":"Drug dealers often work directly with the government to keep hard working people on drugs and prevent them from rising up against Income Taxes. Back in \'77 there was a special government organization all dressed in red that would infiltrate and then facilitate the overthrow of any freethinkers deemed \\"Too Patriotic\\". Believe me I had firsthand experience with those Red Guards when they broke up my Strat-O-Matic Baseball Club by flooding the market with counterfeit Rod Carew cards."},{"user":"red","body":"> Drug dealers often work directly with the government to keep hard working people on drugs and prevent them from rising up against Income Taxes. Back in \'77 there was a special government organization all dressed in red that would infiltrate and then facilitate the overthrow of any freethinkers deemed \\"Too Patriotic\\". Believe me I had firsthand experience with those Red Guards when they broke up my Strat-O-Matic Baseball Club by flooding the market with counterfeit Rod Carew cards.\\n\\nThis is an urban legend. It was disproven years ago after an in-depth CIA investigation."},{"user":"web","body":"why are there so many posts about shoes on here?"},{"user":"shelvn","body":"who doesn\'t wear shoes?"}]}');


var $ef5204e348162dcd$exports = {};
$ef5204e348162dcd$exports = JSON.parse('{"id":"42","board":"theories","title":"Mr Pibbles term ends as the Proving Grounds close. Related? ","author":"red","replies":19,"posts":[{"user":"red","body":"The Proving Grounds outside of town have been in operation and supporting our local economy since the 40\'s. It\'s a pillar of this community. It makes jobs. It brings in commerce. It adds a good reputation to our town. It\'s where the kids go to make out in the woods and then get scared straight by an honest hardworking soldier. And here comes the puppet mayor, closing the door on it on his way out. They closed in the same year, and you expect me to think it\'s a coincidence? We\'re all smarter than this.\\n\\nI personally think he just wants to take us down with him after the zoning debacle of \'94. I bet they were working on something big, and because he couldn\'t get his little paws on it, he shut the whole thing down. Discuss"},{"user":"madmod","body":"I will let this post stay up this time but please remember to keep political discussions civil thnx"},{"user":"red","body":"Noted, thank you. Apologies for my harsh tone. I just think this is an important issue facing the people of this municipality. In reality, Pibbles is probably just doing his best. I don\'t think he\'s a good boy, but others might."},{"user":"web","body":"Rumor has it they shut it down because of some weapons testing gone wrong, not because the mayor wanted to punish us or something. At least thats what I\'ve heard!"},{"user":"red","body":"> Rumor has it they shut it down because of some weapons testing gone wrong, not because the mayor wanted to punish us or something. At least thats what I\'ve heard!\\n\\nWho told you that? Full name is preferable."},{"user":"web","body":"> Who told you that? Full name is preferable.\\n\\nOh ROLF IDK, you just hear it in scuttlebutt around town."},{"user":"weeb","body":"mebbe the radiation in town will give us all SUPERPWERS >.<"},{"user":"red","body":"> mebbe the radiation in town will give us all SUPERPWERS >.<\\n\\nHave you experienced this? That would be pretty remarkable but unlikely! ha"},{"user":"ghost","body":"I thought they closed because funding got cut. $#** happens. One of the guys told me they were shipping him to a base down south. He was pretty excited to be around the ocean, but he didn\'t tell me much about what was going on in there."},{"user":"dude","body":"Thank you for bringing some sense into this, red! It was a humiliation when Pibbles was elected over a hot-blooded American, and then he shuts down the grounds? And then the factory a few years later... we\'re really in need of new leadership."},{"user":"ghost","body":"> Thank you for bringing some sense into this, red! It was a humiliation when Pibbles was elected over a hot-blooded American, and then he shuts down the grounds? And then the factory a few years later... we\'re really in need of new leadership.\\n\\nAnd the taco bongo! why is everything closing \uD83D\uDE22"},{"user":"egg","body":"pibbs is wack yo"},{"user":"red","body":"> pibbs is wack yo\\n\\nWell said... yo."},{"user":"lettuce","body":"Wait is that why everyone would go up there? To make out? Dang I really missed out.\\n\\nJK JK I made out plenty. I did vote for Pibbs, I thought it would bring a fun energy to town. And Flushmore endorsed him! He has had a bumpy and controversial time in office, but his values are strong."},{"user":"madmod","body":"We all know Mr. Pibbles is a figurehead with middling fiscal policy. He\'s not exactly made for leadership. It was a stunt to try to bring tourism into town. The taco bongo thing did kind of ruin his approval ratings, but that\'s hardly his fault"},{"user":"dj","body":"Can we not call it the \\"taco bongo thing\\" please?"},{"user":"madmod","body":"> Can we not call it the \\"taco bongo thing\\" please?\\n\\nOops sorry dude. My bad"},{"user":"rofl","body":"ROFL THE MOD IS MODDED!!"},{"user":"dude","body":"And that\'s why they call her ROFL"}]}');


var $9483d1cf5d3bf281$exports = {};
$9483d1cf5d3bf281$exports = JSON.parse("{\"id\":\"43\",\"board\":\"theories\",\"title\":\"I spilled an iced coffee from Saucer's on my lap (do you think I have a case?)\",\"author\":\"chick\",\"replies\":7,\"posts\":[{\"user\":\"chick\",\"body\":\"I maybe have terrible burns across my legs (they are at least wet), should I sue Saucer's? Also do you think I should go to the hospital?\"},{\"user\":\"signals\",\"body\":\"Please do not sue Saucer's my wife will kill me\"},{\"user\":\"slim\",\"body\":\"I don't know if it's related but last time I ate breakfast at this Saucer's, it seemed like a child was making the coffee...is that even allowed?\"},{\"user\":\"dude\",\"body\":\"It's good for kids to learn the value of hard work early in life\"},{\"user\":\"signals\",\"body\":\"Thank you for the support Trousers! Saucer's is a family run business, there's nothing wrong with the whole family getting involved.\"},{\"user\":\"scotty\",\"body\":\"my Dad says I can only work at night detasseling the corn when no one can see\"},{\"user\":\"greg\",\"body\":\"Legal expert here. If a child injured you with coffee you're out of luck because legally nothing children do is crimes\"}]}");


var $2ff9b6226f6eeb6b$exports = {};
'use strict';

var $acw62 = parcelRequire("acw62");
var $04704e0fe60ec445$exports = {};
'use strict';

$04704e0fe60ec445$exports = (parcelRequire("kfsOU"));


var $dc78fec27dafe5d5$exports = {};
'use strict';
var $ed6a7f7e034afcf2$exports = {};
'use strict';
$ed6a7f7e034afcf2$exports = $ed6a7f7e034afcf2$var$bail;
function $ed6a7f7e034afcf2$var$bail(err) {
    if (err) throw err;
}



var $7B5Ea = parcelRequire("7B5Ea");
var $16d474a0815e976d$exports = {};
'use strict';
var $16d474a0815e976d$var$hasOwn = Object.prototype.hasOwnProperty;
var $16d474a0815e976d$var$toStr = Object.prototype.toString;
var $16d474a0815e976d$var$defineProperty = Object.defineProperty;
var $16d474a0815e976d$var$gOPD = Object.getOwnPropertyDescriptor;
var $16d474a0815e976d$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $16d474a0815e976d$var$toStr.call(arr) === '[object Array]';
};
var $16d474a0815e976d$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $16d474a0815e976d$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $16d474a0815e976d$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $16d474a0815e976d$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $16d474a0815e976d$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $16d474a0815e976d$var$setProperty = function setProperty(target, options) {
    if ($16d474a0815e976d$var$defineProperty && options.name === '__proto__') $16d474a0815e976d$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $16d474a0815e976d$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$16d474a0815e976d$var$hasOwn.call(obj, name)) return void 0;
        else if ($16d474a0815e976d$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $16d474a0815e976d$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$16d474a0815e976d$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $16d474a0815e976d$var$getProperty(target, name);
            copy = $16d474a0815e976d$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($16d474a0815e976d$var$isPlainObject(copy) || (copyIsArray = $16d474a0815e976d$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $16d474a0815e976d$var$isArray(src) ? src : [];
                    } else clone = src && $16d474a0815e976d$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $16d474a0815e976d$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $16d474a0815e976d$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


var $fd11a02fceb57d58$exports = {};
'use strict';
$fd11a02fceb57d58$exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};


var $17ea1ee7077b6d45$exports = {};
'use strict';
var $4e900a60b5516244$exports = {};
'use strict';
var $4e900a60b5516244$var$slice = [].slice;
$4e900a60b5516244$exports = $4e900a60b5516244$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $4e900a60b5516244$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $4e900a60b5516244$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}


$17ea1ee7077b6d45$exports = $17ea1ee7077b6d45$var$trough;
$17ea1ee7077b6d45$var$trough.wrap = $4e900a60b5516244$exports;
var $17ea1ee7077b6d45$var$slice = [].slice;
// Create new middleware.
function $17ea1ee7077b6d45$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $17ea1ee7077b6d45$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== 'function') throw new Error('Expected function as last argument, not ' + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $17ea1ee7077b6d45$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $4e900a60b5516244$exports(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== 'function') throw new Error('Expected `fn` to be a function, not ' + fn);
        fns.push(fn);
        return middleware;
    }
}



// Expose a frozen processor.
$dc78fec27dafe5d5$exports = $dc78fec27dafe5d5$var$unified().freeze();
var $dc78fec27dafe5d5$var$slice = [].slice;
var $dc78fec27dafe5d5$var$own = {}.hasOwnProperty;
// Process pipeline.
var $dc78fec27dafe5d5$var$pipeline = $17ea1ee7077b6d45$exports().use($dc78fec27dafe5d5$var$pipelineParse).use($dc78fec27dafe5d5$var$pipelineRun).use($dc78fec27dafe5d5$var$pipelineStringify);
function $dc78fec27dafe5d5$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $dc78fec27dafe5d5$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $dc78fec27dafe5d5$var$pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === 'string' || $7B5Ea(result)) {
        if ('value' in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function $dc78fec27dafe5d5$var$unified() {
    var attachers = [];
    var transformers = $17ea1ee7077b6d45$exports();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $dc78fec27dafe5d5$var$unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data($16d474a0815e976d$exports(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $dc78fec27dafe5d5$var$assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $dc78fec27dafe5d5$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $dc78fec27dafe5d5$var$assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $dc78fec27dafe5d5$var$assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin.apply(null, arguments);
        else if (typeof value === 'object') {
            if ('length' in value) addList(value);
            else addPreset(value);
        } else throw new Error('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = $16d474a0815e976d$exports(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $16d474a0815e976d$exports(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if ('length' in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error('Expected usable value, not `' + value + '`');
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === 'object' && 'length' in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error('Expected a list of plugins, not `' + plugins + '`');
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($fd11a02fceb57d58$exports(entry[1]) && $fd11a02fceb57d58$exports(value)) value = $16d474a0815e976d$exports(true, entry[1], value);
                entry[1] = value;
            } else attachers.push($dc78fec27dafe5d5$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $04704e0fe60ec445$exports(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $dc78fec27dafe5d5$var$assertParser('parse', Parser);
        if ($dc78fec27dafe5d5$var$newable(Parser, 'parse')) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $dc78fec27dafe5d5$var$assertNode(node);
        freeze();
        if (!cb && typeof file === 'function') {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $04704e0fe60ec445$exports(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        $dc78fec27dafe5d5$var$assertDone('runSync', 'run', complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            $ed6a7f7e034afcf2$exports(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $04704e0fe60ec445$exports(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $dc78fec27dafe5d5$var$assertCompiler('stringify', Compiler);
        $dc78fec27dafe5d5$var$assertNode(node);
        if ($dc78fec27dafe5d5$var$newable(Compiler, 'compile')) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $dc78fec27dafe5d5$var$assertParser('process', processor.Parser);
        $dc78fec27dafe5d5$var$assertCompiler('process', processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $04704e0fe60ec445$exports(doc);
            $dc78fec27dafe5d5$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        $dc78fec27dafe5d5$var$assertParser('processSync', processor.Parser);
        $dc78fec27dafe5d5$var$assertCompiler('processSync', processor.Compiler);
        file = $04704e0fe60ec445$exports(doc);
        process(file, done);
        $dc78fec27dafe5d5$var$assertDone('processSync', 'process', complete);
        return file;
        function done(error) {
            complete = true;
            $ed6a7f7e034afcf2$exports(error);
        }
    }
}
// Check if `value` is a constructor.
function $dc78fec27dafe5d5$var$newable(value, name) {
    return typeof value === 'function' && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($dc78fec27dafe5d5$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $dc78fec27dafe5d5$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $dc78fec27dafe5d5$var$assertParser(name, Parser) {
    if (typeof Parser !== 'function') throw new Error('Cannot `' + name + '` without `Parser`');
}
// Assert a compiler is available.
function $dc78fec27dafe5d5$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== 'function') throw new Error('Cannot `' + name + '` without `Compiler`');
}
// Assert the processor is not frozen.
function $dc78fec27dafe5d5$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot invoke `' + name + '` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.');
}
// Assert `node` is a unist node.
function $dc78fec27dafe5d5$var$assertNode(node) {
    if (!node || typeof node.type !== 'string') throw new Error('Expected node, got `' + node + '`');
}
// Assert that `complete` is `true`.
function $dc78fec27dafe5d5$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}


var $2b860b32f5273cea$exports = {};
'use strict';
$2b860b32f5273cea$exports = $2b860b32f5273cea$var$parse;
var $d5b40b3a4d4e8cd4$exports = {};
'use strict';

$d5b40b3a4d4e8cd4$exports = (parcelRequire("aLwp9"));


function $2b860b32f5273cea$var$parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return $d5b40b3a4d4e8cd4$exports(doc, Object.assign({}, self.data('settings'), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}


var $7f182373f6e7fb77$exports = {};
'use strict';
var $295b1514f388a336$exports = {};
'use strict';

$295b1514f388a336$exports = (parcelRequire("jLZ37"));


$7f182373f6e7fb77$exports = $7f182373f6e7fb77$var$remark2rehype;
// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function $7f182373f6e7fb77$var$remark2rehype(destination, options) {
    if (destination && !destination.process) {
        options = destination;
        destination = null;
    }
    return destination ? $7f182373f6e7fb77$var$bridge(destination, options) : $7f182373f6e7fb77$var$mutate(options);
}
// Bridge mode.
// Runs the destination with the new hast tree.
function $7f182373f6e7fb77$var$bridge(destination, options) {
    return transformer;
    function transformer(node, file, next) {
        destination.run($295b1514f388a336$exports(node, options), file, done);
        function done(error) {
            next(error);
        }
    }
}
// Mutate-mode.
// Further transformers run on the hast tree.
function $7f182373f6e7fb77$var$mutate(options) {
    return transformer;
    function transformer(node) {
        return $295b1514f388a336$exports(node, options);
    }
}


var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $a5ded092d1af5b31$exports = {};
'use strict';
var $9557e96728c042cf$exports = {};
'use strict';
var $c61292941889f8f2$exports = {};
$c61292941889f8f2$exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}


var $ebcb43fb277eac89$exports = {};
'use strict';
$ebcb43fb277eac89$exports = $ebcb43fb277eac89$var$Schema;
var $ebcb43fb277eac89$var$proto = $ebcb43fb277eac89$var$Schema.prototype;
$ebcb43fb277eac89$var$proto.space = null;
$ebcb43fb277eac89$var$proto.normal = {};
$ebcb43fb277eac89$var$proto.property = {};
function $ebcb43fb277eac89$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}


$9557e96728c042cf$exports = $9557e96728c042cf$var$merge;
function $9557e96728c042cf$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $ebcb43fb277eac89$exports($c61292941889f8f2$exports.apply(null, property), $c61292941889f8f2$exports.apply(null, normal), space);
}


var $54e6fef78f3cbe14$exports = {};
'use strict';
var $9ab7a0f2f5273cb1$exports = {};
'use strict';
var $539cbf68cfd34429$exports = {};
'use strict';
$539cbf68cfd34429$exports = $539cbf68cfd34429$var$normalize;
function $539cbf68cfd34429$var$normalize(value) {
    return value.toLowerCase();
}



var $de3826e2cce515f8$exports = {};
'use strict';
var $5570beed4f72c7cb$exports = {};
'use strict';
$5570beed4f72c7cb$exports = $5570beed4f72c7cb$var$Info;
var $5570beed4f72c7cb$var$proto = $5570beed4f72c7cb$var$Info.prototype;
$5570beed4f72c7cb$var$proto.space = null;
$5570beed4f72c7cb$var$proto.attribute = null;
$5570beed4f72c7cb$var$proto.property = null;
$5570beed4f72c7cb$var$proto.boolean = false;
$5570beed4f72c7cb$var$proto.booleanish = false;
$5570beed4f72c7cb$var$proto.overloadedBoolean = false;
$5570beed4f72c7cb$var$proto.number = false;
$5570beed4f72c7cb$var$proto.commaSeparated = false;
$5570beed4f72c7cb$var$proto.spaceSeparated = false;
$5570beed4f72c7cb$var$proto.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$var$proto.mustUseProperty = false;
$5570beed4f72c7cb$var$proto.defined = false;
function $5570beed4f72c7cb$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}


var $7bb28a628b951544$exports = {};

$parcel$export($7bb28a628b951544$exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377, (v) => $7bb28a628b951544$export$4a21f16c33752377 = v);
$parcel$export($7bb28a628b951544$exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f, (v) => $7bb28a628b951544$export$55e9e1fbc638dc8f = v);
$parcel$export($7bb28a628b951544$exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa, (v) => $7bb28a628b951544$export$242ac3d3042558aa = v);
$parcel$export($7bb28a628b951544$exports, "number", () => $7bb28a628b951544$export$98e628dec113755e, (v) => $7bb28a628b951544$export$98e628dec113755e = v);
$parcel$export($7bb28a628b951544$exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e, (v) => $7bb28a628b951544$export$ab8645c862eb5a3e = v);
$parcel$export($7bb28a628b951544$exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3, (v) => $7bb28a628b951544$export$9c8d678629b3d3 = v);
$parcel$export($7bb28a628b951544$exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd, (v) => $7bb28a628b951544$export$2ad25cfebf36cacd = v);
var $7bb28a628b951544$export$4a21f16c33752377;
var $7bb28a628b951544$export$55e9e1fbc638dc8f;
var $7bb28a628b951544$export$242ac3d3042558aa;
var $7bb28a628b951544$export$98e628dec113755e;
var $7bb28a628b951544$export$ab8645c862eb5a3e;
var $7bb28a628b951544$export$9c8d678629b3d3;
var $7bb28a628b951544$export$2ad25cfebf36cacd;
'use strict';
var $7bb28a628b951544$var$powers = 0;
$7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return Math.pow(2, ++$7bb28a628b951544$var$powers);
}


$de3826e2cce515f8$exports = $de3826e2cce515f8$var$DefinedInfo;
$de3826e2cce515f8$var$DefinedInfo.prototype = new $5570beed4f72c7cb$exports();
$de3826e2cce515f8$var$DefinedInfo.prototype.defined = true;
var $de3826e2cce515f8$var$checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var $de3826e2cce515f8$var$checksLength = $de3826e2cce515f8$var$checks.length;
function $de3826e2cce515f8$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $de3826e2cce515f8$var$mark(this, 'space', space);
    $5570beed4f72c7cb$exports.call(this, property, attribute);
    while(++index < $de3826e2cce515f8$var$checksLength){
        check = $de3826e2cce515f8$var$checks[index];
        $de3826e2cce515f8$var$mark(this, check, (mask & $7bb28a628b951544$exports[check]) === $7bb28a628b951544$exports[check]);
    }
}
function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) values[key] = value;
}


$9ab7a0f2f5273cb1$exports = $9ab7a0f2f5273cb1$var$create;
function $9ab7a0f2f5273cb1$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $de3826e2cce515f8$exports(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$539cbf68cfd34429$exports(prop)] = prop;
        normal[$539cbf68cfd34429$exports(info.attribute)] = prop;
    }
    return new $ebcb43fb277eac89$exports(property, normal, space);
}


$54e6fef78f3cbe14$exports = $9ab7a0f2f5273cb1$exports({
    space: 'xlink',
    transform: $54e6fef78f3cbe14$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $54e6fef78f3cbe14$var$xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}


var $9c2001df32d7e0eb$exports = {};
'use strict';

$9c2001df32d7e0eb$exports = $9ab7a0f2f5273cb1$exports({
    space: 'xml',
    transform: $9c2001df32d7e0eb$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $9c2001df32d7e0eb$var$xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}


var $6b2d9925b04ededa$exports = {};
'use strict';

var $f2ac7ad36db76cd1$exports = {};
'use strict';
var $fa5ee16f731231fb$exports = {};
'use strict';
$fa5ee16f731231fb$exports = $fa5ee16f731231fb$var$caseSensitiveTransform;
function $fa5ee16f731231fb$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


$f2ac7ad36db76cd1$exports = $f2ac7ad36db76cd1$var$caseInsensitiveTransform;
function $f2ac7ad36db76cd1$var$caseInsensitiveTransform(attributes, property) {
    return $fa5ee16f731231fb$exports(attributes, property.toLowerCase());
}


$6b2d9925b04ededa$exports = $9ab7a0f2f5273cb1$exports({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: $f2ac7ad36db76cd1$exports,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});


var $90343b68c9a7ed34$exports = {};
'use strict';


var $90343b68c9a7ed34$var$booleanish = $7bb28a628b951544$export$55e9e1fbc638dc8f;
var $90343b68c9a7ed34$var$number = $7bb28a628b951544$export$98e628dec113755e;
var $90343b68c9a7ed34$var$spaceSeparated = $7bb28a628b951544$export$ab8645c862eb5a3e;
$90343b68c9a7ed34$exports = $9ab7a0f2f5273cb1$exports({
    transform: $90343b68c9a7ed34$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $90343b68c9a7ed34$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $90343b68c9a7ed34$var$booleanish,
        ariaChecked: $90343b68c9a7ed34$var$booleanish,
        ariaColCount: $90343b68c9a7ed34$var$number,
        ariaColIndex: $90343b68c9a7ed34$var$number,
        ariaColSpan: $90343b68c9a7ed34$var$number,
        ariaControls: $90343b68c9a7ed34$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $90343b68c9a7ed34$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $90343b68c9a7ed34$var$booleanish,
        ariaDropEffect: $90343b68c9a7ed34$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $90343b68c9a7ed34$var$booleanish,
        ariaFlowTo: $90343b68c9a7ed34$var$spaceSeparated,
        ariaGrabbed: $90343b68c9a7ed34$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $90343b68c9a7ed34$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $90343b68c9a7ed34$var$spaceSeparated,
        ariaLevel: $90343b68c9a7ed34$var$number,
        ariaLive: null,
        ariaModal: $90343b68c9a7ed34$var$booleanish,
        ariaMultiLine: $90343b68c9a7ed34$var$booleanish,
        ariaMultiSelectable: $90343b68c9a7ed34$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $90343b68c9a7ed34$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $90343b68c9a7ed34$var$number,
        ariaPressed: $90343b68c9a7ed34$var$booleanish,
        ariaReadOnly: $90343b68c9a7ed34$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $90343b68c9a7ed34$var$booleanish,
        ariaRoleDescription: $90343b68c9a7ed34$var$spaceSeparated,
        ariaRowCount: $90343b68c9a7ed34$var$number,
        ariaRowIndex: $90343b68c9a7ed34$var$number,
        ariaRowSpan: $90343b68c9a7ed34$var$number,
        ariaSelected: $90343b68c9a7ed34$var$booleanish,
        ariaSetSize: $90343b68c9a7ed34$var$number,
        ariaSort: null,
        ariaValueMax: $90343b68c9a7ed34$var$number,
        ariaValueMin: $90343b68c9a7ed34$var$number,
        ariaValueNow: $90343b68c9a7ed34$var$number,
        ariaValueText: null,
        role: null
    }
});
function $90343b68c9a7ed34$var$ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}


var $71d94da779c1399e$exports = {};
'use strict';



var $71d94da779c1399e$var$boolean = $7bb28a628b951544$export$4a21f16c33752377;
var $71d94da779c1399e$var$overloadedBoolean = $7bb28a628b951544$export$242ac3d3042558aa;
var $71d94da779c1399e$var$booleanish = $7bb28a628b951544$export$55e9e1fbc638dc8f;
var $71d94da779c1399e$var$number = $7bb28a628b951544$export$98e628dec113755e;
var $71d94da779c1399e$var$spaceSeparated = $7bb28a628b951544$export$ab8645c862eb5a3e;
var $71d94da779c1399e$var$commaSeparated = $7bb28a628b951544$export$9c8d678629b3d3;
$71d94da779c1399e$exports = $9ab7a0f2f5273cb1$exports({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: $f2ac7ad36db76cd1$exports,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $71d94da779c1399e$var$commaSeparated,
        acceptCharset: $71d94da779c1399e$var$spaceSeparated,
        accessKey: $71d94da779c1399e$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $71d94da779c1399e$var$boolean,
        allowPaymentRequest: $71d94da779c1399e$var$boolean,
        allowUserMedia: $71d94da779c1399e$var$boolean,
        alt: null,
        as: null,
        async: $71d94da779c1399e$var$boolean,
        autoCapitalize: null,
        autoComplete: $71d94da779c1399e$var$spaceSeparated,
        autoFocus: $71d94da779c1399e$var$boolean,
        autoPlay: $71d94da779c1399e$var$boolean,
        capture: $71d94da779c1399e$var$boolean,
        charSet: null,
        checked: $71d94da779c1399e$var$boolean,
        cite: null,
        className: $71d94da779c1399e$var$spaceSeparated,
        cols: $71d94da779c1399e$var$number,
        colSpan: null,
        content: null,
        contentEditable: $71d94da779c1399e$var$booleanish,
        controls: $71d94da779c1399e$var$boolean,
        controlsList: $71d94da779c1399e$var$spaceSeparated,
        coords: $71d94da779c1399e$var$number | $71d94da779c1399e$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $71d94da779c1399e$var$boolean,
        defer: $71d94da779c1399e$var$boolean,
        dir: null,
        dirName: null,
        disabled: $71d94da779c1399e$var$boolean,
        download: $71d94da779c1399e$var$overloadedBoolean,
        draggable: $71d94da779c1399e$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $71d94da779c1399e$var$boolean,
        formTarget: null,
        headers: $71d94da779c1399e$var$spaceSeparated,
        height: $71d94da779c1399e$var$number,
        hidden: $71d94da779c1399e$var$boolean,
        high: $71d94da779c1399e$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $71d94da779c1399e$var$spaceSeparated,
        httpEquiv: $71d94da779c1399e$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $71d94da779c1399e$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $71d94da779c1399e$var$boolean,
        itemId: null,
        itemProp: $71d94da779c1399e$var$spaceSeparated,
        itemRef: $71d94da779c1399e$var$spaceSeparated,
        itemScope: $71d94da779c1399e$var$boolean,
        itemType: $71d94da779c1399e$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $71d94da779c1399e$var$boolean,
        low: $71d94da779c1399e$var$number,
        manifest: null,
        max: null,
        maxLength: $71d94da779c1399e$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $71d94da779c1399e$var$number,
        multiple: $71d94da779c1399e$var$boolean,
        muted: $71d94da779c1399e$var$boolean,
        name: null,
        nonce: null,
        noModule: $71d94da779c1399e$var$boolean,
        noValidate: $71d94da779c1399e$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $71d94da779c1399e$var$boolean,
        optimum: $71d94da779c1399e$var$number,
        pattern: null,
        ping: $71d94da779c1399e$var$spaceSeparated,
        placeholder: null,
        playsInline: $71d94da779c1399e$var$boolean,
        poster: null,
        preload: null,
        readOnly: $71d94da779c1399e$var$boolean,
        referrerPolicy: null,
        rel: $71d94da779c1399e$var$spaceSeparated,
        required: $71d94da779c1399e$var$boolean,
        reversed: $71d94da779c1399e$var$boolean,
        rows: $71d94da779c1399e$var$number,
        rowSpan: $71d94da779c1399e$var$number,
        sandbox: $71d94da779c1399e$var$spaceSeparated,
        scope: null,
        scoped: $71d94da779c1399e$var$boolean,
        seamless: $71d94da779c1399e$var$boolean,
        selected: $71d94da779c1399e$var$boolean,
        shape: null,
        size: $71d94da779c1399e$var$number,
        sizes: null,
        slot: null,
        span: $71d94da779c1399e$var$number,
        spellCheck: $71d94da779c1399e$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $71d94da779c1399e$var$commaSeparated,
        start: $71d94da779c1399e$var$number,
        step: null,
        style: null,
        tabIndex: $71d94da779c1399e$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $71d94da779c1399e$var$boolean,
        useMap: null,
        value: $71d94da779c1399e$var$booleanish,
        width: $71d94da779c1399e$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $71d94da779c1399e$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $71d94da779c1399e$var$number,
        borderColor: null,
        bottomMargin: $71d94da779c1399e$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $71d94da779c1399e$var$boolean,
        declare: $71d94da779c1399e$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $71d94da779c1399e$var$number,
        leftMargin: $71d94da779c1399e$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $71d94da779c1399e$var$number,
        marginWidth: $71d94da779c1399e$var$number,
        noResize: $71d94da779c1399e$var$boolean,
        noHref: $71d94da779c1399e$var$boolean,
        noShade: $71d94da779c1399e$var$boolean,
        noWrap: $71d94da779c1399e$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $71d94da779c1399e$var$number,
        rules: null,
        scheme: null,
        scrolling: $71d94da779c1399e$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $71d94da779c1399e$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $71d94da779c1399e$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $71d94da779c1399e$var$boolean,
        disableRemotePlayback: $71d94da779c1399e$var$boolean,
        prefix: null,
        property: null,
        results: $71d94da779c1399e$var$number,
        security: null,
        unselectable: null
    }
});


$a5ded092d1af5b31$exports = $9557e96728c042cf$exports([
    $9c2001df32d7e0eb$exports,
    $54e6fef78f3cbe14$exports,
    $6b2d9925b04ededa$exports,
    $90343b68c9a7ed34$exports,
    $71d94da779c1399e$exports
]);


var $ec7b5ee499fa9973$exports = {};

var $i1KRK = parcelRequire("i1KRK");
$ec7b5ee499fa9973$exports = $ec7b5ee499fa9973$var$rehypeFilter;
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef RehypeFilterOptions
 * @property {Array.<string>} [allowedElements]
 * @property {Array.<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */ /**
 * @type {import('unified').Plugin<[RehypeFilterOptions]>}
 */ function $ec7b5ee499fa9973$var$rehypeFilter(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        const node = /** @type {Root} */ tree;
        $i1KRK(node, 'element', onelement);
    };
    /**
   * @param {Node} node_
   * @param {number|null|undefined} index
   * @param {Node|null|undefined} parent_
   * @returns {number|void}
   */ function onelement(node_, index, parent_) {
        const node = /** @type {Element} */ node_;
        const parent = /** @type {Element|Root} */ parent_;
        /** @type {boolean|undefined} */ let remove;
        if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
        else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
        if (!remove && options.allowElement && typeof index === 'number') remove = !options.allowElement(node, index, parent);
        if (remove && typeof index === 'number') {
            if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
            else parent.children.splice(index, 1);
            return index;
        }
        return undefined;
    }
}


var $3a981cb90b397943$exports = {};
const $3a981cb90b397943$var$protocols = [
    'http',
    'https',
    'mailto',
    'tel'
];
$3a981cb90b397943$exports = $3a981cb90b397943$var$uriTransformer;
/**
 * @param {string} uri
 * @returns {string}
 */ function $3a981cb90b397943$var$uriTransformer(uri) {
    const url = (uri || '').trim();
    const first = url.charAt(0);
    if (first === '#' || first === '/') return url;
    const colon = url.indexOf(':');
    if (colon === -1) return url;
    let index = -1;
    while(++index < $3a981cb90b397943$var$protocols.length){
        const protocol = $3a981cb90b397943$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf('?');
    if (index !== -1 && colon > index) return url;
    index = url.indexOf('#');
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0)';
}


var $c425b37ed08897a5$export$d8abd7e5fb6871f9;
var $c425b37ed08897a5$export$d88ad6fc8b890afd;
'use strict';

var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


var $41c9cad340663374$exports = {};
'use strict';





var $81184b40caf3b243$exports = {};
'use strict';



var $81184b40caf3b243$var$boolean = $7bb28a628b951544$export$4a21f16c33752377;
var $81184b40caf3b243$var$number = $7bb28a628b951544$export$98e628dec113755e;
var $81184b40caf3b243$var$spaceSeparated = $7bb28a628b951544$export$ab8645c862eb5a3e;
var $81184b40caf3b243$var$commaSeparated = $7bb28a628b951544$export$9c8d678629b3d3;
var $81184b40caf3b243$var$commaOrSpaceSeparated = $7bb28a628b951544$export$2ad25cfebf36cacd;
$81184b40caf3b243$exports = $9ab7a0f2f5273cb1$exports({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: $fa5ee16f731231fb$exports,
    properties: {
        about: $81184b40caf3b243$var$commaOrSpaceSeparated,
        accentHeight: $81184b40caf3b243$var$number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: $81184b40caf3b243$var$number,
        amplitude: $81184b40caf3b243$var$number,
        arabicForm: null,
        ascent: $81184b40caf3b243$var$number,
        attributeName: null,
        attributeType: null,
        azimuth: $81184b40caf3b243$var$number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: $81184b40caf3b243$var$number,
        by: null,
        calcMode: null,
        capHeight: $81184b40caf3b243$var$number,
        className: $81184b40caf3b243$var$spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: $81184b40caf3b243$var$number,
        diffuseConstant: $81184b40caf3b243$var$number,
        direction: null,
        display: null,
        dur: null,
        divisor: $81184b40caf3b243$var$number,
        dominantBaseline: null,
        download: $81184b40caf3b243$var$boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: $81184b40caf3b243$var$number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: $81184b40caf3b243$var$number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: $81184b40caf3b243$var$number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: $81184b40caf3b243$var$commaSeparated,
        g2: $81184b40caf3b243$var$commaSeparated,
        glyphName: $81184b40caf3b243$var$commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: $81184b40caf3b243$var$number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: $81184b40caf3b243$var$number,
        horizOriginX: $81184b40caf3b243$var$number,
        horizOriginY: $81184b40caf3b243$var$number,
        id: null,
        ideographic: $81184b40caf3b243$var$number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: $81184b40caf3b243$var$number,
        k: $81184b40caf3b243$var$number,
        k1: $81184b40caf3b243$var$number,
        k2: $81184b40caf3b243$var$number,
        k3: $81184b40caf3b243$var$number,
        k4: $81184b40caf3b243$var$number,
        kernelMatrix: $81184b40caf3b243$var$commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: $81184b40caf3b243$var$number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: $81184b40caf3b243$var$number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: $81184b40caf3b243$var$number,
        overlineThickness: $81184b40caf3b243$var$number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: $81184b40caf3b243$var$number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: $81184b40caf3b243$var$spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: $81184b40caf3b243$var$number,
        pointsAtY: $81184b40caf3b243$var$number,
        pointsAtZ: $81184b40caf3b243$var$number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: $81184b40caf3b243$var$commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: $81184b40caf3b243$var$commaOrSpaceSeparated,
        rev: $81184b40caf3b243$var$commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: $81184b40caf3b243$var$commaOrSpaceSeparated,
        requiredFeatures: $81184b40caf3b243$var$commaOrSpaceSeparated,
        requiredFonts: $81184b40caf3b243$var$commaOrSpaceSeparated,
        requiredFormats: $81184b40caf3b243$var$commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: $81184b40caf3b243$var$number,
        specularExponent: $81184b40caf3b243$var$number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: $81184b40caf3b243$var$number,
        strikethroughThickness: $81184b40caf3b243$var$number,
        string: null,
        stroke: null,
        strokeDashArray: $81184b40caf3b243$var$commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: $81184b40caf3b243$var$number,
        strokeOpacity: $81184b40caf3b243$var$number,
        strokeWidth: null,
        style: null,
        surfaceScale: $81184b40caf3b243$var$number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: $81184b40caf3b243$var$commaOrSpaceSeparated,
        tabIndex: $81184b40caf3b243$var$number,
        tableValues: null,
        target: null,
        targetX: $81184b40caf3b243$var$number,
        targetY: $81184b40caf3b243$var$number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: $81184b40caf3b243$var$commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: $81184b40caf3b243$var$number,
        underlineThickness: $81184b40caf3b243$var$number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: $81184b40caf3b243$var$number,
        values: null,
        vAlphabetic: $81184b40caf3b243$var$number,
        vMathematical: $81184b40caf3b243$var$number,
        vectorEffect: null,
        vHanging: $81184b40caf3b243$var$number,
        vIdeographic: $81184b40caf3b243$var$number,
        version: null,
        vertAdvY: $81184b40caf3b243$var$number,
        vertOriginX: $81184b40caf3b243$var$number,
        vertOriginY: $81184b40caf3b243$var$number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: $81184b40caf3b243$var$number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


$41c9cad340663374$exports = $9557e96728c042cf$exports([
    $9c2001df32d7e0eb$exports,
    $54e6fef78f3cbe14$exports,
    $6b2d9925b04ededa$exports,
    $90343b68c9a7ed34$exports,
    $81184b40caf3b243$exports
]);


var $1177b5a900e67f19$exports = {};
'use strict';



var $1177b5a900e67f19$var$data = 'data';
$1177b5a900e67f19$exports = $1177b5a900e67f19$var$find;
var $1177b5a900e67f19$var$valid = /^data[-\w.:]+$/i;
var $1177b5a900e67f19$var$dash = /-[a-z]/g;
var $1177b5a900e67f19$var$cap = /[A-Z]/g;
function $1177b5a900e67f19$var$find(schema, value) {
    var normal = $539cbf68cfd34429$exports(value);
    var prop = value;
    var Type = $5570beed4f72c7cb$exports;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $1177b5a900e67f19$var$data && $1177b5a900e67f19$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = $1177b5a900e67f19$var$datasetToProperty(value);
        else value = $1177b5a900e67f19$var$datasetToAttribute(value);
        Type = $de3826e2cce515f8$exports;
    }
    return new Type(prop, value);
}
function $1177b5a900e67f19$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($1177b5a900e67f19$var$dash, $1177b5a900e67f19$var$camelcase);
    return $1177b5a900e67f19$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $1177b5a900e67f19$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($1177b5a900e67f19$var$dash.test(value)) return property;
    value = value.replace($1177b5a900e67f19$var$cap, $1177b5a900e67f19$var$kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return $1177b5a900e67f19$var$data + value;
}
function $1177b5a900e67f19$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
function $1177b5a900e67f19$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


var $4dc97e8bce215057$exports = {};
$4dc97e8bce215057$exports = JSON.parse("{\"classId\":\"classID\",\"dataType\":\"datatype\",\"itemId\":\"itemID\",\"strokeDashArray\":\"strokeDasharray\",\"strokeDashOffset\":\"strokeDashoffset\",\"strokeLineCap\":\"strokeLinecap\",\"strokeLineJoin\":\"strokeLinejoin\",\"strokeMiterLimit\":\"strokeMiterlimit\",\"typeOf\":\"typeof\",\"xLinkActuate\":\"xlinkActuate\",\"xLinkArcRole\":\"xlinkArcrole\",\"xLinkHref\":\"xlinkHref\",\"xLinkRole\":\"xlinkRole\",\"xLinkShow\":\"xlinkShow\",\"xLinkTitle\":\"xlinkTitle\",\"xLinkType\":\"xlinkType\",\"xmlnsXLink\":\"xmlnsXlink\"}");


var $38edd4def83e695e$exports = {};

$parcel$export($38edd4def83e695e$exports, "parse", () => $38edd4def83e695e$export$98e6a39c04603d36, (v) => $38edd4def83e695e$export$98e6a39c04603d36 = v);
$parcel$export($38edd4def83e695e$exports, "stringify", () => $38edd4def83e695e$export$fac44ee5b035f737, (v) => $38edd4def83e695e$export$fac44ee5b035f737 = v);
var $38edd4def83e695e$export$98e6a39c04603d36;
var $38edd4def83e695e$export$fac44ee5b035f737;
'use strict';
$38edd4def83e695e$export$98e6a39c04603d36 = $38edd4def83e695e$var$parse;
$38edd4def83e695e$export$fac44ee5b035f737 = $38edd4def83e695e$var$stringify;
var $38edd4def83e695e$var$empty = '';
var $38edd4def83e695e$var$space = ' ';
var $38edd4def83e695e$var$whiteSpace = /[ \t\n\r\f]+/g;
function $38edd4def83e695e$var$parse(value) {
    var input = String(value || $38edd4def83e695e$var$empty).trim();
    return input === $38edd4def83e695e$var$empty ? [] : input.split($38edd4def83e695e$var$whiteSpace);
}
function $38edd4def83e695e$var$stringify(values) {
    return values.join($38edd4def83e695e$var$space).trim();
}


var $79f9d1c25aee8303$exports = {};

$parcel$export($79f9d1c25aee8303$exports, "parse", () => $79f9d1c25aee8303$export$98e6a39c04603d36, (v) => $79f9d1c25aee8303$export$98e6a39c04603d36 = v);
$parcel$export($79f9d1c25aee8303$exports, "stringify", () => $79f9d1c25aee8303$export$fac44ee5b035f737, (v) => $79f9d1c25aee8303$export$fac44ee5b035f737 = v);
var $79f9d1c25aee8303$export$98e6a39c04603d36;
var $79f9d1c25aee8303$export$fac44ee5b035f737;
'use strict';
$79f9d1c25aee8303$export$98e6a39c04603d36 = $79f9d1c25aee8303$var$parse;
$79f9d1c25aee8303$export$fac44ee5b035f737 = $79f9d1c25aee8303$var$stringify;
var $79f9d1c25aee8303$var$comma = ',';
var $79f9d1c25aee8303$var$space = ' ';
var $79f9d1c25aee8303$var$empty = '';
// Parse comma-separated tokens to an array.
function $79f9d1c25aee8303$var$parse(value) {
    var values = [];
    var input = String(value || $79f9d1c25aee8303$var$empty);
    var index = input.indexOf($79f9d1c25aee8303$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($79f9d1c25aee8303$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $79f9d1c25aee8303$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $79f9d1c25aee8303$var$empty : $79f9d1c25aee8303$var$space;
    var right = settings.padRight ? $79f9d1c25aee8303$var$space : $79f9d1c25aee8303$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $79f9d1c25aee8303$var$empty) values = values.concat($79f9d1c25aee8303$var$empty);
    return values.join(right + $79f9d1c25aee8303$var$comma + left).trim();
}


var $676978e4775c0e9c$exports = {};
var $9d69df5777ad44b8$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $9d69df5777ad44b8$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $9d69df5777ad44b8$var$NEWLINE_REGEX = /\n/g;
var $9d69df5777ad44b8$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $9d69df5777ad44b8$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $9d69df5777ad44b8$var$COLON_REGEX = /^:\s*/;
var $9d69df5777ad44b8$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $9d69df5777ad44b8$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $9d69df5777ad44b8$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $9d69df5777ad44b8$var$NEWLINE = '\n';
var $9d69df5777ad44b8$var$FORWARD_SLASH = '/';
var $9d69df5777ad44b8$var$ASTERISK = '*';
var $9d69df5777ad44b8$var$EMPTY_STRING = '';
// types
var $9d69df5777ad44b8$var$TYPE_COMMENT = 'comment';
var $9d69df5777ad44b8$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $9d69df5777ad44b8$exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($9d69df5777ad44b8$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($9d69df5777ad44b8$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($9d69df5777ad44b8$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(0) || $9d69df5777ad44b8$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($9d69df5777ad44b8$var$EMPTY_STRING != style.charAt(i) && ($9d69df5777ad44b8$var$ASTERISK != style.charAt(i) || $9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($9d69df5777ad44b8$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $9d69df5777ad44b8$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($9d69df5777ad44b8$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($9d69df5777ad44b8$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($9d69df5777ad44b8$var$VALUE_REGEX);
        var ret = pos({
            type: $9d69df5777ad44b8$var$TYPE_DECLARATION,
            property: $9d69df5777ad44b8$var$trim(prop[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)),
            value: val ? $9d69df5777ad44b8$var$trim(val[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)) : $9d69df5777ad44b8$var$EMPTY_STRING
        });
        // ;
        match($9d69df5777ad44b8$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $9d69df5777ad44b8$var$trim(str) {
    return str ? str.replace($9d69df5777ad44b8$var$TRIM_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING) : $9d69df5777ad44b8$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $676978e4775c0e9c$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $9d69df5777ad44b8$exports(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$676978e4775c0e9c$exports = $676978e4775c0e9c$var$StyleToObject;


$c425b37ed08897a5$export$d8abd7e5fb6871f9 = $c425b37ed08897a5$var$toReact;
$c425b37ed08897a5$export$d88ad6fc8b890afd = $c425b37ed08897a5$var$childrenToReact;
/**
 * @typedef {JSX.IntrinsicElements} IntrinsicElements
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 */ /**
 * @typedef Info
 * @property {string?} space
 * @property {string?} attribute
 * @property {string?} property
 * @property {boolean} boolean
 * @property {boolean} booleanish
 * @property {boolean} overloadedBoolean
 * @property {boolean} number
 * @property {boolean} commaSeparated
 * @property {boolean} spaceSeparated
 * @property {boolean} commaOrSpaceSeparated
 * @property {boolean} mustUseProperty
 * @property {boolean} defined
 *
 * @typedef Schema
 * @property {Object.<string, Info>} property
 * @property {Object.<string, string>} normal
 * @property {string?} space
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {TransformOptions} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array.<Comment|Element|Text>} children
 * @param {string?} title
 * @returns {string|undefined}
 *
 * @typedef {keyof IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef ReactMarkdownProps
 * @property {Element} node
 * @property {string} key
 * @property {ReactNode[]} children
 * @property {Position?} [sourcePosition] Passed when `options.rawSourcePos` is given
 * @property {number} [index] Passed when `options.includeElementIndex` is given
 * @property {number} [siblingCount] Passed when `options.includeElementIndex` is given
 *
 * @callback CodeComponent
 * @param {JSX.IntrinsicElements['code'] & ReactMarkdownProps & {inline?: boolean}} props
 * @returns {ReactNode}
 *
 * @callback HeadingComponent
 * @param {JSX.IntrinsicElements['h1'] & ReactMarkdownProps & {level: number}} props
 * @returns {ReactNode}
 *
 * @callback LiComponent
 * @param {JSX.IntrinsicElements['li'] & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} props
 * @returns {ReactNode}
 *
 * @callback OrderedListComponent
 * @param {JSX.IntrinsicElements['ol'] & ReactMarkdownProps & {depth: number, ordered: true}} props
 * @returns {ReactNode}
 *
 * @callback TableCellComponent
 * @param {JSX.IntrinsicElements['table'] & ReactMarkdownProps & {style?: Object.<string, unknown>, isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback TableRowComponent
 * @param {JSX.IntrinsicElements['tr'] & ReactMarkdownProps & {isHeader: boolean}} props
 * @returns {ReactNode}
 *
 * @callback UnorderedListComponent
 * @param {JSX.IntrinsicElements['ul'] & ReactMarkdownProps & {depth: number, ordered: false}} props
 * @returns {ReactNode}
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {{[TagName in keyof IntrinsicElements]: TagName | ((props: IntrinsicElements[TagName] & ReactMarkdownProps) => ReactNode)}} NormalComponents
 * @typedef {Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 */ /**
 * @typedef TransformOptions
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {string|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ const $c425b37ed08897a5$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $c425b37ed08897a5$var$tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr'
]);
/**
 * @param {Context} context
 * @param {Element|Root} node
 */ function $c425b37ed08897a5$var$childrenToReact(context, node) {
    /** @type {Array.<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === 'element') children.push($c425b37ed08897a5$var$toReact(context, child, childIndex, node));
        else if (child.type === 'text') // React does not permit whitespace text elements as children of table:
        // cf. https://github.com/remarkjs/react-markdown/issues/576
        {
            if (node.type !== 'element' || !$c425b37ed08897a5$var$tableElements.has(node.tagName) || child.value !== '\n') children.push(child.value);
        } else if (child.type === 'raw' && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        // @ts-expect-error `raw` nodes are non-standard
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $c425b37ed08897a5$var$toReact(context, node, index, parent) {
    const options = context.options;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Object.<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === 'html' && name === 'svg') {
        schema = $41c9cad340663374$exports;
        context.schema = schema;
    }
    /* istanbul ignore else - types say they’re optional. */ if (node.properties) {
        for(property in node.properties)/* istanbul ignore else - prototype polution. */ if ($c425b37ed08897a5$var$own.call(node.properties, property)) $c425b37ed08897a5$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === 'ol' || name === 'ul') context.listDepth++;
    const children = $c425b37ed08897a5$var$childrenToReact(context, node);
    if (name === 'ol' || name === 'ul') context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the positon interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $c425b37ed08897a5$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === 'string' || component === $acw62.Fragment;
    if (!$3251146683c5d714$exports.isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = [
        name,
        position.start.line,
        position.start.column,
        index
    ].join('-');
    if (name === 'a' && options.linkTarget) properties.target = typeof options.linkTarget === 'function' ? options.linkTarget(properties.href, node.children, properties.title) : options.linkTarget;
    if (name === 'a' && options.transformLinkUri) properties.href = options.transformLinkUri(// @ts-expect-error assume `href` is a string
    properties.href, node.children, properties.title);
    if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') properties.inline = true;
    if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) properties.level = parseInt(name.charAt(1), 10);
    if (name === 'img' && options.transformImageUri) properties.src = options.transformImageUri(// @ts-expect-error assume `src` is a string
    properties.src, properties.alt, properties.title);
    if (!basic && name === 'li' && parent.type === 'element') {
        const input = $c425b37ed08897a5$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $c425b37ed08897a5$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === 'ol';
    }
    if (!basic && (name === 'ol' || name === 'ul')) {
        properties.ordered = name === 'ol';
        properties.depth = context.listDepth;
    }
    if (name === 'td' || name === 'th') {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === 'th';
    }
    if (!basic && name === 'tr' && parent.type === 'element') properties.isHeader = Boolean(parent.tagName === 'thead');
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties['data-sourcepos'] = $c425b37ed08897a5$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $c425b37ed08897a5$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $c425b37ed08897a5$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? $acw62.createElement(component, properties, children) : $acw62.createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $c425b37ed08897a5$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === 'element' && child.tagName === 'input') return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $c425b37ed08897a5$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === 'element') count++;
    }
    return count;
}
/**
 * @param {Object.<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $c425b37ed08897a5$var$addProperty(props, prop, value, ctx) {
    /** @type {Info} */ const info = $1177b5a900e67f19$exports(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (result && typeof result === 'object' && 'length' in result) // type-coverage:ignore-next-line remove when typed.
    result = (info.commaSeparated ? $79f9d1c25aee8303$exports : $38edd4def83e695e$exports).stringify(result);
    if (info.property === 'style' && typeof result === 'string') result = $c425b37ed08897a5$var$parseStyle(result);
    /* istanbul ignore else - types say they’re optional. */ if (info.space && info.property) props[$c425b37ed08897a5$var$own.call($4dc97e8bce215057$exports, info.property) ? $4dc97e8bce215057$exports[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Object.<string, string>}
 */ function $c425b37ed08897a5$var$parseStyle(value) {
    /** @type {Object.<string, string>} */ const result = {};
    try {
        $676978e4775c0e9c$exports(value, iterator);
    } catch (/** @type {unknown} */ _) {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $c425b37ed08897a5$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $c425b37ed08897a5$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $c425b37ed08897a5$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ':',
        pos.start.column,
        '-',
        pos.end.line,
        ':',
        pos.end.column
    ].map((d)=>String(d)).join('');
}


var $2ff9b6226f6eeb6b$require$childrenToReact = $c425b37ed08897a5$export$d88ad6fc8b890afd;
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').RehypeFilterOptions} FilterOptions
 * @typedef {import('./ast-to-react.js').TransformOptions} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [plugins=[]] **deprecated**: use `remarkPlugins` instead
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 */ $2ff9b6226f6eeb6b$exports = $2ff9b6226f6eeb6b$var$ReactMarkdown;
const $2ff9b6226f6eeb6b$var$own = {}.hasOwnProperty;
const $2ff9b6226f6eeb6b$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/**
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ /**
 * @type {Object.<string, Deprecation>}
 */ const $2ff9b6226f6eeb6b$var$deprecated = {
    renderers: {
        to: 'components',
        id: 'change-renderers-to-components'
    },
    astPlugins: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    allowDangerousHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    escapeHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    source: {
        to: 'children',
        id: 'change-source-to-children'
    },
    allowNode: {
        to: 'allowElement',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    allowedTypes: {
        to: 'allowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    disallowedTypes: {
        to: 'disallowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    includeNodeIndex: {
        to: 'includeElementIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    }
};
/**
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */ function $2ff9b6226f6eeb6b$var$ReactMarkdown(options) {
    for(const key in $2ff9b6226f6eeb6b$var$deprecated)if ($2ff9b6226f6eeb6b$var$own.call($2ff9b6226f6eeb6b$var$deprecated, key) && $2ff9b6226f6eeb6b$var$own.call(options, key)) {
        /** @type {Deprecation} */ const deprecation = $2ff9b6226f6eeb6b$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'} \`${key}\` (see <${$2ff9b6226f6eeb6b$var$changelog}#${deprecation.id}> for more info)`);
        delete $2ff9b6226f6eeb6b$var$deprecated[key];
    }
    const processor = $dc78fec27dafe5d5$exports().use($2b860b32f5273cea$exports)// TODO: deprecate `plugins` in v7.0.0.
    .use(options.remarkPlugins || options.plugins || []).use($7f182373f6e7fb77$exports, {
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use($ec7b5ee499fa9973$exports, options);
    /** @type {vfile} */ let file;
    if (typeof options.children === 'string') file = $04704e0fe60ec445$exports(options.children);
    else {
        if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
        file = $04704e0fe60ec445$exports();
    }
    /** @type {Root} */ // @ts-expect-error we’ll throw if it isn’t a root next.
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== 'root') throw new TypeError('Expected a `root` node');
    /** @type {ReactElement} */ let result = $acw62.createElement($acw62.Fragment, {}, $2ff9b6226f6eeb6b$require$childrenToReact({
        options: options,
        schema: $a5ded092d1af5b31$exports,
        listDepth: 0
    }, hastNode));
    if (options.className) result = $acw62.createElement('div', {
        className: options.className
    }, result);
    return result;
}
$2ff9b6226f6eeb6b$var$ReactMarkdown.defaultProps = {
    transformLinkUri: $3a981cb90b397943$exports
};
$2ff9b6226f6eeb6b$var$ReactMarkdown.propTypes = {
    // Core options:
    children: $8da5bfbbed271cd7$exports.string,
    // Layout options:
    className: $8da5bfbbed271cd7$exports.string,
    // Filter options:
    allowElement: $8da5bfbbed271cd7$exports.func,
    allowedElements: $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.string),
    disallowedElements: $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.string),
    unwrapDisallowed: $8da5bfbbed271cd7$exports.bool,
    // Plugin options:
    // type-coverage:ignore-next-line
    remarkPlugins: $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.oneOfType([
        $8da5bfbbed271cd7$exports.object,
        $8da5bfbbed271cd7$exports.func,
        $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.object,
            $8da5bfbbed271cd7$exports.func
        ]))
    ])),
    // type-coverage:ignore-next-line
    rehypePlugins: $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.oneOfType([
        $8da5bfbbed271cd7$exports.object,
        $8da5bfbbed271cd7$exports.func,
        $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.object,
            $8da5bfbbed271cd7$exports.func
        ]))
    ])),
    // Transform options:
    sourcePos: $8da5bfbbed271cd7$exports.bool,
    rawSourcePos: $8da5bfbbed271cd7$exports.bool,
    skipHtml: $8da5bfbbed271cd7$exports.bool,
    includeElementIndex: $8da5bfbbed271cd7$exports.bool,
    transformLinkUri: $8da5bfbbed271cd7$exports.oneOfType([
        $8da5bfbbed271cd7$exports.func,
        $8da5bfbbed271cd7$exports.bool
    ]),
    linkTarget: $8da5bfbbed271cd7$exports.oneOfType([
        $8da5bfbbed271cd7$exports.func,
        $8da5bfbbed271cd7$exports.string
    ]),
    transformImageUri: $8da5bfbbed271cd7$exports.func,
    components: $8da5bfbbed271cd7$exports.object
};
$2ff9b6226f6eeb6b$var$ReactMarkdown.uriTransformer = $3a981cb90b397943$exports;


var $7ec884babe4b212e$exports = {};
$7ec884babe4b212e$exports = import.meta.resolve("dPffl");


var $4b00c4ddc7682cd2$exports = {};
$4b00c4ddc7682cd2$exports = import.meta.resolve("4Za8D");


var $9179d4762a7878f4$exports = {};
$9179d4762a7878f4$exports = import.meta.resolve("jDEDB");


var $eabd2c8b09bd39df$exports = {};
$eabd2c8b09bd39df$exports = import.meta.resolve("emZXi");


var $882e290477a95805$exports = {};
$882e290477a95805$exports = import.meta.resolve("ew98B");


var $7e383fef35ab89a0$exports = {};
$7e383fef35ab89a0$exports = import.meta.resolve("dZCnx");


var $e15924db0f47d033$exports = {};
$e15924db0f47d033$exports = import.meta.resolve("drYTI");


var $5a3df2d9a8400064$exports = {};
$5a3df2d9a8400064$exports = import.meta.resolve("etNhn");


var $be585fcbd3db8001$exports = {};
$be585fcbd3db8001$exports = import.meta.resolve("43ixD");


var $1adea336543382f7$exports = {};
$1adea336543382f7$exports = import.meta.resolve("4lLDv");


var $56ec458668a38a1c$exports = {};
$56ec458668a38a1c$exports = import.meta.resolve("kxNp2");


var $d2f4112488a7ef8e$exports = {};
$d2f4112488a7ef8e$exports = import.meta.resolve("b21OU");


var $39a55b3b2cd81b50$exports = {};
$39a55b3b2cd81b50$exports = import.meta.resolve("2pgI6");


var $b1a417a42b0f50d7$exports = {};
$b1a417a42b0f50d7$exports = import.meta.resolve("eBpc0");


var $931c45f6f476de98$exports = {};
$931c45f6f476de98$exports = import.meta.resolve("1nZqx");


var $a347ae7994f74068$exports = {};
$a347ae7994f74068$exports = import.meta.resolve("7EkMg");


var $913f0a629be8fa40$exports = {};
$913f0a629be8fa40$exports = import.meta.resolve("iaZdb");


var $fb06eb9c794a3936$exports = {};
$fb06eb9c794a3936$exports = import.meta.resolve("cycWq");


var $28d896ff6744cc3c$exports = {};
$28d896ff6744cc3c$exports = import.meta.resolve("eQ1km");


var $2148351f82604b99$exports = {};
$2148351f82604b99$exports = import.meta.resolve("7joxe");


var $032309fa02305cf0$exports = {};
$032309fa02305cf0$exports = import.meta.resolve("aKXSZ");


var $46ec93fe50fc5317$exports = {};
$46ec93fe50fc5317$exports = import.meta.resolve("igeYn");


var $4978a3d912080130$exports = {};
$4978a3d912080130$exports = import.meta.resolve("e5vmz");


var $6ae16092a7fa9a4f$exports = {};
$6ae16092a7fa9a4f$exports = import.meta.resolve("9po0R");


var $4b7b2eb20c2483dc$exports = {};
$4b7b2eb20c2483dc$exports = import.meta.resolve("4LMd1");


var $bef7ac0e278cc2a4$exports = {};
$bef7ac0e278cc2a4$exports = import.meta.resolve("cU58x");


var $a47bad8a5249da32$exports = {};
$a47bad8a5249da32$exports = import.meta.resolve("96lPx");



function $b773492cde44da36$export$dedbf5c8cc754a98(icon) {
    switch(icon){
        case "babs":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7ec884babe4b212e$exports));
        case "egg":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4b00c4ddc7682cd2$exports));
        case "honse":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9179d4762a7878f4$exports));
        case "mask":
            return 0, (/*@__PURE__*/$parcel$interopDefault($eabd2c8b09bd39df$exports));
        case "nyan":
            return 0, (/*@__PURE__*/$parcel$interopDefault($882e290477a95805$exports));
        case "yea":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7e383fef35ab89a0$exports));
        case "scribe":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e15924db0f47d033$exports));
        case "television":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5a3df2d9a8400064$exports));
        case "group2":
            return 0, (/*@__PURE__*/$parcel$interopDefault($be585fcbd3db8001$exports));
        case "creature":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1adea336543382f7$exports));
        case "fairy":
            return 0, (/*@__PURE__*/$parcel$interopDefault($56ec458668a38a1c$exports));
        case "actor":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d2f4112488a7ef8e$exports));
        case "layer4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($39a55b3b2cd81b50$exports));
        case "candle":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b1a417a42b0f50d7$exports));
        case "cheese":
            return 0, (/*@__PURE__*/$parcel$interopDefault($931c45f6f476de98$exports));
        case "books":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a347ae7994f74068$exports));
        case "castle":
            return 0, (/*@__PURE__*/$parcel$interopDefault($913f0a629be8fa40$exports));
        case "drinking":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fb06eb9c794a3936$exports));
        case "cassette":
            return 0, (/*@__PURE__*/$parcel$interopDefault($28d896ff6744cc3c$exports));
        case "layer2":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2148351f82604b99$exports));
        case "minotaur":
            return 0, (/*@__PURE__*/$parcel$interopDefault($032309fa02305cf0$exports));
        case "broom":
            return 0, (/*@__PURE__*/$parcel$interopDefault($46ec93fe50fc5317$exports));
        case "mermaid":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4978a3d912080130$exports));
        case "page5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6ae16092a7fa9a4f$exports));
        case "group1":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4b7b2eb20c2483dc$exports));
        case "mask2":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bef7ac0e278cc2a4$exports));
        case "clown":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a47bad8a5249da32$exports));
    }
    return 0, (/*@__PURE__*/$parcel$interopDefault($ed47dfc85fd25007$exports));
}


class $c21c451509e5a7ea$var$BoardData {
    id = '';
    title = '';
    description = '';
    topics = 0;
    posts = 0;
}
class $c21c451509e5a7ea$var$TopicData {
    id = '';
    board = '';
    title = '';
    author = '';
    replies = 0;
    posts = [];
}
class $c21c451509e5a7ea$var$PostData {
    user = '';
    body = '';
    parsedBody = [];
}
class $c21c451509e5a7ea$var$UserData {
    id = '';
    icon = '';
    username = '';
    signature = '';
}
function $c21c451509e5a7ea$var$ParseTopic(topic) {
    topic.posts.forEach((p)=>{
        p.parsedBody = p.body.split('\n');
    });
    return topic;
}
function $c21c451509e5a7ea$export$933ece00e7b71809() {
    const { boardId: boardId, topicId: topicId } = (0, $f0eb7f6a0a55da23$export$99eaa27ddbbb95ef)();
    const boards = (0, $acw62.useRef)([]);
    const topics = (0, $acw62.useRef)([]);
    const users = (0, $acw62.useRef)([]);
    try {
        boards.current = (0, (/*@__PURE__*/$parcel$interopDefault($b439820d0f0b1ba1$exports)));
        users.current = (0, (/*@__PURE__*/$parcel$interopDefault($95a738d32638362f$exports)));
        topics.current = [];
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($dfebc6e9267b18ee$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($ffc1ade8c75ce539$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($e50509e141fd6b02$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($d7eef6648aca1c82$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($bf968068791fb1d9$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($31c481fdc871e26e$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($46e2f766144f2c1c$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($00ff80505b809d53$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($12f9804bd779af7a$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($3718e2bed1fea69f$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($966fc426433e19f1$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($5c0b2d1972b2505c$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($61cb99177463e565$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($c7a4e9bcc01bc840$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($2175a29575833fc9$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($1f10c668c6db5e80$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($239ec43ad6a17bf2$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($faaf10f4adb639e7$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($bf9dbf11f3599644$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($9d2427651ee7ea85$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($954c7c79338f17b9$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($688b4e5164a021ad$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($1faa7eed8fc6dcce$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($f6313b31d2218519$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($02082425468a3cb9$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($129171750faae9f6$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($e95350e03fc7ad99$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($3f07d6c36a738051$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($433b0a113cf40047$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($3faca96884ff7c4c$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($d8e049cb84be76aa$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($f7876c3a7d4f42f5$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($c693dc454344d4fd$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($ce0c818d352a923f$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($5936439095b8e266$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($231abf942feb6cc9$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($0ce6a4c95df79b66$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($a99de8f6bed5f72f$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($b5c8f3d2cca8eedd$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($85e90116743976f1$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($9317d328ac34a34a$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($ef5204e348162dcd$exports)))));
        topics.current.push($c21c451509e5a7ea$var$ParseTopic((0, (/*@__PURE__*/$parcel$interopDefault($9483d1cf5d3bf281$exports)))));
        boards.current.forEach((b)=>{
            b.topics = 0;
            b.posts = 0;
            topics.current.forEach((t)=>{
                if (t.board === b.id) {
                    b.topics++;
                    b.posts += t.replies ?? 0;
                }
            });
        });
    } catch (e) {
        console.error(e);
    }
    if (boardId == undefined) return null;
    let page;
    switch(boardId){
        case 'home':
            page = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c21c451509e5a7ea$export$750ab94ae265c900, {
                boards: boards.current
            });
            break;
        default:
            const board = boards.current.find((b)=>b.id == boardId);
            if (board === undefined) return null;
            if (topicId !== undefined) {
                const topic = topics.current.find((t)=>t.id == topicId);
                if (topic === undefined) return null;
                page = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c21c451509e5a7ea$var$CNNForumTopic, {
                    board: board,
                    topic: topic,
                    users: users.current
                });
            } else {
                const boardTopics = [];
                topics.current.forEach((t)=>{
                    if (t.board == board.id) boardTopics.push(t);
                });
                page = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c21c451509e5a7ea$var$CNNForumBoard, {
                    board: board,
                    topics: boardTopics,
                    users: users.current
                });
            }
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cnn-outline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "cnn-box-header text-24 text-white",
                        children: "CNN FORUMS"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "cnn-box-header-alt cnn-outline text-white",
                        children: "THE SOURCE OF TRUTH"
                    })
                ]
            }),
            page
        ]
    });
}
function $c21c451509e5a7ea$export$750ab94ae265c900(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-16 cnn-forum",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-path-header cnn-outline h-box align-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "text-green width-100p",
                    children: "Forums Home"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-box cnn-outline bg-black",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cnn-forum-box cnn-forum-body",
                        children: "Boards"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cnn-forum-box cnn-forum-box-count",
                        children: "Topics"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cnn-forum-box cnn-forum-box-count",
                        children: "Posts"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box cnn-outline",
                children: props.boards.map((b, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c21c451509e5a7ea$var$CNNForumBoardButton, {
                        board: b
                    }, i))
            })
        ]
    });
}
function $c21c451509e5a7ea$var$CNNForumBoardButton(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box bg-black cnn-forum-box-boardline",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-forum-box cnn-forum-box-icon",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ed47dfc85fd25007$exports))),
                    className: "width-32 height-32"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cnn-forum-box cnn-forum-body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "/cnn/forums/" + props.board.id,
                        className: "text-18",
                        children: props.board.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-14 text-white",
                        children: props.board.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-forum-box cnn-forum-box-count",
                children: props.board.topics
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-forum-box cnn-forum-box-count",
                children: props.board.posts
            })
        ]
    });
}
function $c21c451509e5a7ea$var$CNNForumBoard(props) {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-16 cnn-forum",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cnn-path-header cnn-outline h-box align-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "bg-black text-white",
                        onClick: ()=>{
                            nav("/cnn/forums/home");
                        },
                        children: "\u2190"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-green width-100p",
                        children: props.board.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-box cnn-outline bg-black",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cnn-forum-box cnn-forum-body",
                        children: "Topic"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cnn-forum-box cnn-forum-box-count",
                        children: "Author"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "cnn-forum-box cnn-forum-box-count",
                        children: "Replies"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box cnn-outline",
                children: props.topics.map((t, i)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c21c451509e5a7ea$var$CNNForumTopicButton, {
                        board: props.board,
                        topic: t,
                        users: props.users
                    }, i);
                })
            })
        ]
    });
}
function $c21c451509e5a7ea$var$CNNForumTopicButton(props) {
    const author = props.users.find((u)=>u.id == props.topic.author);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box bg-black cnn-forum-box-topicline",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-forum-box cnn-forum-body",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "/cnn/forums/" + props.board.id + "/" + props.topic.id,
                    className: "text-18",
                    children: props.topic.title
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-forum-box cnn-forum-box-count",
                children: author !== undefined ? author.username : ''
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-forum-box cnn-forum-box-count",
                children: props.topic.replies
            })
        ]
    });
}
function $c21c451509e5a7ea$var$CNNForumTopic(props) {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-16 cnn-forum",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cnn-path-header cnn-outline h-box align-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "bg-black text-white",
                        onClick: ()=>{
                            nav("/cnn/forums/" + props.board.id);
                        },
                        children: "\u2190"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-green",
                        children: props.board.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-white",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-green",
                        children: props.topic.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box cnn-outline",
                children: props.topic.posts.map((p, i)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c21c451509e5a7ea$var$CNNForumPost, {
                        post: p,
                        users: props.users
                    }, i);
                })
            })
        ]
    });
}
function $c21c451509e5a7ea$var$CNNForumPost(props) {
    const user = props.users.find((u)=>u.id == props.post.user);
    if (user === undefined) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "cnn-outline cnn-forum-post bg-black h-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "cnn-forum-box-user v-box center-all gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-14 text-center",
                        children: user.username
                    }),
                    user.icon !== "" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, $b773492cde44da36$export$dedbf5c8cc754a98)(user.icon),
                        className: "width-64"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed47dfc85fd25007$exports))),
                        className: "width-64"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box cnn-forum-post-body gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "v-box",
                        children: props.post.parsedBody.map((b, i)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ff9b6226f6eeb6b$exports))), {
                                className: "text-14 text-white",
                                children: b
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "cnn-forum-divider"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-white text-14",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            children: user.signature
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $1d9ab9617fab9e5e$exports = {};
$1d9ab9617fab9e5e$exports = import.meta.resolve("71rzR");


var $9475154a3dd56ffb$exports = {};
$9475154a3dd56ffb$exports = import.meta.resolve("cZqJN");


var $61229423646a8f9b$exports = {};
$61229423646a8f9b$exports = import.meta.resolve("bhSUN");


var $5c9fc9e21e8cb5a9$exports = {};
$5c9fc9e21e8cb5a9$exports = import.meta.resolve("6KoJm");


var $b735b16da605d496$exports = {};
$b735b16da605d496$exports = import.meta.resolve("cseXq");


var $8de6404f5a08b343$exports = {};
$8de6404f5a08b343$exports = import.meta.resolve("5dzb4");


var $a7b5a6493b7cb09b$exports = {};
$a7b5a6493b7cb09b$exports = import.meta.resolve("2zgbF");


var $b069f11e4bb9030a$exports = {};
$b069f11e4bb9030a$exports = import.meta.resolve("lqOtn");


var $d4e8eed33f81bd08$exports = {};
$d4e8eed33f81bd08$exports = import.meta.resolve("lpum2");


var $3813cf634f9601bc$exports = {};
$3813cf634f9601bc$exports = import.meta.resolve("d81du");


var $2953ad4c6c61935a$exports = {};
$2953ad4c6c61935a$exports = import.meta.resolve("eYWIv");


var $bd44a30931c7b47b$exports = {};
$bd44a30931c7b47b$exports = import.meta.resolve("8zpIF");


var $d277795d0303afc4$exports = {};
$d277795d0303afc4$exports = import.meta.resolve("5nLj5");


var $ac5bf8e9f55d8aa6$exports = {};
$ac5bf8e9f55d8aa6$exports = import.meta.resolve("aL5UQ");


var $9fb5cd60bdb812d7$exports = {};
$9fb5cd60bdb812d7$exports = import.meta.resolve("d8XPM");


var $4395d72620d3a9db$exports = {};
$4395d72620d3a9db$exports = import.meta.resolve("alxa5");


var $12fc5e4e4b67f69e$exports = {};
$12fc5e4e4b67f69e$exports = import.meta.resolve("XhCh5");


var $adb8b53a35ab12a6$exports = {};
$adb8b53a35ab12a6$exports = import.meta.resolve("gYPSz");


var $16e5988cc56600cd$exports = {};
$16e5988cc56600cd$exports = import.meta.resolve("89Ikz");


var $63c2c1aa79089a12$exports = {};
$63c2c1aa79089a12$exports = import.meta.resolve("4RNB0");


var $cc6224dc9ec22e4e$exports = {};
$cc6224dc9ec22e4e$exports = import.meta.resolve("coBmL");


var $435d661c9a395efd$exports = {};
$435d661c9a395efd$exports = import.meta.resolve("2wQQ9");


var $b389b4c8c6b0416a$exports = {};
$b389b4c8c6b0416a$exports = import.meta.resolve("kPhMM");


var $3c863da6d7b50a1c$exports = {};
$3c863da6d7b50a1c$exports = import.meta.resolve("flwdT");


var $7f4ef22fb27fc454$exports = {};
$7f4ef22fb27fc454$exports = import.meta.resolve("kfTuf");


var $a7fef34aba472de8$exports = {};
$a7fef34aba472de8$exports = import.meta.resolve("acG60");


var $610ef439a536ac65$exports = {};
$610ef439a536ac65$exports = import.meta.resolve("dArl7");


var $9e555dc6e4d7d17d$exports = {};
$9e555dc6e4d7d17d$exports = import.meta.resolve("j9inH");


var $8afcff2e341b559c$exports = {};
$8afcff2e341b559c$exports = import.meta.resolve("aG76j");


var $fcfa2d58abc9c128$exports = {};
$fcfa2d58abc9c128$exports = import.meta.resolve("ldjtR");


var $fe35b75061960ce9$exports = {};
$fe35b75061960ce9$exports = import.meta.resolve("1Ljgt");


var $8315797855732ab0$exports = {};
$8315797855732ab0$exports = import.meta.resolve("eezWb");


var $91cfdf68f99da089$exports = {};
$91cfdf68f99da089$exports = import.meta.resolve("ldmJr");


var $f543212be2809cba$exports = {};
$f543212be2809cba$exports = import.meta.resolve("g6MnI");


var $6f4824ad471b7846$exports = {};
$6f4824ad471b7846$exports = import.meta.resolve("mWD9Q");


var $eb8e3d35f990705e$exports = {};
$eb8e3d35f990705e$exports = import.meta.resolve("k3Kum");


var $5c1b8b52ca8b31bb$exports = {};
$5c1b8b52ca8b31bb$exports = import.meta.resolve("1c7z5");


var $cc017c65c184ec01$exports = {};
$cc017c65c184ec01$exports = import.meta.resolve("bAN5K");


var $d73b45d90ef973e6$exports = {};
$d73b45d90ef973e6$exports = import.meta.resolve("17P3m");


var $c13f787983a72d0f$exports = {};
$c13f787983a72d0f$exports = import.meta.resolve("9U0eM");


var $3ccca7c2d24a7521$exports = {};
$3ccca7c2d24a7521$exports = import.meta.resolve("4MSW6");


var $98f61d7e49c90c31$exports = {};
$98f61d7e49c90c31$exports = import.meta.resolve("dF8QS");


var $31b27815d11c6a8a$exports = {};
$31b27815d11c6a8a$exports = import.meta.resolve("8eYbD");


var $4d7061ea4ba12681$exports = {};
$4d7061ea4ba12681$exports = import.meta.resolve("hTadr");


var $1ded276516dcc3ee$exports = {};
$1ded276516dcc3ee$exports = import.meta.resolve("c81Be");


var $dfd4a95bd11882c4$exports = {};
$dfd4a95bd11882c4$exports = import.meta.resolve("kQOhG");


var $7146180bc6e804c7$exports = {};
$7146180bc6e804c7$exports = import.meta.resolve("5gvrD");


var $1856931f8e919555$exports = {};
$1856931f8e919555$exports = import.meta.resolve("9mioB");


var $6d945320afdaa895$exports = {};
$6d945320afdaa895$exports = import.meta.resolve("fSOr9");


var $dda747fcd206201b$exports = {};
$dda747fcd206201b$exports = import.meta.resolve("kW9Pv");


var $bcf9af4212e726f3$exports = {};
$bcf9af4212e726f3$exports = import.meta.resolve("aVmQL");


var $76bb0fdd661287a3$exports = {};
$76bb0fdd661287a3$exports = import.meta.resolve("flu45");


var $2831c8729e936f65$exports = {};
$2831c8729e936f65$exports = import.meta.resolve("hej2o");


var $95740018b89f3820$exports = {};
$95740018b89f3820$exports = import.meta.resolve("4kh6E");


var $d12fff46609c0421$exports = {};
$d12fff46609c0421$exports = import.meta.resolve("eVe4d");


var $bb64cdebfbe11250$exports = {};
$bb64cdebfbe11250$exports = import.meta.resolve("asPAe");


var $9ec191192d8714ff$exports = {};
$9ec191192d8714ff$exports = import.meta.resolve("kRJke");


var $f47fb61d2b1b40cc$exports = {};
$f47fb61d2b1b40cc$exports = import.meta.resolve("g78Np");


var $934f38345ab423d6$exports = {};
$934f38345ab423d6$exports = import.meta.resolve("kAfYh");


var $4b03bdb1e76193c8$exports = {};
$4b03bdb1e76193c8$exports = import.meta.resolve("lsdr2");


var $34d57f8d40013fc4$exports = {};
$34d57f8d40013fc4$exports = import.meta.resolve("6Yr6g");


var $dde3d0c834bc3f3b$exports = {};
$dde3d0c834bc3f3b$exports = import.meta.resolve("cCFzd");


var $3ad744c47dfd7dce$exports = {};
$3ad744c47dfd7dce$exports = import.meta.resolve("3SYM5");


var $6549bf5b85930abe$exports = {};
$6549bf5b85930abe$exports = import.meta.resolve("gyAEl");


var $8e491962bf8b6ea0$exports = {};
$8e491962bf8b6ea0$exports = import.meta.resolve("8OQID");







var $acw62 = parcelRequire("acw62");
class $44ddd8d7d9176fe8$var$State {
    index = 0;
    node = null;
    check = ()=>{
        return false;
    };
    canSkipTo = false;
    canReturnTo = false;
}
function $44ddd8d7d9176fe8$export$b84446f5899e929b(props) {
    const state = (0, $acw62.useRef)(props.states[0]);
    const s = (0, $acw62.useMemo)(()=>{
        if (props.id !== undefined) console.log("re-render " + props.id + ", " + state.current.index);
        for(let i = props.states.length - 1; i >= 0; i--){
            const checkState = props.states[i];
            if (checkState.index == state.current.index) continue;
            const canCheck = checkState.index == state.current.index + 1 || checkState.canSkipTo || checkState.canReturnTo;
            if (!canCheck) continue;
            const checkValid = checkState.check();
            if (!checkValid) continue;
            state.current = checkState;
            return checkState;
        }
        return state.current;
    }, [
        props.check
    ]);
    return s.node;
}



function $7d81fec9edbde1fc$export$6aa12a20afa4a6b9(props) {
    const id = props.id !== undefined ? props.id : '';
    const className = props.className !== undefined ? props.className : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        id: id,
        src: props.src,
        className: className + " width-100p"
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


function $46f67e62c93b3a2b$export$56141a31cdccd984(props) {
    const [smashed, setSmashed] = (0, $acw62.useState)(false);
    const className = props.className !== undefined ? props.className : "";
    const style = props.style !== undefined ? props.style : {};
    return smashed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        style: style,
        children: props.post
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $887b4dfdb08ec5f4$export$7cfed81e33fc1826), {
        cursor: (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).HAM,
        onClick: ()=>{
            setSmashed(true);
        },
        className: className,
        style: style,
        children: props.pre
    });
}




var $00c3a13b5badf44d$exports = {};
$00c3a13b5badf44d$exports = import.meta.resolve("6l9wB");


var $e73cadddd90b9e2c$exports = {};
$e73cadddd90b9e2c$exports = import.meta.resolve("gbdt1");


var $6c981228b0743b78$exports = {};
$6c981228b0743b78$exports = import.meta.resolve("4jvEs");


var $2ad02d99939a6047$exports = {};
$2ad02d99939a6047$exports = import.meta.resolve("itqtA");


var $a20c2f6dec181995$exports = {};
$a20c2f6dec181995$exports = import.meta.resolve("LxMXL");


var $b3120b06a6d1874c$exports = {};
$b3120b06a6d1874c$exports = import.meta.resolve("2zpyV");


var $1e011ccdb6271d3d$exports = {};
$1e011ccdb6271d3d$exports = import.meta.resolve("e93LB");


var $9a348134aaa21285$exports = {};
$9a348134aaa21285$exports = import.meta.resolve("hIiti");


var $9fd8f3835050870f$exports = {};
$9fd8f3835050870f$exports = import.meta.resolve("lSiNE");


var $16a593d6df5f28c4$exports = {};
$16a593d6df5f28c4$exports = import.meta.resolve("eGnoM");


var $56a4ba9c12b62397$exports = {};
$56a4ba9c12b62397$exports = import.meta.resolve("d5NPm");


var $d121e2eefca3a779$exports = {};
$d121e2eefca3a779$exports = import.meta.resolve("gOrCN");


var $3f495a0530e06e34$exports = {};
$3f495a0530e06e34$exports = import.meta.resolve("lM7Yt");


var $f36694cd12b88b3c$exports = {};
$f36694cd12b88b3c$exports = import.meta.resolve("f4jPG");





var $df4b6e7b11883ead$exports = {};
$df4b6e7b11883ead$exports = import.meta.resolve("amKr1");






const $a53a1942f12ce630$var$SMOG_ID = "smog-the-destroyer";
function $a53a1942f12ce630$export$6bffe77b8eee705f() {
    const titeBoxRef = (0, $acw62.useRef)(HTMLDivElement.prototype);
    const [state, setState] = (0, $acw62.useState)({
        ps: 0,
        tc: 0
    });
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    const cursor = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const checkTitesLocation = ()=>{
        let allInPlace = true;
        let inPlaceCount = tites.max;
        const boxBounds = titeBoxRef.current.getBoundingClientRect();
        tites.titeRefs.forEach((t)=>{
            const bounds = t.current.getBoundingClientRect();
            if (bounds.top < boxBounds.top || bounds.bottom > boxBounds.bottom) {
                allInPlace = false;
                inPlaceCount--;
            }
        });
        let ps = state.ps;
        if (ps == 0 && inPlaceCount >= tites.max) ps = 1;
        console.log(inPlaceCount);
        setState({
            tc: inPlaceCount,
            ps: ps
        });
    };
    const tites = (0, $acw62.useMemo)(()=>{
        const tites = [];
        const refs = [];
        const addTite = (i, src, x, y, w, mite)=>{
            tites.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$Tite, {
                i: i,
                src: src,
                x: x,
                y: y,
                w: w,
                mite: mite,
                refList: refs,
                onDragEnded: ()=>{
                    checkTitesLocation();
                }
            }, "tite-" + i));
        };
        addTite(1, (0, (/*@__PURE__*/$parcel$interopDefault($56a4ba9c12b62397$exports))), 17, 47.14, 8);
        addTite(2, (0, (/*@__PURE__*/$parcel$interopDefault($6c981228b0743b78$exports))), 73, 45.86, 11);
        // addTite(3, tite12, 88, 54.14, 5, true);
        addTite(4, (0, (/*@__PURE__*/$parcel$interopDefault($b3120b06a6d1874c$exports))), 86, 51.29, 10, true);
        addTite(5, (0, (/*@__PURE__*/$parcel$interopDefault($9a348134aaa21285$exports))), 8, 59.14, 7);
        addTite(6, (0, (/*@__PURE__*/$parcel$interopDefault($1e011ccdb6271d3d$exports))), 73, 59.29, 10);
        addTite(7, (0, (/*@__PURE__*/$parcel$interopDefault($2ad02d99939a6047$exports))), 84, 60, 9);
        addTite(8, (0, (/*@__PURE__*/$parcel$interopDefault($e73cadddd90b9e2c$exports))), 76, 66.43, 8);
        addTite(9, (0, (/*@__PURE__*/$parcel$interopDefault($16a593d6df5f28c4$exports))), 87, 67.57, 6);
        addTite(10, (0, (/*@__PURE__*/$parcel$interopDefault($a20c2f6dec181995$exports))), 15, 67.57, 8);
        addTite(11, (0, (/*@__PURE__*/$parcel$interopDefault($9fd8f3835050870f$exports))), 2, 68.86, 8);
        return {
            visuals: tites,
            max: tites.length,
            titeRefs: refs
        };
    }, []);
    const cloakman = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$Cloakman, {
            tc: state.tc,
            maxTc: tites.max,
            ps: state.ps
        });
    }, [
        state
    ]);
    const cage = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$Cage, {
            x: 5,
            y: 53.71,
            w: 90,
            ps: state.ps,
            onInLocation: ()=>{
                setState({
                    tc: state.tc,
                    ps: 3
                });
            },
            onPowered: ()=>{
                if (state.ps === 3) setState({
                    tc: state.tc,
                    ps: 4
                });
                else if (state.ps === 1) setState({
                    tc: state.tc,
                    ps: 2
                });
            },
            onUnpowered: ()=>{
                if (state.ps === 4) setState({
                    tc: state.tc,
                    ps: 3
                });
                else if (state.ps === 2) setState({
                    tc: state.tc,
                    ps: 1
                });
            }
        });
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pos-abs no-events",
        style: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$TiteBox, {
                x: 5,
                y: 53.71,
                w: 90,
                h: 4.3,
                ref: titeBoxRef
            }),
            cloakman,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$Debugs, {
                x: 5,
                y: 53.71,
                w: 10,
                h: 2,
                onClicked: ()=>{
                    setState({
                        tc: tites.max,
                        ps: 1
                    });
                }
            }),
            state.ps < 1 ? tites.visuals : null,
            cage,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$Smog, {
                ps: state.ps,
                onDead: ()=>{
                    setState({
                        tc: state.tc,
                        ps: 5
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53a1942f12ce630$var$PageWipe, {
                ps: state.ps,
                onComplete: ()=>{
                    player.unlockCursor((0, $4d33f92596c93eff$export$e78d7fa5414a086a).key);
                    cursor.setState((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).KY1);
                }
            })
        ]
    });
}
// interface TiteRef 
// {
//     i : number;
//     ref : RefObject<HTMLDivElement>;
// }
function $a53a1942f12ce630$var$Debugs(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs yes-events",
        style: {
            left: props.x.toString() + "%",
            top: props.y.toString() + "%",
            width: props.w.toString() + "%",
            height: props.h.toString() + "%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            onClick: props.onClicked,
            children: "Debug"
        })
    });
}
function $a53a1942f12ce630$var$Tite(props) {
    const mite = props.mite !== undefined ? props.mite : false;
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(HTMLDivElement.prototype);
    const posRef = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const [check, setCheck] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!props.refList.includes(ref)) props.refList.push(ref);
        return ()=>{
            props.refList.splice(props.refList.indexOf(ref), 1);
        };
    });
    const comp = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46f67e62c93b3a2b$export$56141a31cdccd984), {
            className: "pos-abs yes-events",
            style: {
                top: props.y.toString() + "%",
                left: props.x.toString() + "%",
                width: props.w.toString() + "%"
            },
            pre: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: id,
                className: "pos-abs",
                style: {
                    top: 0,
                    left: 0,
                    width: "100%"
                },
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                        src: props.src,
                        className: "bug-off"
                    }),
                    mite ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d121e2eefca3a779$exports))),
                        className: "pos-abs",
                        style: {
                            top: "85%",
                            left: "-5%",
                            width: "110%"
                        }
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d121e2eefca3a779$exports))),
                        className: "pos-abs",
                        style: {
                            top: "-5%",
                            left: "-5%",
                            width: "110%"
                        }
                    })
                ]
            }),
            post: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
                className: "pos-abs width-100p",
                onEnable: ()=>{
                    setCheck(check + 1);
                },
                onDisable: ()=>{
                    setCheck(check + 1);
                },
                onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "pos-abs width-100p",
                    style: {
                        top: posRef.current.y,
                        left: posRef.current.x
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                        id: id,
                        src: props.src,
                        className: "pos-abs width-100p electric-pulse-3s"
                    })
                }),
                offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f847b33720aceef$export$da18f7b9a566a9ea), {
                    id: id,
                    x: posRef.current.x,
                    y: posRef.current.y,
                    w: "100%",
                    posRef: posRef,
                    dragRef: ref,
                    onDragEnded: (r)=>{
                        if (props.onDragEnded !== undefined) props.onDragEnded();
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                        id: id,
                        src: props.src,
                        className: "bug-off"
                    })
                })
            })
        });
    }, [
        check
    ]);
    return comp;
}
function $a53a1942f12ce630$var$TiteBox(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs opacity-0 no-events",
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: props.h + "%"
        },
        ref: props.ref
    });
}
function $a53a1942f12ce630$var$Cloakman(props) {
    const [check, setCheck] = (0, $acw62.useState)(0);
    const speech = (0, $acw62.useRef)(0);
    (0, $acw62.useMemo)(()=>{
        setCheck(check + 1);
    }, [
        props.ps,
        props.tc
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44ddd8d7d9176fe8$export$b84446f5899e929b), {
        check: check,
        states: [
            {
                index: 1,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($00c3a13b5badf44d$exports))),
                    x: 82,
                    y: 54.57,
                    w: 15,
                    flipH: true,
                    className: "yes-events z-9",
                    onEnded: ()=>{
                        speech.current = 1;
                        setCheck(check + 1);
                    },
                    texts: [
                        "Bring me the stones.",
                        "With all 10 sacred hanging stones, I can form a cage.",
                        "He can't be killed...",
                        "But just maybe he can be contained..."
                    ],
                    position: (0, $5dd43b988ac46ac6$export$3b4c0c60a3286f97).Left
                }),
                check: ()=>{
                    return false;
                }
            },
            {
                index: 2,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($00c3a13b5badf44d$exports))),
                    x: 82,
                    y: 54.57,
                    w: 15,
                    flipH: true,
                    className: "yes-events",
                    texts: [
                        "You have brought me " + props.tc + " stones.",
                        "I need " + (props.maxTc - props.tc) + " more."
                    ],
                    position: (0, $5dd43b988ac46ac6$export$3b4c0c60a3286f97).Left
                }),
                check: ()=>{
                    return speech.current == 1;
                }
            },
            {
                index: 3,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($00c3a13b5badf44d$exports))),
                    x: 82,
                    y: 54.57,
                    w: 15,
                    flipH: true,
                    className: "yes-events",
                    texts: [
                        "The cage is formed!",
                        "Take it and contain him!"
                    ],
                    position: (0, $5dd43b988ac46ac6$export$3b4c0c60a3286f97).Left
                }),
                check: ()=>{
                    return props.ps == 1;
                },
                canSkipTo: true
            }
        ]
    });
}
function $a53a1942f12ce630$var$Cage(props) {
    const id = (0, $acw62.useId)();
    const posRef = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const [check, setCheck] = (0, $acw62.useState)(0);
    const comp = (0, $acw62.useMemo)(()=>{
        if (props.ps === 4) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "pos-abs no-events",
            style: {
                left: props.x + "%",
                top: props.y + "%",
                width: props.w + "%",
                height: 656
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pos-abs width-100p",
                style: {
                    top: posRef.current.y,
                    left: posRef.current.x
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f36694cd12b88b3c$exports))),
                        className: "pos-abs yes-events z-5 electric-pulse-3s"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3f495a0530e06e34$exports))),
                        className: "pos-abs yes-events z-7 electric-pulse-3s"
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "pos-abs no-events",
            style: {
                left: props.x + "%",
                top: props.y + "%",
                width: props.w + "%",
                height: 656
            },
            children: props.ps >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
                className: "pos-abs width-100p height-512",
                startOn: props.ps === 5 || props.ps === 4 || props.ps === 2,
                onEnable: ()=>{
                    props.onPowered();
                    setCheck(check + 1);
                },
                onDisable: ()=>{
                    props.onUnpowered();
                    setCheck(check + 1);
                },
                onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "pos-abs width-100p",
                    style: {
                        top: posRef.current.y,
                        left: posRef.current.x
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f36694cd12b88b3c$exports))),
                            className: "pos-abs yes-events z-5 electric-pulse-3s"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3f495a0530e06e34$exports))),
                            className: "pos-abs yes-events z-7 electric-pulse-3s"
                        })
                    ]
                }),
                offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f847b33720aceef$export$da18f7b9a566a9ea), {
                    id: id,
                    x: posRef.current.x,
                    y: posRef.current.y,
                    w: "100%",
                    h: "656px",
                    targetId: $a53a1942f12ce630$var$SMOG_ID,
                    onTarget: ()=>{
                        props.onInLocation();
                        setCheck(check + 1);
                    },
                    targetBehaviour: (0, $8f847b33720aceef$export$6d1afdc636af48e2).Stick,
                    posRef: posRef,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f36694cd12b88b3c$exports))),
                            className: "pos-abs yes-events z-5 bug-off"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3f495a0530e06e34$exports))),
                            className: "pos-abs yes-events z-7 bug-off"
                        })
                    ]
                })
            }) : null
        });
    }, [
        props.ps,
        check
    ]);
    return comp;
}
function $a53a1942f12ce630$var$Smog(props) {
    const [check, setCheck] = (0, $acw62.useState)(0);
    let timer = 0;
    let animationFrame = 0;
    (0, $acw62.useMemo)(()=>{
        setCheck(check + 1);
    }, [
        props.ps
    ]);
    const loop = ()=>{
        timer++;
        if (timer > 1200 && props.ps === 4) props.onDead();
        animationFrame = requestAnimationFrame(loop);
    };
    (0, $acw62.useEffect)(()=>{
        animationFrame = requestAnimationFrame(loop);
        return ()=>{
            cancelAnimationFrame(animationFrame);
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44ddd8d7d9176fe8$export$b84446f5899e929b), {
        id: "Smog",
        check: check,
        states: [
            {
                index: 1,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f), {
                    id: $a53a1942f12ce630$var$SMOG_ID,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($df4b6e7b11883ead$exports))),
                    x: 10,
                    y: 95.71,
                    w: 80,
                    bubbleClass: "smog-bubble rumble-1s",
                    className: "z-6 yes-events",
                    autotalk: true,
                    bubbleWidth: 512,
                    texts: [
                        "WAUUH HA HA HA",
                        "I CANNOT BE DEFEATED",
                        "CORRUPTION IS INEVITABLE",
                        "HIS BUNS ARE DEVITALIZED!!",
                        "ALL YOUR BUNS WILL BE!!"
                    ],
                    position: (0, $5dd43b988ac46ac6$export$3b4c0c60a3286f97).Above
                }),
                check: ()=>{
                    return props.ps <= 2;
                }
            },
            {
                index: 2,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f), {
                    id: $a53a1942f12ce630$var$SMOG_ID,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($df4b6e7b11883ead$exports))),
                    x: 10,
                    y: 95.71,
                    w: 80,
                    bubbleClass: "smog-bubble rumble-1s",
                    className: "z-6 yes-events",
                    autotalk: true,
                    bubbleWidth: 512,
                    texts: [
                        "YOU THINK THAT WILL CONTAIN ME?",
                        "FOOL! YOU ABSOLUTE IMBECILE!!",
                        "ME, CONTAINED BY SIMPLE ROCKS?? NONSENSE!!",
                        "I WILL DECIMATE YOU, BUFFOON!!",
                        "CORRUPTION IS INEVITABLE!"
                    ],
                    position: (0, $5dd43b988ac46ac6$export$3b4c0c60a3286f97).Above
                }),
                check: ()=>{
                    return props.ps === 3;
                }
            },
            {
                index: 3,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f), {
                    id: $a53a1942f12ce630$var$SMOG_ID,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($df4b6e7b11883ead$exports))),
                    x: 10,
                    y: 95.71,
                    w: 80,
                    bubbleClass: "smog-bubble rumble-1s",
                    className: "z-6 yes-events rumble-1s",
                    autotalk: true,
                    bubbleWidth: 512,
                    texts: [
                        "WHAT IS THIS???",
                        "WAIT... NO!",
                        "THESE ARE... THE STONES!",
                        "NOOOOOOOO",
                        "I AM CONTAINED"
                    ],
                    position: (0, $5dd43b988ac46ac6$export$3b4c0c60a3286f97).Above
                }),
                check: ()=>{
                    return props.ps === 4;
                }
            },
            {
                index: 4,
                node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "pos-abs z-6",
                    style: {
                        left: "10%",
                        top: "95.71%",
                        width: "80%"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($df4b6e7b11883ead$exports))),
                        className: "pos-abs filter-grayscale"
                    })
                }),
                check: ()=>{
                    return props.ps === 5;
                }
            }
        ]
    });
}
function $a53a1942f12ce630$var$PageWipe(props) {
    let animationFrame = 0;
    let timer = (0, $acw62.useRef)(0);
    let complete = (0, $acw62.useRef)(false);
    const loop = ()=>{
        timer.current++;
        if (timer.current > 1000 && !complete.current) {
            props.onComplete();
            complete.current = true;
        }
        animationFrame = requestAnimationFrame(loop);
    };
    (0, $acw62.useEffect)(()=>{
        animationFrame = requestAnimationFrame(loop);
        return ()=>{
            cancelAnimationFrame(animationFrame);
        };
    }, [
        props
    ]);
    return props.ps === 5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs bg-white fade-in-10s yes-events z-11",
        style: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        }
    }) : null;
}



var $7d0f82c2af31d0c2$exports = {};
$7d0f82c2af31d0c2$exports = import.meta.resolve("d5yQ2");


var $4d90119641d26b47$exports = {};
$4d90119641d26b47$exports = import.meta.resolve("53Z3F");


var $483f9fea179564dd$exports = {};
$483f9fea179564dd$exports = import.meta.resolve("a1GdQ");


var $149340391fab0e60$exports = {};
$149340391fab0e60$exports = import.meta.resolve("9pR71");


var $772928d6bd6b7ea7$exports = {};
$772928d6bd6b7ea7$exports = import.meta.resolve("4X0tG");


var $d4dbf41b04912fa2$exports = {};
$d4dbf41b04912fa2$exports = import.meta.resolve("1ueuW");


var $f3760bac5937efb4$exports = {};
$f3760bac5937efb4$exports = import.meta.resolve("gck4W");


var $777ce575d6ff6f3c$exports = {};
$777ce575d6ff6f3c$exports = import.meta.resolve("ga9t0");


var $81d0ba1903830fae$exports = {};
$81d0ba1903830fae$exports = import.meta.resolve("bHpd2");


var $6049db14a91e0589$exports = {};
$6049db14a91e0589$exports = import.meta.resolve("e9vjR");


var $e906d44385d7790a$exports = {};
$e906d44385d7790a$exports = import.meta.resolve("gpljw");


var $81688dd422640133$exports = {};
$81688dd422640133$exports = import.meta.resolve("8VKDT");


var $3ffa4f4b31482d33$exports = {};
$3ffa4f4b31482d33$exports = import.meta.resolve("lERje");


var $003c02b32adf5930$exports = {};
$003c02b32adf5930$exports = import.meta.resolve("3snbQ");


var $3ea6f2d22eaaef1e$exports = {};
$3ea6f2d22eaaef1e$exports = import.meta.resolve("3Qpxx");


var $dd2e8155e0d6f4cd$exports = {};
$dd2e8155e0d6f4cd$exports = import.meta.resolve("cHQwL");


var $23b99dcb50e7b849$exports = {};
$23b99dcb50e7b849$exports = import.meta.resolve("hxmB2");


var $b240905b8eb32e3a$exports = {};
$b240905b8eb32e3a$exports = import.meta.resolve("7qtAf");


var $5f3a99e8d36ef87a$exports = {};
$5f3a99e8d36ef87a$exports = import.meta.resolve("9xHVP");


var $90e604d4535b66c1$exports = {};
$90e604d4535b66c1$exports = import.meta.resolve("lsXL3");


var $2f0a88b993b6ae55$exports = {};
$2f0a88b993b6ae55$exports = import.meta.resolve("9P7cg");


var $dd9275a092ff21d8$exports = {};
$dd9275a092ff21d8$exports = import.meta.resolve("b0BiF");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $b129cf429da813cf$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    bongoStay: false,
    gameOn: false,
    diningIn: false,
    darkMode: false,
    enterGame: ()=>{},
    exitGame: (h)=>{},
    enterShop: ()=>{},
    exitShop: ()=>{}
});
const $b129cf429da813cf$var$TACOProvider = (props)=>{
    const bongoStay = (0, $acw62.useRef)(false);
    const gameOn = (0, $acw62.useRef)(false);
    const diningIn = (0, $acw62.useRef)(false);
    const [darkMode, setDarkMode] = (0, $acw62.useState)(false);
    const enterGame = ()=>{
        gameOn.current = true;
        bongoStay.current = false;
        diningIn.current = false;
        setDarkMode(true);
    };
    const exitGame = (h)=>{
        gameOn.current = false;
        if (h) bongoStay.current = true;
        setDarkMode(false);
    };
    const enterShop = ()=>{
        diningIn.current = true;
        gameOn.current = false;
        setDarkMode(true);
    };
    const exitShop = ()=>{
        diningIn.current = false;
        setDarkMode(false);
    };
    const value = (0, $acw62.useMemo)(()=>{
        return {
            bongoStay: bongoStay.current,
            gameOn: gameOn.current,
            diningIn: diningIn.current,
            darkMode: darkMode,
            enterGame: enterGame,
            exitGame: exitGame,
            enterShop: enterShop,
            exitShop: exitShop
        };
    }, [
        darkMode
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b129cf429da813cf$var$context.Provider, {
        value: value,
        children: props.children
    });
};
$b129cf429da813cf$var$TACOProvider.context = $b129cf429da813cf$var$context;
var $b129cf429da813cf$export$2e2bcd8739ae039 = $b129cf429da813cf$var$TACOProvider;


function $15923fa4c3209c93$export$c54ca98fe1237602() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($15923fa4c3209c93$export$e8f549601299870c, {
        onClick: ()=>{}
    });
}
class $15923fa4c3209c93$var$DRESSUP_OPTION {
    id = 0;
    src = "";
    on = false;
    height = 100;
    x = 0;
    y = 0;
    constructor(id, src, height, x, y){
        this.id = id;
        this.src = src;
        this.height = height;
        this.x = x;
        this.y = y;
    }
    load(data) {
        this.on = data.includes(this.id);
    }
    icon(onClick) {
        const outline = this.on ? "#f04979" : "#dba9ff";
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "width-64 height-64 v-box center-all",
            style: {
                border: '4px solid ' + outline,
                borderRadius: '4px',
                background: '#e4beff'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: this.src,
                className: "width-100p height-100p cursor-pointer",
                style: {
                    objectFit: 'contain'
                },
                onClick: ()=>{
                    this.on = !this.on;
                    onClick();
                }
            })
        }, this.id);
    }
    render() {
        if (!this.on) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: this.src,
            className: "pos-abs",
            style: {
                height: this.height + "%",
                left: this.x + "%",
                top: this.y + "%"
            }
        }, this.id);
    }
}
class $15923fa4c3209c93$var$DRESSUP_CONFIG {
    options = [];
}
const $15923fa4c3209c93$var$TIE_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(1, (0, (/*@__PURE__*/$parcel$interopDefault($777ce575d6ff6f3c$exports))), 47.64, 11.6, 33);
const $15923fa4c3209c93$var$BOWTIE_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(2, (0, (/*@__PURE__*/$parcel$interopDefault($772928d6bd6b7ea7$exports))), 14.88, 11.6, 35);
const $15923fa4c3209c93$var$BLACK_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(3, (0, (/*@__PURE__*/$parcel$interopDefault($6049db14a91e0589$exports))), 21.14, 14.6, 6.5);
const $15923fa4c3209c93$var$BLUSH_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(4, (0, (/*@__PURE__*/$parcel$interopDefault($e906d44385d7790a$exports))), 12, 12, 16.5);
const $15923fa4c3209c93$var$MOONS_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(5, (0, (/*@__PURE__*/$parcel$interopDefault($81688dd422640133$exports))), 13.09, 16.4, 8.5);
const $15923fa4c3209c93$var$TRIANGLES_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(6, (0, (/*@__PURE__*/$parcel$interopDefault($2f0a88b993b6ae55$exports))), 25.42, 14.4, 4.5);
const $15923fa4c3209c93$var$TEARS_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(7, (0, (/*@__PURE__*/$parcel$interopDefault($90e604d4535b66c1$exports))), 18.33, 14.4, 14.5);
const $15923fa4c3209c93$var$OUTLINE_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(8, (0, (/*@__PURE__*/$parcel$interopDefault($003c02b32adf5930$exports))), 12.9, 14.4, 22);
const $15923fa4c3209c93$var$LIPS_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(9, (0, (/*@__PURE__*/$parcel$interopDefault($3ffa4f4b31482d33$exports))), 13.22, 14, 22.5);
const $15923fa4c3209c93$var$SPOT1_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(10, (0, (/*@__PURE__*/$parcel$interopDefault($3ea6f2d22eaaef1e$exports))), 13.92, 53, 30);
const $15923fa4c3209c93$var$SPOT2_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(11, (0, (/*@__PURE__*/$parcel$interopDefault($dd2e8155e0d6f4cd$exports))), 4.09, 52.5, 70);
const $15923fa4c3209c93$var$SPOT3_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(12, (0, (/*@__PURE__*/$parcel$interopDefault($23b99dcb50e7b849$exports))), 17.82, 34, 65);
const $15923fa4c3209c93$var$SPOT4_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(13, (0, (/*@__PURE__*/$parcel$interopDefault($b240905b8eb32e3a$exports))), 19.16, 72, 45);
const $15923fa4c3209c93$var$SPOT5_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(14, (0, (/*@__PURE__*/$parcel$interopDefault($5f3a99e8d36ef87a$exports))), 14.81, 67, 30);
const $15923fa4c3209c93$var$BLUEEARS_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(15, (0, (/*@__PURE__*/$parcel$interopDefault($483f9fea179564dd$exports))), 43.49, 33.8, 7.8);
const $15923fa4c3209c93$var$PINKEARS_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(16, (0, (/*@__PURE__*/$parcel$interopDefault($149340391fab0e60$exports))), 40.68, 2, 0);
const $15923fa4c3209c93$var$NOSE_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(17, (0, (/*@__PURE__*/$parcel$interopDefault($d4dbf41b04912fa2$exports))), 9.58, 21, 13);
const $15923fa4c3209c93$var$SHOESF_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(18, (0, (/*@__PURE__*/$parcel$interopDefault($f3760bac5937efb4$exports))), 28.16, -3, 75);
const $15923fa4c3209c93$var$SHOESB_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(19, (0, (/*@__PURE__*/$parcel$interopDefault($f3760bac5937efb4$exports))), 28.16, 50, 75);
const $15923fa4c3209c93$var$FLOWER_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(20, (0, (/*@__PURE__*/$parcel$interopDefault($81d0ba1903830fae$exports))), 54.66, -1.7, 3.2);
const $15923fa4c3209c93$var$WIG_OPTION = new $15923fa4c3209c93$var$DRESSUP_OPTION(21, (0, (/*@__PURE__*/$parcel$interopDefault($dd9275a092ff21d8$exports))), 39.78, 6.5, -21);
const $15923fa4c3209c93$var$config = {
    options: [
        $15923fa4c3209c93$var$TIE_OPTION,
        $15923fa4c3209c93$var$BOWTIE_OPTION,
        $15923fa4c3209c93$var$BLACK_OPTION,
        $15923fa4c3209c93$var$BLUSH_OPTION,
        $15923fa4c3209c93$var$MOONS_OPTION,
        $15923fa4c3209c93$var$TRIANGLES_OPTION,
        $15923fa4c3209c93$var$TEARS_OPTION,
        $15923fa4c3209c93$var$OUTLINE_OPTION,
        $15923fa4c3209c93$var$LIPS_OPTION,
        $15923fa4c3209c93$var$SPOT1_OPTION,
        $15923fa4c3209c93$var$SPOT2_OPTION,
        $15923fa4c3209c93$var$SPOT3_OPTION,
        $15923fa4c3209c93$var$SPOT4_OPTION,
        $15923fa4c3209c93$var$SPOT5_OPTION,
        $15923fa4c3209c93$var$BLUEEARS_OPTION,
        $15923fa4c3209c93$var$PINKEARS_OPTION,
        $15923fa4c3209c93$var$NOSE_OPTION,
        $15923fa4c3209c93$var$SHOESF_OPTION,
        $15923fa4c3209c93$var$SHOESB_OPTION,
        $15923fa4c3209c93$var$FLOWER_OPTION,
        $15923fa4c3209c93$var$WIG_OPTION
    ]
};
function $15923fa4c3209c93$export$e8f549601299870c(props) {
    const [clicks, setClicks] = (0, $acw62.useState)(0);
    const state = localStorage.getItem('BDUDATA');
    const data = (0, $acw62.useRef)(state == null ? [] : JSON.parse(state));
    const loaded = (0, $acw62.useRef)(false);
    if (!loaded.current) {
        $15923fa4c3209c93$var$config.options.forEach((o)=>{
            o.load(data.current);
        });
        loaded.current = true;
    }
    (0, $acw62.useEffect)(()=>{
        let d = [];
        $15923fa4c3209c93$var$config.options.forEach((o)=>{
            if (o.on) d.push(o.id);
        });
        localStorage.setItem('BDUDATA', JSON.stringify(d));
        data.current = d;
    }, [
        clicks
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box padding-32 pos-rel yes-events",
        style: {
            width: 1024,
            height: 512
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($15923fa4c3209c93$var$DRESSUPBG, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-box gap-64 align-end",
                style: {
                    height: 480
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box justify-start height-100p",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($15923fa4c3209c93$export$c4a88969917444a9, {
                                title: "Bongo Dressup!"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "h-box",
                                style: {
                                    padding: '0 16px'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-taco-black font-taco-secondary z-3",
                                    children: "Our beloved friend Bongo needs help getting dressed for the big show at Taco Bongo! What should Bongo wear??"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($15923fa4c3209c93$var$DRESSUPSELECTOR, {
                                onClick: ()=>{
                                    setClicks(clicks + 1);
                                    props.onClick();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box pos-rel",
                        style: {
                            height: 384
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7d0f82c2af31d0c2$exports))),
                                className: "pos-abs",
                                style: {
                                    left: -64,
                                    top: -128,
                                    width: 512
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($15923fa4c3209c93$export$2049f84fee98b4ab, {})
                        ]
                    })
                ]
            })
        ]
    });
}
function $15923fa4c3209c93$var$DRESSUPBG() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $887b4dfdb08ec5f4$export$7cfed81e33fc1826), {
        cursor: (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).HAM,
        onClick: ()=>{
            tacoProvider.exitGame(true);
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "pos-abs taco-box",
            style: {
                top: -32,
                left: -32,
                right: -32,
                bottom: -32
            }
        })
    });
}
function $15923fa4c3209c93$export$c4a88969917444a9(props) {
    var array = props.title.split('');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "h-box",
        children: array.map((c, i)=>{
            let color = '';
            const ip = i % 3;
            switch(ip){
                case 0:
                    color = 'text-taco-teal';
                    break;
                case 1:
                    color = 'text-taco-pink';
                    break;
                case 2:
                    color = 'text-taco-purp';
                    break;
            }
            const className = color + " font-taco-primary text-48 floaty-1s";
            const style = {
                animationDelay: -i * 0.1 + "s"
            };
            if (c === ' ') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: className,
                style: style,
                children: "\xa0"
            }, i);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: className,
                style: style,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                    children: c
                })
            }, i);
        })
    });
}
function $15923fa4c3209c93$var$DRESSUPSELECTOR(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "grid gap-16 z-1",
        style: {
            gridTemplateColumns: "64px 64px 64px 64px 64px 64px 64px"
        },
        children: $15923fa4c3209c93$var$config.options.map((o)=>o.icon(props.onClick))
    });
}
function $15923fa4c3209c93$export$2049f84fee98b4ab() {
    const options = $15923fa4c3209c93$var$config.options.map((o)=>o.render());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pos-rel height-100p ",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4d90119641d26b47$exports))),
                className: "height-100p"
            }),
            options
        ]
    });
}
function $15923fa4c3209c93$export$e1adaf956eb84a5f(props) {
    const state = localStorage.getItem('BDUDATA');
    const data = (0, $acw62.useRef)(state == null ? [] : JSON.parse(state));
    $15923fa4c3209c93$var$config.options.forEach((o)=>{
        o.load(data.current);
    });
    const ratio = 412.0 / 384.0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "v-box pos-rel",
        style: {
            width: props.height * ratio,
            height: props.height
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($15923fa4c3209c93$export$2049f84fee98b4ab, {})
    });
}


const $5dd43b988ac46ac6$var$CMD_FIN = 'xanmi-fin';
function $5dd43b988ac46ac6$export$44e24a2ce4316f2f() {
    const exec = (0, $acw62.useContext)((0, $7486e87f2dee7e03$export$2e2bcd8739ae039).context);
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "page-basic width-100v bg-black",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "v-box pos-rel width-768 mask-content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1d9ab9617fab9e5e$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9e555dc6e4d7d17d$exports))),
                            x: 80,
                            y: 1,
                            w: 10,
                            texts: [
                                "Smells like trouble..."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$BoringThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f47fb61d2b1b40cc$exports))),
                            x: 2,
                            y: 11,
                            w: 36
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$BoringThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d73b45d90ef973e6$exports))),
                            x: 60,
                            y: 15,
                            w: 9
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4d7061ea4ba12681$exports))),
                            x: 28,
                            y: 15,
                            w: 5,
                            texts: [
                                "Halt! No Bugs allowed!",
                                "Oh, wait... you're not a Bug.",
                                "Proceed at your own pearil.",
                                "Peril, sorry. I meant peril."
                            ],
                            end: 1,
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($91cfdf68f99da089$exports))),
                            x: 2,
                            y: 15,
                            w: 7,
                            texts: [
                                "Have you seen the Lord?",
                                "Tall orange hat?",
                                "Oh, well."
                            ],
                            end: 1,
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$BoringThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($31b27815d11c6a8a$exports))),
                            x: 78,
                            y: 13.5,
                            w: 20
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($610ef439a536ac65$exports))),
                            x: 76,
                            y: 19,
                            w: 8,
                            texts: [
                                "I just hold the flag, buddy.",
                                "Move along.",
                                "Don't get eaten by a bug.",
                                "Or do get eaten by a bug. Whatever.",
                                "I just hold the flag, like I said."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            x: 10,
                            y: 20,
                            w: 10,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b069f11e4bb9030a$exports))),
                            texts: [
                                "This just in...",
                                "You've been isekai'ed!",
                                "Back to you, Janet."
                            ],
                            position: 1,
                            ps: [
                                new $5dd43b988ac46ac6$var$PostScript(2, "I'm off the air now."),
                                new $5dd43b988ac46ac6$var$PostScript(3, "Stop clicking on me."),
                                new $5dd43b988ac46ac6$var$PostScript(4, "Scroll down! Get away from me!"),
                                new $5dd43b988ac46ac6$var$PostScript(5, "This isn't funny!"),
                                new $5dd43b988ac46ac6$var$PostScript(7, "Okay, it's a *little* bit funny."),
                                new $5dd43b988ac46ac6$var$PostScript(8, "But not anymore. Stop it."),
                                new $5dd43b988ac46ac6$var$PostScript(99, "Okay it's funny again lol."),
                                new $5dd43b988ac46ac6$var$PostScript(103, "Am I alive?"),
                                new $5dd43b988ac46ac6$var$PostScript(104, "I'm a soulless webstie element, aren't I?")
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fe35b75061960ce9$exports))),
                            x: 63,
                            y: 23,
                            w: 6,
                            bubbleWidth: 256,
                            texts: [
                                "Oh, noble traveller, over there",
                                "Oh, noble traveller, over there\nWith kindest eyes and flowing hair",
                                "Oh, noble traveller, over there\nWith kindest eyes and flowing hair\nI said to them, these bugs aren't fair",
                                "Oh, noble traveller, over there\nWith kindest eyes and flowing hair\nI said to them, these bugs aren't fair\nDestroyin' homes, its quite a scare",
                                "Oh, noble traveller, over there\nWith kindest eyes and flowing hair\nI said to them, these bugs aren't fair\nDestroyin' homes, its quite a scare\nThe devil bugs, they're everywhere!",
                                "Help defeat the bugs of ten",
                                "Help defeat the bugs of ten\nThen follow Smog unto its den",
                                "Help defeat the bugs of ten\nThen follow Smog unto its den\nCage the beast that threatens thee",
                                "Help defeat the bugs of ten\nThen follow Smog unto its den\nCage the beast that threatens thee\nOr at least that threatens me!!",
                                "A bard is good, I do my best",
                                "A bard is good, I do my best\nI sing the songs of big conquest",
                                "A bard is good, I do my best\nI sing the songs of big conquest\nI do not fight, I flee again",
                                "A bard is good, I do my best\nI sing the songs of big conquest\nI do not fight, I flee again\nRetreat to stories from my pen",
                                "...",
                                "Tis the only song I've got, sorry."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3813cf634f9601bc$exports))),
                            x: 4,
                            y: 30,
                            w: 30,
                            texts: [
                                "...",
                                "Your ame is strange."
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c13f787983a72d0f$exports))),
                            x: 42,
                            y: 45,
                            w: 6,
                            texts: [
                                "Bugs... are merely a state of mind."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2831c8729e936f65$exports))),
                            x: 70,
                            y: 38,
                            w: 14,
                            texts: [
                                "*enthusiastic gurgling*"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d277795d0303afc4$exports))),
                            x: 82,
                            y: 42,
                            w: 14,
                            texts: [
                                "A bug trapped me in this mirror.",
                                "Destroy them, noble traveler."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$BarrelCat, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d12fff46609c0421$exports))),
                            x: 0,
                            y: 58,
                            w: 25,
                            texts: [
                                "Bug strong.. Can eat boy. Easy lunch",
                                "Mm... lunch"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($eb8e3d35f990705e$exports))),
                            x: 64,
                            y: 64,
                            w: 6,
                            texts: [
                                "Uh oh...",
                                "Oh no!",
                                "Ohhh NO!",
                                "I'm gonna get ate!!!"
                            ],
                            end: 1,
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dda747fcd206201b$exports))),
                            bubbleWidth: 64,
                            x: 16,
                            y: 74,
                            w: 6,
                            texts: [
                                "Brrp.."
                            ],
                            end: 1,
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6f4824ad471b7846$exports))),
                            x: 24,
                            y: 73,
                            w: 13,
                            texts: [
                                "*huff huff huff*... He almost died!",
                                "That Bug knocked this baby thing into the river!",
                                "This place sucks!"
                            ],
                            position: 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9475154a3dd56ffb$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($fcfa2d58abc9c128$exports))),
                            x: 54,
                            y: -10,
                            w: 45,
                            texts: [
                                "New hat says to crush you.",
                                "Hats never lie.",
                                "Right and good hat, full of smarts."
                            ],
                            end: 1,
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8e491962bf8b6ea0$exports))),
                            x: 69,
                            y: -12,
                            w: 24,
                            texts: [
                                "TALL",
                                "I AM HAT",
                                "BUG HAT"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dde3d0c834bc3f3b$exports))),
                            x: 10,
                            y: 15,
                            w: 24
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 33,
                            y: 17,
                            w: 5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 46,
                            y: 38,
                            w: 5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 43,
                            y: 39,
                            w: 5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1ded276516dcc3ee$exports))),
                            x: 58,
                            y: 30,
                            w: 40,
                            texts: [
                                "My mouth is a door.",
                                "It hurts",
                                "To be this"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($34d57f8d40013fc4$exports))),
                            x: 64,
                            y: 27,
                            w: 15,
                            texts: [
                                "Stand on house, tall now.",
                                "Big, like Smog"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($16e5988cc56600cd$exports))),
                            x: 5,
                            y: 43,
                            w: 10,
                            texts: [
                                "I thrive in chaos!"
                            ],
                            end: 1,
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7146180bc6e804c7$exports))),
                            x: 90,
                            y: 40,
                            w: 8,
                            texts: [
                                "I hate dads.",
                                "Dads are bads.",
                                "You're not a dad, are you?"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ad744c47dfd7dce$exports))),
                            x: 65,
                            y: 43,
                            w: 18,
                            texts: [
                                "Blurp",
                                "Grubble"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bd44a30931c7b47b$exports))),
                            x: 28,
                            y: 43,
                            w: 33,
                            texts: [
                                "*menacing stance*"
                            ],
                            end: 1,
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a7fef34aba472de8$exports))),
                            x: 90,
                            y: 46,
                            w: 8,
                            texts: [
                                "Me dad...'E got turned into a dog man 'e did.",
                                "That mean magic man did it to 'im",
                                "Now 'e just cries and woofs",
                                "Ran away from home... where's me da..."
                            ],
                            end: 1,
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2953ad4c6c61935a$exports))),
                            x: 70,
                            y: 48,
                            w: 9,
                            texts: [
                                "I'm a real guy outta land hoohoo heehee",
                                "Get it?"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($adb8b53a35ab12a6$exports))),
                            x: 5,
                            y: 54,
                            w: 35,
                            texts: [
                                "WHEEREEEe is my BEAUUTIFFFULL WIIIFEEEE ??",
                                "WE HAVE DINNER PLANS",
                                "SHE'S SO BEAUTIFUL...",
                                "WIFE???"
                            ],
                            end: 1,
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($dfd4a95bd11882c4$exports))),
                            x: 62,
                            y: 56,
                            w: 8,
                            texts: [
                                "Can you please destroy those bugs?",
                                "They're displacing the mirth."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc6224dc9ec22e4e$exports))),
                            x: 85,
                            y: 56,
                            w: 8,
                            texts: [
                                "WEEEEEEEEEE",
                                "WWEEEEEEEEEEE"
                            ],
                            end: 1,
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8315797855732ab0$exports))),
                            x: 45,
                            y: 65,
                            w: 12,
                            texts: [
                                "You should smile more, old man"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ac5bf8e9f55d8aa6$exports))),
                            x: 60,
                            y: 64.5,
                            w: 11,
                            bubbleWidth: 64,
                            texts: [
                                "I'm 26..."
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2831c8729e936f65$exports))),
                            x: 17,
                            y: 72,
                            w: 20,
                            texts: [
                                "I'M GOONA EAT SOMETHING",
                                "NEED TO EAT SOON",
                                "I'M GOONA EAT ONE THESE PEOPLE",
                                "NOT EVEN GONNA CHEW"
                            ],
                            position: 3
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 80,
                            y: 77,
                            w: 5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 83,
                            y: 78,
                            w: 5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 14,
                            y: 83,
                            w: 10,
                            loot: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7f4ef22fb27fc454$exports))),
                                x: 0,
                                y: 0,
                                w: 100,
                                texts: [
                                    "Finally!",
                                    "I've been freed from foul barrel!",
                                    "Oh blessed day of unbarrelled splendor!",
                                    "Fortune upon you, strange hero!",
                                    "You have rescued an artist from darkness!",
                                    "Light shines upon the Rat Poet once again!"
                                ],
                                position: 1,
                                end: 1
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($98f61d7e49c90c31$exports))),
                            x: 35,
                            y: 92,
                            w: 14,
                            texts: [
                                "My husband! He's run away again!"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 30,
                            y: 98,
                            w: 5
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($61229423646a8f9b$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                            x: 80,
                            y: 7,
                            w: 8,
                            loot: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15923fa4c3209c93$export$e1adaf956eb84a5f), {
                                height: 96
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$BoringThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1856931f8e919555$exports))),
                            x: 2,
                            y: -2.5,
                            w: 30
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8afcff2e341b559c$exports))),
                            x: 28,
                            y: 20,
                            w: 13,
                            texts: [
                                "I use my ame! My lifeforce! To make beatiful art!!"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b389b4c8c6b0416a$exports))),
                            x: 20,
                            y: 22.5,
                            w: 7,
                            texts: [
                                "My life is my art."
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($95740018b89f3820$exports))),
                            x: 45,
                            y: 25,
                            w: 25,
                            texts: [
                                "Da great smog fuels me. Yumma yumma",
                                "I said YUMMA YUMMA"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$BoringThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9ec191192d8714ff$exports))),
                            x: 40,
                            y: 55,
                            w: 35
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$PoweredThing, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6d945320afdaa895$exports))),
                            x: 67,
                            y: 68,
                            w: 14,
                            texts: [
                                "AWAKE!",
                                "STONE...",
                                "YES, STONE!!",
                                "THE ANSWER LIES IN STONE!!"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($12fc5e4e4b67f69e$exports))),
                            x: 15,
                            y: 72,
                            w: 18,
                            texts: [
                                "Be careful of the beasts ahead! It's not safe here!"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f543212be2809cba$exports))),
                            x: 70,
                            y: 85,
                            w: 23,
                            texts: [
                                "*burp* Do you come to the Valley of NAN often?"
                            ],
                            position: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5c9fc9e21e8cb5a9$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($6549bf5b85930abe$exports))),
                            x: -25,
                            y: -6,
                            w: 65,
                            texts: [
                                "Wut are u? Bug like me?"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9fb5cd60bdb812d7$exports))),
                            x: 56,
                            y: 39,
                            w: 20,
                            texts: [
                                "Boo hoo bark woof boo hoo hoo",
                                "Woof woof boo hoo"
                            ],
                            end: 1,
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4b03bdb1e76193c8$exports))),
                            x: 78,
                            y: 50,
                            w: 8,
                            texts: [
                                "This neighborhood's really gone to the dogs."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4395d72620d3a9db$exports))),
                            x: 33,
                            y: 59,
                            w: 12,
                            texts: [
                                "Be still foul beast!! The surface is not for you!"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($76bb0fdd661287a3$exports))),
                            x: 8,
                            y: 62,
                            w: 25,
                            texts: [
                                "Wommmp woooahhmmpp!!"
                            ],
                            position: 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b735b16da605d496$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3c863da6d7b50a1c$exports))),
                            x: 82,
                            y: 2,
                            w: 15,
                            texts: [
                                "No bugs getting past me, no way",
                                "Oh, bugs did get past me?",
                                "Oops"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($cc017c65c184ec01$exports))),
                            x: 2,
                            y: 40,
                            w: 20,
                            texts: [
                                "Do you have apple?",
                                "Yes, apple, please?"
                            ],
                            position: 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($63c2c1aa79089a12$exports))),
                            x: 49,
                            y: 45,
                            w: 49,
                            texts: [
                                "The smog lies below.",
                                "I cannot contain him."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bb64cdebfbe11250$exports))),
                            x: 8,
                            y: 68,
                            w: 8,
                            texts: [
                                "It's quiet down here...",
                                "Please don't tell me husband where you found me."
                            ],
                            position: 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8de6404f5a08b343$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($934f38345ab423d6$exports))),
                            x: 50,
                            y: -2,
                            w: 24,
                            texts: [
                                "Wish i had apple..."
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5c1b8b52ca8b31bb$exports))),
                            x: 12,
                            y: 20,
                            w: 7,
                            rotation: 200,
                            texts: [
                                "Glad I brought my apple!"
                            ],
                            position: 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "v-box pos-rel width-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a7b5a6493b7cb09b$exports))),
                            className: "width-100p"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$Bug, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($bcf9af4212e726f3$exports))),
                            x: 57,
                            y: 35,
                            w: 25,
                            texts: [
                                "ZEEP ZOOPIN UR BUNZ!!"
                            ],
                            position: 0
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($435d661c9a395efd$exports))),
                            x: 38,
                            y: 42,
                            w: 18,
                            texts: [
                                "YEOUCH! MY BUNS!!",
                                "OWW OW OWWW OW",
                                "MY BUNS!!"
                            ],
                            end: 1,
                            position: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a53a1942f12ce630$export$6bffe77b8eee705f), {})
            ]
        })
    });
}
var $5dd43b988ac46ac6$export$3b4c0c60a3286f97 = /*#__PURE__*/ function(DialoguePosition) {
    DialoguePosition[DialoguePosition["Left"] = 0] = "Left";
    DialoguePosition[DialoguePosition["Right"] = 1] = "Right";
    DialoguePosition[DialoguePosition["Above"] = 2] = "Above";
    DialoguePosition[DialoguePosition["Below"] = 3] = "Below";
    return DialoguePosition;
}({});
var $5dd43b988ac46ac6$export$a073ef473143f1f8 = /*#__PURE__*/ function(EndBehavior) {
    EndBehavior[EndBehavior["End"] = 0] = "End";
    EndBehavior[EndBehavior["Loop"] = 1] = "Loop";
    return EndBehavior;
}({});
class $5dd43b988ac46ac6$var$PostScript {
    i = 0;
    text = "";
    constructor(i, text){
        this.i = i;
        this.text = text;
    }
}
function $5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f(props) {
    const [dialogue, setDialogue] = (0, $acw62.useState)("");
    let clicks = 0;
    const anim = (0, $acw62.useRef)('');
    const endBehaviour = props.end !== undefined ? props.end : 1;
    const id = props.id !== undefined ? props.id : (0, $acw62.useId)();
    let animationFrame;
    const autotalk = props.autotalk !== undefined ? props.autotalk : false;
    const autotalkLineTime = props.autotalkLineTime !== undefined ? props.autotalkLineTime : 2;
    let lastTalkTime = 0;
    const resetTalkTime = ()=>{
        lastTalkTime = Date.now() / 1000.0;
    };
    resetTalkTime();
    const onClick = ()=>{
        advanceTalkState();
    };
    const autoUpdate = ()=>{
        const currentTimeInSeconds = Date.now() / 1000.0;
        if (currentTimeInSeconds - lastTalkTime > autotalkLineTime) advanceTalkState();
    };
    const advanceTalkState = ()=>{
        resetTalkTime();
        clicks++;
        const index = Math.floor(clicks / 2);
        const count = props.texts.length;
        if (clicks % 2 == 0) {
            setDialogue("");
            anim.current = "";
            if (index == count && props.onEnded !== undefined) props.onEnded();
            return;
        }
        anim.current = "wiggle-1s";
        if (index < count) {
            setDialogue(props.texts[index]);
            return;
        }
        const overflow = index - count;
        if (props.ps !== undefined) {
            for(let i = 0; i < props.ps.length; i++)if (props.ps[i].i == overflow) {
                setDialogue(props.ps[i].text);
                return;
            }
        }
        if (endBehaviour == 1) {
            setDialogue(props.texts[index % count]);
            return;
        }
        setDialogue("...");
    };
    const init = ()=>{
        if (autotalk) loop();
    };
    const deinit = ()=>{
        if (autotalk) cancelAnimationFrame(animationFrame);
    };
    const loop = ()=>{
        autoUpdate();
        animationFrame = requestAnimationFrame(loop);
    };
    (0, $acw62.useEffect)(()=>{
        init();
        return ()=>{
            deinit();
        };
    }, [
        props
    ]);
    const width = props.bubbleWidth !== undefined ? props.bubbleWidth : 192;
    const halfWidth = width / 2.0;
    let style;
    switch(props.position){
        case 0:
            style = {
                top: "20%",
                left: "calc(-" + (width + 16) + "px - 10%)",
                width: width
            };
            break;
        case 1:
            style = {
                top: "20%",
                right: "calc(-" + (width + 16) + "px - 10%)",
                width: width
            };
            break;
        case 2:
            style = {
                top: "-30%",
                left: "calc(50% - " + halfWidth + "px)",
                width: width
            };
            break;
        case 3:
            style = {
                bottom: "-20%",
                left: "calc(50% - " + halfWidth + "px)",
                width: width
            };
            break;
    }
    const flipH = props.flipH !== undefined ? -1 : 1;
    const rotation = props.rotation !== undefined ? props.rotation : 0;
    const img = props.src !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        className: "width-100p",
        style: {
            transform: "rotateZ(" + rotation + "deg) scaleX(" + flipH + ")"
        }
    }) : props.children;
    const className = props.className !== undefined ? props.className : '';
    const bubbleClass = props.bubbleClass !== undefined ? props.bubbleClass : "bg-white-off border-black padding-8 border-radius-4";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $887b4dfdb08ec5f4$export$7cfed81e33fc1826), {
        id: id,
        cursor: (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).STD,
        onClick: onClick,
        className: "pos-abs " + className,
        style: {
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: anim.current,
                children: img
            }),
            dialogue == "" ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs z-10 " + bubbleClass,
                style: style,
                children: dialogue.split('\n').map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: d
                    }, "d" + i))
            })
        ]
    });
}
function $5dd43b988ac46ac6$var$PoweredThing(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
            src: props.src,
            x: 0,
            y: 0,
            w: 100,
            className: "pulse-3s",
            texts: props.texts,
            position: props.position,
            end: 1
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
            src: props.src,
            className: "bug-off"
        }),
        className: "pos-abs",
        style: {
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        },
        startOn: false
    });
}
function $5dd43b988ac46ac6$var$SmashableThing(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
        className: "pos-abs",
        style: {
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        },
        loot: props.loot,
        stateRef: props.stateRef,
        onSmash: props.onSmash,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
            src: props.src
        })
    });
}
function $5dd43b988ac46ac6$var$BoringThing(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs",
        style: {
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
            src: props.src
        })
    });
}
function $5dd43b988ac46ac6$var$Bug(props) {
    const delay = Math.random();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        className: "pos-abs",
        style: {
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        },
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
            x: 0,
            y: 0,
            w: 100,
            texts: props.texts,
            position: props.position,
            bubbleClass: "bug-bubble bug-on",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
                src: props.src,
                className: "bug-on"
            })
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d81fec9edbde1fc$export$6aa12a20afa4a6b9), {
            src: props.src,
            className: "bug-off"
        }),
        startOn: true
    });
}
function $5dd43b988ac46ac6$var$BarrelCat() {
    const [check, setCheck] = (0, $acw62.useState)(0);
    const barrelRef = (0, $acw62.useRef)(false);
    const checkAgain = ()=>{
        setCheck(check + 1);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pos-abs",
        style: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44ddd8d7d9176fe8$export$b84446f5899e929b), {
                check: check,
                states: [
                    {
                        index: 1,
                        node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d4e8eed33f81bd08$exports))),
                            x: 82,
                            y: 54,
                            w: 8,
                            texts: [
                                "Meow!",
                                "Myew...",
                                "Mrrraw!",
                                "MEOW"
                            ],
                            end: 1,
                            position: 0
                        }),
                        check: ()=>{
                            return !barrelRef.current;
                        },
                        canReturnTo: true
                    },
                    {
                        index: 2,
                        node: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$export$6a55a4bfa8f6bc6f, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d4e8eed33f81bd08$exports))),
                            x: 84,
                            y: 54,
                            w: 8,
                            texts: [
                                "Oh thank god.",
                                "That was an evil barrel."
                            ],
                            end: 1,
                            position: 0
                        }),
                        check: ()=>{
                            return barrelRef.current;
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5dd43b988ac46ac6$var$SmashableThing, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3ccca7c2d24a7521$exports))),
                x: 46,
                y: 58,
                w: 5,
                stateRef: barrelRef,
                onSmash: checkAgain
            })
        ]
    });
}




var $c4fa2a4eed097977$exports = {};
$c4fa2a4eed097977$exports = import.meta.resolve("6wXqk");


var $adab277a26ff9ede$exports = {};
$adab277a26ff9ede$exports = import.meta.resolve("88YpM");


var $9d81fef9bb218f9c$exports = {};
$9d81fef9bb218f9c$exports = import.meta.resolve("9JVVu");


var $a825555ee6c1f9be$exports = {};
$a825555ee6c1f9be$exports = import.meta.resolve("2LhRp");


var $ad44f431c98fe204$exports = {};
$ad44f431c98fe204$exports = import.meta.resolve("cEEmY");


var $25ac7e2601d1007e$exports = {};
$25ac7e2601d1007e$exports = import.meta.resolve("jjt3N");


var $4f79287fe64c6f72$exports = {};
$4f79287fe64c6f72$exports = import.meta.resolve("hIKS2");


var $04bc954212f3bd6e$exports = {};
$04bc954212f3bd6e$exports = import.meta.resolve("hZejB");



var $acw62 = parcelRequire("acw62");

function $63b46b8341748184$export$6979653456ce8111() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box pos-rel",
        style: {
            width: 640,
            height: 880
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs taco-box",
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                },
                children: " "
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($04bc954212f3bd6e$exports))),
                x: 12,
                y: 5,
                w: 70
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapBox, {
                x: 60,
                y: 0,
                w: 40,
                h: 10,
                text: "Bongo's sauce recipe has changed 20 times over the franchise's history! Try our Pink Sauce for a flavor explosion!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapBox, {
                x: -3,
                y: 25,
                w: 40,
                h: 8,
                text: "Bongo's favorite order is a Bongo Meal + toy with three ring onion hoops and a medium Sipper!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapBox, {
                x: -3,
                y: 38,
                w: 40,
                h: 8,
                text: "UNFORTUNATELY, dogs can't eat onions. That's why he cries! Sorry, Bongo!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($adab277a26ff9ede$exports))),
                x: 6,
                y: 0,
                w: 30,
                class: "flip-h"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($c4fa2a4eed097977$exports))),
                x: 70,
                y: 20,
                w: 30
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($a825555ee6c1f9be$exports))),
                x: 27,
                y: 64,
                w: 12,
                class: "flip-h"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ad44f431c98fe204$exports))),
                x: 48,
                y: 68,
                w: 12,
                class: "flip-h"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($25ac7e2601d1007e$exports))),
                x: 42,
                y: 34,
                w: 8
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9d81fef9bb218f9c$exports))),
                x: 60,
                y: 80,
                w: 40,
                onClick: ()=>{
                    tacoProvider.enterShop();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63b46b8341748184$var$MapImage, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f79287fe64c6f72$exports))),
                x: 75,
                y: 95,
                w: 25,
                class: "no-events"
            })
        ]
    });
}
function $63b46b8341748184$var$MapBox(props) {
    const className = props.class !== undefined ? props.class : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs taco-map-box text-center v-box center-all " + className,
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: props.h + "%"
        },
        children: props.text
    });
}
function $63b46b8341748184$var$MapImage(props) {
    const onclick = props.onClick !== undefined ? props.onClick : ()=>{};
    const className = props.class !== undefined ? props.class : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        onClick: onclick,
        className: "pos-abs " + className,
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%"
        }
    });
}



var $836936668088944d$exports = {};
$836936668088944d$exports = import.meta.resolve("beBpJ");


var $3eaca4b82af916f4$exports = {};
$3eaca4b82af916f4$exports = import.meta.resolve("ffial");


var $a8e3ea1306f61c28$exports = {};
$a8e3ea1306f61c28$exports = import.meta.resolve("bjb6Y");


var $ea28e155468da755$exports = {};
$ea28e155468da755$exports = import.meta.resolve("3x82v");


function $31e7a9b3a014ce87$export$5fd14aea6876468() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box pos-rel",
        style: {
            width: 640,
            height: 920
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($836936668088944d$exports))),
                className: "pos-abs width-100p"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3eaca4b82af916f4$exports))),
                className: "pos-abs width-256",
                style: {
                    left: "27%",
                    top: "3%"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-100p",
                style: {
                    padding: "256px 48px 48px 48px"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "pos-rel height-100p",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Main Attractions",
                            x: 0,
                            y: 0,
                            size: 28,
                            header: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuDivider, {
                            x: 0,
                            y: 6.5,
                            w: 43,
                            h: 1.5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Tragic Clown Jr.",
                            x: 0,
                            y: 6,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "1.65",
                            x: 35,
                            y: 6,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Tragic Clown Sr.",
                            x: 0,
                            y: 11,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "1.68",
                            x: 35,
                            y: 11,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Bigtop Burgrito",
                            x: 0,
                            y: 16,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".95",
                            x: 36,
                            y: 16,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "ChicagoStyle Nacho Slammer",
                            x: 0,
                            y: 21,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "1.50",
                            x: 55,
                            y: 21,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Chicky Rippies",
                            x: 0,
                            y: 26,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".95",
                            x: 36,
                            y: 26,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Beefy Beaned Bongolicious",
                            x: 0,
                            y: 31,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Cheesy Bowl",
                            x: 0,
                            y: 36,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "1.40",
                            x: 35,
                            y: 36,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuImage, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a8e3ea1306f61c28$exports))),
                            x: 60,
                            y: -2,
                            w: 40
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuDivider, {
                            x: 0,
                            y: 46,
                            w: 43,
                            h: 19,
                            class: "border-radius-4"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Make a BongoMeal",
                            x: 2,
                            y: 46,
                            header: true,
                            textClass: "text-white"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "- one main",
                            x: 6,
                            y: 49,
                            size: 18,
                            textClass: "text-blue"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "- one side",
                            x: 6,
                            y: 53,
                            size: 18,
                            textClass: "text-blue"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "- one slurp",
                            x: 6,
                            y: 57,
                            size: 18,
                            textClass: "text-blue"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Side Shows",
                            x: 68,
                            y: 32,
                            size: 28,
                            header: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuDivider, {
                            x: 50,
                            y: 38.5,
                            w: 43,
                            h: 1.5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Beans with a Z",
                            x: 50,
                            y: 37,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".50",
                            x: 85,
                            y: 37,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Ringaling 3Ring",
                            x: 50,
                            y: 42,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Onion Hoops",
                            x: 50,
                            y: 47,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".75",
                            x: 85,
                            y: 47,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "n' Bits",
                            x: 50,
                            y: 52,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "1.50",
                            x: 83,
                            y: 52,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Burrito Fries",
                            x: 50,
                            y: 57,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".75",
                            x: 85,
                            y: 57,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuImage, {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ea28e155468da755$exports))),
                            x: 50,
                            y: 67,
                            w: 28
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Slurps and Sips",
                            x: 0,
                            y: 65,
                            size: 28,
                            header: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuDivider, {
                            x: 0,
                            y: 71.5,
                            w: 43,
                            h: 1.5
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "All Drinksi\u2122 Products!",
                            x: 0,
                            y: 71,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Puppy Size",
                            x: 4,
                            y: 76,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".45",
                            x: 36,
                            y: 76,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "Doggie Size",
                            x: 4,
                            y: 81,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".55",
                            x: 36,
                            y: 81,
                            bold: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: "GoodBoy Bowl",
                            x: 4,
                            y: 86,
                            class: "font-italic"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($31e7a9b3a014ce87$var$MenuText, {
                            text: ".65",
                            x: 36,
                            y: 86,
                            bold: true
                        })
                    ]
                })
            })
        ]
    });
}
function $31e7a9b3a014ce87$var$MenuText(props) {
    const header = props.header !== undefined ? props.header : false;
    const textClass = props.textClass !== undefined ? props.textClass : 'text-taco-pink';
    const className = "pos-abs " + textClass + " " + (props.class !== undefined ? props.class : '');
    const size = props.size !== undefined ? props.size : 24;
    const bold = props.bold !== undefined ? props.bold : false;
    return header ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
        className: className,
        style: {
            left: props.x + "%",
            top: props.y + "%",
            fontSize: size
        },
        children: bold ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
            children: props.text
        }) : props.text
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: className,
        style: {
            left: props.x + "%",
            top: props.y + "%",
            fontSize: size,
            padding: "0px 8px"
        },
        children: bold ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
            children: props.text
        }) : props.text
    });
}
function $31e7a9b3a014ce87$var$MenuDivider(props) {
    const className = props.class !== undefined ? props.class : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs bg-taco-teal " + className,
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: props.h + "%",
            margin: "0px 8px"
        }
    });
}
function $31e7a9b3a014ce87$var$MenuImage(props) {
    return props.h !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        className: "pos-abs",
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: props.h + "%"
        }
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        className: "pos-abs",
        style: {
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%"
        }
    });
}


function $850e8f70ecbd1a1e$export$4d69813342def711() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e7a9b3a014ce87$export$5fd14aea6876468), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63b46b8341748184$export$6979653456ce8111), {})
        ]
    });
}




var $acw62 = parcelRequire("acw62");
function $9e2aaff57b535a23$export$103620f6b2a7467a() {
    const [text, setText] = (0, $acw62.useState)('');
    const [result, setResult] = (0, $acw62.useState)('');
    const handleChange = (event)=>{
        setText(event.target.value);
    };
    const handleSubmit = (event)=>{
        setResult('Sorry, there are no Taco Bongos in your area.');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "taco-box width-768 height-512 v-box padding-64",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-taco-purp",
                style: {
                    margin: 0
                },
                children: "Find Us!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Enter your Zip Code to find a Taco Bongo near you!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "h-box gap-4 cursor-none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        value: text,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "submit",
                        value: "Search!",
                        className: "og-button"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: result
            })
        ]
    });
}




var $6c0a08e569cc4c88$exports = {};
$6c0a08e569cc4c88$exports = import.meta.resolve("jfYYG");


function $3d6e8f6e9d86c378$export$2276db8aaf5543e2() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "taco-box width-768 height-512 h-box padding-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box width-192",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15923fa4c3209c93$export$c4a88969917444a9), {
                        title: "MEET BONGO!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "font-taco-primary text-black text-20 padding-8",
                        children: [
                            "This is Bongo! He's our crier straight to Clown Alley! A barrel of laughs and a drum of a dog. Our witty whimsical tail-wagging woebegone wisecracker wants Taco Bongo SO wuch.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "Don't let his wails fool you, he wants to be here! Get him inside a Taco Bongo, and he'll wolf it all down!"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pos-rel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "pos-abs width-768",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c0a08e569cc4c88$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pos-abs",
                        style: {
                            left: 200,
                            top: 140
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15923fa4c3209c93$export$e1adaf956eb84a5f), {
                            height: 256
                        })
                    })
                ]
            })
        ]
    });
}



var $8454c5d41f834654$exports = {};
$8454c5d41f834654$exports = import.meta.resolve("9Q5VA");


function $9b0823546d45f34f$export$99812b5a81e51b38() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box center-all gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "width-640 height-auto",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8454c5d41f834654$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box center-all",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "ROCK and TALK around the CLOCK."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "We play THE Hits,"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "the DEEPEST Cuts,"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "the LEGENDS of the Local Scene,"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "and EVERYTHING ELSE YOUR EARS WANT."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "YES, EVEN THAT!!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "OUR DISCS TO YOUR EARS!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "CALL 333-MIKE FOR REQUESTS!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box font-treb center-all width-512 gap-8 text-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            "Check out our ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/wtrok/sweepstakes",
                                children: "Sweepstakes"
                            }),
                            " page to learn about the DAILY Sweepstakes. Prizes prizes prizes!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "We are PROUD to be sponsored by BIG CORNER GASOLINE. Pull up to the BIG CORNER to gas up FAST. There's no gas station more convenient in all of Triple Oaks!"
                    })
                ]
            })
        ]
    });
}


// import logo2 from "url:../../assets/taco/LOGO2.png";

function $fe0552e0f1ef51aa$export$27b46e3a2d493e41() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box center-all gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-32"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box center-all",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "text-64 font-soon",
                    children: "WIN BIG WITH WTROK"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "width-512 height-384"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Every week, WTROK partners with a local business here in Triple Oaks to give out BIG prizes. You could be next week's winner! Call Derek for more information!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Current Sweepstakes runs through 6/12 at 11:59PM!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-28 font-soon",
                children: "This week's prize comes from:"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "HONK HONK, TRIPLE OAKS. HERE COME THE CLOWNS! Bongo is coming to a franchise location near you, Triple Oaks, and he's HUNGRY! Taco Bongo, Inc. and WTROK are teaming up to bring 2 lucky winners the ride of a lifetime."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Have you ever wanted to ride in The Automobongomobile? Stick your head out the window and feel the cool breeze of freedom? Have you ever wanty Taco Bongo? Well now you can, ON US!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Two lucky winners who call in during the BONGO BEAT BREAK with the correct password will receive a ride across town in the Automobongo and a photoshoot with our very own Bongo!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Wanty more? You gluttonous beast! Fine. Both winners will also receive one taco a day for LIFE with filling of your choice at participating locations all over the country."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-28 font-soon",
                children: "How To Enter"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box font-treb width-512 gap-16 text-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Call our station at any time and ask for Bongo! He'll tell you the password of the day. Once you have it, wait for the BONGO BEAT BREAK. If you call during the BBB and say the right password, you'll be entered to win!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-10",
                        children: "Must be 18 or older to enter. Must not be allergic to dogs. Taco offer only available at select participating locations, excludes buff beef as a filling. Limit to 5 entries per person. Must present physical image of winner meeting Bongo to receive offer. Bongo may be replaced by Bozo if conditions require."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-128"
            })
        ]
    });
}



function $fbb79a897a94281e$export$7084ee4a5ffb59d() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-32 center-all",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-32 font-soon",
                children: "Need good taste?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "font-treb",
                children: "Here's the WTROK staff's latest recommendations!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box gap-16",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fbb79a897a94281e$var$WTROKREC, {
                        dj: "DJ Bug",
                        title: "Tubthumping",
                        artist: "Chumbawumba"
                    })
                ]
            })
        ]
    });
}
function $fbb79a897a94281e$var$WTROKREC(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box gap-64",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "font-treb text-24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                    children: props.dj
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-box gap-8 font-treb text-24",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "font-treb text-24",
                        children: [
                            '"',
                            props.title,
                            '"'
                        ]
                    }),
                    "-",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "font-treb text-24",
                        children: props.artist
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $a4deb66058ff213b$exports = {};
$a4deb66058ff213b$exports = import.meta.resolve("7JcnZ");




var $acw62 = parcelRequire("acw62");

const $ecf06b3fe41650f4$var$empty_clip = {
    key: "empty",
    url: "",
    title: "Empty",
    artist: "The Empties"
};
const $ecf06b3fe41650f4$var$default_clip = {
    key: "qwer",
    url: "https://music.wixstatic.com/mp3/4af535_143a3c6c2cc241b5a2dad9c8e5b1214a.mp3",
    title: "Run Like the Wind",
    artist: "DavidKBD"
};
const $ecf06b3fe41650f4$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    clip: $ecf06b3fe41650f4$var$default_clip,
    loadClip: (key)=>{},
    clearClip: ()=>{}
});
const $ecf06b3fe41650f4$var$WTROKPROV = (props)=>{
    const [clip, setClip] = (0, $acw62.useState)(undefined);
    const loadClip = async (key)=>{
        console.log("load clip: " + key);
        await (0, $bbd230e5ce70aa2a$export$299ba2dee77727e9)('api/clips', {
            key: key
        }).then((res)=>res.json()).then((res)=>{
            setClip(res.value);
        });
    };
    const clearClip = ()=>{
        setClip(undefined);
    };
    const value = (0, $acw62.useMemo)(()=>{
        return {
            clip: clip,
            loadClip: loadClip,
            clearClip: clearClip
        };
    }, [
        clip
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ecf06b3fe41650f4$var$context.Provider, {
        value: value,
        children: props.children
    });
};
$ecf06b3fe41650f4$var$WTROKPROV.context = $ecf06b3fe41650f4$var$context;
var $ecf06b3fe41650f4$export$2e2bcd8739ae039 = $ecf06b3fe41650f4$var$WTROKPROV;


var $c1b06dedbd6aef4e$exports = {};
$c1b06dedbd6aef4e$exports = import.meta.resolve("ek0QW");


var $677e0cbf7d2a6ee2$exports = {};
$677e0cbf7d2a6ee2$exports = import.meta.resolve("7WvAS");


var $1d623f71439a94bc$exports = {};
$1d623f71439a94bc$exports = import.meta.resolve("c8f4O");


function $08b1abefbb57ac8c$export$44ce46a07a687085() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-32 width-100p center-all",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box margin-32 gap-32",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "6:00am",
                        title: "Walt Lafrizer's Easy Listening Morning",
                        description: "Tune in early while our early rising DJ Walt Kafrizer eases you into the day with two hours of soft rock."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "8:00am",
                        title: "BIGG MIKE'S DRIVE TIME O'CLOCK",
                        description: "DJ BIGG MIKE WITH TWO G's will get you to work with DRIVE TIME. All the HITS with the kick of energy you need -- all while you drive your motor vehicle."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "10:00am",
                        title: "Walkin' Taco Talkin' Hour",
                        description: "Local news, weather, and traffic brought to you by our boots on the ground! A walkin talk-o a day keeps the boredom away."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "11:00am",
                        title: "HOT 20 Countdown with Mike in the Morning!",
                        description: "Don't miss it as WTROK counts down our top 20 tracks of the week. The best 20 songs of the week, all before lunch."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "12:00pm",
                        disc: "qwer",
                        title: "OUT 2 LUNCH.",
                        description: "WTROK lines up our favorite rock tracks for a solid hour of interrupted ROCK music while we all go out to lunch."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "1:00pm",
                        disc: "wert",
                        title: "HOT 20 Countdown, AGAIN!",
                        sponsor: "Brought to you by Flushmore Industries",
                        description: "Don't miss it as WTROK counts down out top 20 tracks of the week AGAIN just after lunch -- because they're THAT GOOD."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:00pm",
                        disc: "erty",
                        title: "Oldies but Goodies",
                        description: "Travel back in time to hear the classics your parents made you listen to! Embrace a warm and comforting sense of nostalgia with the broadcasts of yesteryear."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "3:15pm",
                        title: "80s Afternoon",
                        description: "Miss the 80s? So does DJ BIGG Mike with Two G's. He won't stop playing 80s hits, and that's okay because some people like that!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "4:00pm",
                        title: "Taste Makers",
                        description: "For your evening drive, tune into DJ Backflow's Taste Makers. She's got the best taste in the county -- who needs your own taste when you've got DJ Backflow?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "6:00pm",
                        title: "Hank in the Evening",
                        description: "WTROK legend Hank Simmons plays the same LEGENDARY set he's been playing since 1961. See you at high noon (that's cowboy for 6pm)!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "7:00pm",
                        title: "Rock Surprise Hour",
                        description: "We put every rock CD we have into a big ol' bucket and play whatever our intern Pat pulls out of the pile. It could be anything."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "8:00pm",
                        title: "The Shania Show",
                        description: "2ish hours of the best and worst love songs of all time, with a whole lotta love mixed in. Let Shania patch up your lonely hearts and celebrate what the heart wants."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "9:00pm",
                        title: "NEWS AT NINE",
                        description: "A brief interlude of The Shania Show to bring you all the news from mid to west! Local sports, breaking news, and weather events YOU need to know about!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "9:20pm",
                        title: "The Shania Show",
                        description: "She's back, and she's all about love. Let Shania patch up your lonely hearts and celebrate what the heart wants."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "10:00pm",
                        title: "Night Ska",
                        description: "WTROK guest DJ and the boy son of WTROK's manager Lenny Stomp stomps by to give us an exhilarating hour of the only genre he will listen to -- SKA!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "12:00am",
                        title: "FREAK ARENA",
                        description: "DJ NicheMiche is back with an ear-bleeding hour of NU METAL. NEW TIME SLOT: FREAK ARENA is now after midnight, by popular demand!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-96"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "1:00am",
                        title: "",
                        description: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c1b06dedbd6aef4e$exports))),
                        className: "width-100p opacity-60 blend-lighten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "1:00am",
                        title: "",
                        description: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "1:00am",
                        title: "Trip-Hop Nightclub",
                        description: "Volunteer DJ Nocto takes us into the night with a power block of Trip Hop. If you're up this late, you deserve some Trip-Hop."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:00am",
                        title: "Nocto Night",
                        description: "DJ Nocto treats us to two hours of, well, whatever music they're into. None of us are willing to stay up that late, so we don't know what Nell is playing!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "3:33am",
                        title: "The Witching Minute",
                        description: "EEeehheeheeehee! A curse be upon ye! Double double toil and trouble, station burn and poems bubble."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "11:00pm",
                        title: "Oldies but Goodies",
                        description: "Travel back in time to hear the classics your parents made you listen to! Embrace a warm and comforting sense of nostalgia with the broadcasts of yesteryear."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($677e0cbf7d2a6ee2$exports))),
                className: "width-100p opacity-60 blend-lighten"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box width-100p pos-rel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1d623f71439a94bc$exports))),
                        className: "width-100p opacity-60 height-384 blend-lighten"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pos-abs v-box center-all",
                        style: {
                            left: 32,
                            top: 64
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                                time: "12:00am",
                                title: "FREAK ARENA",
                                description: "DJ NicheMiche is back with an ear-bleeding hour of NU METAL. NEW TIME SLOT: FREAK ARENA is now after midnight, by popular demand!"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "height-128"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                                time: "2:25am",
                                title: "2:25am",
                                description: "It's TIME"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box margin-32 gap-32",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:00am",
                        title: "Nocto Night",
                        description: "DJ Nocto treats us to two hours of, well, whatever music they're into. The rest of us are having weird dreams, so we don't know what Caell is playing!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "6:00pm",
                        title: "Hank in the Evening",
                        description: "WTROK legend Hank Simmons plays your favorite western movie soundtracks, always at 6pm! We can't legally force him to any other timeslot! Yee and Haw!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-512"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "3:00am",
                        title: "Local Limelight",
                        description: "WTROK loves its local music! We play our favorite, hand-selected tracks from our talented local artists. Get your big break at WTROK!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-512"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:06am",
                        title: "Nocto Nightmare",
                        description: "DJ Nocto treats us to two hours of, well, whatever music haunts you. None of us are willing to face our fears, so we don't know what Caell is playing!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:08am",
                        title: "Nocto Nightmare",
                        description: "DJ Nocto treats us to two hours of, well, whatever music haunts you. None of us are willing to face our fears, so we don't know what Caell is playing!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:09am",
                        title: "Nocto Nightmare",
                        description: "DJ Nocto treats us to two hours of, well, whatever music haunts you. None of us are willing to face our fears, so we don't know what Caell is playing!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-32"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:13am",
                        title: "Nocto Nightmare",
                        description: "DJ Nocto treats us to two hours of, well, whatever music haunts you. None of us are willing to face our fears, so we don't know what Caell is playing!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "2:15am",
                        title: "Nocto Nightmare",
                        description: "DJ Nocto treats us to two hours of, well, whatever music haunts you. None of us are willing to face our fears, so we don't know what Caell is playing!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box margin-32 gap-32",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-512"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "4:00am",
                        title: "New Age Power Hour",
                        description: "If you're awake at 4:00am, something has gone wrong! Either you can't sleep or you can't get back to sleep. Either way, how about some Enya?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-1024"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-1024"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "5:00am",
                        title: "HOT 20 Countdown",
                        description: "Don't miss it as WTROK counts down our top 20 tracks of the week. The best 20 songs of the week, all before sunrise."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-1024"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "5:03am",
                        title: "HOT 19 Countdown",
                        description: "Don't miss it as WTROK counts down our top 19 tracks of the week. The best 19 songs of the week, all before sunrise."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "5:06am",
                        title: "HOT 18 Countdown",
                        description: "Don't miss it as WTROK counts down our top 18 tracks of the week. The best 18 songs of the week, all before sunrise."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "5:09am",
                        title: "HOT 17 Countdown",
                        description: "Don't miss it as WTROK counts down our top 17 tracks of the week. The best 17 songs of the week, all before sunrise."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-512"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "5:12am",
                        title: "HOT 16 Countdown",
                        description: "Don't miss it as WTROK counts down our top 16 tracks of the week. The best 16 songs of the week, all before sunrise."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "8:00pm",
                        title: "Sleepytime with Walt!",
                        description: "Tune in as DJ Walt Kafrizer eases us (and himself) back to sleep with a solid hour of more soft rock. It may not be your bedtime, but it's Walt's!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "4:30pm",
                        title: "Grunge Grub",
                        description: "All the grungiest, greasiest, grossest rock hits that you crave. Grunge may be dead, but from 9 to 10pm in Triple Oaks it comes back wrong, but it sounds ohh so right."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-256"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$TIMESLOT, {
                        time: "",
                        title: "Kiss and Tell",
                        description: "The rock and gossip hour. Tell us a secret, listen to a song! Repeat!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-128"
                    })
                ]
            })
        ]
    });
}
function $08b1abefbb57ac8c$var$TIMESLOT(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box gap-16",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-24 width-96",
                children: props.time
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box gap-8 width-512",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-24",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: props.title
                        })
                    }),
                    props.sponsor !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-18 font-italic",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: props.sponsor
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: props.description
                    })
                ]
            }),
            props.disc !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($08b1abefbb57ac8c$var$DISC, {
                k: props.disc
            }) : null
        ]
    });
}
function $08b1abefbb57ac8c$var$DISC(props) {
    const context = (0, $acw62.useContext)((0, $ecf06b3fe41650f4$export$2e2bcd8739ae039).context);
    const [avlb, setAvlb] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        const isAvlb = context.clip === undefined || context.clip.key !== props.k;
        setAvlb(isAvlb);
    }, [
        context.clip
    ]);
    const k = props.k !== undefined ? props.k : 'silence';
    const disp = avlb ? '' : 'display-none';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $729be54a6ff46139$export$6b40d0162fab68e5), {
            targetId: "wtrokds",
            canReachTarget: ()=>{
                return context.clip === undefined;
            },
            onTarget: ()=>context.loadClip(k),
            lock: true,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($a4deb66058ff213b$exports))),
                className: "z-2 width-64 height-64 " + disp
            })
        })
    });
}



function $5dc7aec66f541314$export$c7294414d472d743() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
        className: "text-white",
        children: "Bowling"
    });
}



function $d0a06261a859f33f$export$1f6cc3c298c2bc33() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
        className: "text-white",
        children: "I"
    });
}





var $acw62 = parcelRequire("acw62");

var $701ee155670857fd$exports = {};
$701ee155670857fd$exports = import.meta.resolve("y5D1x");




var $dd45fd18e864edb5$exports = {};
$dd45fd18e864edb5$exports = import.meta.resolve("dNVrl");


var $a6dc11b6cba1789d$exports = {};
$a6dc11b6cba1789d$exports = import.meta.resolve("kAkCC");



var $f5c1f7af8e2101b8$export$857b11641fa70c36 = /*#__PURE__*/ function(Ad) {
    Ad[Ad["Gooze"] = 0] = "Gooze";
    return Ad;
}({});
function $f5c1f7af8e2101b8$export$becfa739375e4318(props) {
    const animated = props.animated !== undefined ? props.animated : true;
    let onImage = '';
    let offImage = '';
    switch(props.ad){
        case 0:
            onImage = (0, (/*@__PURE__*/$parcel$interopDefault($dd45fd18e864edb5$exports)));
            offImage = (0, (/*@__PURE__*/$parcel$interopDefault($a6dc11b6cba1789d$exports)));
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: onImage,
            className: "adbanner",
            onClick: props.onClick
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: offImage,
            className: "adbanner",
            onClick: props.onClick
        }),
        startOn: animated
    });
}




var $acw62 = parcelRequire("acw62");


function $a40e90e91dc5b5e5$export$353f5b6fc5456de1(props) {
    const label = props.label != undefined ? props.label : null;
    const img = props.img !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.img
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: "basic-button",
        onClick: props.onClick,
        children: [
            label,
            img
        ]
    });
}


var $9af22e8f5183f65d$exports = {};
$9af22e8f5183f65d$exports = import.meta.resolve("1NIRk");


var $7dc02e346ae507e0$exports = {};
$7dc02e346ae507e0$exports = import.meta.resolve("1XllH");


var $766ab30a6a7369a3$exports = {};
$766ab30a6a7369a3$exports = import.meta.resolve("81hrO");



function $628a2f96601881e3$export$55a5cecb88257141(props) {
    const [audioSrc, setAudioSrc] = (0, $acw62.useState)(props.audio);
    const audioRef = (0, $acw62.useRef)(new Audio(audioSrc));
    audioRef.current.volume = 0.15;
    const [audioTime, setAudioTime] = (0, $acw62.useState)(0);
    const [audioDuration, setAudioDuration] = (0, $acw62.useState)(audioRef.current.duration);
    const [audioFill, setAudioFill] = (0, $acw62.useState)(0);
    const loop = props.loop === undefined ? true : props.loop;
    const autoplay = props.autoplay === undefined ? false : props.autoplay;
    const [paused, setPaused] = (0, $acw62.useState)(!autoplay);
    const restartAudio = ()=>{
        audioRef.current.currentTime = 0;
        if (!paused) audioRef.current.play();
    };
    const updateAudioTime = ()=>{
        setAudioTime(audioRef.current.currentTime);
        setAudioDuration(audioRef.current.duration);
    };
    const endAudio = ()=>{
        if (loop) restartAudio();
    };
    const handlePlayPause = ()=>{
        if (paused) setPaused(false);
        else setPaused(true);
    };
    (0, $acw62.useEffect)(()=>{
        audioRef.current.src = audioSrc;
        restartAudio();
    }, [
        audioSrc
    ]);
    (0, $acw62.useEffect)(()=>{
        setAudioFill(Math.round(audioTime / audioDuration * 100));
    }, [
        audioTime,
        audioDuration
    ]);
    (0, $acw62.useEffect)(()=>{
        if (paused) audioRef.current.pause();
        else audioRef.current.play();
    }, [
        paused
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "music-player",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("audio", {
                ref: audioRef,
                src: audioSrc,
                autoPlay: autoplay,
                onTimeUpdate: updateAudioTime,
                onLoadedMetadata: updateAudioTime,
                onEnded: endAudio
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a40e90e91dc5b5e5$export$353f5b6fc5456de1), {
                img: paused ? (0, (/*@__PURE__*/$parcel$interopDefault($7dc02e346ae507e0$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($766ab30a6a7369a3$exports))),
                onClick: handlePlayPause
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "music-player-bar",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "music-player-bar-fill",
                    style: {
                        width: audioFill + "%",
                        height: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a40e90e91dc5b5e5$export$353f5b6fc5456de1), {
                img: (0, (/*@__PURE__*/$parcel$interopDefault($9af22e8f5183f65d$exports))),
                onClick: restartAudio
            })
        ]
    });
}


var $da0bdd01b3c9ecc0$exports = {};
$da0bdd01b3c9ecc0$exports = import.meta.resolve("bCuTg");


var $299483492c92e394$exports = {};
$299483492c92e394$exports = import.meta.resolve("ka04Y");


var $6598c2cb4362d66c$exports = {};
$6598c2cb4362d66c$exports = import.meta.resolve("KvLQp");




function $a89499c873ca0823$export$2e0a83ec2e27ecbb() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "divider"
    });
}




function $f65be1f4143e2d0e$export$6ed0f6489738fdfb() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "counter",
        children: "0000029"
    });
}







var $acw62 = parcelRequire("acw62");


function $fc15d8f06114a404$export$e048a3c6e5d2a624(props) {
    const cursor = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const [enb, setEnb] = (0, $acw62.useState)();
    const className = props.className !== undefined ? props.className : '';
    const style = props.style !== undefined ? props.style : {};
    const hasStyleOrClass = props.className !== undefined || props.style !== undefined;
    const onState = hasStyleOrClass ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        style: style,
        children: props.onState
    }) : props.onState;
    return enb ? onState : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $887b4dfdb08ec5f4$export$7cfed81e33fc1826), {
        className: className,
        style: style,
        cursor: (0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).PLZ,
        onClick: ()=>{
            if (!cursor.plzchg) {
                if (enb && props.stdOnClick !== undefined) props.stdOnClick();
                return;
            }
            setEnb(true);
            cursor.setPlzchg(false);
            if (props.onEnable !== undefined) props.onEnable();
        },
        stdOnClick: ()=>{
            if (enb && props.stdOnClick !== undefined) props.stdOnClick();
        },
        children: props.offState
    });
}





function $464b677cdf27d159$export$a7036ce17db05184() {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    (0, $acw62.useEffect)(()=>{
        player.unlockSite((0, $5fc7b830e79d6137$export$2f1b57c8d7991048).key);
    }, []);
    const page = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "page-basic cnn-bg font-treb",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-box cnn-body-width padding-16",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5c1f7af8e2101b8$export$becfa739375e4318), {
                                ad: (0, $f5c1f7af8e2101b8$export$857b11641fa70c36).Gooze,
                                animated: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "h-box center-all gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-gray-light text-16 font-mono",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            children: "You are not alone..."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f65be1f4143e2d0e$export$6ed0f6489738fdfb), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-32 text-red font-treb",
                                children: "CREEPY NOWHERE NEWS"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidNav, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$910ae8079b2c2852), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $729be54a6ff46139$export$6b40d0162fab68e5), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($701ee155670857fd$exports))),
                            width: "96px"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "cnn-sidebar",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($464b677cdf27d159$export$4c17749a7881e7f2, {
                                header: "SITE UPDATES",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-green text-18",
                                        children: "9.22.99"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-white text-18",
                                        children: "Fixed text anomalies. Should be normal now."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$export$4c17749a7881e7f2, {
                                header: "SIGNALS",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "cnn-audio-box",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $628a2f96601881e3$export$55a5cecb88257141), {
                                            audio: (0, (/*@__PURE__*/$parcel$interopDefault($da0bdd01b3c9ecc0$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "cnn-audio-list",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidAudioItem, {
                                                    label: "Mothfoot",
                                                    audio: ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidAudioItem, {
                                                    label: "Outhound",
                                                    audio: ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidAudioItem, {
                                                    label: "Old Janet",
                                                    audio: ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidAudioItem, {
                                                    label: "Cornhog",
                                                    audio: ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidAudioItem, {
                                                    label: "Disappearances",
                                                    audio: ""
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$var$CryptidAudioItem, {
                                                    label: "UFOs",
                                                    audio: ""
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$export$4c17749a7881e7f2, {
                                header: "REPORT SIGHTINGS",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        children: "Click Here!!"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac4e059a2c538140$export$ea59b6255584f4ce), {
                                stamps: [
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).TROK,
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).WTROK,
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Anime,
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Cryptid,
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Phranks
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }, []);
    return page;
}
function $464b677cdf27d159$var$CryptidNav() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box gap-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$export$6c6dfaf92405c139, {
                text: "HOME",
                url: "/cnn"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$export$6c6dfaf92405c139, {
                text: "TESTIMONIALS",
                url: "/cnn/testimonials"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464b677cdf27d159$export$12e77e5085a3b05, {
                text: "FORUMS",
                url: "/cnn/forums/home"
            })
        ]
    });
}
function $464b677cdf27d159$export$6c6dfaf92405c139(props) {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "cnn-outline width-192 text-white text-18 bg-red padding-4",
        onClick: ()=>{
            nav(props.url);
        },
        children: props.text
    });
}
function $464b677cdf27d159$export$12e77e5085a3b05(props) {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc15d8f06114a404$export$e048a3c6e5d2a624), {
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "cnn-outline width-192 text-white text-18 bg-red padding-4",
            onClick: ()=>{
                nav(props.url);
            },
            children: props.text
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "cnn-outline width-192 text-gray-dark text-18 bg-black padding-4",
            children: props.text
        })
    });
}
function $464b677cdf27d159$export$4c17749a7881e7f2(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "cnn-outline",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "cnn-box-header text-24 text-white",
                children: props.header
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cnn-box-body",
                children: props.children
            })
        ]
    });
}
function $464b677cdf27d159$var$CryptidAudioItem(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc15d8f06114a404$export$e048a3c6e5d2a624), {
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "cnn-audio-item",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($299483492c92e394$exports))),
                    width: "32px"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "text-white",
                    children: props.label
                })
            ]
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "cnn-audio-item",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6598c2cb4362d66c$exports))),
                    width: "32px"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "text-gray-dark",
                    children: props.label
                })
            ]
        })
    });
}


function $0131e9ee11c45c37$export$5bdc406f871f9545() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $464b677cdf27d159$export$4c17749a7881e7f2), {
                header: "WELCOME WEARY TRAVELERS",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-white text-18",
                        children: "You are lost. The buildings around you are all familiar but never enough to recognize. You are looking for something. A friend? A story? Answers? You don't know. You are looking."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-white text-18",
                        children: "Ah--a newspaper strewn carelessly on the ground! It is damp but inviting. The text across the top reads CRYPTOZOOLOGICAL NOWHERE NEWS. You're not lost, you remember! You're in the middle of Nowhere. The Midwest! Already this paper has given you more answers than you expected... you read on, enticed... perhaps there's more to learn."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $464b677cdf27d159$export$4c17749a7881e7f2), {
                header: "DISPATCHES FROM BEYOND",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-green text-18",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: "NEW!"
                            }),
                            " - Updates on the string of household object disappearances"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-white text-18",
                        children: "Previously thought to be a local band of ruffian gnomes, we have received reports of objects moving seemingly of their own volition. This leads the CNN team to believe that hte cause is INVISIBLE gnomes!!! Regular correspondent, The Professor, recommends flour on the ground to track gnome footprints. As for what plans they have for our blenders and bedazzlers, it ... REMAINS TO BE SEEN!! HAHAHAHAHAA"
                    })
                ]
            })
        ]
    });
}



var $48048e4e791a2389$exports = {};
$48048e4e791a2389$exports = import.meta.resolve("8Pj3B");


function $2cece11c74fffb3b$export$dd03d31035207375() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box center-all gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box center-all gap-16",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-64 font-soon",
                        children: "WTROK"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-28 font-soon",
                        children: "Rock and Talk Around the Clock at 89.7FM"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($48048e4e791a2389$exports))),
                        width: 512,
                        className: "wtrok-box-border"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "WTROK is a historic community radio station, playing the hits on the hill and working as the voice of the people since 1933 under the same call sign! The station settled into our current location wayyy back in 1946 after a WWII bunker was retired off of the town's adjacent military base, and we've been here, on the only hill in Triple Oaks, ever since!"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "Our programming has changed over the years to match the times, but we've always been your one stop shop for what's hip and what's hot. Radio plays, weather and traffic reports, and radical tunes\u2026WTROK's got it all. We love to air shows from folks around town, so you might tune in and hear your neighbor talking taxes or spinning ska. Most of our shows these days are hosted by the emcee, DJ, Host with the Most, Midnight Mambo Mikey, Mike in the Morning, Mike and Mike, the Mike on the mic\u2026. Mike: our sonorous voice of Triple Oaks. He's been with the station for over a decade now, and he's still spinning those tunes like you wouldn't believe. "
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "Amateur signal hoppers and casual listeners alike can find us at 89.7FM. Interested in hosting your own program? Give us a ring."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Want to help? We take donations!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "We could not do what we do without buying lunch for our volunteer DJs using the generous donations of our listeners."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "If radio was profitable, we'd have sold out already!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box font-treb width-512 gap-8 text-18",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Looking for us?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Find us just outside downtown, next to the old proving grounds on the hill. The bad news: it's haunted. The good news: the ghosts love rock and freaking roll. "
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "125 S Flushle Ln"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-128"
            })
        ]
    });
}





var $bd2b354557fbe577$exports = {};
$bd2b354557fbe577$exports = import.meta.resolve("cNnjg");


function $c23b482464308643$export$d69176fa41be421c() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "v-box gap-32 text-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $464b677cdf27d159$export$4c17749a7881e7f2), {
            header: "I Was Abducted",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e4c87942015340$export$4a7108e5554afff8), {
                id: "abd",
                ascii: (0, (/*@__PURE__*/$parcel$interopDefault($bd2b354557fbe577$exports))),
                size: 11
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");



var $a6efb2e43822289c$exports = {};
$a6efb2e43822289c$exports = import.meta.resolve("4CkJZ");





function $4e4773c75eeed42d$export$7d7c25fbdb0ddd94(props) {
    const context = (0, $acw62.useContext)((0, $ecf06b3fe41650f4$export$2e2bcd8739ae039).context);
    const audioRef = (0, $acw62.useRef)(new Audio());
    audioRef.current.crossOrigin = "anonymous";
    const [clip, setClip] = (0, $acw62.useState)(undefined);
    const audioTime = (0, $acw62.useRef)(0);
    const audioDuration = (0, $acw62.useRef)(1);
    const [audioFill, setAudioFill] = (0, $acw62.useState)(0);
    const [paused, setPaused] = (0, $acw62.useState)(true);
    const started = (0, $acw62.useRef)(false);
    const restartAudio = ()=>{
        if (audioRef.current === undefined) return;
        audioRef.current.currentTime = 0;
        if (!paused) audioRef.current.play();
    };
    (0, $acw62.useEffect)(()=>{
        setClip(context.clip);
    }, [
        context.clip
    ]);
    (0, $acw62.useEffect)(()=>{
        if (clip !== undefined) {
            audioRef.current.src = clip.url;
            audioRef.current.volume = 0.15;
            audioTime.current = 0;
            audioDuration.current = audioRef.current.duration;
            setAudioFill(0);
            if (!started.current) return;
            audioRef.current.play();
            if (paused) setPaused(false);
        } else {
            audioRef.current.src = (0, (/*@__PURE__*/$parcel$interopDefault($a6efb2e43822289c$exports)));
            audioTime.current = 0;
            audioDuration.current = 1;
            setAudioFill(0);
            setPaused(true);
        }
    }, [
        clip
    ]);
    const updateAudioTime = ()=>{
        audioTime.current = audioRef.current.currentTime;
        audioDuration.current = audioRef.current.duration;
        setAudioFill(Math.round(audioTime.current / audioDuration.current * 100));
    };
    const endAudio = ()=>{
        setClip(undefined);
    };
    const handlePlayPause = ()=>{
        if (paused) {
            started.current = true;
            setPaused(false);
        } else setPaused(true);
    };
    (0, $acw62.useEffect)(()=>{
        if (started.current) {
            if (paused) audioRef.current.pause();
            else audioRef.current.play();
        }
    }, [
        paused
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "wtrok-ply padding-8 h-box gap-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("audio", {
                ref: audioRef,
                onTimeUpdate: updateAudioTime,
                onLoadedMetadata: updateAudioTime,
                onEnded: endAudio
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "width-64 v-box height-100p center-all",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "pos-rel width-64 height-64",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a4deb66058ff213b$exports))),
                            className: "pos-abs width-64 filter-darken-h",
                            id: "wtrokds"
                        }),
                        clip !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                            onSmash: context.clearClip,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a4deb66058ff213b$exports))),
                                className: "pos-abs width-64 " + (paused ? '' : 'spin-3s')
                            })
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "v-box gap-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "font-treb text-12",
                        children: "Now Playing:"
                    }),
                    clip !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-box font-soon gap-8 text-14",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    '"',
                                    clip.title,
                                    '"'
                                ]
                            }),
                            "-",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: clip.artist
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "h-box font-soon text-14 text-gray-dark",
                        children: "No Disc Loaded"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "h-box gap-4 center-all",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: handlePlayPause,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: paused ? (0, (/*@__PURE__*/$parcel$interopDefault($7dc02e346ae507e0$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($766ab30a6a7369a3$exports))),
                                    className: "width-16 height-16 filter-black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "width-128 height-16 bg-gray wtrok-ply-bar",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "wtrok-ply-fill",
                                    style: {
                                        width: audioFill + "%",
                                        height: 16
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: restartAudio,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9af22e8f5183f65d$exports))),
                                    className: "width-16 height-16 filter-black"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





function $afba5e966490edef$export$824b0208ab061dba() {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    (0, $acw62.useEffect)(()=>{
        player.unlockSite((0, $5fc7b830e79d6137$export$aacc34ff648bd1aa).key);
    }, []);
    const page = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecf06b3fe41650f4$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "wtrok-page gap-none",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($afba5e966490edef$var$WTROKSidebar, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box wtrok-content",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($afba5e966490edef$var$WTROKLines, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "height-128"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "h-box width-auto padding-8 text-18 font-treb justify-end",
                                children: "The official sound of Triple Oaks"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "v-box width-100p center-all",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$910ae8079b2c2852), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "wtrok-footer bg-wtrok-purple h-box center-all gap-64 text-18 font-soon z-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/wtrok/airtimes",
                                children: "Air Times"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/wtrok/about",
                                children: "About Our Station"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/wtrok/music",
                                children: "What's Playing"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/wtrok/sweepstakes",
                                children: "Sweepstakes"
                            })
                        ]
                    })
                ]
            })
        });
    }, []);
    return page;
}
function $afba5e966490edef$var$WTROKHeader() {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box width-100p bg-wtrok-darkred center-all",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-16"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "v-box justify-end height-96",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "text-white text-wtrok-yellow font-treb text-64 margin-none padding-none",
                    onClick: ()=>{
                        nav("/wtrok");
                    },
                    children: "WTROK"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-purple height-16 width-100p"
            })
        ]
    });
}
function $afba5e966490edef$var$WTROKSidebar() {
    const context = (0, $acw62.useContext)((0, $ecf06b3fe41650f4$export$2e2bcd8739ae039).context);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box wtrok-sidebar z-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($afba5e966490edef$var$WTROKHeader, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-wtrok-darkred flex-spacing font-treb v-box justify-space align-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e4773c75eeed42d$export$7d7c25fbdb0ddd94), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "v-box margin-32 padding-16 bg-wtrok-yellow text-wtrok-purple wtrok-box-border center-all",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "We're ALWAYS on the pulse of TRIPLE OAKS. We know who you are -- yes, YOU -- and we're going to play what you NEED TO HEAR."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Be sure to tune in! On your way to work at the factory? WTROK. Waiting in the parking lot for your wife? WTROK. Drinking a beer alone in the garage? WTROK."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "WTROK is always there bringing the tunes straight from our discs through the radio waves to your hungry ears. Let us feed you! Open wide!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "v-box pos-rel center-all",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($87b11bebc505ae94$exports))),
                            className: "width-128"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "font-soon center-all v-box",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Friends of WTROK:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac4e059a2c538140$export$ea59b6255584f4ce), {
                                stamps: [
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).TROK,
                                    (0, $452a05b0d36845a0$export$cd58f743ba5bc404).TacoBongo
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-16"
                    })
                ]
            })
        ]
    });
}
function $afba5e966490edef$var$WTROKLines() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box width-100p wtrok-header z-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-dark height-48"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-yellow height-16 width-100p"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-orange height-16 width-100p"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-red height-16 width-100p"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-darkred height-16 width-100p"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-wtrok-purple height-16 width-100p"
            })
        ]
    });
}




var $19db5d29d3cd1207$exports = {};
$19db5d29d3cd1207$exports = import.meta.resolve("apnEV");


var $b8c5103aa5a2e4b6$exports = {};
$b8c5103aa5a2e4b6$exports = import.meta.resolve("1kR9S");


var $b3cdbba8917973ca$exports = {};
$b3cdbba8917973ca$exports = import.meta.resolve("dHQnF");


var $4c6db5ff96ea7bdb$exports = {};
$4c6db5ff96ea7bdb$exports = import.meta.resolve("co2j1");




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $ea833cac136696ce$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    lair: false,
    setLair: (b)=>{},
    revealed: false,
    setRevealed: (b)=>{}
});
const $ea833cac136696ce$var$TripleOaksProvider = ({ children: children })=>{
    const [lair, setLair] = (0, $acw62.useState)(false);
    const [revealed, setRevealed] = (0, $acw62.useState)(false);
    const value = (0, $acw62.useMemo)(()=>({
            lair: lair,
            setLair: setLair,
            revealed: revealed,
            setRevealed: setRevealed
        }), [
        lair,
        setLair,
        revealed,
        setRevealed
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ea833cac136696ce$var$context.Provider, {
        value: value,
        children: children
    });
};
$ea833cac136696ce$var$TripleOaksProvider.context = $ea833cac136696ce$var$context;
var $ea833cac136696ce$export$2e2bcd8739ae039 = $ea833cac136696ce$var$TripleOaksProvider;








function $32976ef980cdb4b4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ca19742b74835a8$exports))),
        className: "anime-divider"
    });
}





var $acw62 = parcelRequire("acw62");


function $3f6ccaee92d797f6$export$8b9d430e8b6f4bd9(props) {
    let animationFrame;
    const width = 64;
    const height = 64;
    const slowing = 0.95;
    const rotSpeed = 3;
    const speed = 20;
    const pad = 4;
    const [pos, setPos] = (0, $acw62.useState)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(props.x - width / 2, props.y - height / 2));
    const posRef = (0, $acw62.useRef)(pos);
    const rotRef = (0, $acw62.useRef)(0);
    const velRef = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const speedRef = (0, $acw62.useRef)(0);
    const cursorRef = (0, $acw62.useRef)(new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(0, 0));
    const onMouseMove = (e)=>{
        if (props.wrapper) {
            const boundingRect = props.wrapper.getBoundingClientRect();
            cursorRef.current.x = e.clientX - boundingRect.left;
            cursorRef.current.y = e.clientY - boundingRect.top;
        } else {
            cursorRef.current.x = e.clientX;
            cursorRef.current.y = e.clientY;
        }
    };
    const onUpdate = ()=>{
        let diffX = cursorRef.current.x - (posRef.current.x - window.scrollX);
        let diffY = cursorRef.current.y - (posRef.current.y - window.scrollY);
        const dist = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
        if (dist < props.r && dist > 0) {
            const distLerp = 1 - dist / props.r;
            velRef.current.x = -diffX / dist;
            velRef.current.y = -diffY / dist;
            speedRef.current = Math.max(speedRef.current, distLerp);
            rotRef.current += distLerp * (diffX > 0 ? rotSpeed : -rotSpeed);
        }
        const newPos = new (0, $f15fd37f3c71009b$export$2e2bcd8739ae039)(posRef.current.x, posRef.current.y);
        newPos.x += velRef.current.x * speedRef.current * speed;
        newPos.y += velRef.current.y * speedRef.current * speed;
        if (newPos.x >= window.innerWidth - width - pad && velRef.current.x > 0) {
            velRef.current.x = -velRef.current.x;
            newPos.x = window.innerWidth - width - pad;
        }
        if (newPos.x <= pad && velRef.current.x < 0) {
            velRef.current.x = -velRef.current.x;
            newPos.x = pad;
        }
        if (newPos.y >= window.innerHeight - height - pad && velRef.current.y > 0) {
            velRef.current.y = -velRef.current.y;
            newPos.y = window.innerHeight - height - pad;
        }
        if (newPos.y <= pad && velRef.current.y < 0) {
            velRef.current.y = -velRef.current.y;
            newPos.y = pad;
        }
        speedRef.current *= slowing;
        posRef.current.x = newPos.x;
        posRef.current.y = newPos.y;
        setPos(newPos);
    };
    const init = ()=>{
        window.addEventListener("mousemove", onMouseMove);
        loop();
    };
    const loop = ()=>{
        onUpdate();
        animationFrame = requestAnimationFrame(loop);
    };
    (0, $acw62.useEffect)(()=>{
        init();
        return ()=>{
            cancelAnimationFrame(animationFrame);
            window.removeEventListener("mousemove", onMouseMove);
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ab-div",
        style: {
            top: pos.y,
            left: pos.x,
            width: width,
            height: height,
            transform: 'rotate(' + rotRef.current + 'deg)'
        },
        children: props.content
    });
}



var $41687c73747d2db9$exports = {};
$41687c73747d2db9$exports = import.meta.resolve("juM6G");


var $5e93ac325a9518dc$exports = {};
$5e93ac325a9518dc$exports = import.meta.resolve("79B9n");



function $d7b79fd1351ba96e$export$14b0c8573b6c494b(props) {
    const count = 64;
    const index = Math.round(Math.random() * count);
    let elements = [];
    for(let i = 0; i < count; i++){
        const w = 64;
        const h = 48;
        if (i == count - 1) {
            const x = Math.random() * (window.innerWidth - w - 8);
            const y = 512 + Math.random() * (window.innerHeight - h - 8 - 512);
            elements.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f847b33720aceef$export$da18f7b9a566a9ea), {
                id: "gec101",
                targetId: "gec101-tar",
                onTarget: props.onTarget,
                x: x,
                y: y,
                "z-index": 9999,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    id: "gec101",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($41687c73747d2db9$exports))),
                    style: {
                        width: 64,
                        height: 48
                    }
                })
            }, i));
        } else {
            const x = Math.random() * (window.innerWidth - w - 8);
            const y = Math.random() * (window.innerHeight - h - 8);
            elements.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f6ccaee92d797f6$export$8b9d430e8b6f4bd9), {
                x: x,
                y: y,
                w: w,
                h: h,
                r: Math.max(w, h),
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e1763e3299c07fa2$exports))),
                    style: {
                        width: w,
                        height: h
                    }
                })
            }, i));
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "main-body",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                id: "gec101-tar",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5e93ac325a9518dc$exports))),
                style: {
                    color: '#000000',
                    width: 66,
                    height: 50,
                    position: 'absolute',
                    left: window.innerWidth / 2 - 65,
                    top: window.innerHeight / 2 + 120
                }
            }),
            elements
        ]
    });
}


var $e1b6783d4a7d9d7d$exports = {};
$e1b6783d4a7d9d7d$exports = import.meta.resolve("jnY29");


var $2eae98e747d4233f$exports = {};
$2eae98e747d4233f$exports = import.meta.resolve("7Jzhx");



parcelRequire("acw62");

class $56d116b4d7a6356a$export$2645e55fc2753805 {
    headerClass = undefined;
    containerClass = undefined;
    contentsClass = undefined;
    headerContents = [];
    updates = [];
}
function $56d116b4d7a6356a$export$d5d3883e7641d85d(props) {
    const headerClass = props.headerClass !== undefined ? props.headerClass : 'site-update-box-header';
    const containerClass = props.containerClass !== undefined ? props.containerClass : 'site-update-box-container';
    const contentsClass = props.contentsClass !== undefined ? props.contentsClass : 'site-update-box-contents';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: containerClass,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: headerClass,
                children: props.headerContents
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: contentsClass,
                children: props.updates.map((u, i)=>{
                    const update = u;
                    update.id = 'site-update-' + i.toString();
                    return $56d116b4d7a6356a$export$f517e0371bd4c6bd(update);
                })
            })
        ]
    });
}
class $56d116b4d7a6356a$export$82a32afa9e4df1ac {
    headerContents = [];
    bodyContents = [];
    mainClass = undefined;
    headerClass = undefined;
    bodyClass = undefined;
    id = undefined;
}
function $56d116b4d7a6356a$export$f517e0371bd4c6bd(props) {
    const mainClass = props.mainClass !== undefined ? props.mainClass : 'site-update-main';
    const headerClass = props.headerClass !== undefined ? props.headerClass : 'site-update-header';
    const bodyClass = props.bodyClass !== undefined ? props.bodyClass : 'site-update-body';
    let id = props.id !== undefined ? props.id : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: mainClass,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: headerClass,
                children: props.headerContents
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: bodyClass,
                children: props.bodyContents
            })
        ]
    }, id);
}


function $270760d91b7a5d2e$export$a24192fcf575abf4(props) {
    const trokContext = (0, $acw62.useContext)((0, $ea833cac136696ce$export$2e2bcd8739ae039).context);
    const [seen, setSeen] = (0, $acw62.useState)(trokContext.lair);
    const [revealed, setRevealed] = (0, $acw62.useState)(trokContext.revealed);
    (0, $acw62.useEffect)(()=>{
        setSeen(trokContext.lair);
        setRevealed(trokContext.revealed);
    }, [
        trokContext
    ]);
    const revealedSection = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: "WELCOME \u2026 TO YOUR DOOM!!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Just Kidding..."
            }),
            "\xa0",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "wlair-red",
                children: "STOP!!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e1b6783d4a7d9d7d$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: "Welcome\u2026 TO MY HOME!!!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "You found me!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "I am the Webmaster of this site! Nice to meet you. This is my little corner of the world. I\u2019d enjoy pina coladas and getting lost in the rain if I wasn\u2019t stuck in my computer rofl. I help the local folks out by maintaining this website, so if you see anything weird, let me know! I\u2019ll make it worse! Just joshing. See, isn\u2019t this fun already? Are you having fun? Better start!\xa0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2eae98e747d4233f$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $729be54a6ff46139$export$6b40d0162fab68e5), {
                id: "wlair-webmaster",
                slot: "wlair-webmaster-slot",
                lock: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e4c87942015340$export$4a7108e5554afff8), {
                    id: 'wlair-webmaster',
                    ascii: (0, (/*@__PURE__*/$parcel$interopDefault($d8b801afb9641d7d$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    children: "Artist's rendition of the artist"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Things I\u2019ve been Enjoying Lately [4-15-99]"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "iSpy books"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Trolling forums"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Hiding things from my boss shhhh"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "This new website called Napster. There\u2019s so much music on there! ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "/",
                                    children: "Check it!!!"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56d116b4d7a6356a$export$d5d3883e7641d85d), {
                headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Site Updates"
                }),
                updates: [
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "2-5-2001"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Going dark. Apparently my web design is too \u201Cunprofessional\u201D and \u201Cwhimsical.\u201D Site will no longer be maintained. I was asked to stop updates to avoid confusion, so I\u2019m just gonna bounce. If you know where to find me, find me there. Smell ya later."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-8-2000"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Town received a grant for modernization! I\u2019m told this means we can build a brand new, beautiful site. Many pages going under construction to test new styling. Do not be alarmed!\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-1-2000"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Can anyone hear me in the new millennium? Did we survive? If we can do that together, we can do anything. Invented hoverboards and that robot dog from the Jetsons. Website didn\u2019t crash. HAPPY NEW YEAR!"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "12-31-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Oops lol I thought there were 30 days in December. THIS IS MY FINAL MESSAGE. SEE YOU IN THE FUTURE\u2026 I HOPE."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "12-30-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "If all the tech goes away at midnight, know that this has been da bomb. I\u2019ll miss you Triple Oaks! ZEEP ZOOB FOR4EVER.\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "11-24-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added cursor effects and dog that follows your mouse around. Gonna spend time on my side projects for the holidays in case the whole internet blows up, and I can\u2019t do this anymore.\xa0\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "9-1-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Oh snap! Thanks for all the quotes! I got soooooo many. Keep them coming, especially if you have one you want to send but were worried I\u2019d be overwhelmed. I\u2019m not, so keep \u2018em coming.\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-27-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added a daily quotes section. Send me your favorites, and you might see them on the town website!\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-1-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added some side projects to the web ring. Go support my friends, or add us to yours!\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "7-18-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Updated community calendar. Added a music player! Been finding lots of cool music on Naps and wanted to share it."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "6-20-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Poke poke"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "6-17-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added visitor counter to the site. We may be a small town, but we\u2019re the life of the party once you get to know us. I wonder if Kevin is one of those numbers."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "6-15-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "I\u2019ve added an extra period somewhere on this website. Email me if you find it, and I\u2019ll give you a prize."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "6-10-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Moved community calendar to its own page so the home page is cleaner.\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "6-1-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Kevin moved away, so it\u2019s just you and me everyone. When the cat\u2019s away, eh? As Kevin used to say, \u201CThe show must go on.\u201D"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "5-12-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added URL not found page, sprinkled a little fun in.\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "4-1-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Psyche!! ROFLOL everyone calm down. I was just yankin your chain. I am fine. All belong to Planet Zeep Zoob though."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "4-1-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Ughhhh what happened?? How long was I out. My computer blue screened and I heard a terrible sound. Wait- why is everything on the page space themed? Did one of you do this?"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "4-1-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Beep boop. I am an alien from a distant galaxy. I heard about your \u201Ccool\u201D webbed site and have taken it for my planet. All belong to Planet Zeep Zoob!! ZEEEEEEEEEP!!! I have abducted your web\u2019s master for experiments."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "3-3-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "improved performance, fixed typo on community calendar- k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-8-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "News archive added, now hosts articles from the not too distant past. I feel like an old timey paper boy. Extra Extra! Read all about our fun little town!"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "9-10-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Changed theme for fall, leaves are now orange. Updated Community Calendar for the holidays! What are you going to get me?"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "7-19-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Changed home page display, width of boxes expanded"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "5-16-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "updated tourism mentions to be compliant -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "4-2-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Website is normal again :\\"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "4-1-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "APRIL FOOLS! I was never in a hot air balloon. Did I fool you? Will change the balloon images and cursor back tomorrow."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "4-1-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "I\u2019m giving up web design to travel the world in a hot air balloon. This website is now to catalogue my travels. I am reaching out through the world\u2019s longest ethernet cable.",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "Traveller\u2019s Log Day 1. It is cold up here, despite the fire inflating my hot air balloon with hot air. You would think hot air balloons would be hotter. Everything looks so small from up here. Little ants going about their business, instead of freezing to death in a wicker basket in the sky. The town of Triple Oaks is but a blip on the map now, a place I am from not a place that I am",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "Traveller\u2019s Log Day 2: I am beginning to wonder if I should have planned more for this venture. Hunger encroaches from every angle. I am like the fire that keeps me afloat, insatiable. I propel others to new heights, but what am I? A void for fuel? At least I am a whimsical one."
                            ]
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "2-25-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Updated What To Do and Home for notable tourism spots and highlights."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "12-30-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "kevin page removed -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "10-31-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Ate too much candy\u2026 but just one more byte ROFL. Happy Halloween!"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "10-23-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Trick or Treating schedule uploaded. Added Halloween icons for atmosphere. Be safe, and don\u2019t forget to check your candy! Trick or Treat for Unicef boxes available at library."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "10-13-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Updated Home to include founder\u2019s story. Said Flushle so much it no longer sounds real. Flushle Flushle flushle flushle flushle flushle"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "9-18-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added Kevin page again. Thanks Mrs Gunkley for the help! Now Kevin will never find it muhahaha\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "9-15-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "kevin page removed -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "9-3-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "What To Do section, Site Map added, Kevin Is My Best Friend page added"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-26-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "New author appears! Hello! I will be taking the seat of Webmaster from this point on. Thanks for keeping my cyber seat warm, Kevin. I\u2019m just a hobbyist helping out my friends who work for the town, so everyone be nice! :3"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-23-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "roger. test a success. don\u2019t yell lol -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-22-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "TEST TEST TEST TEST!!! CAN YOU HEAR ME NOW??"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-21-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "site performance issues resolved. help brought on to maintain site. last update was a test - k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-20-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Can you hear me?"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "5-14-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "typos fixed, broken links updated -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "3-5-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "town logo updated -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-10-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "site launched"
                        })
                    }
                ]
            })
        ]
    });
    return seen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "wlair-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($270760d91b7a5d2e$var$WebmasterBackground, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "wlair-content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "THE WEBMASTER'S LAIR"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32976ef980cdb4b4$export$2e2bcd8739ae039), {}),
                    revealed ? revealedSection : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "wlair-gap"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7b79fd1351ba96e$export$14b0c8573b6c494b), {
                onTarget: ()=>{
                    trokContext.setRevealed(true);
                }
            })
        ]
    }) : null;
}
function $270760d91b7a5d2e$var$WebmasterBackground() {
    const trokContext = (0, $acw62.useContext)((0, $ea833cac136696ce$export$2e2bcd8739ae039).context);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "wlair-bg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "wlair-bg-crack"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "wlair-bg-exit-a",
                onClick: ()=>{
                    trokContext.setLair(false);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "wlair-bg-exit-b",
                onClick: ()=>{
                    trokContext.setLair(false);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "wlair-bg-tr"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "wlair-bg-bot"
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");




function $4203da7486a3581a$export$5a57f017055ced45() {
    const execProvider = (0, $acw62.useContext)((0, $7486e87f2dee7e03$export$2e2bcd8739ae039).context);
    const style = execProvider.cmds.includes('iamblue') ? 'bg-clue' : 'trok-bg';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea833cac136696ce$export$2e2bcd8739ae039), {
        value: {},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "page-basic " + style,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "trok-header-box height-256 h-box center-all gap-16",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                id: "lefttree",
                                className: "filter-black height-128",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($19db5d29d3cd1207$exports)))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "v-box gap-8",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                        className: "trok-text text-48 shadow-black compact",
                                        children: [
                                            "Triple Oaks",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            "Municipal Website"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "trok-text text-24 font-italic compact",
                                        children: "Piscis in capulus factorem."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "trok-leaves",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b8c5103aa5a2e4b6$exports)))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "trok-body-width h-box gap-32",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "trok-side-width",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4203da7486a3581a$var$TripleOaksNav, {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        height: 128
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$910ae8079b2c2852), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "trok-side-width v-box gap-16",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "trok-info v-box",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "v-box text-center center-all padding-4 height-64 text-24 font-gill trok-text-color trok-body-color",
                                                children: "Today's Status"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "trok-info-body",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "trok-info-weather",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "trok-info-quote",
                                                            children: [
                                                                "\uD83E\uDD7A\uD83D\uDE4F ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                    children: "Hopeful"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                        "64\xb0 and \u2601\uFE0F Cloudy"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "trok-info v-box",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "v-box text-center center-all padding-4 height-64 text-24 font-gill trok-text-color trok-body-color",
                                                children: "Today's Quote"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "trok-info-body",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "trok-info-quote",
                                                        children: '"And we said, behold and benot befraid. The answers are before your eyes."'
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "trok-info-quote",
                                                        children: "Gorks 11:43"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "height-64"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "trok-info v-box",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "v-box text-center center-all padding-4 text-24 font-gill trok-text-color trok-body-color pos-rel",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4c6db5ff96ea7bdb$exports))),
                                                    className: "trok-email-icon"
                                                }),
                                                "Contact the Webmaster",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc15d8f06114a404$export$e048a3c6e5d2a624), {
                                                    onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        children: "Click Here!!!"
                                                    }),
                                                    offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "bg-black text-gray-dark",
                                                        children: "Click Here"
                                                    }),
                                                    stdOnClick: ()=>{
                                                        window.location.href = 'mailto:webmaster@tripleoaks.org';
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "height-64"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac4e059a2c538140$export$ea59b6255584f4ce), {
                                    stamps: [
                                        (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Anime,
                                        (0, $452a05b0d36845a0$export$cd58f743ba5bc404).TacoBongo,
                                        (0, $452a05b0d36845a0$export$cd58f743ba5bc404).WTROK,
                                        (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Cryptid,
                                        (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Weblair,
                                        (0, $452a05b0d36845a0$export$cd58f743ba5bc404).Phranks
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $270760d91b7a5d2e$export$a24192fcf575abf4), {})
            ]
        })
    });
}
function $4203da7486a3581a$var$TripleOaksNav() {
    const navigate = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-leaf-buttons",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "trok-leaf-button",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "trok-leaf-button-a",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3cdbba8917973ca$exports))),
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "trok-leaf-button-text",
                        onClick: ()=>navigate('/tripleoaks/'),
                        children: "Site Map"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "trok-leaf-button",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "trok-leaf-button-b",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3cdbba8917973ca$exports))),
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "trok-leaf-button-text",
                        onClick: ()=>navigate('/tripleoaks/construction'),
                        children: "News & Events"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "trok-leaf-button",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "trok-leaf-button-a",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3cdbba8917973ca$exports))),
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "trok-leaf-button-text",
                        onClick: ()=>navigate('/tripleoaks/lost'),
                        children: "What To Do"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "trok-leaf-button",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "trok-leaf-button-b",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3cdbba8917973ca$exports))),
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "trok-leaf-button-text",
                        onClick: ()=>navigate('/tripleoaks/what'),
                        children: "Our History"
                    })
                ]
            })
        ]
    });
}




var $46b7e08dd9444d07$exports = {};
$46b7e08dd9444d07$exports = import.meta.resolve("k1tle");


var $b2508b0bb3dbe77f$exports = {};
$b2508b0bb3dbe77f$exports = import.meta.resolve("loNfJ");




var $acw62 = parcelRequire("acw62");

var $6c9fbff3d4273811$exports = {};
$6c9fbff3d4273811$exports = import.meta.resolve("gJJkI");


var $7941bda74b6dd62b$exports = {};
$7941bda74b6dd62b$exports = import.meta.resolve("bAh6p");


var $dbac2e7d1bd4d77a$exports = {};
$dbac2e7d1bd4d77a$exports = import.meta.resolve("1grVv");


var $9f5712e5cd03ede4$exports = {};
$9f5712e5cd03ede4$exports = import.meta.resolve("aax1V");


var $2c1286e89ce833cb$exports = {};
$2c1286e89ce833cb$exports = import.meta.resolve("lP1EL");


function $6212a7aa17be6e51$export$7b75bdd71175d2fe(props) {
    const [code, setCode] = (0, $acw62.useState)('');
    const updateCode = (s)=>{
        if (s == '1143') {
            props.onSuccess();
            setCode('');
        } else setCode(s);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-blips",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "trok-blip",
                onClick: ()=>{
                    updateCode(code + '1');
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c9fbff3d4273811$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "trok-blip",
                onClick: ()=>{
                    updateCode(code + '2');
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7941bda74b6dd62b$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "trok-blip",
                onClick: ()=>{
                    updateCode(code + '3');
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dbac2e7d1bd4d77a$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "trok-blip",
                onClick: ()=>{
                    updateCode(code + '4');
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2c1286e89ce833cb$exports)))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "trok-blip",
                onClick: ()=>{
                    setCode('');
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9f5712e5cd03ede4$exports)))
                })
            })
        ]
    });
}
function $6212a7aa17be6e51$export$428d221d9d92619c(props) {
    const [code, setCode] = (0, $acw62.useState)('');
    const updateCode = (s)=>{
        if (s == props.pass) {
            props.onSuccess();
            setCode('');
        } else setCode(s);
    };
    const buttons = props.elements.map((e, i)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            onClick: ()=>{
                updateCode(code + (i + 1));
            },
            children: e
        }, i);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-blips",
        children: [
            buttons,
            props.clear
        ]
    });
}



var $acw62 = parcelRequire("acw62");



function $7540512296ff2cb5$export$b4d4e73308ac2e30() {
    const trokContext = (0, $acw62.useContext)((0, $ea833cac136696ce$export$2e2bcd8739ae039).context);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-main-width v-box gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "trok-main",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "trok-text",
                        children: "Welcome to Triple Oaks!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "trok-text text-white",
                            children: [
                                "Triple Oaks is a lively town nestled in the Heartland. ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "F"
                                }),
                                "ounded in 1828, Triple Oaks has a long, storied history of proud American fortitude and ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "i"
                                }),
                                "nnovation."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "trok-text text-white",
                            children: [
                                "Triple Oaks has multiple claims to fame! A beacon of agriculture, we grow many essential crops like cor",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "n"
                                }),
                                " and soybeans. We have also become popular with cryptozoologists camping out for a glimpse at local legen",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "d"
                                }),
                                "s like Mothfoot."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "trok-text text-white",
                            children: [
                                "Our town is most well-known for the Flushmore Toilet Factory. In 1993, Flushmore Enterprises revealed ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "M"
                                }),
                                "ount Flushmore to commemorate their history in our town. Through feast and famine, Flushmore ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    children: "E"
                                }),
                                "nterprises has supported this town and its 2400 residents, so if you\u2019re traveling along I-70, make sure to stop by and snap a pic of our town\u2019s great landmark!"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "trok-sp",
                        children: "This message is sponsored by Flushmore Enterprises."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6212a7aa17be6e51$export$7b75bdd71175d2fe), {
                        onSuccess: ()=>{
                            trokContext.setLair(true);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "trok-text",
                            children: "Want To Visit?"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            width: "100%",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($46b7e08dd9444d07$exports))),
                            className: "trok-box"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Check out ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "/tripleoaks/construction",
                                children: "[What to Do]"
                            }),
                            " for ways to immerse yourself in the local culture."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "trok-news-box",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34c3c3c781117e32$export$df63e0ab6c58b679), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b2508b0bb3dbe77f$exports))),
                                    className: "trok-news-icon"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "trok-news-box-a",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "trok-leaf-divider"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "trok-news-header",
                                        children: "TRIPLE OAKS IN THE NEWS"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "trok-leaf-divider"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56d116b4d7a6356a$export$d5d3883e7641d85d), {
                headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Site Updates"
                }),
                updates: [
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "2-5-2001"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Going dark on this site. They brought in an outside contractor to build the new site, so this one will be depreciated. Thanks for all the fish!  If you know where to find me, find me there."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-8-2000"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Town received a grant for modernization! I\u2019m told this means we can build a brand new, beautiful site. Many pages going under construction to test new styling. Do not be alarmed!\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-1-2000"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Can anyone hear me in the new millennium? Did we survive? If we can do that together, we can do anything. Invented hoverboards and that robot dog from the Jetsons. Website didn\u2019t crash. HAPPY NEW YEAR!"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "12-31-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "See you in the future.... I hope!"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-27-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added a daily quotes section. Send me your favorites, and you might see them on the town website!\xa0"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "6-17-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Added visitor counter to the site. We may be a small town, but we\u2019re the life of the party once you get to know us."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "3-3-1999"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "improved performance, fixed typo on community calendar"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "7-19-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Changed home page display, width of boxes expanded"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "5-16-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "updated tourism mentions to be compliant -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "2-25-1998"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Updated What To Do and Home for notable tourism spots and highlights."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "10-31-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Ate too much candy\u2026 but just one more byte ROFL. Happy Halloween!"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "10-23-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Trick or Treating schedule uploaded. Added Halloween icons for atmosphere. Be safe, and don\u2019t forget to check your candy! Trick or Treat for Unicef boxes available at library."
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-26-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "New author appears! Hello! I will be taking the seat of Webmaster from this point on. Thanks for keeping my cyber seat warm, Kevin. I\u2019m just a hobbyist helping out my friends who work for the town, so everyone be nice! X3"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-23-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "roger. test a success. don\u2019t yell lol -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-22-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "TEST TEST TEST TEST!!! CAN YOU HEAR ME NOW??"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-21-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "site performance issues resolved. help brought on to maintain site. last update was a test -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "8-20-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Can you hear me?"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "5-14-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "typos fixed, broken links updated -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "3-5-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "town logo updated -k"
                        })
                    },
                    {
                        headerContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: "1-10-1997"
                        }),
                        bodyContents: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "site launched"
                        })
                    }
                ]
            })
        ]
    });
}



function $4a15ffaab41ece3e$export$2ce35fbd1a63425c() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-main-width v-box gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Town Events"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: "All you need to know to get to know our town!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Triple Oaks is a wonderful place where stuff happens and people live.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "Nothing is here that shouldn't be here! Don't worry. Don't think. It's ok. You're maybe right to be suspicious but stop that anyway!",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "There are so many things happening here that it's hard to summarize all of them. Just know -- it's a great town with many interesting places. Come and see them! Just one little walkie through town and you'll be like -- oh, neat! Huh!"
                ]
            })
        ]
    });
}




function $d603eaddd4a0bf6e$export$9a4aed3567b76e59() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-main",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "What to Do"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Sights"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: "Sponsored by Flushmore Industries"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Go to Mt Flushmore and learn about history of industry"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Dining"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Diner"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Third Thing"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {})
        ]
    });
}



function $c07f7443fcf0c4b3$export$31a8f1515a761e86() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "trok-main-width v-box gap-32",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "History"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: "All you need to know to get to know our town!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Triple Oaks is a wonderful place where stuff happens and people live.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "Nothing is here that shouldn't be here! Don't worry. Don't think. It's ok. You're maybe right to be suspicious but stop that anyway!",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "There are so many things happening here that it's hard to summarize all of them. Just know -- it's a great town with many interesting places. Come and see them! Just one little walkie through town and you'll be like -- oh, neat! Huh!"
                ]
            })
        ]
    });
}




var $c19780c76d51a82c$exports = {};
$c19780c76d51a82c$exports = import.meta.resolve("g1oNj");


function $88a84b72e8b3c367$export$bab1812e1be7e1b4() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "trok-main-width v-box gap-32",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "trok-main",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "This Page is Under Construction."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Please Check Back Later."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c19780c76d51a82c$exports))),
                    width: "100%",
                    className: "trok-box"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
            ]
        })
    });
}





function $b2928e991d51b785$export$1bbafc480fb2d1be() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "trok-main-width v-box gap-32",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "trok-main",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "This Page is Lost."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: "Hopefully You Can Find It."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c19780c76d51a82c$exports))),
                    width: "100%",
                    className: "trok-box"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89499c873ca0823$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
            ]
        })
    });
}





var $47a45299b03072a1$exports = {};
$47a45299b03072a1$exports = import.meta.resolve("lzDYK");



function $94e7af8ae76e8cfe$export$6806ff6f5378ed2c() {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "trok-main-width v-box gap-32",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "trok-main gap-16",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($46b7e08dd9444d07$exports))),
                    width: "100%",
                    className: "trok-box"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($47a45299b03072a1$exports))),
                    width: "100%",
                    className: "trok-box"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "h-box gap-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($19db5d29d3cd1207$exports))),
                            className: "trok-tree height-128"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($19db5d29d3cd1207$exports))),
                            className: "trok-tree height-128",
                            onClick: ()=>{
                                nav("/vault");
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($19db5d29d3cd1207$exports))),
                            className: "trok-tree height-128"
                        })
                    ]
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");



var $6d7c61f07defa2c2$exports = {};
$6d7c61f07defa2c2$exports = import.meta.resolve("2COil");


var $ee532ff2bad67609$exports = {};
$ee532ff2bad67609$exports = import.meta.resolve("i9Rcf");


var $ef34ee6e3a3efdbc$exports = {};
$ef34ee6e3a3efdbc$exports = import.meta.resolve("h8ZzD");


var $61e230749787a262$exports = {};
$61e230749787a262$exports = import.meta.resolve("COTMA");


var $f4cb49b28ed0512f$exports = {};
$f4cb49b28ed0512f$exports = import.meta.resolve("jOQYG");


var $4a4aec6603fbfcf9$exports = {};
$4a4aec6603fbfcf9$exports = import.meta.resolve("5T7kw");


var $fa58764813a6e25a$exports = {};
$fa58764813a6e25a$exports = import.meta.resolve("1iWlt");


var $7a72188bbb14b3c4$exports = {};
$7a72188bbb14b3c4$exports = import.meta.resolve("lvTlS");







var $acw62 = parcelRequire("acw62");
var $8d670894deb7ad56$exports = {};
$8d670894deb7ad56$exports = import.meta.resolve("1ZRoU");







var $744e705e6e841b53$exports = {};
$744e705e6e841b53$exports = import.meta.resolve("gvlJ1");






function $4cb25ba68150abcd$export$45e38e1055f61f3f() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    var comp = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "v-box",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$IBLK, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "pos-fix v-box center-all no-events",
                    style: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$IINT, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$IGAME, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$IPRIZE, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$IPILE, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$OBONGO, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$IBONGO, {})
                    ]
                })
            ]
        });
    }, [
        tacoProvider.darkMode
    ]);
    return comp;
}
function $4cb25ba68150abcd$var$IBLK() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return tacoProvider.darkMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-fix bg-black opacity-90 v-box center-all yes-events",
        style: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        onClick: ()=>{
            if (tacoProvider.diningIn) tacoProvider.exitShop();
            else if (tacoProvider.gameOn) tacoProvider.exitGame(false);
        }
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}
function $4cb25ba68150abcd$var$IINT() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return tacoProvider.diningIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "pos-abs",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9d81fef9bb218f9c$exports))),
                style: {
                    width: 1500,
                    top: 64
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "pos-abs z-2",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4f79287fe64c6f72$exports))),
                style: {
                    width: 512,
                    top: 256
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "width-1024 taco-box z-1",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8d670894deb7ad56$exports)))
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}
function $4cb25ba68150abcd$var$IGAME() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return tacoProvider.gameOn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15923fa4c3209c93$export$e8f549601299870c), {
        onClick: ()=>{
        // ut(t + 1);
        }
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}
function $4cb25ba68150abcd$var$IPRIZE() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return tacoProvider.bongoStay && tacoProvider.diningIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$PrizePile, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}
function $4cb25ba68150abcd$var$OBONGO() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return tacoProvider.bongoStay && !tacoProvider.diningIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs z-2",
        style: {
            right: "18.5%",
            top: "37.5%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15923fa4c3209c93$export$e1adaf956eb84a5f), {
            height: 384
        })
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}
function $4cb25ba68150abcd$var$IBONGO() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return tacoProvider.bongoStay && tacoProvider.diningIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs z-2 bongo-enter",
        style: {
            right: "18.5%",
            top: "37.5%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15923fa4c3209c93$export$2049f84fee98b4ab), {})
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}
function $4cb25ba68150abcd$var$IPILE() {
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    const [eaten, setEaten] = (0, $acw62.useState)(0);
    let animationFrame = 0;
    let lastEatTime = Date.now() / 1000.0 + 1;
    const resetEatTime = ()=>{
        lastEatTime = Date.now() / 1000.0;
    };
    const autoUpdate = ()=>{
        const animate = tacoProvider.diningIn && tacoProvider.bongoStay;
        if (!animate) return;
        const currentTimeInSeconds = Date.now() / 1000.0;
        if (currentTimeInSeconds - lastEatTime > 1) {
            resetEatTime();
            setEaten(eaten + 1);
        }
    };
    const init = ()=>{
        loop();
    };
    const deinit = ()=>{
        cancelAnimationFrame(animationFrame);
    };
    const loop = ()=>{
        autoUpdate();
        animationFrame = requestAnimationFrame(loop);
    };
    (0, $acw62.useEffect)(()=>{
        init();
        return ()=>{
            deinit();
        };
    }, [
        tacoProvider,
        eaten
    ]);
    if (!tacoProvider.diningIn) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pos-abs yes-events",
        children: [
            eaten < 21 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 80,
                y: 64
            }) : null,
            eaten < 20 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 48,
                y: 64
            }) : null,
            eaten < 19 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 16,
                y: 64
            }) : null,
            eaten < 18 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -16,
                y: 64
            }) : null,
            eaten < 17 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -48,
                y: 64
            }) : null,
            eaten < 16 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -80,
                y: 64
            }) : null,
            eaten < 15 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 64,
                y: 34
            }) : null,
            eaten < 14 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 32,
                y: 34
            }) : null,
            eaten < 13 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 0,
                y: 34
            }) : null,
            eaten < 12 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -32,
                y: 34
            }) : null,
            eaten < 11 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -64,
                y: 34
            }) : null,
            eaten < 10 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 48,
                y: 4
            }) : null,
            eaten < 9 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 16,
                y: 4
            }) : null,
            eaten < 8 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -16,
                y: 4
            }) : null,
            eaten < 7 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -48,
                y: 4
            }) : null,
            eaten < 6 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 32,
                y: -26
            }) : null,
            eaten < 5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 0,
                y: -26
            }) : null,
            eaten < 4 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -32,
                y: -26
            }) : null,
            eaten < 3 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 16,
                y: -56
            }) : null,
            eaten < 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: -16,
                y: -56
            }) : null,
            eaten < 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4cb25ba68150abcd$var$Food, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($744e705e6e841b53$exports))),
                x: 0,
                y: -86
            }) : null
        ]
    }, "bongo-food-pile");
}
function $4cb25ba68150abcd$var$Food(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: props.src,
        className: "pos-abs width-64 z-4",
        style: {
            left: props.x,
            top: props.y
        }
    });
}
function $4cb25ba68150abcd$var$PrizePile() {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    const cursor = (0, $acw62.useContext)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039).context);
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pos-abs yes-events",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8c3dd32c4da10694$exports))),
            className: "pos-abs width-32 z-3 cursor-pointer",
            style: {
                left: 16,
                top: 48
            },
            onClick: ()=>{
                player.unlockCursor((0, $4d33f92596c93eff$export$e5e83cf1a7fb0861).key);
                cursor.setState((0, $ecf8a511bd2be543$export$4490bbf8c7a4868b).YOY);
            }
        })
    });
}


function $c009a6152ec85ea2$export$f76d35691779fb1b() {
    const player = (0, $acw62.useContext)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039).context);
    (0, $acw62.useEffect)(()=>{
        player.unlockSite((0, $5fc7b830e79d6137$export$575b2d92557d6d13).key);
    }, []);
    const page = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b129cf429da813cf$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "page-basic bg-taco v-box gap-64",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "height-32"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c009a6152ec85ea2$var$TACONav, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "v-box gap-64 padding-16 center-all pos-rel",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$910ae8079b2c2852), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c009a6152ec85ea2$export$e217cd2960c1628c, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cb25ba68150abcd$export$45e38e1055f61f3f), {})
                ]
            })
        });
    }, []);
    return page;
}
function $c009a6152ec85ea2$var$TACONav() {
    const nav = (0, $f0eb7f6a0a55da23$export$9770f232ac06a008)();
    const tacoProvider = (0, $acw62.useContext)((0, $b129cf429da813cf$export$2e2bcd8739ae039).context);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h-box gap-32 justify-start align-center pos-rel",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "width-256 height-192 cursor-pointer pos-rel ",
                onClick: ()=>{
                    nav('/tacobongo/');
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c009a6152ec85ea2$export$839f5a82c472e18c, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c009a6152ec85ea2$var$LogoBongoDoggo, {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-128 cursor-pointer v-box center-all",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($61e230749787a262$exports))),
                    className: "height-100p",
                    onClick: ()=>{
                        nav('/tacobongo/');
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-128 cursor-pointer v-box center-all",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4cb49b28ed0512f$exports))),
                    className: "height-100p",
                    onClick: ()=>{
                        nav('/tacobongo/menu');
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-128 cursor-pointer v-box justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4a4aec6603fbfcf9$exports))),
                    className: "height-100p",
                    onClick: ()=>{
                        nav('/tacobongo/findus');
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "pos-abs",
                onClick: ()=>{
                    tacoProvider.enterGame();
                },
                style: {
                    right: 0,
                    bottom: 0
                },
                children: "Play the Bongo Dressup Game!"
            })
        ]
    });
}
function $c009a6152ec85ea2$var$LogoBongoDoggo() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7a72188bbb14b3c4$exports))),
        className: "pos-abs width-192",
        style: {
            left: 32,
            bottom: 72
        }
    });
}
function $c009a6152ec85ea2$export$839f5a82c472e18c() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fa58764813a6e25a$exports))),
        className: "pos-abs width-256",
        style: {
            bottom: 0
        }
    });
}
function $c009a6152ec85ea2$export$e217cd2960c1628c() {
    const execProvider = (0, $acw62.useContext)((0, $7486e87f2dee7e03$export$2e2bcd8739ae039).context);
    const showp = execProvider.cmds.includes('bongo-down') ? true : false;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "v-box gap-16",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6212a7aa17be6e51$export$428d221d9d92619c), {
                pass: "111222111",
                elements: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "height-128",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6d7c61f07defa2c2$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "height-128",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ee532ff2bad67609$exports)))
                    })
                ],
                clear: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "height-64",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ef34ee6e3a3efdbc$exports)))
                }),
                onSuccess: ()=>{
                    execProvider.addCommand('bongo-down');
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "h-box width-100p center-all",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                    href: "",
                    className: "text-taco-pink font-taco-secondary text-24 text-center",
                    children: [
                        "Copyright 1998 Taco Bongo Inc.",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "All Rights Reserved.\xa0All Snacks Allowed ;)"
                    ]
                })
            })
        ]
    });
}



var $bc5573b93f43b5ec$exports = {};
$bc5573b93f43b5ec$exports = import.meta.resolve("9r0EI");


var $ddacdf4f65eb5a0b$exports = {};
$ddacdf4f65eb5a0b$exports = import.meta.resolve("dswGa");


var $f2945f8062db97b8$exports = {};
$f2945f8062db97b8$exports = import.meta.resolve("6KFQ7");


var $1c50a7771de32cf7$exports = {};
$1c50a7771de32cf7$exports = import.meta.resolve("9OYGJ");


var $2d3586820b428fb2$exports = {};
$2d3586820b428fb2$exports = import.meta.resolve("ayMox");


var $cee1beafb3d40be4$exports = {};
$cee1beafb3d40be4$exports = import.meta.resolve("7Ab5O");


var $7bd30829a82ec2a3$exports = {};
$7bd30829a82ec2a3$exports = import.meta.resolve("3quab");


var $6af7170564863609$exports = {};
$6af7170564863609$exports = import.meta.resolve("bdCGO");


var $892811e93911d6af$exports = {};
$892811e93911d6af$exports = import.meta.resolve("abkEk");


var $87a78b6be89e4fa7$exports = {};
$87a78b6be89e4fa7$exports = import.meta.resolve("9WUiF");


var $a79c3230af16b39e$exports = {};
$a79c3230af16b39e$exports = import.meta.resolve("cf1VD");


var $90eef92139409094$exports = {};
$90eef92139409094$exports = import.meta.resolve("gMmI5");


var $429cdd9eb113465c$exports = {};
$429cdd9eb113465c$exports = import.meta.resolve("icA3i");


var $7452ade0ba53c498$exports = {};
$7452ade0ba53c498$exports = import.meta.resolve("bcH0I");


var $b54a4f9f458fd219$exports = {};
$b54a4f9f458fd219$exports = import.meta.resolve("7pD9E");


var $01d691ac73d392c0$exports = {};
$01d691ac73d392c0$exports = import.meta.resolve("2qpWB");


var $8a60977c2cac4a7a$exports = {};
$8a60977c2cac4a7a$exports = import.meta.resolve("ddjIM");


var $d280f5a0c4420f7f$exports = {};
$d280f5a0c4420f7f$exports = import.meta.resolve("epzIi");


var $1c55936799ba1111$exports = {};
$1c55936799ba1111$exports = import.meta.resolve("2O1Nv");


var $af76d227e2b9325c$exports = {};
$af76d227e2b9325c$exports = import.meta.resolve("4eIyy");


var $3dd4b4d7a08f112f$exports = {};
$3dd4b4d7a08f112f$exports = import.meta.resolve("euWKh");


var $348ec51e4129f02d$exports = {};
$348ec51e4129f02d$exports = import.meta.resolve("f1f5x");


var $76d53d571226e38b$exports = {};
$76d53d571226e38b$exports = import.meta.resolve("lg80S");


var $cef2e1613f02d901$exports = {};
$cef2e1613f02d901$exports = import.meta.resolve("28MSt");


var $cf9be4b10685949d$exports = {};
$cf9be4b10685949d$exports = import.meta.resolve("83LNk");


var $313a21ce4e887fc7$exports = {};
$313a21ce4e887fc7$exports = import.meta.resolve("aV2Jf");


var $414aa6af98c7a4b7$exports = {};
$414aa6af98c7a4b7$exports = import.meta.resolve("iDlRQ");


var $037fcc862ede8fbd$exports = {};
$037fcc862ede8fbd$exports = import.meta.resolve("1JjEq");


var $ce12ce7dc5b1f31a$exports = {};
$ce12ce7dc5b1f31a$exports = import.meta.resolve("5otKj");


var $d0f130d9a8c4c2a0$exports = {};
$d0f130d9a8c4c2a0$exports = import.meta.resolve("1W7lk");


var $b728d9d361b66ba2$exports = {};
$b728d9d361b66ba2$exports = import.meta.resolve("dVkXl");


var $273b0ff4090b7c59$exports = {};
$273b0ff4090b7c59$exports = import.meta.resolve("fuIKn");


var $89926e841badc7f0$exports = {};
$89926e841badc7f0$exports = import.meta.resolve("bGNiO");


var $ebf62314e12810ed$exports = {};
$ebf62314e12810ed$exports = import.meta.resolve("klrUN");


var $55ff12855d0e98e2$exports = {};
$55ff12855d0e98e2$exports = import.meta.resolve("98FRt");


var $16bb1c69e8fd3f29$exports = {};
$16bb1c69e8fd3f29$exports = import.meta.resolve("bRkmh");


var $ad39600717d4d7f6$exports = {};
$ad39600717d4d7f6$exports = import.meta.resolve("hmTOj");


var $5f38420ca2c903f4$exports = {};
$5f38420ca2c903f4$exports = import.meta.resolve("45Y2G");


var $5233de8b041828ed$exports = {};
$5233de8b041828ed$exports = import.meta.resolve("ckvQP");


var $b08316d376c5b88e$exports = {};
$b08316d376c5b88e$exports = import.meta.resolve("bRP9N");


var $55ea610464601864$exports = {};
$55ea610464601864$exports = import.meta.resolve("ci3N0");


var $0acddb56a9a87964$exports = {};
$0acddb56a9a87964$exports = import.meta.resolve("1l1Tu");


var $2a7b63c7347e06f9$exports = {};
$2a7b63c7347e06f9$exports = import.meta.resolve("49REr");


var $d956e3b25c1f387a$exports = {};
$d956e3b25c1f387a$exports = import.meta.resolve("i80c4");


var $5fddc6130e7f5573$exports = {};
$5fddc6130e7f5573$exports = import.meta.resolve("3M3Uu");


var $d30b27012b6809a4$exports = {};
$d30b27012b6809a4$exports = import.meta.resolve("92aFX");


var $c431db6cd175c359$exports = {};
$c431db6cd175c359$exports = import.meta.resolve("9gptG");


var $64dfe0662d3813c7$exports = {};
$64dfe0662d3813c7$exports = import.meta.resolve("2YLsv");


var $38565ca71af535b0$exports = {};
$38565ca71af535b0$exports = import.meta.resolve("cOj3J");


var $899ba73f9a4a68ad$exports = {};
$899ba73f9a4a68ad$exports = import.meta.resolve("dB9Qn");


var $2642db04896f2d39$exports = {};
$2642db04896f2d39$exports = import.meta.resolve("kGU08");


var $bde60f001ba2dd2a$exports = {};
$bde60f001ba2dd2a$exports = import.meta.resolve("grkqb");


var $83df072af4dd4f65$exports = {};
$83df072af4dd4f65$exports = import.meta.resolve("kKrp6");


var $680bde1eb99e24da$exports = {};
$680bde1eb99e24da$exports = import.meta.resolve("hAVGh");


var $0e0fa05199ae0e22$exports = {};
$0e0fa05199ae0e22$exports = import.meta.resolve("cjNAM");


var $01d6873eda608114$exports = {};
$01d6873eda608114$exports = import.meta.resolve("eQRAU");


var $a9086239052530d9$exports = {};
$a9086239052530d9$exports = import.meta.resolve("4vO4m");


var $00b3b02a36e74105$exports = {};
$00b3b02a36e74105$exports = import.meta.resolve("ilJYq");


var $759b49d2a67646a4$exports = {};
$759b49d2a67646a4$exports = import.meta.resolve("8LNBl");


var $5a67595817a9a179$exports = {};
$5a67595817a9a179$exports = import.meta.resolve("6KwkM");


var $6d28e58a88aeb87c$exports = {};
$6d28e58a88aeb87c$exports = import.meta.resolve("gp285");


var $52cfcf74a059e231$exports = {};
$52cfcf74a059e231$exports = import.meta.resolve("l0rmP");


var $b1d0770bc227bb8d$exports = {};
$b1d0770bc227bb8d$exports = import.meta.resolve("5mxyK");


var $5ab2967b95ba6fc7$exports = {};
$5ab2967b95ba6fc7$exports = import.meta.resolve("9IilR");


var $36d1c79ae277b94a$exports = {};
$36d1c79ae277b94a$exports = import.meta.resolve("iiCCQ");


var $84ce8bac51bc05d6$exports = {};
$84ce8bac51bc05d6$exports = import.meta.resolve("bhYM1");


var $883ea24eab0caa77$exports = {};
$883ea24eab0caa77$exports = import.meta.resolve("apydy");


var $aad65c2b9b6cdc82$exports = {};
$aad65c2b9b6cdc82$exports = import.meta.resolve("b08ZN");


var $2c1e36b4c814491f$exports = {};
$2c1e36b4c814491f$exports = import.meta.resolve("6dMmm");


var $f17ccfae634ff1af$exports = {};
$f17ccfae634ff1af$exports = import.meta.resolve("2GTcA");


var $28397bb45f149fbf$exports = {};
$28397bb45f149fbf$exports = import.meta.resolve("cfSGB");


var $90c21383a532db50$exports = {};
$90c21383a532db50$exports = import.meta.resolve("70GQi");


var $7ba0922fd31a5053$exports = {};
$7ba0922fd31a5053$exports = import.meta.resolve("luhvQ");


var $5cbf05518d77b22c$exports = {};
$5cbf05518d77b22c$exports = import.meta.resolve("5w4IF");


var $4d8d2b1ee09b4629$exports = {};
$4d8d2b1ee09b4629$exports = import.meta.resolve("dieDU");


var $4720666293f8fa7d$exports = {};
$4720666293f8fa7d$exports = import.meta.resolve("fq3di");


var $1f6809265c1957d2$exports = {};
$1f6809265c1957d2$exports = import.meta.resolve("nKAvO");


var $7a95ec75862f08de$exports = {};
$7a95ec75862f08de$exports = import.meta.resolve("1ZlpP");


var $18f4c4b51668a76f$exports = {};
$18f4c4b51668a76f$exports = import.meta.resolve("gCHXY");


var $b3ef2b99255c5014$exports = {};
$b3ef2b99255c5014$exports = import.meta.resolve("2joDU");


var $f1af15010c8f2fa6$exports = {};
$f1af15010c8f2fa6$exports = import.meta.resolve("kltkI");


var $9836542118e9147a$exports = {};
$9836542118e9147a$exports = import.meta.resolve("7OOng");


var $410d82fcf5818ba4$exports = {};
$410d82fcf5818ba4$exports = import.meta.resolve("5Dimp");


var $d1879323df6a0b9e$exports = {};
$d1879323df6a0b9e$exports = import.meta.resolve("cO2U4");


var $da4d6cba2e26646d$exports = {};
$da4d6cba2e26646d$exports = import.meta.resolve("jodOU");


var $13a37e2e423687cc$exports = {};
$13a37e2e423687cc$exports = import.meta.resolve("lninO");


var $4e9d78572904d31b$exports = {};
$4e9d78572904d31b$exports = import.meta.resolve("d5Bbc");


var $6bd9df253f0e05ac$exports = {};
$6bd9df253f0e05ac$exports = import.meta.resolve("hbJ6S");



var $acw62 = parcelRequire("acw62");

const $73d83df6edf9a422$var$STD_WIDTH = 2100;
const $73d83df6edf9a422$var$STD_HEIGHT = 1500;
function $73d83df6edf9a422$export$3d4e061e759e2816() {
    const width = 960;
    const [bl, setBL] = (0, $acw62.useState)(0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "page-basic bg-black v-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-64"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pos-rel mask-content",
                style: {
                    width: width,
                    height: width * $73d83df6edf9a422$var$STD_HEIGHT / $73d83df6edf9a422$var$STD_WIDTH
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bc5573b93f43b5ec$exports))),
                        left: -7.33,
                        top: -12.6,
                        width: 124.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ddacdf4f65eb5a0b$exports))),
                        left: 35.57,
                        top: 79.20,
                        width: 9.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$STC1, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1c50a7771de32cf7$exports))),
                        left: 7.62,
                        top: 86.73,
                        width: 31.05,
                        style: {
                            transform: "rotateZ(-1.5deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4d8d2b1ee09b4629$exports))),
                        left: 80.48,
                        top: 20.73,
                        width: 12.14,
                        height: 15.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2d3586820b428fb2$exports))),
                        left: 80.90,
                        top: 30.20,
                        width: 11.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cee1beafb3d40be4$exports))),
                        left: 74.00,
                        top: 10.47,
                        width: 15.86,
                        height: 21.40,
                        style: {
                            transform: "rotateZ(10deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7bd30829a82ec2a3$exports))),
                        left: 68.43,
                        top: 23.47,
                        width: 5.76,
                        style: {
                            transform: "rotateZ(-5deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6af7170564863609$exports))),
                        left: 63.05,
                        top: 1.53,
                        width: 14.52,
                        height: 23.07
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($892811e93911d6af$exports))),
                        left: 63.29,
                        top: 2.60,
                        width: 13.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6af7170564863609$exports))),
                        left: 48.10,
                        top: 16.80,
                        width: 16.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6af7170564863609$exports))),
                        left: 63.76,
                        top: 29.00,
                        width: 10.62
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6af7170564863609$exports))),
                        left: 36.57,
                        top: 41.93,
                        width: 17.33,
                        height: 17.60
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($87a78b6be89e4fa7$exports))),
                        left: 2.67,
                        top: 17.87,
                        width: 17.10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a79c3230af16b39e$exports))),
                        left: 64.43,
                        top: 30.87,
                        width: 10.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($90eef92139409094$exports))),
                        left: 6.38,
                        top: 22.33,
                        width: 7.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($429cdd9eb113465c$exports))),
                        left: 12.05,
                        top: 0.53,
                        width: 17.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FL1, {
                        bl: bl,
                        setBL: setBL
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b54a4f9f458fd219$exports))),
                        left: 17.76,
                        top: 2.13,
                        width: 10.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($01d691ac73d392c0$exports))),
                        left: 14.90,
                        top: 25.40,
                        width: 10.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a60977c2cac4a7a$exports))),
                        left: 13.71,
                        top: 17.40,
                        width: 8.43,
                        style: {
                            transform: "rotateZ(2deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d280f5a0c4420f7f$exports))),
                        left: 15.71,
                        top: 5.13,
                        width: 5.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1c55936799ba1111$exports))),
                        left: 7.43,
                        top: 6.67,
                        width: 7.95
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($af76d227e2b9325c$exports))),
                        left: -4,
                        top: -3.47,
                        width: 15.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4720666293f8fa7d$exports))),
                        left: 45.52,
                        top: 59.80,
                        width: 8.00,
                        height: 17.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4720666293f8fa7d$exports))),
                        left: 39.10,
                        top: 66.93,
                        width: 6.10,
                        height: 11.20
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3dd4b4d7a08f112f$exports))),
                        left: 23.62,
                        top: 19.27,
                        width: 17.05,
                        style: {
                            transform: "rotateZ(-2.5deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($348ec51e4129f02d$exports))),
                        left: 25.87,
                        top: 27.53,
                        width: 11.05,
                        style: {
                            transform: "rotateZ(20deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6af7170564863609$exports))),
                        left: 31.00,
                        top: 14.47,
                        width: 10.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($76d53d571226e38b$exports))),
                        left: 40.24,
                        top: 67.27,
                        width: 3.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cef2e1613f02d901$exports))),
                        left: 45.67,
                        top: 59.67,
                        width: 7.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cf9be4b10685949d$exports))),
                        left: 42.86,
                        top: 75.47,
                        width: 9.76
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($313a21ce4e887fc7$exports))),
                        left: -3.52,
                        top: 72.00,
                        width: 14.14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($414aa6af98c7a4b7$exports))),
                        left: 0.00,
                        top: 55.80,
                        width: 10.52
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($037fcc862ede8fbd$exports))),
                        left: 3.52,
                        top: 91.07,
                        width: 10.81
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FL2, {
                        bl: bl,
                        setBL: setBL
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d0f130d9a8c4c2a0$exports))),
                        left: 3.33,
                        top: 91.40,
                        width: 5.62
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b728d9d361b66ba2$exports))),
                        left: 50.71,
                        top: 85.80,
                        width: 10.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($273b0ff4090b7c59$exports))),
                        left: 55.95,
                        top: 72.60,
                        width: 25.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($89926e841badc7f0$exports))),
                        left: 70.19,
                        top: 66.20,
                        width: 36.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ebf62314e12810ed$exports))),
                        left: 31.76,
                        top: 89.93,
                        width: 33.14,
                        style: {
                            transform: "rotateZ(4.5deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($55ff12855d0e98e2$exports))),
                        left: 40.24,
                        top: 87.80,
                        width: 14.81,
                        style: {
                            transform: "scaleY(-1) rotateZ(-163deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($16bb1c69e8fd3f29$exports))),
                        left: 32.62,
                        top: 75.93,
                        width: 7.38,
                        style: {
                            transform: "scaleY(-1) rotateZ(-125deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d0f130d9a8c4c2a0$exports))),
                        left: 25.29,
                        top: 39.80,
                        width: 11.24
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ad39600717d4d7f6$exports))),
                        left: 14.29,
                        top: 34.93,
                        width: 6.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5f38420ca2c903f4$exports))),
                        left: 35.14,
                        top: -1.2,
                        width: 12.76
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5233de8b041828ed$exports))),
                        left: 54.90,
                        top: 3.47,
                        width: 6.29
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b08316d376c5b88e$exports))),
                        left: 47.67,
                        top: 1.93,
                        width: 7.62,
                        style: {
                            transform: "rotateZ(-12deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($55ea610464601864$exports))),
                        left: 49.81,
                        top: 9.60,
                        width: 5.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($55ea610464601864$exports))),
                        left: 44.52,
                        top: 9.60,
                        width: 5.71,
                        class: "flip-h"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0acddb56a9a87964$exports))),
                        left: 92.29,
                        top: 41.40,
                        width: 7.52,
                        style: {
                            transform: "rotateZ(-26deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2a7b63c7347e06f9$exports))),
                        left: 91.14,
                        top: 2.00,
                        width: 6.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$STC2, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FL3, {
                        bl: bl,
                        setBL: setBL
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d30b27012b6809a4$exports))),
                        left: 78.76,
                        top: 5.67,
                        width: 11.62
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c431db6cd175c359$exports))),
                        left: 80.05,
                        top: 20.07,
                        width: 8.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($64dfe0662d3813c7$exports))),
                        left: 82.00,
                        top: 36.27,
                        width: 5.33,
                        style: {
                            transform: "rotateZ(31deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($64dfe0662d3813c7$exports))),
                        left: 75.90,
                        top: -3.6,
                        width: 7.19,
                        style: {
                            transform: "scaleY(-1) rotateZ(-106deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($38565ca71af535b0$exports))),
                        left: 78.29,
                        top: 52.40,
                        width: 13.14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($899ba73f9a4a68ad$exports))),
                        left: 84.52,
                        top: 55.73,
                        width: 2.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($899ba73f9a4a68ad$exports))),
                        left: 83.52,
                        top: 56.07,
                        width: 2.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2642db04896f2d39$exports))),
                        left: 78.29,
                        top: 64.07,
                        width: 8.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$STC3, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($83df072af4dd4f65$exports))),
                        left: 72.43,
                        top: 38.73,
                        width: 9.38
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($680bde1eb99e24da$exports))),
                        left: 76.76,
                        top: 39.73,
                        width: 5.10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0e0fa05199ae0e22$exports))),
                        left: 75.48,
                        top: 47.93,
                        width: 2.62
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($01d6873eda608114$exports))),
                        left: 48.05,
                        top: 22.53,
                        width: 7.81
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a9086239052530d9$exports))),
                        left: 48.71,
                        top: 20.07,
                        width: 14.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($00b3b02a36e74105$exports))),
                        left: 56.67,
                        top: 42.60,
                        width: 6.90,
                        style: {
                            transform: "rotateZ(2.5deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($759b49d2a67646a4$exports))),
                        left: 53.24,
                        top: 47.47,
                        width: 9.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5a67595817a9a179$exports))),
                        left: 46.81,
                        top: 37.67,
                        width: 6.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6d28e58a88aeb87c$exports))),
                        left: 37.19,
                        top: 37.73,
                        width: 5.14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($52cfcf74a059e231$exports))),
                        left: 42.95,
                        top: 29.87,
                        width: 5.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b1d0770bc227bb8d$exports))),
                        left: 41.52,
                        top: 30.27,
                        width: 1.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5ab2967b95ba6fc7$exports))),
                        left: 31.67,
                        top: 18.00,
                        width: 8.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d0f130d9a8c4c2a0$exports))),
                        left: 28.48,
                        top: -4.73,
                        width: 11.52
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($36d1c79ae277b94a$exports))),
                        left: 68.38,
                        top: 56.13,
                        width: 8.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($84ce8bac51bc05d6$exports))),
                        left: 55.95,
                        top: 91.80,
                        width: 10.67,
                        style: {
                            transform: "scaleY(-1) rotateZ(-146deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($883ea24eab0caa77$exports))),
                        left: 68.05,
                        top: 91.20,
                        width: 4.38
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aad65c2b9b6cdc82$exports))),
                        left: 79.81,
                        top: 69.00,
                        width: 5.33,
                        style: {
                            transform: "rotateZ(-80deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2c1e36b4c814491f$exports))),
                        left: 56.81,
                        top: 66.07,
                        width: 13.95
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f17ccfae634ff1af$exports))),
                        left: 39.05,
                        top: 48.47,
                        width: 10.14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($28397bb45f149fbf$exports))),
                        left: 87.57,
                        top: 40.07,
                        width: 4.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c21383a532db50$exports))),
                        left: 62.38,
                        top: 28.80,
                        width: 2.48
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c21383a532db50$exports))),
                        left: 58.95,
                        top: 15.73,
                        width: 2.48,
                        style: {
                            transform: "scaleY(-1) rotateZ(-116.5deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c21383a532db50$exports))),
                        left: 74.52,
                        top: 0.80,
                        width: 2.48
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c21383a532db50$exports))),
                        left: 86.00,
                        top: 19.80,
                        width: 2.48
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0922fd31a5053$exports))),
                        left: 43.24,
                        top: 65.00,
                        width: 2.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0922fd31a5053$exports))),
                        left: 29.24,
                        top: 23.67,
                        width: 2.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0922fd31a5053$exports))),
                        left: 5.14,
                        top: 18.80,
                        width: 2.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0922fd31a5053$exports))),
                        left: 38.95,
                        top: 12.47,
                        width: 2.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0922fd31a5053$exports))),
                        left: 51.10,
                        top: 56.47,
                        width: 2.90,
                        style: {
                            transform: "rotateZ(30deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ba0922fd31a5053$exports))),
                        left: 60.76,
                        top: 40.93,
                        width: 2.90,
                        style: {
                            transform: "rotateZ(30deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: 25.67,
                        top: 5.20,
                        width: 69.10,
                        noEvents: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: 62.14,
                        top: 0.53,
                        width: 27.76,
                        noEvents: true,
                        style: {
                            transform: "scaleY(-1) rotateZ(162deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: 70.90,
                        top: 11.47,
                        width: 22.52,
                        noEvents: true,
                        style: {
                            transform: "scaleY(-1) rotateZ(-169deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: 59.86,
                        top: 28.47,
                        width: 22.52,
                        noEvents: true,
                        style: {
                            transform: "scaleY(-1) rotateZ(-165deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: 47.62,
                        top: 47.00,
                        width: 13.19,
                        noEvents: true,
                        style: {
                            transform: "scaleY(-1) rotateZ(153deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: -22.1,
                        top: 25.20,
                        width: 30.14,
                        noEvents: true,
                        style: {
                            transform: "scaleY(-1) rotateZ(-172deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cbf05518d77b22c$exports))),
                        left: -20.62,
                        top: 26.63,
                        width: 30.14,
                        noEvents: true,
                        style: {
                            transform: "scaleY(-1) rotateZ(-167deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$BL, {
                        bl: bl
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$BL1, {
                        bl: bl
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$BL2, {
                        bl: bl
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$BL3, {
                        bl: bl
                    })
                ]
            })
        ]
    });
}
function $73d83df6edf9a422$var$STC1() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        startOn: true,
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f2945f8062db97b8$exports))),
                    left: 1.67,
                    top: 41.93,
                    width: 37.71
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d1879323df6a0b9e$exports))),
                    left: 10.14,
                    top: 47.13,
                    width: 25.95,
                    height: 29.93
                })
            ]
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f2945f8062db97b8$exports))),
            left: 1.67,
            top: 41.93,
            width: 37.71
        })
    });
}
function $73d83df6edf9a422$var$STC2() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        startOn: true,
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d956e3b25c1f387a$exports))),
                    left: 90.10,
                    top: 13.33,
                    width: 8.71
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($da4d6cba2e26646d$exports))),
                    left: 91.00,
                    top: 14.07,
                    width: 6.95,
                    height: 8.13
                })
            ]
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d956e3b25c1f387a$exports))),
            left: 90.10,
            top: 13.33,
            width: 8.71
        })
    });
}
function $73d83df6edf9a422$var$STC3() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        startOn: true,
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($bde60f001ba2dd2a$exports))),
                    left: 86.57,
                    top: 51.67,
                    width: 15.71
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($13a37e2e423687cc$exports))),
                    left: 93.81,
                    top: 52.80,
                    width: 4.71,
                    height: 7.87
                })
            ]
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($bde60f001ba2dd2a$exports))),
            left: 86.57,
            top: 51.67,
            width: 15.71
        })
    });
}
function $73d83df6edf9a422$var$FL1(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        startOn: false,
        onEnable: ()=>{
            props.setBL(props.bl + 1);
        },
        onDisable: ()=>{
            props.setBL(props.bl - 1);
        },
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7452ade0ba53c498$exports))),
            left: 20.81,
            top: 8.07,
            width: 9.38,
            style: {
                transform: "rotateZ(34deg)"
            }
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($7452ade0ba53c498$exports))),
            left: 20.81,
            top: 8.07,
            width: 9.38,
            style: {
                transform: "rotateZ(34deg)"
            }
        })
    });
}
function $73d83df6edf9a422$var$FL2(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        startOn: false,
        onEnable: ()=>{
            props.setBL(props.bl + 2);
        },
        onDisable: ()=>{
            props.setBL(props.bl - 2);
        },
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5fddc6130e7f5573$exports))),
            left: 87.10,
            top: 18.27,
            width: 18.24,
            style: {
                transform: "scaleY(-1) rotateZ(166deg)"
            }
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5fddc6130e7f5573$exports))),
            left: 87.10,
            top: 18.27,
            width: 18.24,
            style: {
                transform: "scaleY(-1) rotateZ(166deg)"
            }
        })
    });
}
function $73d83df6edf9a422$var$FL3(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3aebe2660fadb1d$export$61bfbcb6cfee0061), {
        startOn: false,
        onEnable: ()=>{
            props.setBL(props.bl + 4);
        },
        onDisable: ()=>{
            props.setBL(props.bl - 4);
        },
        onState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ce12ce7dc5b1f31a$exports))),
            left: 12.10,
            top: 92.27,
            width: 18.29
        }),
        offState: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ce12ce7dc5b1f31a$exports))),
            left: 12.10,
            top: 92.27,
            width: 18.29
        })
    });
}
function $73d83df6edf9a422$var$BL(props) {
    return props.bl > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs bg-black no-events",
                style: {
                    left: 0,
                    top: 0,
                    bottom: -1,
                    right: 0,
                    filter: "opacity(.04)"
                },
                children: " "
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs bg-blue no-events",
                style: {
                    left: 0,
                    top: 0,
                    bottom: -1,
                    right: 0,
                    filter: "opacity(.84)",
                    mixBlendMode: "color-burn"
                },
                children: " "
            })
        ]
    }) : null;
}
function $73d83df6edf9a422$var$BL1(props) {
    return (props.bl & 1) == 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b3ef2b99255c5014$exports))),
                left: 41.52,
                top: 38.00,
                width: 1.14,
                height: 2.07,
                style: {
                    transform: "rotateZ(15deg)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f1af15010c8f2fa6$exports))),
                left: 18.14,
                top: 36.13,
                width: 1.29,
                height: 1.67
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9836542118e9147a$exports))),
                left: 43.24,
                top: 71.20,
                width: 1.71,
                height: 3.07
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6bd9df253f0e05ac$exports))),
                left: 25.66,
                top: 17.67,
                width: 2.62,
                height: 4.47,
                style: {
                    transform: "rotateZ(62deg)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4e9d78572904d31b$exports))),
                left: 22.77,
                top: 18.43,
                width: 10.00,
                height: 15.87,
                style: {
                    transform: "rotateZ(-110deg)"
                }
            })
        ]
    }) : null;
}
function $73d83df6edf9a422$var$BL2(props) {
    return (props.bl & 2) == 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($1f6809265c1957d2$exports))),
                left: 69.71,
                top: 13.80,
                width: 1.57,
                height: 2.87,
                style: {
                    transform: "rotateZ(10deg)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7a95ec75862f08de$exports))),
                left: 70.33,
                top: 34.93,
                width: 2.52,
                height: 4.53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($410d82fcf5818ba4$exports))),
                left: 52.20,
                top: 19.53,
                width: 3.43,
                height: 6.20,
                style: {
                    transform: "rotateZ(-120deg)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6bd9df253f0e05ac$exports))),
                left: 89.81,
                top: 26.7,
                width: 4.38,
                height: 7.53
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4e9d78572904d31b$exports))),
                left: 77.05,
                top: 15.60,
                width: 15.90,
                height: 25.20
            })
        ]
    }) : null;
}
function $73d83df6edf9a422$var$BL3(props) {
    return (props.bl & 4) == 4 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($18f4c4b51668a76f$exports))),
                left: 1.33,
                top: 86.40,
                width: 2.05,
                height: 3.73,
                style: {
                    transform: "rotateZ(180deg)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6bd9df253f0e05ac$exports))),
                left: 15.87,
                top: 93.67,
                width: 1.95,
                height: 7.53,
                style: {
                    transform: "rotateZ(-7deg)"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($73d83df6edf9a422$var$FME, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4e9d78572904d31b$exports))),
                left: 1.47,
                top: 83.70,
                width: 15.90,
                height: 25.20,
                style: {
                    transform: "rotateZ(-7deg)"
                }
            })
        ]
    }) : null;
}
function $73d83df6edf9a422$var$FME(props) {
    const src = props.src;
    const t = props.top;
    const l = props.left;
    const w = props.width;
    let c = props.class !== undefined ? props.class : '';
    if (props.noEvents) c += ' no-events';
    return props.height !== null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        className: 'pos-abs ' + c,
        style: {
            top: t + "%",
            left: l + "%",
            width: w + "%",
            height: props.height + "%",
            ...props.style
        }
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        className: 'pos-abs ' + c,
        style: {
            top: t + "%",
            left: l + "%",
            width: w + "%",
            ...props.style
        }
    });
}
function $73d83df6edf9a422$var$FML(props) {
    const t = props.top;
    const l = props.left;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pos-abs text-32 text-white",
        style: {
            top: t + "%",
            left: l + "%",
            mixBlendMode: "hard-light"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs cnn-bl",
                children: props.chr
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "pos-abs cnn-bl",
                style: {
                    filter: "blur(4px)",
                    mixBlendMode: "screen"
                },
                children: props.chr
            })
        ]
    });
}



var $b73ba3fe3d4c11be$exports = {};
$b73ba3fe3d4c11be$exports = import.meta.resolve("39sJ6");


var $4d9586ebb18a6395$exports = {};
$4d9586ebb18a6395$exports = import.meta.resolve("1Tozs");


var $7f4f0c062c8bf731$exports = {};
$7f4f0c062c8bf731$exports = import.meta.resolve("4QIzZ");


var $9635aaaefad05492$exports = {};
$9635aaaefad05492$exports = import.meta.resolve("lBrKQ");


var $b4ee5451829f1cf1$exports = {};
$b4ee5451829f1cf1$exports = import.meta.resolve("cHJo4");


var $820cba3246403705$exports = {};
$820cba3246403705$exports = import.meta.resolve("iMPzX");


var $368a92da992b845b$exports = {};
$368a92da992b845b$exports = import.meta.resolve("dkFJg");


var $47b1729fb2ad80af$exports = {};
$47b1729fb2ad80af$exports = import.meta.resolve("8DXMD");


var $ec9f9584d5bade83$exports = {};
$ec9f9584d5bade83$exports = import.meta.resolve("7MDtL");


var $6acc5d7b4b28a463$exports = {};
$6acc5d7b4b28a463$exports = import.meta.resolve("8Bcgx");


var $834a3dc491997ec4$exports = {};
$834a3dc491997ec4$exports = import.meta.resolve("hVzJD");


var $6229a39afe2d8ddd$exports = {};
$6229a39afe2d8ddd$exports = import.meta.resolve("7Rit3");


var $22818d543c540209$exports = {};
$22818d543c540209$exports = import.meta.resolve("j6pUI");


var $5750a84f8cd12e23$exports = {};
$5750a84f8cd12e23$exports = import.meta.resolve("evd9e");


var $89bfa8d998be3ffe$exports = {};
$89bfa8d998be3ffe$exports = import.meta.resolve("bZPcE");


var $540416a9bb1bc2ee$exports = {};
$540416a9bb1bc2ee$exports = import.meta.resolve("1jcEq");


var $2d33fd4c1e8e13f1$exports = {};
$2d33fd4c1e8e13f1$exports = import.meta.resolve("aqEG3");


var $ebb916b2e4a693e2$exports = {};
$ebb916b2e4a693e2$exports = import.meta.resolve("bEvoX");


var $a7f19ed8a6a13482$exports = {};
$a7f19ed8a6a13482$exports = import.meta.resolve("h3ds0");



var $aba2c61e184716be$exports = {};
$aba2c61e184716be$exports = import.meta.resolve("jomr5");


var $d694a1e97e691f67$exports = {};
$d694a1e97e691f67$exports = import.meta.resolve("dMSwJ");


var $4b8f30b439d89dcb$exports = {};
$4b8f30b439d89dcb$exports = import.meta.resolve("h3kpt");


var $7ea75f18b58ea803$exports = {};
$7ea75f18b58ea803$exports = import.meta.resolve("lg3zR");


var $2b4a7188d1bf502a$exports = {};
$2b4a7188d1bf502a$exports = import.meta.resolve("lS7Ep");



var $45e95a12eec01806$exports = {};
$45e95a12eec01806$exports = import.meta.resolve("3ImXC");


var $3ffc3ec43fae1087$exports = {};
$3ffc3ec43fae1087$exports = import.meta.resolve("8qyIK");


var $3a44628ded30463b$exports = {};
$3a44628ded30463b$exports = import.meta.resolve("4VrAm");


var $85a7d5b715bee9e6$exports = {};
$85a7d5b715bee9e6$exports = import.meta.resolve("4iHov");


var $ba0bb0e2eda9b5e1$exports = {};
$ba0bb0e2eda9b5e1$exports = import.meta.resolve("jPQ2g");


var $b959bf24b2996cdb$exports = {};
$b959bf24b2996cdb$exports = import.meta.resolve("j2Bnu");


var $077267b6c94d6b6f$exports = {};
$077267b6c94d6b6f$exports = import.meta.resolve("gNdOI");


var $1371d1de3bbc9925$exports = {};
$1371d1de3bbc9925$exports = import.meta.resolve("LddeF");


var $d458d911a75b0ec1$exports = {};
$d458d911a75b0ec1$exports = import.meta.resolve("9QJFd");


var $ca4d2f47f43a40d6$exports = {};
$ca4d2f47f43a40d6$exports = import.meta.resolve("2I62P");


var $d542f4675d1ac592$exports = {};
$d542f4675d1ac592$exports = import.meta.resolve("hz2lx");


var $4e5b85c3cfd910cf$exports = {};
$4e5b85c3cfd910cf$exports = import.meta.resolve("8CDKE");


var $85e453674097a446$exports = {};
$85e453674097a446$exports = import.meta.resolve("cJyTh");


var $c8beb47c60b6fc98$exports = {};
$c8beb47c60b6fc98$exports = import.meta.resolve("6N12F");


var $200a6b3f6d3d0932$exports = {};
$200a6b3f6d3d0932$exports = import.meta.resolve("hy7rJ");


var $9b0bc49e585ed4c1$exports = {};
$9b0bc49e585ed4c1$exports = import.meta.resolve("9PzYN");


var $f7822f54525351a7$exports = {};
$f7822f54525351a7$exports = import.meta.resolve("55qGg");


var $a233e30b4785177a$exports = {};
$a233e30b4785177a$exports = import.meta.resolve("cvH4W");


var $2ba4660bba4d38df$exports = {};
$2ba4660bba4d38df$exports = import.meta.resolve("ghmzG");


var $119d7e2376b50ba1$exports = {};
$119d7e2376b50ba1$exports = import.meta.resolve("7JcGf");


var $f0f145d3f4fc6ad4$exports = {};
$f0f145d3f4fc6ad4$exports = import.meta.resolve("5fI1O");


var $6a0058207a660069$exports = {};
$6a0058207a660069$exports = import.meta.resolve("hF7jE");


var $f8c924c8bde58855$exports = {};
$f8c924c8bde58855$exports = import.meta.resolve("cfuFf");


var $759435eee45bd856$exports = {};
$759435eee45bd856$exports = import.meta.resolve("kXJx9");


var $4d7f8cb5a00967f0$exports = {};
$4d7f8cb5a00967f0$exports = import.meta.resolve("3GbKI");


var $2bf0ab411421bf74$exports = {};
$2bf0ab411421bf74$exports = import.meta.resolve("5RnkL");



const $24595d90e08ed120$var$STD_WIDTH = 1920;
const $24595d90e08ed120$var$STD_HEIGHT = 1080;
function $24595d90e08ed120$export$3bbcefb60044b6fb() {
    const width = 960;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "page-basic bg-black v-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "height-64"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pos-rel mask-content",
                style: {
                    width: width,
                    height: width * $24595d90e08ed120$var$STD_HEIGHT / $24595d90e08ed120$var$STD_WIDTH
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b73ba3fe3d4c11be$exports))),
                        left: 0.00,
                        top: 0.00,
                        width: 100.00,
                        height: 100.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4d9586ebb18a6395$exports))),
                        left: 0.00,
                        top: 0.00,
                        width: 100.00,
                        height: 46.85
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4ee5451829f1cf1$exports))),
                        left: -4.22,
                        top: -3.33,
                        width: 18.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($820cba3246403705$exports))),
                        left: 36.61,
                        top: 2.59,
                        width: 21.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($820cba3246403705$exports))),
                        left: 62.66,
                        top: 7.96,
                        width: 21.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($820cba3246403705$exports))),
                        left: 88.39,
                        top: 14.72,
                        width: 21.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($368a92da992b845b$exports))),
                        left: 11.46,
                        top: -1.48,
                        width: 15.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($47b1729fb2ad80af$exports))),
                        left: 74.32,
                        top: -2.13,
                        width: 11.33,
                        class: "rotate-180"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ec9f9584d5bade83$exports))),
                        left: 85.21,
                        top: 3.06,
                        width: 6.10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6acc5d7b4b28a463$exports))),
                        left: 22.81,
                        top: 26.94,
                        width: 11.10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($834a3dc491997ec4$exports))),
                        left: 49.69,
                        top: 27.96,
                        width: 19.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6229a39afe2d8ddd$exports))),
                        left: 27.71,
                        top: 16.48,
                        width: 5.05
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($22818d543c540209$exports))),
                        left: 93.44,
                        top: 36.57,
                        width: 5.95
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f4f0c062c8bf731$exports))),
                        left: 84.43,
                        top: 32.22,
                        width: 4.00
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5750a84f8cd12e23$exports))),
                        left: 73.18,
                        top: 41.39,
                        width: 6.67,
                        class: "flip-h"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($89bfa8d998be3ffe$exports))),
                        left: 1.56,
                        top: 25.65,
                        width: 5.33
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($540416a9bb1bc2ee$exports))),
                        left: 5.99,
                        top: 28.70,
                        width: 4.29
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2d33fd4c1e8e13f1$exports))),
                        left: 13.59,
                        top: 40.83,
                        width: 5.95
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ebb916b2e4a693e2$exports))),
                        left: 43.18,
                        top: 42.59,
                        width: 3.10,
                        class: "flip-h"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a7f19ed8a6a13482$exports))),
                        left: 50.26,
                        top: 21.76,
                        width: 11.33,
                        class: "flip-h"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b069f11e4bb9030a$exports))),
                        left: 46.35,
                        top: 33.89,
                        width: 5.95,
                        class: "flip-h"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aba2c61e184716be$exports))),
                        left: 31.98,
                        top: 37.87,
                        width: 6.52
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d694a1e97e691f67$exports))),
                        left: 39.06,
                        top: 42.13,
                        width: 2.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4b8f30b439d89dcb$exports))),
                        left: 64.06,
                        top: 42.78,
                        width: 6.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ea75f18b58ea803$exports))),
                        left: 72.86,
                        top: 46.02,
                        width: 3.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d4e8eed33f81bd08$exports))),
                        left: 88.39,
                        top: 47.04,
                        width: 3.05
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2b4a7188d1bf502a$exports))),
                        left: 91.72,
                        top: 39.35,
                        width: 4.81,
                        class: "flip-h"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($45e95a12eec01806$exports))),
                        left: 93.44,
                        top: 52.96,
                        width: 4.95
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ffc3ec43fae1087$exports))),
                        left: 5.63,
                        top: 42.13,
                        width: 8.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3a44628ded30463b$exports))),
                        left: 1.67,
                        top: 42.22,
                        width: 5.86,
                        class: "wtrok-rot-n27"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($85a7d5b715bee9e6$exports))),
                        left: 64.01,
                        top: 53.43,
                        width: 5.76
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ba0bb0e2eda9b5e1$exports))),
                        left: 51.98,
                        top: 49.44,
                        width: 6.81
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b959bf24b2996cdb$exports))),
                        left: 24.90,
                        top: 49.54,
                        width: 7.29
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($077267b6c94d6b6f$exports))),
                        left: 11.51,
                        top: 52.96,
                        width: 11.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1371d1de3bbc9925$exports))),
                        left: 76.56,
                        top: 52.04,
                        width: 7.14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d458d911a75b0ec1$exports))),
                        left: 66.61,
                        top: 57.69,
                        width: 10.76
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ca4d2f47f43a40d6$exports))),
                        left: 79.38,
                        top: 57.78,
                        width: 9.29,
                        sfx: (0, (/*@__PURE__*/$parcel$interopDefault($2bf0ab411421bf74$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d542f4675d1ac592$exports))),
                        left: 76.35,
                        top: 68.70,
                        width: 2.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4e5b85c3cfd910cf$exports))),
                        left: 88.65,
                        top: 62.69,
                        width: 7.10,
                        sfx: (0, (/*@__PURE__*/$parcel$interopDefault($bd50770fbf187e88$exports)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($85e453674097a446$exports))),
                        left: 56.77,
                        top: 60.74,
                        width: 8.10
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c8beb47c60b6fc98$exports))),
                        left: 42.24,
                        top: 56.48,
                        width: 9.76
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($200a6b3f6d3d0932$exports))),
                        left: 33.59,
                        top: 56.20,
                        width: 6.48
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9b0bc49e585ed4c1$exports))),
                        left: 20.68,
                        top: 60.74,
                        width: 10.43
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f7822f54525351a7$exports))),
                        left: 2.97,
                        top: 61.57,
                        width: 4.90
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a233e30b4785177a$exports))),
                        left: 5.73,
                        top: 66.39,
                        width: 15.24
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2ba4660bba4d38df$exports))),
                        left: 2.29,
                        top: 85.28,
                        width: 4.67
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($119d7e2376b50ba1$exports))),
                        left: 77.55,
                        top: 85.19,
                        width: 10.19
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f0f145d3f4fc6ad4$exports))),
                        left: 87.45,
                        top: 75.00,
                        width: 8.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6a0058207a660069$exports))),
                        left: 57.86,
                        top: 68.06,
                        width: 19.57
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8c924c8bde58855$exports))),
                        left: 46.61,
                        top: 71.11,
                        width: 11.71
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9635aaaefad05492$exports))),
                        left: 26.30,
                        top: 73.61,
                        width: 16.86
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($24595d90e08ed120$var$FME, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($759435eee45bd856$exports))),
                        left: 43.02,
                        top: 90.83,
                        width: 4.19
                    })
                ]
            })
        ]
    });
}
function $24595d90e08ed120$var$FME(props) {
    const src = props.src;
    const t = props.top;
    const l = props.left;
    const w = props.width;
    const c = props.class !== undefined ? props.class : '';
    const a = props.sfx !== undefined ? props.sfx : (0, (/*@__PURE__*/$parcel$interopDefault($4d7f8cb5a00967f0$exports)));
    const audio = new Audio();
    audio.volume = 0.1;
    const playAudio = ()=>{
        audio.src = a;
        audio.play();
    };
    if (props.height !== undefined) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        onClick: playAudio,
        className: 'pos-abs ' + c,
        style: {
            top: t + "%",
            left: l + "%",
            width: w + "%",
            height: props.height + "%"
        }
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        onClick: playAudio,
        className: 'pos-abs ' + c,
        style: {
            top: t + "%",
            left: l + "%",
            width: w + "%"
        }
    });
}




function $e67471334be9aeae$export$5e10349f4ba9bd19() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "taco-box width-768 height-512 v-box padding-64",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "font-taco-primary text-black text-24",
                children: "WANT TO RIDE THE AUTOBONGOMOBILE?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "font-taco-primary text-black text-20 padding-8",
                children: [
                    "In partnership with local radio stations around the country, Taco Bongo is bringing Bongo's Big Ride to a city near you!",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "HONK HONK. HERE COME THE CLOWNS! Bongo is coming to a franchise location near you, and he's HUNGRY! Taco Bongo, Inc. and your local radio station are teaming up to bring 2 lucky winners the ride of a lifetime. Have you ever wanted to ride in The Automobongomobile? Stick your head out the window and feel the cool breeze of freedom? Have you ever wanty Taco Bongo? Well now you can, ON US!",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "Two lucky winners who call in during the BONGO BEAT BREAK with the correct password will receive a ride across town in the Automobongomobile and a photoshoot with our very own Bongo!",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    "Wanty more? You gluttonous beast! Fine. Both winners will also receive one taco a day for LIFE with filling of your choice at participating locations all over the country."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "font-taco-primary text-12 font-italic",
                children: "Must be 18 or older to enter. Must not be allergic to dogs. Taco offer only available at select participating locations, excludes buff beef as a filling. Limit to 5 entries per person. Must present physical image of winner meeting Bongo to receive offer. Bongo may be replaced by Bozo if conditions require."
            })
        ]
    });
}




const $3158954400b93f54$var$foundCrsKey = 'lst-fnd-crs-stt';
const $3158954400b93f54$var$foundPassKey = 'lst-fnd-crs-pss';
function $3158954400b93f54$export$75d84b6c964c0cd5() {
    const crsString = localStorage.getItem($3158954400b93f54$var$foundCrsKey);
    const pssString = localStorage.getItem($3158954400b93f54$var$foundPassKey);
    if (crsString == null || pssString == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const info = (0, $4d33f92596c93eff$export$e68fe7bc96d6a348)(crsString);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "page-basic center-all v-box",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: info.icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                children: [
                    "You found ... ",
                    info.name
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "The password to use it is..."
            }),
            pssString
        ]
    });
}


function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7486e87f2dee7e03$export$2e2bcd8739ae039), {
        value: {},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acd90146ef1cd4d7$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecf8a511bd2be543$export$2e2bcd8739ae039), {
                    value: {},
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50eff8c4f50f7148$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0eb7f6a0a55da23$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c7b5dbceb4de053$export$861edd1ccea2f746), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/tripleoaks/*",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4203da7486a3581a$export$5a57f017055ced45), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7540512296ff2cb5$export$b4d4e73308ac2e30), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "news",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a15ffaab41ece3e$export$2ce35fbd1a63425c), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "wtd",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d603eaddd4a0bf6e$export$9a4aed3567b76e59), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "history",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c07f7443fcf0c4b3$export$31a8f1515a761e86), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "construction",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88a84b72e8b3c367$export$bab1812e1be7e1b4), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "lost",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2928e991d51b785$export$1bbafc480fb2d1be), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "what",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94e7af8ae76e8cfe$export$6806ff6f5378ed2c), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "found",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b4304a014acb038$export$bae074112137dc8e), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/gouch",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c0ef430159b6fa2$export$ae303b2cb7384706), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/bowliver",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $248a5a58ce7572bd$export$8381844b7346a7c4), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/found",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b4304a014acb038$export$bae074112137dc8e), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/cnn/*",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $464b677cdf27d159$export$a7036ce17db05184), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0131e9ee11c45c37$export$5bdc406f871f9545), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "testimonials",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c23b482464308643$export$d69176fa41be421c), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "forums/:boardId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c21c451509e5a7ea$export$933ece00e7b71809), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "forums/:boardId/:topicId",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c21c451509e5a7ea$export$933ece00e7b71809), {})
                                        })
                                    ]
                                }),
                                "=",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/phrankscranks",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9f54c59ab503c66$export$34e22106a921bb9c), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/thecomedyshow",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $550cc20321efe4ec$export$42fdbd9715c0ebc6), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/somewhere",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b35899696dacc5b$export$19665ecffce36abe), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/tacobongo/*",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c009a6152ec85ea2$export$f76d35691779fb1b), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50851625e1699575$export$31a099fb9154a7cb), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "menu",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $850e8f70ecbd1a1e$export$4d69813342def711), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "findus",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e2aaff57b535a23$export$103620f6b2a7467a), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "meetbongo",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d6e8f6e9d86c378$export$2276db8aaf5543e2), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "sweepstakes",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e67471334be9aeae$export$5e10349f4ba9bd19), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/ringringring",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24595d90e08ed120$export$3bbcefb60044b6fb), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/wtrok/*",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afba5e966490edef$export$824b0208ab061dba), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b0823546d45f34f$export$99812b5a81e51b38), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "about",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cece11c74fffb3b$export$dd03d31035207375), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "sweepstakes",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe0552e0f1ef51aa$export$27b46e3a2d493e41), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "music",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbb79a897a94281e$export$7084ee4a5ffb59d), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "airtimes",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08b1abefbb57ac8c$export$44ce46a07a687085), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "bowling",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dc7aec66f541314$export$c7294414d472d743), {})
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                            path: "transcript",
                                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0a06261a859f33f$export$1f6cc3c298c2bc33), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/xtremeanime",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee72c4bd74cbe700$export$4b2f84f7845fd), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/omgitbfghbb",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $990dae71a55e8f53$export$9f833f0b07b32372), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/fitp",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb1496e00a69fcc1$export$d3ee0c2daf5ead2b), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/isekai",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dd43b988ac46ac6$export$44e24a2ce4316f2f), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/vault",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b0ab93779cc2597$export$f0a9532e1048387e), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/radicaltruthchaserz",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73d83df6edf9a422$export$3d4e061e759e2816), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0eb7f6a0a55da23$export$e7b0ac011bb776c6), {
                                    path: "/something",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3158954400b93f54$export$75d84b6c964c0cd5), {})
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}


let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=repo.89afa036.js.map
